import React, { useEffect, useState, useContext, useCallback, useRef, useMemo } from 'react';
import FuelOTPanel from './FuelOTPanel';
import FuelOrderWizard from './FuelOrderWizard';
import ImportGuiasDialog from './ImportGuiasDialog';
import {
  Box, Typography, Button, TextField, Chip, IconButton, Tooltip,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Checkbox, Select, MenuItem, FormControl, InputLabel, Paper,
  CircularProgress, Menu, ListItemIcon, Popover, Dialog,
} from '@material-ui/core';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import { usePlannerTheme, usePlannerDialogTheme, BRAND_GRADIENT, BRAND_GRADIENT_DARK, ON_BRAND } from '../../theme/plannerTheme';
import CheckIcon from '@material-ui/icons/Check';
import PlaceIcon from '@material-ui/icons/Place';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import LinkIcon from '@material-ui/icons/Link';
import SearchIcon from '@material-ui/icons/Search';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import NearMeIcon from '@material-ui/icons/NearMe';
import SendIcon from '@material-ui/icons/Send';
import SmartphoneIcon from '@material-ui/icons/Smartphone';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import RefreshIcon from '@material-ui/icons/Refresh';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import StopIcon from '@material-ui/icons/Stop';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HistoryIcon from '@material-ui/icons/History';
import PersonIcon from '@material-ui/icons/Person';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PrintIcon from '@material-ui/icons/Print';
import DirectionsIcon from '@material-ui/icons/Directions';
import CloseIcon from '@material-ui/icons/Close';
import ReactDOM from 'react-dom';
import WarningIcon from '@material-ui/icons/Warning';
import VehicleLocationPreview from './VehicleLocationPreview';
import OrderMiniMap from './OrderMiniMap';
import OrdersGanttView from './OrdersGanttView';
import OrdersLiveView from './OrdersLiveView';
import OrdersDeliveredSummary from './OrdersDeliveredSummary';
import OrdersOperationsView from './OrdersOperationsView';
import DriverContactDialog from './DriverContactDialog';
import DriverEditPanel from './DriverEditPanel';
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';
import ViewCompactIcon from '@material-ui/icons/ViewCompact';
import ViewComfyIcon from '@material-ui/icons/ViewComfy';
import ViewAgendaIcon from '@material-ui/icons/ViewAgenda';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import GetAppIcon from '@material-ui/icons/GetApp';
import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TableChartIcon from '@material-ui/icons/TableChart';
import ViewTimelineIcon from '@material-ui/icons/Timeline';
import DashboardIcon from '@material-ui/icons/Dashboard';
import { useSelector, useDispatch } from 'react-redux';
import { setActiveView, navigateTo, setSidebarVisible, setNeedsRecalculation, setAutoSaveReturn, setShowDetails, setSidebarTab, setShowMobilePreview, selectUI, setPendingOrderTimelineId } from '../../store/slices/uiSlice';
import { setOrigin, setDestination, setRouteName, setCargoRef, setSourceOTId, setSourceOTIds, clearRoute, fetchRouteDetail, setVehicle, setDriver, setRouteCisterns, setRouteDbId, addWaypoint, insertWaypointAt, setWaypoints, updateRouteStatus, setReadOnly, setReplanningRouteId, setReplanReturnLiveOTId, setRouteOptions, setFuelConsumption, setFuelType, setRoundTrip, fetchSavedRoutes } from '../../store/slices/routesSlice';
import { buildPresetPatch, subTypeFromVehicleCategory } from '../../utils/vehiclePresets';
import { validateConsolidation, collectUniquePoints, makeMatrixProvider } from '../../utils/consolidationValidator';
import { fetchTravelMatrix, calculateRouteHERE } from '../../utils/hereApi';
import ConsolidationConflictsDialog from './ConsolidationConflictsDialog';
import AOPetrotecOTBadges from './AOPetrotecOTBadges';
import PhonePreview from '../MobilePreview/PhonePreview';
import DriverPdfPreviewDialog from '../common/DriverPdfPreviewDialog';
import ConfirmDialog from '../common/ConfirmDialog';
import { resolveDefaultDeparture } from '../../utils/resolveDefaultDeparture';
import { isPetrotecTenant, isMoveExpressTenant } from '../../utils/manageHelpers';
import ManageDriversDialog from '../Sidebar/ManageDriversDialog';
import LiveRoutePanel from './LiveRoutePanel';

import { selectVehicles, selectAllVehicles, fetchAllVehicles } from '../../store/slices/vehiclesSlice';
import { selectDrivers, fetchDrivers } from '../../store/slices/driversSlice';
import { geocodeSearchMulti } from '../../utils/mapboxApi';
import { selectLocations, fetchLocations } from '../../store/slices/locationsSlice';
import { addToast } from '../../store/slices/notificationsSlice';
import { otLabel, otTooltip } from '../../utils/otLabel';
import {
  fetchOrders, deleteOrder, updateOrder, createOrder,
  setFilters, setSort, setPage, setLimit,
  selectOrdersList, selectOrdersPagination, selectOrdersFilters, selectOrdersLoading,
} from '../../store/slices/transportOrdersSlice';
import { AuthContext } from '../../App';
import { t } from '../../i18n';
import OrderForm from './OrderForm';
import OrderReportDialog from './OrderReportDialog';
import FuelDeliveryReport from './FuelDeliveryReport';
import OrderLaborDialog from './OrderLaborDialog';
// Narrow selector for simulation progress of a single route. Subscribing with
// this alone means OrdersView doesn't re-render every 2s when a simulation
// tick arrives — only the <TripProgressBar> for that specific route does.
// Returns null when no simulation is active for the route.
function selectRouteSimProgress(routeId) {
  return (state) => {
    if (routeId == null) return null;
    const v = (state.vehicles?.list || []).find(x =>
      x._simulating && x._simRouteId != null && String(x._simRouteId) === String(routeId)
    );
    if (!v) return null;
    // Round so tiny wiggle doesn't trigger re-render (still smooth enough)
    return Math.round(v._simProgress || 0);
  };
}

// Isolated progress bar — subscribes only to its own route's sim progress.
// Falls back to a time-based progress (elapsed vs ETA) when no simulation
// is active. Rendering this as a standalone component keeps the expensive
// simulation re-renders out of the main OT row tree.
function TripProgressBar({ order, lang, otStatus }) {
  const simProgress = useSelector(selectRouteSimProgress(order.assignedRouteId));
  const inTransitWithTimes = otStatus === 'in_transit' && order.actualStartAt && order.estimatedArrival;
  if (simProgress == null && !inTransitWithTimes) return null;

  let pct, remainingPct, isOverdue, subtitle, isSim = false;
  if (simProgress != null) {
    isSim = true;
    pct = simProgress;
    remainingPct = 100 - pct;
    isOverdue = false;
    subtitle = lang === 'pt' ? `Simulação · ${pct}% concluído` : `Simulation · ${pct}% complete`;
  } else {
    // This bar is computed from elapsed wall-clock time vs ETA — NOT from
    // the vehicle's GPS progress along the polyline. So the marker can
    // appear to "drive" while the truck is parked. The label below is
    // explicit so the operator knows what it represents and goes to the
    // live monitor for actual-position tracking.
    const start = new Date(order.actualStartAt).getTime();
    const eta = new Date(order.estimatedArrival).getTime();
    const now = Date.now();
    const total = Math.max(1, eta - start);
    const elapsed = Math.max(0, Math.min(total, now - start));
    pct = Math.round((elapsed / total) * 100);
    remainingPct = 100 - pct;
    isOverdue = now > eta;
    subtitle = isOverdue
      ? (lang === 'pt' ? '⚠ Previsão ultrapassada' : '⚠ Overdue')
      : (lang === 'pt' ? `${pct}% do tempo previsto · ${remainingPct}% restante` : `${pct}% of ETA elapsed · ${remainingPct}% remaining`);
  }
  return (
    <Box style={{
      marginBottom: 12, padding: '10px 14px',
      background: isSim
        ? 'linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)'
        : isOverdue
          ? 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)'
          : 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
      border: `1px solid ${isSim ? '#c7d2fe' : isOverdue ? '#fecaca' : '#bae6fd'}`,
      borderRadius: 10,
    }}>
      <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
        <Typography style={{ fontSize: '0.58rem', fontWeight: 800, color: isSim ? '#4338ca' : isOverdue ? '#991b1b' : '#0369a1', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
          {isSim
            ? (lang === 'pt' ? 'Simulação em curso' : 'Simulation running')
            : (lang === 'pt' ? 'Tempo decorrido (estimativa)' : 'Elapsed time (estimate)')}
        </Typography>
        <Typography style={{ fontSize: '0.64rem', fontWeight: 700, color: isSim ? '#4338ca' : isOverdue ? '#dc2626' : '#0284c7' }}>
          {subtitle}
        </Typography>
      </Box>
      <Box style={{ position: 'relative', height: 28 }}>
        <Box style={{
          position: 'absolute', top: 12, left: 14, right: 14, height: 4,
          background: '#cbd5e1', borderRadius: 2,
          backgroundImage: 'repeating-linear-gradient(90deg, #cbd5e1 0 8px, transparent 8px 14px)',
        }} />
        <Box style={{
          position: 'absolute', top: 12, left: 14,
          width: `calc((100% - 28px) * ${pct / 100})`,
          height: 4,
          background: isSim ? '#6366f1' : isOverdue ? '#ef4444' : '#22c55e',
          borderRadius: 2,
          transition: 'width 0.5s ease',
        }} />
        <Box style={{
          position: 'absolute', top: 7, left: 8,
          width: 14, height: 14, borderRadius: '50%',
          background: '#22c55e', border: '2px solid #fff', boxShadow: '0 0 0 1px #22c55e',
        }} />
        <Box style={{
          position: 'absolute', top: 7, right: 8,
          width: 14, height: 14, borderRadius: '50%',
          background: isOverdue ? '#ef4444' : '#22c55e',
          border: '2px solid #fff', boxShadow: `0 0 0 1px ${isOverdue ? '#ef4444' : '#22c55e'}`,
        }} />
        <Box style={{
          position: 'absolute', top: 0, left: `calc(14px + (100% - 28px) * ${pct / 100} - 14px)`,
          transition: 'left 0.5s ease',
          width: 28, height: 28,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 22,
          filter: 'drop-shadow(0 2px 4px rgba(15,23,42,0.15))',
          transform: 'scaleX(-1)',
        }}>
          🚚
        </Box>
      </Box>
      {/* Stats row — start / km remaining / ETA */}
      <Box style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6, fontSize: '0.6rem', color: '#64748b' }}>
        {order.actualStartAt ? (
          <span>
            <b style={{ color: '#16a34a' }}>{lang === 'pt' ? 'Início:' : 'Start:'}</b> {new Date(order.actualStartAt).toLocaleTimeString(lang === 'pt' ? 'pt-PT' : 'en-GB', { hour: '2-digit', minute: '2-digit' })}
          </span>
        ) : <span />}
        {order.distanceKm != null && (
          <span style={{ fontWeight: 600, color: isSim ? '#4338ca' : isOverdue ? '#dc2626' : '#0284c7' }}>
            {Number(order.distanceKm).toFixed(0)} km {lang === 'pt' ? 'restantes' : 'remaining'}
          </span>
        )}
        {order.estimatedArrival ? (
          <span>
            <b style={{ color: '#dc2626' }}>{lang === 'pt' ? 'ETA:' : 'ETA:'}</b> {new Date(order.estimatedArrival).toLocaleTimeString(lang === 'pt' ? 'pt-PT' : 'en-GB', { hour: '2-digit', minute: '2-digit' })}
          </span>
        ) : <span />}
      </Box>
    </Box>
  );
}

const STATUS_COLORS = {
  pending: '#94a3b8',
  assigned: '#3b82f6',
  in_transit: '#f59e0b',
  delivered: '#22c55e',
  cancelled: '#ef4444',
};

const STATUS_KEYS = {
  pending: 'otPending',
  assigned: 'otAssigned',
  in_transit: 'otInTransit',
  delivered: 'otDelivered',
  cancelled: 'otCancelled',
};

const PRIORITY_ICONS = { high: '\u{1F534}', normal: '\u26AA', low: '\u{1F535}' };

// \u2500\u2500\u2500 Modo CARDS das Ordens \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
// Cronologia de 3 fases derivada do status da OT.
const CARD_STAGES_PT = ['Em prepara\u00E7\u00E3o', 'Em tr\u00E2nsito', 'Entregue'];
const CARD_STAGES_EN = ['Preparing', 'In transit', 'Delivered'];
function orderStageIndex(status) {
  if (status === 'in_transit' || status === 'in_progress') return 1;
  if (status === 'delivered' || status === 'completed') return 2;
  return 0; // pending / assigned / draft
}
function fmtCardETA(iso, lang) {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  const hhmm = d.toLocaleTimeString(lang === 'pt' ? 'pt-PT' : 'en-GB', { hour: '2-digit', minute: '2-digit' });
  return (lang === 'pt' ? 'chega \u00E0s ' : 'arrives at ') + hhmm;
}
// Chips de carga a partir dos campos existentes (uma carga por OT).
function cargoChips(order, lang) {
  const chips = [];
  if (order.cargoDescription) chips.push(order.cargoDescription);
  if (order.cargoWeight) chips.push(`${order.cargoWeight} kg`);
  if (order.cargoPallets) chips.push(`${order.cargoPallets} ${lang === 'pt' ? 'paletes' : 'pallets'}`);
  else if (order.cargoType) chips.push(order.cargoType);
  return chips;
}

// Card de uma OT (modo "cards") — cronologia + carga + viatura/motorista/nota.
// Claro/escuro via prop dark. Adaptado dos campos reais da OT.
function OrderCard({ order, lang, dark, onOpen, onMap }) {
  const pt = lang === 'pt';
  const pal = dark
    ? { card: '#122133', border: 'rgba(110,193,228,0.14)', ink: '#eaf2f6', muted: '#9fb3c0', soft: '#6f93a6',
        line: 'rgba(110,193,228,0.12)', chipBg: 'rgba(255,255,255,0.04)', shadow: '0 12px 30px rgba(0,0,0,0.42)',
        done: '#3DDC97', onDone: '#03121c', track: 'rgba(255,255,255,0.14)', ring: 'rgba(61,220,151,0.2)' }
    : { card: '#ffffff', border: '#e5eef3', ink: '#0f2733', muted: '#5b7384', soft: '#94a3b8',
        line: '#eef4f8', chipBg: '#f4f8fb', shadow: '0 12px 30px rgba(15,39,51,0.08)',
        done: '#14b37d', onDone: '#ffffff', track: '#e2e8f0', ring: 'rgba(20,179,125,0.14)' };
  const cancelled = order.status === 'cancelled';
  const stage = cancelled ? -1 : orderStageIndex(order.status);
  const stages = pt ? CARD_STAGES_PT : CARD_STAGES_EN;
  const eta = fmtCardETA(order.estimatedArrival, lang);
  const chips = cargoChips(order, lang);
  const origin = order.pickupName || order.pickupAddress || (pt ? 'Origem' : 'Origin');
  const dest = order.deliveryName || order.deliveryAddress || (pt ? 'Destino' : 'Destination');
  const brand = dark ? BRAND_GRADIENT_DARK : BRAND_GRADIENT;
  const num = order.orderNumber || order.externalRef || order.customRef || `#${order.id || order._id || ''}`;

  return (
    <Box style={{ background: pal.card, border: `1px solid ${pal.border}`, borderRadius: 18,
      padding: '18px 20px', boxShadow: pal.shadow, display: 'flex', flexDirection: 'column', gap: 14,
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif' }}>

      {/* Cabeçalho: nº · origem → destino · ETA */}
      <Box style={{ display: 'flex', alignItems: 'baseline', gap: 10, flexWrap: 'wrap' }}>
        <span style={{ fontWeight: 800, fontSize: '0.95rem',
          background: brand, WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>{num}</span>
        <span style={{ fontWeight: 800, fontSize: '1.02rem', color: pal.ink }}>{origin}</span>
        <span style={{ color: pal.soft, fontSize: '1.05rem', lineHeight: 1 }}>→</span>
        <span style={{ fontWeight: 800, fontSize: '1.02rem', color: pal.ink }}>{dest}</span>
        <Box style={{ flex: 1 }} />
        {cancelled
          ? <span style={{ fontSize: '0.84rem', fontWeight: 700, color: '#ef4444' }}>{pt ? 'Cancelada' : 'Cancelled'}</span>
          : eta && <span style={{ fontSize: '0.86rem', color: pal.muted }}>{eta}</span>}
      </Box>

      {/* Cronologia de 3 fases */}
      {!cancelled && (
        <Box style={{ display: 'flex', alignItems: 'flex-start', padding: '2px 6px 0' }}>
          {stages.map((label, i) => {
            const done = i < stage;
            const current = i === stage;
            return (
              <React.Fragment key={i}>
                <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 7, flex: '0 0 auto', zIndex: 1 }}>
                  <Box style={{ width: current ? 26 : 22, height: current ? 26 : 22, borderRadius: '50%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: (done || current) ? pal.done : 'transparent',
                    border: (done || current) ? 'none' : `2px solid ${pal.track}`,
                    boxShadow: current ? `0 0 0 4px ${pal.ring}` : 'none' }}>
                    {done && <CheckIcon style={{ fontSize: 14, color: pal.onDone }} />}
                    {current && <Box style={{ width: 8, height: 8, borderRadius: '50%', background: pal.onDone }} />}
                  </Box>
                  <Typography style={{ fontSize: '0.72rem', fontWeight: current ? 800 : 600,
                    color: i <= stage ? pal.ink : pal.soft, whiteSpace: 'nowrap' }}>{label}</Typography>
                </Box>
                {i < stages.length - 1 && (
                  <Box style={{ flex: 1, height: 3, borderRadius: 2, marginTop: 10,
                    background: i < stage ? pal.done : pal.track }} />
                )}
              </React.Fragment>
            );
          })}
        </Box>
      )}

      {/* Chips de carga */}
      {chips.length > 0 && (
        <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
          {chips.map((c, i) => (
            <Box key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, background: pal.chipBg,
              border: `1px solid ${pal.border}`, borderRadius: 12, padding: '8px 12px' }}>
              <Box style={{ width: 26, height: 26, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: dark ? 'rgba(255,255,255,0.05)' : '#eaf2f7', color: pal.muted, flexShrink: 0 }}>
                <LocalShippingIcon style={{ fontSize: 15 }} />
              </Box>
              <span style={{ fontWeight: 700, fontSize: '0.82rem', color: pal.ink }}>{c}</span>
            </Box>
          ))}
        </Box>
      )}

      {/* Rodapé: viatura · motorista · nota · ações */}
      <Box style={{ borderTop: `1px solid ${pal.line}`, paddingTop: 14, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        {order.vehiclePlate && (
          <Box style={{ display: 'flex', alignItems: 'center', border: `1px solid ${pal.border}`, borderRadius: 9, overflow: 'hidden' }}>
            <span style={{ width: 24, height: 26, display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: dark ? '#20C6F4' : '#2563eb', color: '#fff', fontWeight: 800, fontSize: '0.72rem' }}>P</span>
            <span style={{ padding: '0 10px', fontWeight: 800, fontSize: '0.82rem', color: pal.ink }}>{order.vehiclePlate}</span>
          </Box>
        )}
        {order.driverName && <span style={{ fontWeight: 700, fontSize: '0.84rem', color: pal.ink }}>{order.driverName}</span>}
        {order.instructions && <span style={{ fontSize: '0.82rem', color: pal.muted, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 280 }}>{order.instructions}</span>}
        <Box style={{ flex: 1, minWidth: 8 }} />
        <Button onClick={onMap} startIcon={<PlaceIcon style={{ fontSize: 17 }} />}
          style={{ textTransform: 'none', fontWeight: 700, fontSize: '0.82rem', color: pal.ink,
            border: `1px solid ${pal.border}`, borderRadius: 11, padding: '7px 16px' }}>
          {pt ? 'Ver no mapa' : 'View on map'}
        </Button>
        <Button onClick={onOpen}
          style={{ textTransform: 'none', fontWeight: 800, fontSize: '0.82rem', color: ON_BRAND,
            background: brand, borderRadius: 11, padding: '7px 18px', boxShadow: '0 6px 16px rgba(24,189,238,0.3)' }}>
          {pt ? 'Abrir' : 'Open'}
        </Button>
      </Box>
    </Box>
  );
}

// Fases da cronologia das OT de combust\u00EDvel (para o filtro por etapa).
// 7 buckets mutuamente exclusivos, derivados do campo `fuelStage` da OT
// (denormalizado no backend a partir do \u00FAltimo marco). arrived_pa e
// unloading partilham o bucket "No PA / a entregar".
const FUEL_STAGE_BUCKETS = [
  { key: 'na_base',          emoji: '\u{1F17F}\uFE0F', pt: 'Na base',            en: 'At base',       color: '#94a3b8' },
  { key: 'departed',         emoji: '\u{1F69A}',       pt: 'A caminho do terminal', en: 'To terminal', color: '#0ea5e9' },
  { key: 'arrived_terminal', emoji: '\u26FD',          pt: 'No terminal / a carregar', en: 'At terminal', color: '#6366f1' },
  { key: 'loaded',           emoji: '\u{1F6E3}\uFE0F', pt: 'A caminho do PA',     en: 'To PA',         color: '#8b5cf6' },
  { key: 'no_pa',            emoji: '\u{1F4CD}',       pt: 'No PA / a entregar',  en: 'At PA',         color: '#ea580c' },
  { key: 'completed',        emoji: '\u21A9\uFE0F',    pt: 'A regressar',         en: 'Returning',     color: '#0d9488' },
  { key: 'returned',         emoji: '\u2705',          pt: 'Conclu\u00EDda',           en: 'Done',          color: '#16a34a' },
];
// fuelStage (coluna) \u2192 bucket key
function fuelStageBucket(stage) {
  switch (stage) {
    case 'departed': return 'departed';
    case 'arrived_terminal': return 'arrived_terminal';
    case 'loaded': return 'loaded';
    case 'arrived_pa':
    case 'unloading': return 'no_pa';
    case 'completed': return 'completed';
    case 'returned': return 'returned';
    default: return 'na_base'; // null / vazio = ainda por sair
  }
}

// Dura\u00E7\u00E3o do servi\u00E7o a partir do serviceStartedAt (Fase 1A) \u2014 separa
// tempo factur\u00E1vel (started \u2192 completed) do tempo de espera (arrived
// \u2192 started). Em OT j\u00E1 conclu\u00EDda usa actualDurationMin (calculado no
// backend com a nova prioridade); em OT em curso conta ao segundo
// at\u00E9 `nowMs` para o operador ver no chip da linha.
function serviceDuration(report, nowMs) {
  if (!report?.serviceStartedAt) return null;
  if (report.completedAt) {
    if (Number.isFinite(report.actualDurationMin) && report.actualDurationMin >= 0) {
      return { ms: report.actualDurationMin * 60000, live: false };
    }
    const ms = new Date(report.completedAt).getTime() - new Date(report.serviceStartedAt).getTime();
    return ms > 0 ? { ms, live: false } : null;
  }
  const ms = nowMs - new Date(report.serviceStartedAt).getTime();
  return ms > 0 ? { ms, live: true } : null;
}

// "12m 34s" para servi\u00E7o em curso (precis\u00E3o de segundos), "1h 45m" /
// "45 min" para servi\u00E7o j\u00E1 conclu\u00EDdo (precis\u00E3o de minutos).
function fmtServiceDuration(ms, live) {
  if (!Number.isFinite(ms) || ms < 0) return '';
  const totalSec = Math.floor(ms / 1000);
  if (live) {
    const mm = Math.floor(totalSec / 60);
    const ss = totalSec % 60;
    return `${mm}m ${String(ss).padStart(2, '0')}s`;
  }
  const totalMin = Math.round(ms / 60000);
  if (totalMin >= 60) {
    const h = Math.floor(totalMin / 60);
    const m = totalMin % 60;
    return m > 0 ? `${h}h ${m}min` : `${h}h`;
  }
  return `${totalMin} min`;
}

// ── SLA countdown ─────────────────────────────────────────────────────
//
// Calcula o estado do SLA contratual de uma OT (Petrotec) com base em:
//   · início do relógio: `createdAt` da OT (decisão Sprint C)
//   · fim do relógio:    `arrivedAt` (tempo de resposta) ou `now` quando
//                        ainda não chegou
//   · prazo:             `slaHours` (vem do contrato do FinalCustomer
//                        × interventionType, auto-populado no backend)
//
// Estados:
//   · null          — OT sem slaHours ou já entregue há muito tempo
//   · 'met'         — chegou dentro do prazo (verde escuro)
//   · 'breached'    — chegou DEPOIS do prazo (vermelho escuro)
//   · 'overdue'     — ainda não chegou e já passou do prazo (vermelho)
//   · 'critical'    — restante <= 25% do prazo (laranja)
//   · 'warning'     — restante <= 50% (amarelo)
//   · 'ok'          — restante > 50% (verde)
//
// Retorna { status, remainingMs, elapsedMs, totalMs, pctElapsed } ou null.
function slaCountdown(order, nowMs) {
  if (!order || order.slaHours == null) return null;
  // SLA aplica-se SÓ a OTs de assistência — fuel/delivery não têm
  // contrato de tempo de resposta no modelo Petrotec actual.
  if (order.serviceType !== 'assistance') return null;
  const hours = Number(order.slaHours);
  if (!Number.isFinite(hours) || hours <= 0) return null;
  const totalMs = hours * 3600 * 1000;

  const createdAt = order.createdAt ? new Date(order.createdAt).getTime() : null;
  if (!createdAt) return null;
  const deadlineMs = createdAt + totalMs;

  const arrivedRaw = order.assistanceReport?.arrivedAt
    || order.actualStartAt
    || (order.status === 'delivered' ? order.deliveredAt : null);

  if (arrivedRaw) {
    const arrivedMs = new Date(arrivedRaw).getTime();
    const elapsedMs = Math.max(0, arrivedMs - createdAt);
    const remainingMs = deadlineMs - arrivedMs;
    return {
      status: arrivedMs <= deadlineMs ? 'met' : 'breached',
      remainingMs, elapsedMs, totalMs,
      pctElapsed: Math.min(100, Math.round((elapsedMs / totalMs) * 100)),
      stopped: true,
    };
  }

  const elapsedMs = Math.max(0, nowMs - createdAt);
  const remainingMs = deadlineMs - nowMs;
  const pctElapsed = Math.min(999, Math.round((elapsedMs / totalMs) * 100));
  let status;
  if (remainingMs <= 0) status = 'overdue';
  else if (pctElapsed >= 75) status = 'critical';
  else if (pctElapsed >= 50) status = 'warning';
  else status = 'ok';
  return { status, remainingMs, elapsedMs, totalMs, pctElapsed, stopped: false };
}

// SLA Resolução — espelho de slaResolutionCountdown no backend.
// Calcula tempo desde createdAt até completedAt (ou now se em curso),
// com base em slaResolutionHours. Devolve null quando não aplica.
function slaResolutionCountdown(order, nowMs) {
  if (!order || order.slaResolutionHours == null) return null;
  if (order.serviceType !== 'assistance') return null;
  const hours = Number(order.slaResolutionHours);
  if (!Number.isFinite(hours) || hours <= 0) return null;
  const totalMs = hours * 3600 * 1000;
  const createdAt = order.createdAt ? new Date(order.createdAt).getTime() : null;
  if (!createdAt) return null;
  const deadlineMs = createdAt + totalMs;
  const completedRaw = order.assistanceReport?.completedAt
    || (order.status === 'delivered' ? order.deliveredAt : null);
  if (completedRaw) {
    const completedMs = new Date(completedRaw).getTime();
    const elapsedMs = Math.max(0, completedMs - createdAt);
    const remainingMs = deadlineMs - completedMs;
    return {
      status: completedMs <= deadlineMs ? 'met' : 'breached',
      remainingMs, elapsedMs, totalMs,
      pctElapsed: Math.min(100, Math.round((elapsedMs / totalMs) * 100)),
      stopped: true, kind: 'resolution',
    };
  }
  const elapsedMs = Math.max(0, nowMs - createdAt);
  const remainingMs = deadlineMs - nowMs;
  const pctElapsed = Math.min(999, Math.round((elapsedMs / totalMs) * 100));
  let status;
  if (remainingMs <= 0) status = 'overdue';
  else if (pctElapsed >= 75) status = 'critical';
  else if (pctElapsed >= 50) status = 'warning';
  else status = 'ok';
  return { status, remainingMs, elapsedMs, totalMs, pctElapsed, stopped: false, kind: 'resolution' };
}

// Formata a duração restante/decorrida em "5h 23m", "47m", "−1h 12m" etc.
// Aceita ms (positivo ou negativo). Para overdue mostra "−2h 14m".
function fmtSlaDuration(ms) {
  const neg = ms < 0;
  const abs = Math.abs(ms);
  const totalMin = Math.floor(abs / 60000);
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  const sign = neg ? '−' : '';
  if (h >= 24) {
    const d = Math.floor(h / 24);
    const rh = h % 24;
    return `${sign}${d}d${rh > 0 ? ` ${rh}h` : ''}`;
  }
  if (h > 0) return `${sign}${h}h ${m}m`;
  return `${sign}${m}m`;
}

const SLA_META = {
  met:      { bg: '#dcfce7', color: '#166534', border: '#bbf7d0', label: 'Cumprido',  labelEn: 'Met',       icon: '✓' },
  breached: { bg: '#7f1d1d', color: '#fee2e2', border: '#7f1d1d', label: 'Falhou',    labelEn: 'Missed',    icon: '✕' },
  overdue:  { bg: '#dc2626', color: '#fff',    border: '#991b1b', label: 'Vencido',   labelEn: 'Overdue',   icon: '⏱' },
  critical: { bg: '#fed7aa', color: '#9a3412', border: '#fb923c', label: 'Crítico',   labelEn: 'Critical',  icon: '⏱' },
  warning:  { bg: '#fef3c7', color: '#92400e', border: '#fcd34d', label: 'Atenção',   labelEn: 'Warning',   icon: '⏱' },
  ok:       { bg: '#dbeafe', color: '#1e40af', border: '#93c5fd', label: 'No prazo',  labelEn: 'On track',  icon: '⏱' },
};

const useStyles = makeStyles(() => ({
  // Pulse contínuo (mais lento, 2s) enquanto há novidades pendentes —
  // glow mais largo e mais forte para o operador notar mesmo de relance.
  // Pára naturalmente quando o operador clica e o staleHint reset.
  '@keyframes pulseRedBtn': {
    '0%':   { boxShadow: '0 0 0 0 rgba(220,38,38,0.85), 0 4px 14px rgba(220,38,38,0.5)' },
    '70%':  { boxShadow: '0 0 0 14px rgba(220,38,38,0), 0 4px 14px rgba(220,38,38,0.5)' },
    '100%': { boxShadow: '0 0 0 0 rgba(220,38,38,0), 0 4px 14px rgba(220,38,38,0.5)' },
  },
  '@keyframes pulseRedDot': {
    '0%':   { transform: 'scale(1)',   opacity: 1 },
    '50%':  { transform: 'scale(1.7)', opacity: 0.7 },
    '100%': { transform: 'scale(1)',   opacity: 1 },
  },
  // Alerta P.A. (Move Express fuel): a bolinha "Ver rota em tempo real" pisca
  // — vermelho quando a viatura chegou ao P.A., verde quando saiu do P.A. e a
  // OT ainda não foi concluída. Cor definida inline (background); só a animação
  // vive aqui.
  '@keyframes paDotBlink': {
    '0%':   { opacity: 1,    transform: 'scale(1)' },
    '50%':  { opacity: 0.35, transform: 'scale(1.55)' },
    '100%': { opacity: 1,    transform: 'scale(1)' },
  },
  paBlinkDot: { animation: '$paDotBlink 1s ease-in-out infinite' },
  // Pulse para o chip "Em serviço · 00:23:14" — verde suave que respira
  // ao segundo. Sinaliza ao operador, com um relance, que aquela OT
  // está em execução AGORA (relógio a correr).
  '@keyframes pulseServiceChip': {
    '0%':   { boxShadow: '0 0 0 0 rgba(22,163,74,0.55), 0 2px 8px rgba(22,163,74,0.25)' },
    '70%':  { boxShadow: '0 0 0 8px rgba(22,163,74,0), 0 2px 8px rgba(22,163,74,0.25)' },
    '100%': { boxShadow: '0 0 0 0 rgba(22,163,74,0), 0 2px 8px rgba(22,163,74,0.25)' },
  },
  '@keyframes pulseServiceDot': {
    '0%':   { transform: 'scale(1)',   opacity: 1 },
    '50%':  { transform: 'scale(1.5)', opacity: 0.55 },
    '100%': { transform: 'scale(1)',   opacity: 1 },
  },
  serviceChipLive: {
    animation: '$pulseServiceChip 1.8s ease-in-out infinite',
  },
  serviceChipDot: {
    animation: '$pulseServiceDot 1.4s ease-in-out infinite',
  },
  refreshBtnStale: {
    animation: '$pulseRedBtn 1.8s ease-in-out infinite',
    color: '#ffffff !important',
  },
  refreshDotStale: {
    animation: '$pulseRedDot 1.2s ease-in-out infinite',
  },
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    background: 'var(--surf-page, #f8fafc)',
    overflow: 'hidden',
    height: '100%',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 24px 8px',
    flexShrink: 0,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  filterBar: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '4px 24px 12px',
    flexWrap: 'wrap',
    flexShrink: 0,
  },
  searchField: {
    '& .MuiInputBase-root': { height: 34, fontSize: '0.82rem' },
    minWidth: 220,
  },
  statusChip: {
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: '0.72rem',
    height: 26,
    transition: 'all 0.15s',
  },
  tableWrap: {
    flex: 1,
    minWidth: 0,                  // permite encolher dentro do flex coluna
    overflow: 'auto',
    overflowX: 'auto',            // explícito para garantir barra horizontal
    padding: '0 24px',
    // Barra de scroll discreta mas visível para o operador perceber
    // que pode arrastar lateralmente em modo confortável/espaçoso.
    '&::-webkit-scrollbar': {
      height: 10,
      width: 10,
    },
    '&::-webkit-scrollbar-track': {
      background: 'rgba(15,23,42,0.04)',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(99,102,241,0.35)',
      borderRadius: 6,
      '&:hover': { background: 'rgba(99,102,241,0.55)' },
    },
  },
  table: {
    '& .MuiTableCell-root': {
      padding: '8px 12px',
      fontSize: '0.78rem',
      verticalAlign: 'top',
      borderBottom: '1px solid var(--surf-border-soft, #eef2f7)',
    },
    // Cabeçalho MODERNO: linha única (sem quebra feia a 2 linhas), sticky no topo
    // ao fazer scroll, tipografia compacta e um traço de base mais marcado.
    '& .MuiTableHead-root .MuiTableCell-root': {
      fontWeight: 700,
      background: 'var(--surf-head-bg, #f1f5f9)',
      color: 'var(--surf-muted, #64748b)',
      fontSize: '0.66rem',
      textTransform: 'uppercase',
      letterSpacing: '0.04em',
      whiteSpace: 'nowrap',
      verticalAlign: 'middle',
      lineHeight: 1.1,
      position: 'sticky',
      top: 0,
      zIndex: 3,
      borderBottom: '1.5px solid var(--surf-border, #e2e8f0)',
    },
    // Linhas: hover suave; a 1.ª célula (nº OT) com um realce discreto.
    '& .MuiTableBody-root .MuiTableRow-root': {
      transition: 'background 0.12s ease',
    },
    '& .MuiTableBody-root .MuiTableRow-root:hover': {
      background: 'var(--surf-row-hover, #f8fafc)',
    },
  },
  tableCompact: {
    '& .MuiTableCell-root': {
      padding: '2px 7px !important',
      fontSize: '0.68rem !important',
      verticalAlign: 'middle !important',
    },
    // Cabeçalho: labels MAIS PEQUENAS (cabem em 1 linha e deixam ver mais
    // colunas sem cortar). Linha única garantida pelo nowrap inline.
    '& .MuiTableHead-root .MuiTableCell-root': {
      fontSize: '0.56rem !important',
      letterSpacing: '0.02em !important',
      padding: '7px 7px !important',
    },
  },
  tableSpacious: {
    minWidth: 1400,
    '& .MuiTableCell-root': {
      padding: '12px 14px !important',
      fontSize: '0.92rem !important',
      whiteSpace: 'nowrap',
    },
    '& .MuiTableCell-root .MuiTypography-root': {
      fontSize: '0.88rem !important',
    },
    '& .MuiTableCell-root span': {
      fontSize: '0.78rem !important',
    },
    '& .MuiTableCell-root .MuiChip-label': {
      fontSize: '0.68rem !important',
    },
    '& .MuiTableCell-root .MuiSelect-root': {
      fontSize: '0.78rem !important',
    },
    '& .MuiTableCell-head': {
      fontSize: '0.72rem !important',
    },
    '& .MuiTableCell-head .MuiTypography-root': {
      fontSize: '0.72rem !important',
    },
  },
  // Confortável: valores MÉDIOS, mas com !important para vencer os fontSizes
  // inline que a condensação pôs em algumas células (Nº/Datas) — senão o modo
  // base não se distinguia do Compacto. Espelha a estrutura do tableSpacious.
  tableComfortable: {
    '& .MuiTableCell-root': {
      padding: '7px 12px !important',
      fontSize: '0.8rem !important',
      verticalAlign: 'top !important',
    },
    '& .MuiTableCell-root .MuiTypography-root': {
      fontSize: '0.78rem !important',
    },
    '& .MuiTableCell-root span': {
      fontSize: '0.72rem !important',
    },
    '& .MuiTableCell-root .MuiChip-label': {
      fontSize: '0.64rem !important',
    },
    '& .MuiTableHead-root .MuiTableCell-root': {
      fontSize: '0.62rem !important',
    },
  },
  // Move Express / fuel: a tabela tem muitas colunas e a de Ações saía do ecrã.
  // Encolhe o padding e LIMITA a largura das 3 colunas de texto longo (Recolha,
  // Entrega, Veículo/Motorista) — o conteúdo passa a várias linhas em vez de
  // esticar a coluna, deixando a tabela caber e a coluna Ações aparecer.
  // Só aplicado quando onlyFuelOrders (Casais/mercadoria fica intacta).
  // nth-child: 1=check 2=Nº 3=Datas 4=Estado 5=Recolha 6=Entrega 7=Veíc/Mot 8=Execução 9=Progresso 10=Ações
  tableFuelTight: {
    // table-layout fixed + width 100% → a tabela cabe SEMPRE na largura do ecrã
    // (nunca passa a margem direita), distribuindo as colunas pelas larguras-base
    // abaixo. Assim a coluna Ações fica sempre visível. !important porque neste
    // <table> as regras de classe só pegam com !important.
    tableLayout: 'fixed !important',
    width: '100% !important',
    '& .MuiTableCell-root': {
      paddingLeft: '7px !important',
      paddingRight: '7px !important',
      overflow: 'hidden !important',
      textOverflow: 'ellipsis',
    },
    // nth-child: 1=check 2=Nº 3=Datas 4=Estado 5=Recolha 6=Entrega 7=Veíc/Mot 8=Execução 9=Progresso 10=Ações
    '& .MuiTableCell-root:nth-child(1)': { width: '58px !important' },
    '& .MuiTableCell-root:nth-child(2)': { width: '13% !important' },
    '& .MuiTableCell-root:nth-child(3)': { width: '8% !important' },
    '& .MuiTableCell-root:nth-child(4)': { width: '8% !important' },
    '& .MuiTableCell-root:nth-child(5)': { width: '13% !important' },
    '& .MuiTableCell-root:nth-child(6)': { width: '11% !important' },
    '& .MuiTableCell-root:nth-child(7)': { width: '15% !important' },
    '& .MuiTableCell-root:nth-child(8)': { width: '11% !important' },
    '& .MuiTableCell-root:nth-child(9)': { width: '10% !important' },
    '& .MuiTableCell-root:nth-child(10)': { width: '96px !important' },
  },
  orderNumber: {
    fontWeight: 700,
    color: 'var(--surf-strong, #1e293b)',
    fontSize: '0.82rem',
  },
  routeCell: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    fontSize: '0.76rem',
  },
  badge: {
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: 12,
    fontWeight: 600,
    fontSize: '0.7rem',
    color: '#fff',
  },
  pagination: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    padding: '10px 24px',
    flexShrink: 0,
    borderTop: '1px solid rgba(0,0,0,0.06)',
  },
  // Ghost primary — white fill with a thin *dark* border to mark it as primary
  // (vs secondary buttons which use a pale-grey border). The dark edge gives
  // hierarchy without any heavy fill. Style adapted from Arc/Linear's outlined
  // action buttons.
  newBtn: {
    background: 'var(--surf-card, #fff)',
    color: 'var(--surf-strong, #0f172a)',
    fontWeight: 500,
    fontSize: '0.76rem',
    letterSpacing: '-0.005em',
    textTransform: 'none',
    borderRadius: 8,
    padding: '6px 14px',
    border: '1px solid var(--surf-strong, #0f172a)',
    boxShadow: 'none',
    transition: 'all 0.15s',
    '&:hover': {
      background: 'var(--surf-card-alt, #f8fafc)',
    },
    '& .MuiButton-startIcon': { marginRight: 4 },
    '& .MuiButton-startIcon svg': { color: 'var(--surf-strong, #0f172a)' },
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    gap: 12,
    color: 'var(--surf-muted2, #94a3b8)',
  },
}));

function OrdersView({ lang }) {
  const classes = useStyles();
  const plannerTheme = usePlannerTheme();
  const dlgTheme = usePlannerDialogTheme();
  const dispatch = useDispatch();
  const { token, clientSettings, clientExternalId, userPermission, userRole } = useContext(AuthContext);
  // Só GESTOR (ou super_admin) pode ELIMINAR ordens — transversal a todos os
  // clientes. Esconde as ações de eliminar p/ operador/viewer (o backend também
  // recusa com 403, de forma autoritária).
  const canDeleteOrders = userPermission === 'manager' || userRole === 'super_admin';
  // Tipos de OT que esta Organização cria (config do Perfil). Quando só há UM
  // tipo, o botão "Nova Ordem" abre-o direto, sem perguntar. Quando é só
  // combustível, abre o wizard dedicado (o form genérico não tem os campos de
  // combustível). DERIVA da config — não da variante (ex.: Move Express).
  const allowedOrderTypes = Array.isArray(clientSettings?.allowedOrderTypes) && clientSettings.allowedOrderTypes.length > 0
    ? clientSettings.allowedOrderTypes
    : ['delivery', 'assistance', 'fuel'];
  const onlyFuelOrders = allowedOrderTypes.length === 1 && allowedOrderTypes[0] === 'fuel';
  // Fase B — 'viewer' é só leitura: esconde os botões de criar/despachar.
  const canWrite = userPermission !== 'viewer';

  const list = useSelector(selectOrdersList);
  const pagination = useSelector(selectOrdersPagination);
  const filters = useSelector(selectOrdersFilters);
  const loading = useSelector(selectOrdersLoading);
  // Custom equality — ignore simulation-only fields so OrdersView doesn't
  // re-render every 2s during a running simulation (was causing visible flicker
  // on a long OT list). The trip progress bar uses a separate narrow selector
  // instead (see <TripProgressFromSim />). Only fields that really affect the
  // row rendering are compared.
  // Para Move Express precisamos das viaturas "disabled" também (as 106
  // cisternas reboque vêm como disabled do EcooGPS — sem GPS individual).
  // Sem isto o sub-selector de cisterna no Atribuir Veículo aparece vazio.
  const allVehicles = useSelector(selectAllVehicles);
  useEffect(() => {
    if (token && isMoveExpressTenant(clientExternalId, clientSettings)) {
      dispatch(fetchAllVehicles(token));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, clientExternalId]);
  const vehicles = useSelector(
    selectVehicles,
    (prev, next) => {
      if (prev === next) return true;
      if (!Array.isArray(prev) || !Array.isArray(next)) return false;
      if (prev.length !== next.length) return false;
      for (let i = 0; i < prev.length; i++) {
        const a = prev[i]; const b = next[i];
        if (a === b) continue;
        if (a.id !== b.id) return false;
        if (a.plate !== b.plate) return false;
        if (a.name !== b.name) return false;
        if (a.type !== b.type) return false;
        if (a.driverName !== b.driverName) return false;
        if (a.fuelType !== b.fuelType) return false;
        if (a.fuelPer100km !== b.fuelPer100km) return false;
        // Only care about coarse position changes (e.g. moved significantly)
        const ap = a.position?.latitude; const an = b.position?.latitude;
        const bp = a.position?.longitude; const bn = b.position?.longitude;
        if (Math.abs((ap || 0) - (an || 0)) > 0.001) return false;
        if (Math.abs((bp || 0) - (bn || 0)) > 0.001) return false;
      }
      return true;
    }
  );
  const allDrivers = useSelector(selectDrivers);
  const allLocations = useSelector(selectLocations);
  const replanReturnLiveOTId = useSelector((s) => s.routes.current.replanReturnLiveOTId);
  const activeView = useSelector((s) => s.ui.activeView);
  // Pais de operação do tenant. 'ao' = Petrotec Angola (tem oficina/base
  // central — garagem entra como tenantBase). 'pt' (default) = todos os
  // outros tenants → comportamento original onde o GPS do veículo ganha
  // sobre garage no modo "Auto" do dispatch.
  const { operationOrigin, pendingOrderTimelineId } = useSelector(selectUI);
  const [phonePreviewRoute, setPhonePreviewRoute] = useState(null);
  // Driver PDF preview — same dialog as the planner's "Acções > PDF Motorista"
  // but launched per-OT from the Orders table. Holds the route record fetched
  // for the OT (consolidated routes naturally include all sibling OTs in the
  // route's stops/waypoints, so the preview reflects the joint dispatch).
  const [pdfPreviewRoute, setPdfPreviewRoute] = useState(null);
  const [pdfPreviewMeta, setPdfPreviewMeta] = useState({ vehiclePlate: '', driverName: '' });
  // Fetch client locations once — we need them to resolve the "departure"
  // favourite when creating routes from fuel-distribution OTs.
  useEffect(() => {
    if (token && (!allLocations || allLocations.length === 0)) {
      dispatch(fetchLocations(token));
    }
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps
  const sort = useSelector((state) => state.transportOrders.sort);

  const [selected, setSelected] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  // Wizard dedicado para OTs de combustível (Move Express). Vive
  // separado do OrderForm para não tocar nos fluxos existentes.
  const [fuelWizardOpen, setFuelWizardOpen] = useState(false);
  // Consulta (read-only) do wizard de combustível — usado quando a OT já está
  // entregue/concluída e não pode ser editada.
  const [fuelWizardViewOnly, setFuelWizardViewOnly] = useState(false);
  // Dialog temporário "Dashboard em desenvolvimento" — escondido até
  // a feature ser validada pelo cliente.
  const [dashboardWipOpen, setDashboardWipOpen] = useState(false);
  const [editOrder, setEditOrder] = useState(null);
  const [searchInput, setSearchInput] = useState('');
  const tableWrapRef = useRef(null);
  // Quick filter presets — mutually exclusive, sit above the existing filter bar
  const [quickFilter, setQuickFilter] = useState(null); // 'today' | 'inTransit' | 'delayed' | 'noVehicle' | 'urgent' | 'custom' | null
  // Filtro por fase da cronologia (só OT combustível). null = todas as fases.
  const [fuelStageFilter, setFuelStageFilter] = useState(null);
  // Card expansível de pesquisa por fase (fechado por defeito).
  const [fuelStagePanelOpen, setFuelStagePanelOpen] = useState(false);
  const [dateRangeAnchor, setDateRangeAnchor] = useState(null);
  const [customDateFrom, setCustomDateFrom] = useState('');
  const [customDateTo, setCustomDateTo] = useState('');
  const [counts, setCounts] = useState({ total: 0, today: 0, inTransit: 0, noVehicle: 0, urgent: 0, delayed: 0 });
  // Row expand — inline details panel under the clicked OT
  const [expandedOrderId, setExpandedOrderId] = useState(null);

  // Deep-link vindo da popup do veículo (clicar no card da rota): filtra a lista
  // pela OT (garante que aparece mesmo com paginação), expande-a (abre a
  // cronologia) e faz scroll até à linha. Consome o pedido e limpa-o.
  useEffect(() => {
    const p = pendingOrderTimelineId;
    if (p == null) return;
    const id = (p && typeof p === 'object') ? p.id : p;
    const on = (p && typeof p === 'object') ? p.orderNumber : null;
    if (on) setSearchInput(String(on)); // filtra → OT visível
    if (id != null) setExpandedOrderId(id);
    dispatch(setPendingOrderTimelineId(null));
    setTimeout(() => {
      const el = id != null ? document.querySelector(`[data-ot-id="${id}"]`) : null;
      if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 600);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingOrderTimelineId]);

  // Tick de 1Hz para o contador "Em serviço" no selo da linha compacta
  // e na cronologia expandida. Só corre quando há pelo menos uma OT em
  // execução de serviço (arrivedAt + serviceStartedAt + ainda não
  // concluída) — evita re-render desnecessário noutros estados.
  const [serviceNow, setServiceNow] = useState(() => Date.now());
  const anyOTInService = (list || []).some(o =>
    o.serviceType !== 'fuel'
    && o.assistanceReport?.arrivedAt
    && o.assistanceReport?.serviceStartedAt
    && o.status !== 'delivered'
    && !o.assistanceReport?.completedAt
  );
  useEffect(() => {
    if (!anyOTInService) return undefined;
    const id = setInterval(() => setServiceNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [anyOTInService]);

  // Tick de 60s para os chips de SLA (tempo restante / vencido). Não
  // precisamos de 1Hz — SLA é em horas. Corre só quando há pelo menos
  // uma OT com slaHours definido e ainda não chegou ao destino.
  const [slaNow, setSlaNow] = useState(() => Date.now());
  const anyOTWithLiveSla = (list || []).some(o =>
    o.slaHours != null
    && !o.assistanceReport?.arrivedAt
    && o.status !== 'delivered'
    && o.status !== 'cancelled'
  );
  useEffect(() => {
    if (!anyOTWithLiveSla) return undefined;
    const id = setInterval(() => setSlaNow(Date.now()), 60_000);
    return () => clearInterval(id);
  }, [anyOTWithLiveSla]);

  // Dashboard SLA — KPIs servidor (atravessa todas as páginas e inclui
  // % cumprimento 30d). Fetch on-mount e quando WS dispara sla:alert.
  // SALTADO para clientes SÓ de combustível (ex.: Move Express): não usam SLA,
  // por isso poupamos o pedido + o polling de 60s + o processamento ao entrar.
  const [slaDashboard, setSlaDashboard] = useState(null);
  useEffect(() => {
    if (!token || onlyFuelOrders) return undefined;
    let cancelled = false;
    const load = async () => {
      try {
        const r = await fetch('/planner-api/reports/sla-dashboard', {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!r.ok) return;
        const data = await r.json();
        if (!cancelled) setSlaDashboard(data);
      } catch { /* swallow */ }
    };
    load();
    const id = setInterval(load, 60_000);
    const onSlaWs = () => load();
    const sock = require('../../utils/websocket').getSocket?.();
    sock?.on('sla:alert', onSlaWs);
    return () => {
      cancelled = true;
      clearInterval(id);
      sock?.off('sla:alert', onSlaWs);
    };
  }, [token, onlyFuelOrders]);

  // Counts de SLA "em risco" e "vencidos" sobre a lista actual (página
  // visível). Re-calcula a cada tick de 60s OU quando a lista muda.
  // NOTA: para pesquisa server-side (todas as páginas), passar para o
  // backend numa fase seguinte (Sprint E — dashboard).
  const slaCounts = useMemo(() => {
    // Clientes só de combustível não usam SLA — evita percorrer a lista.
    if (onlyFuelOrders) return { atRisk: 0, overdue: 0 };
    let atRisk = 0, overdue = 0;
    for (const o of (list || [])) {
      // Conta a OT como at-risk/overdue se QUALQUER um dos dois SLAs
      // (Resposta ou Resolução) estiver nesses estados — assim os
      // filtros e contadores cobrem ambos os tempos contratuais.
      const sR = slaCountdown(o, slaNow);
      const sT = slaResolutionCountdown(o, slaNow);
      const isOverdue = (sR && !sR.stopped && sR.status === 'overdue')
        || (sT && !sT.stopped && sT.status === 'overdue');
      const isAtRisk = (sR && !sR.stopped && (sR.status === 'critical' || sR.status === 'warning'))
        || (sT && !sT.stopped && (sT.status === 'critical' || sT.status === 'warning'));
      if (isOverdue) overdue++;
      else if (isAtRisk) atRisk++;
    }
    return { atRisk, overdue };
  }, [list, slaNow, onlyFuelOrders]);

  // Filtragem client-side por SLA — aplicada antes do render quando o
  // operador clica num dos chips SLA. Os outros quickFilter chips são
  // server-side (já passam por setFilters do Redux).
  const displayedList = useMemo(() => {
    let out;
    // Fuel chip — filtra OTs de distribuição combustível
    if (quickFilter === 'fuelOnly') {
      out = (list || []).filter(o => o.serviceType === 'fuel');
    } else if (quickFilter === 'slaAtRisk' || quickFilter === 'slaOverdue') {
      out = (list || []).filter(o => {
        const sR = slaCountdown(o, slaNow);
        const sT = slaResolutionCountdown(o, slaNow);
        const match = (s, target) => s && !s.stopped && (
          target === 'slaOverdue'
            ? s.status === 'overdue'
            : (s.status === 'critical' || s.status === 'warning')
        );
        return match(sR, quickFilter) || match(sT, quickFilter);
      });
    } else {
      out = list || [];
    }
    // Filtro por fase da cronologia (client-side, só toca OT de combustível).
    if (fuelStageFilter) {
      out = out.filter(o => o.serviceType === 'fuel' && fuelStageBucket(o.fuelStage) === fuelStageFilter);
    }
    return out;
  }, [list, slaNow, quickFilter, fuelStageFilter]);

  // Mapa otId → observações (notes, sem o sufixo interno "· Cliente: X") — para
  // o PDF do motorista mostrar as observações por OT/paragem via lookup.
  const otNotesById = useMemo(() => {
    const m = {};
    for (const o of (list || [])) {
      const obs = String(o.notes || '').replace(/\s*·?\s*Cliente:.*$/i, '').trim();
      if (obs) m[String(o.id)] = obs;
    }
    return m;
  }, [list]);

  // Fila de chips por fase da cronologia — só no contexto de combustível
  // (Move Express, ou com o filtro "Combustível" activo). Contagens por
  // bucket sobre as OT fuel actualmente na lista (já filtradas server-side).
  const fuelOrders = useMemo(() => (list || []).filter(o => o.serviceType === 'fuel'), [list]);
  const fuelStageCounts = useMemo(() => {
    const c = {};
    for (const o of fuelOrders) { const k = fuelStageBucket(o.fuelStage); c[k] = (c[k] || 0) + 1; }
    return c;
  }, [fuelOrders]);
  const fuelStageContext = isMoveExpressTenant(clientExternalId, clientSettings) || quickFilter === 'fuelOnly';
  // Ao sair do contexto combustível, limpa o filtro de fase para não
  // esconder OTs de outros tipos sem querer.
  useEffect(() => {
    if (!fuelStageContext && fuelStageFilter) setFuelStageFilter(null);
  }, [fuelStageContext, fuelStageFilter]);
  const [viewMode, setViewMode] = useState(() => {
    const stored = localStorage.getItem('ordersView.viewMode');
    // Operators who had `operations` selected before the button was removed
    // would otherwise be stuck on a now-orphaned view. Migrate silently.
    if (stored === 'operations') return 'table';
    return stored || 'table';
  });
  useEffect(() => { localStorage.setItem('ordersView.viewMode', viewMode); }, [viewMode]);
  const [contactOrder, setContactOrder] = useState(null); // OT being contacted via dialog
  const [bulkDeleteConfirm, setBulkDeleteConfirm] = useState(false); // styled confirmation for bulk delete
  const [removeFromRouteOT, setRemoveFromRouteOT] = useState(null); // OT pendente de confirmação para "Retirar da rota"
  const [rowMenuAnchor, setRowMenuAnchor] = useState(null); // { el, order, oid, status, hasRoute, hasVehicle }
  const [laborDialog, setLaborDialog] = useState(null); // { orderId, orderRef } | null
  // Petrotec AO — popup informativo "Enviar para Primavera" (Fase D pendente).
  // Guarda o orderId da OT clicada para o ConfirmDialog identificar.
  const [primaveraInfoOTId, setPrimaveraInfoOTId] = useState(null);
  const [driverDraft, setDriverDraft] = useState(null);   // in-memory contact draft for the vehicle being assigned
  const [manualDriverId, setManualDriverId] = useState(''); // manually picked driver when vehicle has none
  const [driverPickerSearch, setDriverPickerSearch] = useState('');
  const [driverPickerAnchor, setDriverPickerAnchor] = useState(null); // DOM element for Popover
  const driverPickerOpen = Boolean(driverPickerAnchor);
  // ─── Popup "Confirmar morada do motorista" ──────────────────────
  // Aparece quando o operador escolhe (ou o auto-select pega) um motorista
  // SEM homeLat/homeLng. Pré-preenche com o `address` do EcooGPS (ou
  // homeAddress local, se houver) e usa Google Places para escolher a
  // morada exacta — daí saem lat/lng que gravamos via /drivers/upsert.
  // Não bloqueia o diálogo de atribuir veículo (é overlay).
  const [addressPromptDriver, setAddressPromptDriver] = useState(null);
  const [addressPromptInput, setAddressPromptInput] = useState('');
  const [addressPromptSuggestions, setAddressPromptSuggestions] = useState([]);
  const [addressPromptSelected, setAddressPromptSelected] = useState(null); // { address, lat, lng, placeId }
  const [addressPromptSaving, setAddressPromptSaving] = useState(false);
  const addressPromptShownForRef = useRef(new Set()); // ids de motoristas a que já mostrámos popup nesta sessão de dialogo
  // ─── Departure / Arrival pickers in the assign-vehicle dialog ───
  // Both stored as opaque strings so the same field handles favourites,
  // the OT's service location and the assigned driver's home.
  // Conventions:
  //   '' (empty)     → default behaviour (see below per OT type)
  //   'service'      → the OT's service location (assistance: delivery point)
  //   'driver-home'  → the manually-picked driver's home
  //   '<numeric id>' → a ClientLocation favourite
  // Defaults:
  //   delivery / fuel  · partida='', chegada=''  (no overrides)
  //   assistance       · partida=''  (= 'service' implicit), chegada='' or
  //                      'driver-home' if the OT has returnHome=true
  // The ResetEffect below re-applies these defaults whenever the dialog
  // opens for a new OT.
  const [customDepartureLocationId, setCustomDepartureLocationId] = useState('');
  const [customArrivalLocationId, setCustomArrivalLocationId] = useState('');
  // Pesquisa dentro dos dropdowns de favoritos (partida/chegada) — os
  // favoritos vão crescer, por isso é preciso filtrar.
  const [depFavQuery, setDepFavQuery] = useState('');
  const [arrFavQuery, setArrFavQuery] = useState('');

  // Driver suggestions — populated when assign-vehicle dialog opens. Read-only
  // hints; the operator can still pick anyone from the manual picker.
  const [driverSuggestions, setDriverSuggestions] = useState([]);
  const [driverSuggestionsLoading, setDriverSuggestionsLoading] = useState(false);
  // Collapsed by default — once a vehicle is selected the driver-edit panel
  // would otherwise dominate the dialog and push the vehicle list out of view.
  const [driverPanelExpanded, setDriverPanelExpanded] = useState(false);
  const [bulkAssignMode, setBulkAssignMode] = useState(false); // true when assigning vehicle to multiple OTs
  // Order ID whose delivery report is being viewed (popup with photos +
  // signature). Set by clicking the "ver relatório" button in the actions
  // cell of delivered orders.
  const [reportOrderId, setReportOrderId] = useState(null);
  // Persistent UI preferences
  // Default 'compact' sempre que o operador entra no ecrã de Ordens —
  // pedido explícito do utilizador, ignora preferência anterior em
  // localStorage. Durante a sessão pode alternar para 'comfortable',
  // mas ao sair e voltar volta a 'compact'.
  // Dois modos de apresentação das Ordens:
  //   'compact' — tabela densa (default)
  //   'cards'   — um card por OT (cronologia + carga + viatura/motorista/nota)
  // O antigo 'comfortable'/'spacious' foi substituído pelos cards.
  const [density, setDensity] = useState(() => {
    try {
      const d = localStorage.getItem('ordersView.density');
      return (d === 'cards' || d === 'spacious') ? 'cards' : 'compact';
    } catch { return 'compact'; }
  });
  useEffect(() => { localStorage.setItem('ordersView.density', density); }, [density]);
  // Shortcuts help overlay
  const [showShortcuts, setShowShortcuts] = useState(false);
  const searchInputRef = useRef(null);

  // Horizontal drag for the split between list and map inside the dialog
  const handleVehicleSplitDragStart = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!vehicleDragRef.current) return;
    const rect = vehicleDragRef.current.getBoundingClientRect();
    const dialogLeft = rect.left;
    const dialogWidth = rect.width;
    const onMove = (ev) => {
      const newLeft = ev.clientX - dialogLeft;
      // Clamp: min 320 (list), min 400 for map on the right
      const clamped = Math.max(320, Math.min(dialogWidth - 400, newLeft));
      setVehicleSplitLeftPx(clamped);
    };
    const onUp = () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
    };
    document.body.style.userSelect = 'none';
    document.body.style.cursor = 'ew-resize';
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  }, []);

  // Drag behaviour for the vehicle assign dialog (so it doesn't block the header)
  const handleVehicleDialogDragStart = useCallback((e) => {
    if (!vehicleDragRef.current) return;
    const rect = vehicleDragRef.current.getBoundingClientRect();
    const offsetX = e.clientX - rect.left;
    const offsetY = e.clientY - rect.top;
    const onMove = (ev) => {
      setVehicleDialogPos({
        left: Math.max(8, Math.min(window.innerWidth - 200, ev.clientX - offsetX)),
        top: Math.max(8, Math.min(window.innerHeight - 100, ev.clientY - offsetY)),
      });
    };
    const onUp = () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
      document.body.style.userSelect = '';
    };
    document.body.style.userSelect = 'none';
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  }, []);

  // Restore scroll position when returning from Routes Library (or any other view)
  useEffect(() => {
    if (!tableWrapRef.current) return;
    const saved = Number(window.__ordersScrollY || 0);
    if (saved > 0) {
      // Restore on next tick so the list has rendered
      requestAnimationFrame(() => {
        if (tableWrapRef.current) tableWrapRef.current.scrollTop = saved;
        window.__ordersScrollY = 0;
      });
    }
  }, []);

  // Auto-refresh on WS events is OFF on this screen — the operator was
  // seeing the table flicker every few seconds (debounced fetch + Redux
  // re-render). For real-time tracking the operator should open the live
  // panel of a specific OT; here a manual refresh button is enough. We keep
  // a light "stale" indicator that lights up when WS fires, hinting that
  // pressing refresh will pull new data.
  const [staleHint, setStaleHint] = useState(false);
  // Bumps each time a new WS event arrives. Used as a React `key` on the
  // refresh button so the CSS pulse animation re-triggers (3 cycles) on
  // every update, even when staleHint was already true.
  const [stalePulseKey, setStalePulseKey] = useState(0);
  // Janela para SUPRIMIR o auto-piscar: quando é o PRÓPRIO operador a agir (o
  // painel já atualiza a lista via refreshOrders), o WS transmite a mudança de
  // volta a este cliente e faria o botão piscar à toa. Ignoramos o
  // `ordersNeedRefresh` que chega logo a seguir (~3s). Continua a piscar quando
  // a mudança vem de OUTRO operador/motorista (fora da janela).
  const staleSuppressUntil = useRef(0);
  useEffect(() => {
    function onWS() {
      if (Date.now() < staleSuppressUntil.current) return; // ação própria → não pisca
      setStaleHint(true);
      setStalePulseKey(k => k + 1);
    }
    window.addEventListener('ordersNeedRefresh', onWS);
    return () => window.removeEventListener('ordersNeedRefresh', onWS);
  }, []);
  const refreshOrders = useCallback(() => {
    if (!token) return;
    dispatch(fetchOrders({ token, page: pagination.page, limit: pagination.limit, filters, sort }));
    setStaleHint(false);
    staleSuppressUntil.current = Date.now() + 3000;
  }, [dispatch, token, pagination.page, pagination.limit, filters, sort]);

  // Despacho rápido (Casais/mercadoria): envia a rota (draft) de uma OT
  // automática para a app do motorista. Usa o endpoint dedicado do import.
  const [quickDispatchOT, setQuickDispatchOT] = useState(null); // { ot } | null
  const [quickDispatchAlert, setQuickDispatchAlert] = useState(null); // string | null
  const [quickDispatchBusy, setQuickDispatchBusy] = useState(false);
  async function doQuickDispatch(ot) {
    if (!ot) return;
    setQuickDispatchBusy(true);
    try {
      const r = await fetch(`/planner-api/casais-import/dispatch-ot/${ot.id || ot._id}`, {
        method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`);
      setQuickDispatchOT(null);
      setQuickDispatchAlert(lang === 'pt' ? `Rota despachada para a app (${ot.orderNumber || 'OT'}).` : 'Route dispatched.');
      refreshOrders();
    } catch (e) {
      setQuickDispatchOT(null);
      setQuickDispatchAlert((lang === 'pt' ? 'Falha ao despachar: ' : 'Dispatch failed: ') + (e.message || ''));
    } finally { setQuickDispatchBusy(false); }
  }

  // Auto delay toast — fires ONCE per OT per session to avoid spam.
  // Uses a ref-keyed by OT id so even when the ETA recalculates, we don't re-toast.
  // The operator sees the delta in the Execução column regardless.
  const toastedDelaysRef = useRef(new Set());
  useEffect(() => {
    if (!list.length) return;
    // Helper: format minutes as "Xh YYmin" for readability
    const fmtDelay = (min) => {
      const abs = Math.abs(Math.round(min));
      if (abs < 60) return `${abs} min`;
      const h = Math.floor(abs / 60);
      const m = abs % 60;
      return m > 0 ? `${h}h ${String(m).padStart(2, '0')}min` : `${h}h`;
    };
    list.forEach(o => {
      if (o.status !== 'in_transit') return;
      if (!o.estimatedArrival || !o.deliveryWindowTo) return;
      const id = o.id || o._id;
      if (toastedDelaysRef.current.has(id)) return;
      const diffMin = Math.round(
        (new Date(o.estimatedArrival).getTime() - new Date(o.deliveryWindowTo).getTime()) / 60000
      );
      // Only toast for meaningful delays — ignore < 5 min and unrealistic > 12h
      if (diffMin > 5 && diffMin < 720) {
        toastedDelaysRef.current.add(id);
        dispatch(addToast({
          type: 'delay',
          severity: 'warning',
          message: `OT ${otLabel(o) || id} vai atrasar ${fmtDelay(diffMin)}`,
          detail: `${o.vehiclePlate || '—'} · ${(o.deliveryName || o.deliveryAddress || '').split(',')[0]}`,
        }));
      }
    });
  }, [list, dispatch]);

  // Hydrate sort preference from localStorage once on mount
  useEffect(() => {
    try {
      const saved = localStorage.getItem('ordersView.sort');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (parsed && (parsed.field || Array.isArray(parsed.columns))) {
          dispatch(setSort(parsed));
        }
      }
      const qf = localStorage.getItem('ordersView.quickFilter');
      if (qf && qf !== 'null') setQuickFilter(qf);
    } catch {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Persist sort whenever it changes
  useEffect(() => {
    try { localStorage.setItem('ordersView.sort', JSON.stringify(sort)); } catch {}
  }, [sort]);

  // Persist quickFilter
  useEffect(() => {
    try { localStorage.setItem('ordersView.quickFilter', quickFilter || ''); } catch {}
  }, [quickFilter]);

  // Auto-refresh ETAs for in-transit OTs whenever vehicle positions change.
  // The vehicles array is fed by the WS/Traccar polling. We recompute only for
  // orders whose last known ETA is older than 60s OR whose vehicle moved ≥ 500m.
  const lastEtaComputeRef = useRef({});
  // Enquanto o operador tem um popup aberto num painel (ex.: cronologia de
  // combustível), NÃO fazemos o auto-refresh de ETAs — senão o fetchOrders
  // muda a lista por baixo dele. O FuelOTPanel avisa via onInteractingChange.
  const panelInteractingRef = useRef(false);
  const setPanelInteracting = useCallback((v) => { panelInteractingRef.current = !!v; }, []);
  useEffect(() => {
    if (!token || !vehicles.length || !list.length) return;
    if (panelInteractingRef.current) return; // popup aberto → não mexer na lista
    const now = Date.now();
    const toUpdate = [];
    list.forEach(o => {
      if (o.status !== 'in_transit' || !o.vehicleId || !o.assignedRouteId) return;
      const v = vehicles.find(x => x.id === o.vehicleId || String(x.id) === String(o.vehicleId));
      if (!v?.position) return;
      const destLat = Number(o.deliveryLat || o.delivery?.lat);
      const destLng = Number(o.deliveryLng || o.delivery?.lng);
      if (!destLat || !destLng) return;
      const prev = lastEtaComputeRef.current[o.id] || { at: 0, lat: 0, lng: 0 };
      const R = 6371;
      const dLat = (destLat - v.position.latitude) * Math.PI / 180;
      const dLng = (destLng - v.position.longitude) * Math.PI / 180;
      const a = Math.sin(dLat / 2) ** 2 + Math.cos(v.position.latitude * Math.PI / 180) * Math.cos(destLat * Math.PI / 180) * Math.sin(dLng / 2) ** 2;
      const remainKm = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      // Distance from previous compute to current position — skip if < 500m and < 60s
      const dPrev = Math.hypot(v.position.latitude - prev.lat, v.position.longitude - prev.lng);
      const movedEnough = dPrev > 0.0045; // ~500m
      const staleEnough = now - prev.at > 60000;
      if (!movedEnough && !staleEnough) return;
      const remainMin = Math.round(remainKm / 1.1); // ~66 km/h avg
      const newEta = new Date(now + remainMin * 60000).toISOString();
      lastEtaComputeRef.current[o.id] = { at: now, lat: v.position.latitude, lng: v.position.longitude };
      toUpdate.push({ id: o.id, body: { estimatedArrival: newEta, distanceKm: Math.round(remainKm), drivingTimeMin: remainMin } });
    });
    if (toUpdate.length === 0) return;
    Promise.all(toUpdate.map(u =>
      fetch(`/planner-api/transport-orders/${u.id}`, {
        method: 'PATCH',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(u.body),
      }).catch(() => {})
    )).then(() => {
      // Light refresh without full page reload
      dispatch(fetchOrders({ token, page: pagination.page, limit: pagination.limit, filters, sort }));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicles, list.length]);

  // Fetch counts for the quick filter chips
  const fetchCounts = useCallback(async () => {
    if (!token) return;
    try {
      const res = await fetch('/planner-api/transport-orders/counts', {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) setCounts(await res.json());
    } catch {}
  }, [token]);

  useEffect(() => { fetchCounts(); }, [fetchCounts, list.length]);

  // Apply a quick filter preset — translates the chip click into backend filter params
  const applyQuickFilter = useCallback((preset) => {
    const next = quickFilter === preset ? null : preset;
    setQuickFilter(next);
    if (!next) {
      dispatch(setFilters({ status: '', priority: '', deliveryFrom: '', deliveryTo: '', noVehicle: false, delayed: false }));
      return;
    }
    const base = { status: '', priority: '', deliveryFrom: '', deliveryTo: '', noVehicle: false, delayed: false };
    if (preset === 'today') {
      const s = new Date(); s.setHours(0, 0, 0, 0);
      const e = new Date(); e.setHours(23, 59, 59, 999);
      dispatch(setFilters({ ...base, deliveryFrom: s.toISOString(), deliveryTo: e.toISOString() }));
    } else if (preset === 'inTransit') {
      dispatch(setFilters({ ...base, status: 'in_transit' }));
    } else if (preset === 'delayed') {
      dispatch(setFilters({ ...base, delayed: true }));
    } else if (preset === 'noVehicle') {
      dispatch(setFilters({ ...base, noVehicle: true }));
    } else if (preset === 'urgent') {
      dispatch(setFilters({ ...base, priority: '1' }));
    } else if (preset === 'slaAtRisk' || preset === 'slaOverdue' || preset === 'fuelOnly') {
      // Filtros SLA + fuel são CLIENT-SIDE — actuam sobre a lista já carregada.
      // Limpamos filtros server-side para garantir lista mais ampla.
      dispatch(setFilters(base));
    }
  }, [dispatch, quickFilter]);

  const applyCustomDateRange = useCallback(() => {
    if (!customDateFrom && !customDateTo) {
      // Both empty — clear
      setQuickFilter(null);
      dispatch(setFilters({ status: '', priority: '', deliveryFrom: '', deliveryTo: '', noVehicle: false, delayed: false }));
      setDateRangeAnchor(null);
      return;
    }
    const base = { status: '', priority: '', deliveryFrom: '', deliveryTo: '', noVehicle: false, delayed: false };
    const fromIso = customDateFrom ? new Date(customDateFrom + 'T00:00:00').toISOString() : '';
    const toIso = customDateTo ? new Date(customDateTo + 'T23:59:59').toISOString() : '';
    setQuickFilter('custom');
    dispatch(setFilters({ ...base, deliveryFrom: fromIso, deliveryTo: toIso }));
    setDateRangeAnchor(null);
  }, [dispatch, customDateFrom, customDateTo]);

  const clearCustomDateRange = useCallback(() => {
    setCustomDateFrom('');
    setCustomDateTo('');
    setQuickFilter(null);
    dispatch(setFilters({ status: '', priority: '', deliveryFrom: '', deliveryTo: '', noVehicle: false, delayed: false }));
  }, [dispatch]);

  const doFetch = useCallback(() => {
    if (!token) return;
    dispatch(fetchOrders({ token, page: pagination.page, limit: pagination.limit, filters, sort }));
  }, [dispatch, token, pagination.page, pagination.limit, filters, sort]);

  useEffect(() => { doFetch(); }, [doFetch]);

  // Debounced search
  useEffect(() => {
    const t = setTimeout(() => {
      dispatch(setFilters({ search: searchInput }));
    }, 400);
    return () => clearTimeout(t);
  }, [searchInput, dispatch]);

  function handleStatusFilter(status) {
    // Multi-select: o filtro guarda uma lista separada por vírgulas
    // (ex: "pending,assigned"). Click toggles o estado in/out da lista.
    // Click em "Todas" (status sem valor) limpa tudo. Se o operador
    // remover o último estado seleccionado, o filtro fica vazio e
    // mostra todas as ordens.
    const current = filters.status
      ? filters.status.split(',').filter(Boolean)
      : [];
    let next;
    if (current.includes(status)) {
      next = current.filter(s => s !== status);
    } else {
      next = [...current, status];
    }
    dispatch(setFilters({ status: next.join(',') }));
  }

  function handleSortChange(e) {
    const val = e.target.value;
    const map = {
      date: { field: 'createdAt', dir: 'desc', columns: [] },
      orderNumber: { field: 'orderNumber', dir: 'asc', columns: [] },
      priority: { field: 'priority', dir: 'desc', columns: [] },
    };
    dispatch(setSort(map[val] || map.date));
  }

  // Click-to-sort for column headers; Shift+click adds a secondary sort column
  function handleHeaderSort(field, event) {
    const isShift = event?.shiftKey;
    const currentCols = (sort.columns && sort.columns.length > 0)
      ? [...sort.columns]
      : [{ field: sort.field, dir: sort.dir }];

    if (isShift) {
      const existing = currentCols.find(c => c.field === field);
      if (existing) {
        existing.dir = existing.dir === 'asc' ? 'desc' : 'asc';
      } else {
        currentCols.push({ field, dir: 'asc' });
      }
      dispatch(setSort({ field: currentCols[0].field, dir: currentCols[0].dir, columns: currentCols }));
    } else {
      // Plain click — toggle direction if same field, else set new primary with asc
      const top = currentCols[0];
      const nextDir = top && top.field === field ? (top.dir === 'asc' ? 'desc' : 'asc') : 'asc';
      dispatch(setSort({ field, dir: nextDir, columns: [{ field, dir: nextDir }] }));
    }
  }

  function getSortDir(field) {
    if (sort.columns && sort.columns.length > 0) {
      const c = sort.columns.find(x => x.field === field);
      return c ? c.dir : false;
    }
    return sort.field === field ? sort.dir : false;
  }

  function getSortOrder(field) {
    if (!sort.columns || sort.columns.length < 2) return null;
    const idx = sort.columns.findIndex(x => x.field === field);
    return idx >= 0 ? idx + 1 : null;
  }

  const [deleteConfirmId, setDeleteConfirmId] = useState(null);
  // Modo "footprint": OT com histórico operacional — o diálogo passa a
  // oferecer Cancelar (soft) + purga só com confirmação de admin.
  const [deleteFootprintMode, setDeleteFootprintMode] = useState(false);
  const [deleteBusy, setDeleteBusy] = useState(false);
  const [showManageDrivers, setShowManageDrivers] = useState(false);
  // LiveRoutePanel — full-screen overlay opened by clicking the "live" icon
  // on an OT row. Holds the order plus its loaded route geometry. Co-exists
  // with the inline "manage" panel so the operator can keep their workflow.
  const [livePanelState, setLivePanelState] = useState(null); // { order, geometry }
  const [assignOrderId, setAssignOrderId] = useState(null);
  const [assignRouteId, setAssignRouteId] = useState('');
  const [savedRoutes, setSavedRoutes] = useState([]);
  const [assignWarning, setAssignWarning] = useState('');
  const [assignSearch, setAssignSearch] = useState('');
  const [assignStatusFilter, setAssignStatusFilter] = useState('all'); // all | draft | planned | in_progress | completed
  const [assignFreeOnly, setAssignFreeOnly] = useState(false); // only routes not yet dispatched
  const [assignLoading, setAssignLoading] = useState(false);
  // Draggable position of the assign-route dialog (null = default: horizontally centered, below header)
  const [assignDialogPos, setAssignDialogPos] = useState(null);
  const assignDragRef = useRef(null);
  const [vehicleAssignOrderId, setVehicleAssignOrderId] = useState(null);
  // Lightbox para ampliar assinaturas e fotos no painel expandido das OTs
  const [lightboxSrc, setLightboxSrc] = useState(null);
  // Tracks whether the operator made an explicit choice in the departure
  // dropdown — once true, automatic logic (driver home auto-fill) stops
  // overriding their choice. Reset on every dialog open.
  const [departureUserOverride, setDepartureUserOverride] = useState(false);
  const [vehicleAssignMapReady, setVehicleAssignMapReady] = useState(false);

  // Single consolidated effect for dialog-open setup. Reage também a
  // mudanças em clientSettings.defaultDepartureByOrderType e allLocations
  // porque o dialog pode abrir ANTES desses dados estarem hidratados — sem
  // re-correr, o `resolveDefaultDeparture` caía no fallback 'driver-home'
  // (caso prefs vazias) ou em '' (caso favorito ainda não carregado em
  // allLocations), e o operador acabava a ver "casa do motorista" em vez
  // da base que tinha configurado nas preferências (caso Petrotec AO).
  // Só re-aplica quando o operador AINDA não fez override manual.
  useEffect(() => {
    if (!vehicleAssignOrderId) {
      // Reset apenas quando o dialog fecha (vehicleAssignOrderId vai a null).
      setCustomDepartureLocationId('');
      setCustomArrivalLocationId('');
      setDepartureUserOverride(false);
      setVehicleAssignMapReady(false);
      return;
    }
    if (departureUserOverride) return;

    const ot = list.find(o => String(o._id || o.id) === String(vehicleAssignOrderId));
    if (!ot) return;

    // Apply per-type defaults that can be inferred *immediately* from the
    // OT (without depending on the operator's later interactions). For an
    // assistance OT that already has a driver assigned with a registered
    // home, pre-fill departure with the driver's home — and pre-fill
    // arrival with home too if the OT was created with returnHome=true.
    const assignedDriver = (ot.driverId && allDrivers.find(d => String(d.id) === String(ot.driverId))) || null;
    // Preferências do cliente (Preferências → Rotas → "Local de partida
    // por tipo de OT") decidem o default. Substitui a heurística antiga
    // "tenant tem garage = Petrotec AO".
    const resolvedDeparture = resolveDefaultDeparture(
      ot.serviceType,
      clientSettings,
      { driver: assignedDriver, allLocations },
    );
    if (resolvedDeparture) {
      setCustomDepartureLocationId(resolvedDeparture);
      if (ot.returnHome) setCustomArrivalLocationId(resolvedDeparture);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleAssignOrderId, clientSettings?.defaultDepartureByOrderType, allLocations?.length, departureUserOverride]);

  // Effect separado só para o timing do mapa — não tem nada a ver com o
  // local de partida, mas dependia do mesmo trigger antes. Separar evita
  // que mudanças em clientSettings/allLocations re-disparem o mapa.
  useEffect(() => {
    if (!vehicleAssignOrderId) return;
    const t = setTimeout(() => {
      requestAnimationFrame(() => requestAnimationFrame(() => {
        setVehicleAssignMapReady(true);
      }));
    }, 250);
    return () => clearTimeout(t);
  }, [vehicleAssignOrderId]);

  // Separate effect that reacts to manualDriverId changes (operator picked
  // a different driver in the dropdown). For assistance OTs without an
  // operator override, snap the departure to the new driver's home — or
  // the tenant garage when the driver has no registered home.
  useEffect(() => {
    if (!vehicleAssignOrderId) return;
    if (departureUserOverride) return;
    if (!manualDriverId) return;
    const ot = list.find(o => String(o._id || o.id) === String(vehicleAssignOrderId));
    if (ot?.serviceType !== 'assistance') return;
    const drv = allDrivers.find(d => String(d.id) === String(manualDriverId));
    // Reaplica a preferência do tenant agora que mudou o motorista —
    // o resolveDefaultDeparture lida com o caso "motorista sem morada"
    // automaticamente (cai em Auto). Isto evita o estado inconsistente
    // de mostrar 🏠 quando o novo motorista escolhido não tem morada.
    const resolvedDeparture = resolveDefaultDeparture(
      ot.serviceType,
      clientSettings,
      { driver: drv, allLocations },
    );
    setCustomDepartureLocationId(resolvedDeparture);
    if (ot.returnHome) setCustomArrivalLocationId(resolvedDeparture);

    // Centrar mapa na nova partida
    if (resolvedDeparture === 'driver-home' && drv?.homeLat && drv?.homeLng) {
      window.dispatchEvent(new CustomEvent('assignDialogFocusLocation', {
        detail: { lat: Number(drv.homeLat), lng: Number(drv.homeLng), name: `🏠 ${drv.name}` },
      }));
    } else if (resolvedDeparture && resolvedDeparture !== 'driver-home' && resolvedDeparture !== 'vehicle') {
      const fav = (allLocations || []).find(l => String(l.id) === String(resolvedDeparture));
      if (fav?.latitude && fav?.longitude) {
        window.dispatchEvent(new CustomEvent('assignDialogFocusLocation', {
          detail: { lat: Number(fav.latitude), lng: Number(fav.longitude), name: `📍 ${fav.name}` },
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manualDriverId, departureUserOverride]);
  const [availableVehicles, setAvailableVehicles] = useState([]);
  // Ref ao cartão do veículo seleccionado na lista esquerda do dialog
  // "Atribuir Veículo". Quando o operador escolhe um veículo no mapa
  // direito, este ref serve para fazer scrollIntoView e tornar visível
  // a selecção (a lista pode ter dezenas/centenas de veículos).
  const selectedVehicleRowRef = useRef(null);
  // Petrotec AO — stock por viatura no dialog de atribuição. Mapa:
  //   { [vehicleId]: { items: N, units: N, balances: [...] } }
  // Carregado em paralelo quando o dialog abre numa OT AO. Em OTs PT
  // fica `{}` e a UI nem renderiza os chips de stock.
  const [vehicleStockMap, setVehicleStockMap] = useState({});
  const [stockPopoverVehicleId, setStockPopoverVehicleId] = useState(null);
  const [stockPopoverAnchor, setStockPopoverAnchor] = useState(null);
  // OT scheduling context returned by the backend (window + estimated duration)
  const [otAvailContext, setOtAvailContext] = useState(null);
  // Draggable popup position — null = centered on open
  const [vehicleDialogPos, setVehicleDialogPos] = useState(null);
  const vehicleDragRef = useRef(null);
  // Split width between left (list) and right (map) panels of the assign
  // dialog. Default ~36% of the 1440px dialog (~520px). Big enough for the
  // list + suggestions + departure picker without crowding the map (which
  // needs space for the radius circle + vehicle markers). Operator can
  // drag the divider to fine-tune.
  const [vehicleSplitLeftPx, setVehicleSplitLeftPx] = useState(520);
  const [selectedVehicleId, setSelectedVehicleId] = useState('');
  // Cisterna atrelada — só usado em OTs fuel (Move Express).
  // null = sem cisterna escolhida (não bloqueia o assign, é opcional).
  const [selectedCisternIds, setSelectedCisternIds] = useState([]); // até 2 cisternas atreladas
  const [cisternSearch, setCisternSearch] = useState('');
  const [cisternPickerOpen, setCisternPickerOpen] = useState(false);
  const [unloadingTime, setUnloadingTime] = useState('');
  const [vehicleAssignWarning, setVehicleAssignWarning] = useState('');

  // Petrotec AO — fetch do stock para cada viatura quando o dialog abre
  // numa OT com `finalCustomerId` (modo AO). Paraleliza as chamadas — em
  // frotas pequenas é instantâneo. Em PT (OT sem finalCustomerId) não corre.
  useEffect(() => {
    if (!vehicleAssignOrderId || !token) { setVehicleStockMap({}); return; }
    const ot = list.find(o => String(o._id || o.id) === String(vehicleAssignOrderId));
    if (!ot?.finalCustomerId) { setVehicleStockMap({}); return; }
    if (availableVehicles.length === 0) return;
    let cancelled = false;
    (async () => {
      const headers = { Authorization: `Bearer ${token}` };
      const results = await Promise.all(availableVehicles.map(async (v) => {
        try {
          const r = await fetch(`/planner-api/vehicle-stock?vehicleId=${v.id}`, { headers });
          if (!r.ok) return [v.id, { items: 0, units: 0, balances: [] }];
          const data = await r.json();
          const bals = data.balances || [];
          return [v.id, {
            items: bals.length,
            units: bals.reduce((sum, b) => sum + (Number(b.quantity) || 0), 0),
            balances: bals,
          }];
        } catch { return [v.id, { items: 0, units: 0, balances: [] }]; }
      }));
      if (!cancelled) setVehicleStockMap(Object.fromEntries(results));
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleAssignOrderId, availableVehicles, token]);
  const [vehicleAssigning, setVehicleAssigning] = useState(false);
  // Defesa em profundidade — sempre que o ecrã de atribuição abre (novo
  // vehicleAssignOrderId), limpa qualquer estado de loading fantasma para
  // os botões não aparecerem como "..." vindos de uma operação anterior.
  useEffect(() => { if (vehicleAssignOrderId) setVehicleAssigning(false); }, [vehicleAssignOrderId]);
  const [vehicleSearch, setVehicleSearch] = useState('');
  const [vehicleFilterMode, setVehicleFilterMode] = useState('inside'); // 'inside' | 'tacho' | 'available' | 'all'
  // Controlled radius for the vehicle-assign dialog (shared between the left filter and the map)
  // Default 5 km — closer-fitted for assistance work (technicians usually
  // have the vehicle within walking distance of home). Operator can drag
  // the slider on the map to widen if no candidates show up.
  const [vehicleAssignRadiusKm, setVehicleAssignRadiusKm] = useState(5);
  // Fullscreen overlay of the vehicle-assign map. The card map is small,
  // so the operator gets a button to blow it up to full-screen for picking.
  const [mapFullscreenOpen, setMapFullscreenOpen] = useState(false);

  // Pick a vehicle in the assign-vehicle dialog. Always resets the
  // manual driver / draft / unloading time so the picker can auto-suggest
  // the new vehicle's bound driver — otherwise a previously assigned
  // driver (or one carried over from another vehicle) keeps shadowing
  // the auto-detected one. Toggling off (clicking the same vehicle
  // twice) deselects.
  const pickVehicleForAssign = useCallback((vehicleId) => {
    const next = String(vehicleId || '');
    setSelectedVehicleId(prev => {
      if (String(prev) === next) {
        // Deselected — clear all dependent state.
        setManualDriverId('');
        setDriverDraft(null);
        return '';
      }
      // New vehicle picked — clear manual override so the new vehicle's
      // auto-detected driver wins. Operator can still pick another driver
      // explicitly afterwards.
      setManualDriverId('');
      setDriverDraft(null);
      return next;
    });
  }, []);

  // Fuel: ao escolher um veículo no diálogo de atribuição, se o veículo
  // estiver FORA do raio à volta da BASE (parque do cliente), a partida muda
  // automaticamente para "Local atual do veículo"; dentro do raio mantém a
  // base (default). Só OT de combustível e só enquanto o operador não tiver
  // mudado a dropdown manualmente (departureUserOverride). Não inclui
  // vehicles/allLocations nas deps para não re-correr a cada polling de GPS —
  // usa o snapshot do momento em que o veículo é escolhido.
  useEffect(() => {
    if (!vehicleAssignOrderId || !selectedVehicleId) return;
    if (departureUserOverride) return;
    const ot = list.find(o => String(o._id || o.id) === String(vehicleAssignOrderId));
    if (ot?.serviceType !== 'fuel') return;
    const baseId = resolveDefaultDeparture('fuel', clientSettings, { allLocations });
    const base = (allLocations || []).find(l => String(l.id) === String(baseId));
    if (!base || base.latitude == null || base.longitude == null) return;
    const veh = (vehicles || []).find(v => String(v.id) === String(selectedVehicleId));
    const vLat = Number(veh?.position?.latitude);
    const vLng = Number(veh?.position?.longitude);
    if (!Number.isFinite(vLat) || !Number.isFinite(vLng) || (vLat === 0 && vLng === 0)) return;
    const km = haversineKm(
      { lat: Number(base.latitude), lng: Number(base.longitude) },
      { lat: vLat, lng: vLng },
    );
    setCustomDepartureLocationId(km > vehicleAssignRadiusKm ? 'vehicle' : String(base.id));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedVehicleId, vehicleAssignOrderId, departureUserOverride]);
  // Helper: o motorista precisa que o operador confirme a morada para
  // geocoding? Considera-se que sim sempre que não tenha homeLat/homeLng
  // (independentemente de ser local ou só do EcooGPS). Quando o operador
  // confirma, gravamos um registo local com lat/lng e o problema fica
  // resolvido para sempre para este motorista.
  //
  // Excepção: se o tenant tem pelo menos um favorito tipo 'garage' activo,
  // a base substitui a morada do motorista no despacho. Não vale a pena
  // estar a perguntar moradas que não vão ser usadas. Aplica-se a tenants
  // como Petrotec AO onde os técnicos arrancam todos da oficina central;
  // tenants sem garagem (todos os PT actuais) continuam a ver o popup.
  const needsAddressPrompt = useCallback((d) => {
    if (!d) return false;
    // Tenants que configuraram um favorito como default de partida em
    // assistência (Petrotec AO: oficina central) não precisam de morada
    // do motorista — o favorito é o ponto de partida. Em tenants que
    // usam 'driver-home' como default, sim precisamos da morada.
    const assistanceDefault = clientSettings?.defaultDepartureByOrderType?.assistance;
    if (assistanceDefault && assistanceDefault.startsWith('favorite:')) return false;
    const lat = Number(d.homeLat);
    const lng = Number(d.homeLng);
    return !Number.isFinite(lat) || !Number.isFinite(lng);
  }, [clientSettings]);
  // Abre o popup de confirmação de morada para um motorista (uma única vez
  // por motorista por sessão de diálogo — não fica a re-aparecer se o
  // operador cancelar).
  //
  // BAIL: só faz sentido para OTs de assistência (onde o motorista parte de
  // casa). Em delivery/fuel a partida vem do pickup da OT (depósito, base
  // tipo ZZE Viana da Move Express) ou de um favorito — a morada do
  // motorista nunca é usada nestes tipos.
  const maybePromptAddress = useCallback((d) => {
    if (!d) return;
    const activeOt = list?.find(o => String(o._id || o.id) === String(vehicleAssignOrderId));
    if (activeOt && activeOt.serviceType !== 'assistance') return;
    const key = String(d.id);
    if (addressPromptShownForRef.current.has(key)) return;
    if (!needsAddressPrompt(d)) return;
    addressPromptShownForRef.current.add(key);
    setAddressPromptDriver(d);
    setAddressPromptInput(d.homeAddress || d.address || '');
    setAddressPromptSelected(null);
    setAddressPromptSuggestions([]);
  }, [needsAddressPrompt, list, vehicleAssignOrderId]);
  // Limpa o tracking de "popups já mostradas" sempre que o diálogo de
  // atribuir veículo fecha — para reaparecerem na próxima vez se aplicável.
  useEffect(() => {
    if (!vehicleAssignOrderId) {
      addressPromptShownForRef.current = new Set();
    }
  }, [vehicleAssignOrderId]);
  // ─── Handlers da popup "Confirmar morada do motorista" ─────────
  // Mesmo padrão dos outros ecrans com pesquisa de morada:
  //   1) Google Places (rico — main/secondary text);
  //   2) Fallback geocodeSearchMulti (Mapbox + HERE + OSM) se o Google
  //      não devolver nada — cobertura para Angola, Moçambique, etc.
  // País vem do clientSettings (PT default) para enviesar os providers.
  // Cada sugestão fica num shape normalizado:
  //   { source, label, sub, placeId?, name?, coordinates? }
  const handleAddressPromptInput = useCallback(async (input) => {
    setAddressPromptInput(input);
    setAddressPromptSelected(null);
    if (!input || input.length < 3) { setAddressPromptSuggestions([]); return; }
    const country = clientSettings?.defaultCountry || 'PT';
    const merged = [];
    // 1. Google Places — primeiro (UX rica)
    try {
      if (window.google?.maps?.places?.AutocompleteSuggestion) {
        const { suggestions } = await window.google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions({ input });
        (suggestions || []).slice(0, 6).forEach(s => {
          const p = s.placePrediction;
          if (!p?.placeId) return;
          merged.push({
            source: 'google',
            label: p.mainText?.text || p.text?.text || '',
            sub: p.secondaryText?.text || '',
            placeId: p.placeId,
            name: p.text?.text || '',
          });
        });
      } else if (window.google?.maps?.places?.AutocompleteService) {
        const service = new window.google.maps.places.AutocompleteService();
        const predictions = await new Promise((resolve) => {
          service.getPlacePredictions({ input }, (preds, status) => {
            resolve(status === 'OK' && preds ? preds : []);
          });
        });
        predictions.slice(0, 6).forEach(p => {
          merged.push({
            source: 'google',
            label: p.structured_formatting?.main_text || p.description,
            sub: p.structured_formatting?.secondary_text || '',
            placeId: p.place_id,
            name: p.description,
          });
        });
      }
    } catch { /* ignore */ }
    // 2. Fallback Mapbox + HERE + OSM se o Google não trouxe nada
    if (merged.length === 0) {
      try {
        const geo = await geocodeSearchMulti(input, { country });
        geo.slice(0, 6).forEach(g => {
          const parts = (g.name || '').split(',');
          merged.push({
            source: g.source || 'osm',
            label: parts[0]?.trim() || g.name || '',
            sub: parts.slice(1).join(',').trim()
              || (g.source === 'osm' ? 'OpenStreetMap' : g.source === 'here' ? 'HERE Maps' : 'Mapbox'),
            name: g.name || '',
            coordinates: g.coordinates, // [lng, lat] do mapboxApi
          });
        });
      } catch { /* ignore */ }
    }
    setAddressPromptSuggestions(merged.slice(0, 8));
  }, [clientSettings]);
  const handleAddressPromptPick = useCallback(async (s) => {
    if (!s) return;
    // Provider 1 — Google Places: precisa de fetchFields para apanhar lat/lng.
    if (s.source === 'google' && s.placeId) {
      try {
        const place = new window.google.maps.places.Place({ id: s.placeId });
        await place.fetchFields({ fields: ['location', 'formattedAddress', 'displayName'] });
        const lat = typeof place.location?.lat === 'function' ? place.location.lat() : place.location?.lat;
        const lng = typeof place.location?.lng === 'function' ? place.location.lng() : place.location?.lng;
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
        const formatted = place.formattedAddress || s.name || '';
        setAddressPromptSelected({ address: formatted, lat: Number(lat), lng: Number(lng), placeId: s.placeId, source: 'google' });
        setAddressPromptInput(formatted);
        setAddressPromptSuggestions([]);
      } catch { /* ignore */ }
      return;
    }
    // Provider 2 — Mapbox / HERE / OSM: já trazem coordenadas no resultado.
    const coords = s.coordinates;
    if (Array.isArray(coords) && coords.length === 2
        && Number.isFinite(coords[0]) && Number.isFinite(coords[1])) {
      const lng = Number(coords[0]);
      const lat = Number(coords[1]);
      const name = s.name || s.label || '';
      setAddressPromptSelected({ address: name, lat, lng, source: s.source });
      setAddressPromptInput(name);
      setAddressPromptSuggestions([]);
    }
  }, []);
  const closeAddressPrompt = useCallback(() => {
    setAddressPromptDriver(null);
    setAddressPromptInput('');
    setAddressPromptSuggestions([]);
    setAddressPromptSelected(null);
    setAddressPromptSaving(false);
  }, []);
  const confirmAddressPrompt = useCallback(async () => {
    if (!addressPromptDriver || !addressPromptSelected || addressPromptSaving) return;
    const driver = addressPromptDriver;
    const sel = addressPromptSelected;
    setAddressPromptSaving(true);
    try {
      const res = await fetch('/planner-api/drivers/upsert', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          // Preserva a identidade do motorista (vem do EcooGPS ou local).
          externalId: driver.externalId || undefined,
          tachoCard: driver.tachoCard || undefined,
          name: driver.name,
          phone: driver.phone || undefined,
          licenseClass: driver.licenseClass || undefined,
          // Os campos novos com a geocodificação.
          homeAddress: sel.address,
          homeLat: sel.lat,
          homeLng: sel.lng,
        }),
      });
      if (!res.ok) {
        const j = await res.json().catch(() => ({}));
        throw new Error(j.error || 'Falha ao gravar a morada');
      }
      const { driver: saved } = await res.json();
      // Refresca a lista de motoristas e re-selecciona o local (agora com
      // homeLat/homeLng → o efeito existente snap-departure=home dispara).
      await dispatch(fetchDrivers(token));
      if (saved?.id != null) setManualDriverId(String(saved.id));
      closeAddressPrompt();
    } catch (e) {
      dispatch(addToast({
        severity: 'error',
        message: lang === 'pt'
          ? `Erro a gravar a morada: ${e.message || 'desconhecido'}`
          : `Failed to save address: ${e.message || 'unknown'}`,
      }));
      setAddressPromptSaving(false);
    }
  }, [addressPromptDriver, addressPromptSelected, addressPromptSaving, token, dispatch, lang, closeAddressPrompt]);
  // Ao escolher um veículo cujo motorista detectado (tacógrafo) coincide com
  // um motorista da NOSSA BD, pré-selecciona o da BD — disponibiliza a morada
  // dele para o "local de partida = casa" das assistências. Não sobrepõe uma
  // escolha manual já feita.
  useEffect(() => {
    // Scroll-to-view do veículo seleccionado na lista esquerda. RAF
    // para esperar que o DOM já tenha aplicado o `isSelected = true`.
    if (selectedVehicleId && selectedVehicleRowRef.current) {
      requestAnimationFrame(() => {
        selectedVehicleRowRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }
    if (!selectedVehicleId || manualDriverId) return;
    const v = availableVehicles.find(x => String(x.id) === String(selectedVehicleId));
    const detName = v?.driver?.name || v?.tacho?.driverName || '';
    if (!detName) return;
    const dbMatch = allDrivers.find(d => (d.name || '').trim().toLowerCase() === detName.trim().toLowerCase());
    if (dbMatch) {
      setManualDriverId(String(dbMatch.id));
      // Se o motorista auto-seleccionado ainda não tem coordenadas, pede ao
      // operador para as confirmar (foi exactamente para isto que o EcooGPS
      // começou a expor o `address` por motorista).
      maybePromptAddress(dbMatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedVehicleId, availableVehicles]);
  const [confirmDispatchData, setConfirmDispatchData] = useState(null);
  // Polished unassign confirmation. Stays inside the assign-vehicle dialog;
  // when the user confirms, the OT is unassigned in-place and the dialog
  // refreshes to the "no vehicle" state so the operator can pick a new one.
  const [unassignConfirm, setUnassignConfirm] = useState(null);
  const [unassignBusy, setUnassignBusy] = useState(false);
  async function executeUnassign() {
    if (!unassignConfirm?.orderId || unassignBusy) return;
    setUnassignBusy(true);
    try {
      await fetch(`/planner-api/transport-orders/${unassignConfirm.orderId}/unassign`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      doFetch();
      setSelectedVehicleId('');
      // Don't close the assign dialog — the operator wants to pick a new
      // vehicle right after, so we keep the same context open.
      setUnassignConfirm(null);
      dispatch(addToast({
        type: 'success',
        message: lang === 'pt' ? '✓ Atribuição removida — escolhe um novo veículo' : '✓ Assignment removed — pick a new vehicle',
      }));
    } catch (e) {
      console.error('Unassign error:', e);
      dispatch(addToast({
        type: 'error',
        message: lang === 'pt' ? 'Erro ao retirar atribuição' : 'Error removing assignment',
      }));
    }
    setUnassignBusy(false);
  }
  const [statusChangeConfirm, setStatusChangeConfirm] = useState(null);
  const [importDialog, setImportDialog] = useState(null); // 'excel' | 'api' | null // { orderId, newStatus, hasVehicle, hasDriver }
  const [importMenuAnchor, setImportMenuAnchor] = useState(null);
  const [showImportGuias, setShowImportGuias] = useState(false); // import de guias (Casais/mercadoria)
  const isMercadoriaVariant = clientSettings?.uiVariant === 'mercadoria';

  // Keyboard shortcuts — placed here so all state it closes over is already declared
  useEffect(() => {
    function onKey(e) {
      const tag = (e.target?.tagName || '').toLowerCase();
      const isTyping = tag === 'input' || tag === 'textarea' || tag === 'select' || e.target?.isContentEditable;
      if (isTyping && e.key !== 'Escape') return;
      if (e.key === 'Escape') {
        if (showShortcuts) { setShowShortcuts(false); return; }
        if (expandedOrderId) { setExpandedOrderId(null); return; }
        if (vehicleAssignOrderId) { setVehicleAssignOrderId(null); return; }
        if (contactOrder) { setContactOrder(null); return; }
        return;
      }
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      if (e.key === 'n' || e.key === 'N') {
        e.preventDefault();
        handleCreate();
      } else if (e.key === 'f' || e.key === 'F') {
        e.preventDefault();
        searchInputRef.current?.focus();
      } else if (e.key === '?') {
        e.preventDefault();
        setShowShortcuts(s => !s);
      } else if (e.key === 'g' || e.key === 'G') {
        e.preventDefault();
        setViewMode(m => m === 'gantt' ? 'table' : 'gantt');
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expandedOrderId, vehicleAssignOrderId, contactOrder, showShortcuts]);

  function handleDelete(id) {
    setDeleteConfirmId(id);
    // Estimativa client-side do footprint pelo estado da OT — o backend é
    // que decide de forma autoritária (409 OT_HAS_FOOTPRINT), mas isto
    // mostra logo o diálogo certo nos casos óbvios (em trânsito/entregue).
    const ot = list.find(o => (o._id || o.id) === id);
    const OPERATIONAL = ['in_transit', 'in_progress', 'delivered', 'completed'];
    setDeleteFootprintMode(OPERATIONAL.includes(ot?.status));
  }

  function closeDeleteDialog() {
    setDeleteConfirmId(null);
    setDeleteFootprintMode(false);
    setDeleteBusy(false);
  }

  // Purga total (force=true só quando o operador confirma no modo footprint).
  async function confirmDelete(force = false) {
    if (!deleteConfirmId || deleteBusy) return;
    setDeleteBusy(true);
    try {
      await dispatch(deleteOrder({ token, id: deleteConfirmId, force })).unwrap();
      dispatch(addToast({ severity: 'success', message: lang === 'pt' ? 'OT eliminada' : 'Order deleted' }));
      closeDeleteDialog();
    } catch (err) {
      if (err?.code === 'OT_HAS_FOOTPRINT') {
        // O backend confirmou que há rasto — muda o diálogo para o modo
        // footprint (Cancelar / purga de admin) sem fechar.
        setDeleteFootprintMode(true);
        setDeleteBusy(false);
      } else {
        dispatch(addToast({ severity: 'error', message: lang === 'pt' ? 'Erro ao eliminar a OT' : 'Failed to delete order' }));
        setDeleteBusy(false);
      }
    }
  }

  // Alternativa recomendada para OTs com rasto: cancelar (liberta veículo,
  // motorista e rota; mantém a OT e todo o histórico).
  async function cancelOrderFromDelete() {
    if (!deleteConfirmId || deleteBusy) return;
    setDeleteBusy(true);
    try {
      await dispatch(updateOrder({ token, id: deleteConfirmId, data: { status: 'cancelled' } })).unwrap();
      dispatch(addToast({ severity: 'success', message: lang === 'pt' ? 'OT cancelada — rota libertada, histórico mantido' : 'Order cancelled — route freed, history kept' }));
      closeDeleteDialog();
    } catch {
      dispatch(addToast({ severity: 'error', message: lang === 'pt' ? 'Erro ao cancelar a OT' : 'Failed to cancel order' }));
      setDeleteBusy(false);
    }
  }

  function openAssignDialog(orderId) {
    setAssignOrderId(orderId);
    setAssignRouteId('');
    setAssignWarning('');
    setAssignSearch('');
    setAssignStatusFilter('all');
    setAssignFreeOnly(false);
    setAssignDialogPos(null); // reset to default position on each open
    if (token) {
      setAssignLoading(true);
      fetch('/planner-api/routes?page=1&limit=200', { headers: { Authorization: `Bearer ${token}` } })
        .then(r => r.json())
        .then(d => setSavedRoutes(d.data || d))
        .catch(() => {})
        .finally(() => setAssignLoading(false));
    }
  }

  function onAssignDialogDragStart(e) {
    e.preventDefault();
    // Compute current dialog top-left in pixels (handles null default position)
    const defaultLeft = Math.max(20, (window.innerWidth - 960) / 2);
    const defaultTop = 88;
    const currentX = assignDialogPos?.x ?? defaultLeft;
    const currentY = assignDialogPos?.y ?? defaultTop;
    assignDragRef.current = {
      startX: e.clientX, startY: e.clientY,
      initX: currentX, initY: currentY,
    };
    function onMove(ev) {
      if (!assignDragRef.current) return;
      const dx = ev.clientX - assignDragRef.current.startX;
      const dy = ev.clientY - assignDragRef.current.startY;
      const newX = Math.max(0, Math.min(window.innerWidth - 200, assignDragRef.current.initX + dx));
      const newY = Math.max(0, Math.min(window.innerHeight - 100, assignDragRef.current.initY + dy));
      setAssignDialogPos({ x: newX, y: newY });
    }
    function onUp() {
      assignDragRef.current = null;
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    }
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  }

  // Map OT status transitions to the underlying route status. The route endpoint
  // cascades the change back to all associated OTs (assigned → in_transit, etc).
  const [routeActionBusyId, setRouteActionBusyId] = useState(null);
  const [historyDialog, setHistoryDialog] = useState(null); // { order, events, loading }
  const [consolidationPreview, setConsolidationPreview] = useState(null); // { orders, timeline, conflicts }
  // Start-route GPS check dialog — shown when the vehicle isn't at the planned pickup.
  // Shape: { order, vehicle, route, vehicleCoords, pickupCoords, distanceKm, busy }
  const [startRouteDialog, setStartRouteDialog] = useState(null);
  // Fuel (Move Express): diálogo de início "Saí da base". Substitui o botão
  // "Iniciar" nas OT de combustível. Mostra a ROTA PLANEADA correcta
  // (partida=base das Preferências, recolha=terminal, entrega=cliente), em vez
  // da comparação GPS-do-veículo↔recolha (que mostrava a partida errada).
  const [fuelStartDialog, setFuelStartDialog] = useState(null);
  async function openFuelStartDialog(order, routeId) {
    setFuelStartDialog({ order, routeId, loading: true, busy: false });
    const baseFallback = lang === 'pt' ? 'Base (Preferências do cliente)' : 'Base (client preferences)';
    let originName = baseFallback;
    let originObj = order.routeOrigin || null;
    let km = order.routeTotalDistanceM != null ? order.routeTotalDistanceM / 1000 : null;
    let durS = order.routeTotalDurationS != null ? order.routeTotalDurationS : null;
    try {
      const res = await fetch(`/planner-api/routes/${routeId}`, { headers: { Authorization: `Bearer ${token}` } });
      if (res.ok) {
        const route = await res.json();
        const o = route?.origin || order.routeOrigin || null;
        originObj = o;
        originName = o?.text || o?.name || o?.address || baseFallback;
        if (route?.totalDistanceM != null) km = route.totalDistanceM / 1000;
        if (route?.totalDurationS != null) durS = route.totalDurationS;
      } else if (order.routeOrigin) {
        const o = order.routeOrigin;
        originName = o.text || o.name || o.address || baseFallback;
      }
    } catch (_) { /* fallback aos dados da OT */ }
    // Tipo de partida real (base / terminal / posição do veículo) — a origem
    // coincidir com o ponto de recolha significa que o veículo arrancou já no
    // terminal, não na base.
    const departureKind = (() => {
      const oName = originObj?.text || originObj?.name || originObj?.address || '';
      if (/posi[çc][ãa]o actual do ve[íi]culo|local atual do ve[íi]culo|🚗/i.test(String(oName))) return 'vehicle';
      const oc = originObj?.coordinates;
      const oLng = Array.isArray(oc) ? Number(oc[0]) : Number(originObj?.lng ?? originObj?.longitude);
      const oLat = Array.isArray(oc) ? Number(oc[1]) : Number(originObj?.lat ?? originObj?.latitude);
      const pLat = order.pickupLat != null ? Number(order.pickupLat) : null;
      const pLng = order.pickupLng != null ? Number(order.pickupLng) : null;
      if ([oLat, oLng, pLat, pLng].every(Number.isFinite)
        && Math.abs(oLat - pLat) < 0.0015 && Math.abs(oLng - pLng) < 0.0015) return 'terminal';
      return 'base';
    })();
    // Posição real do veículo — serve dois propósitos:
    //   (a) partida = veículo → mostrar o LOCAL aproximado (morada/coords);
    //   (b) partida = local fixo → avisar se o veículo está longe dessa partida.
    const vehLive = vehicles.find(v => String(v.id) === String(order.vehicleId));
    const vLat = Number(vehLive?.position?.latitude);
    const vLng = Number(vehLive?.position?.longitude);
    const hasVehGps = Number.isFinite(vLat) && Number.isFinite(vLng) && !(vLat === 0 && vLng === 0);
    // Coordenadas da origem planeada (o ponto de partida escolhido).
    const oc = originObj?.coordinates;
    let oLng = Array.isArray(oc) ? Number(oc[0]) : Number(originObj?.lng ?? originObj?.longitude);
    let oLat = Array.isArray(oc) ? Number(oc[1]) : Number(originObj?.lat ?? originObj?.latitude);
    let originCoords = null;
    let originAddress = null;
    let vehicleDistanceKm = null;
    if (departureKind === 'vehicle') {
      if (!Number.isFinite(oLat) && hasVehGps) { oLat = vLat; oLng = vLng; }
      if (Number.isFinite(oLat) && Number.isFinite(oLng)) originCoords = { lat: oLat, lng: oLng };
      originAddress = vehLive?.position?.address || vehLive?.position?.formattedAddress || null;
    } else if (hasVehGps && Number.isFinite(oLat) && Number.isFinite(oLng)) {
      // Parte de um local fixo — distância real do veículo a essa partida.
      vehicleDistanceKm = haversineKm({ lat: vLat, lng: vLng }, { lat: oLat, lng: oLng });
    }
    setFuelStartDialog({
      order, routeId, loading: false, busy: false,
      originName, departureKind, originCoords, originAddress, vehicleDistanceKm,
      pickupName: order.pickupName || order.pickupAddress || '—',
      deliveryName: order.deliveryName || order.deliveryAddress || null,
      distanceKm: km, durationS: durS,
    });
    // Reverse-geocode Google (melhor p/ Angola) só se ainda não temos morada.
    if (departureKind === 'vehicle' && !originAddress && originCoords && window.google && window.google.maps) {
      try {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: { lat: originCoords.lat, lng: originCoords.lng } }, (results, status) => {
          const addr = (status === 'OK' && results && results[0]) ? results[0].formatted_address : null;
          if (addr) setFuelStartDialog(d => (d && String(d.order?.id) === String(order.id)) ? { ...d, originAddress: addr } : d);
        });
      } catch (_) { /* fica pelas coordenadas */ }
    }
  }
  async function confirmFuelStart() {
    if (!fuelStartDialog) return;
    const { order, routeId } = fuelStartDialog;
    setFuelStartDialog(d => d ? { ...d, busy: true } : d);
    await doRouteStatusChange(order, routeId, 'in_progress');
    setFuelStartDialog(null);
  }
  async function openOTHistory(order) {
    setHistoryDialog({ order, events: [], loading: true });
    try {
      const res = await fetch(`/planner-api/transport-orders/${order._id || order.id}/history`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setHistoryDialog({ order, events: data.events || [], loading: false });
    } catch (e) {
      setHistoryDialog({ order, events: [], loading: false, error: String(e) });
    }
  }
  // Straight-line distance between two {lat, lng} points, in km.
  function haversineKm(a, b) {
    const toRad = d => d * Math.PI / 180;
    const R = 6371;
    const dLat = toRad(b.lat - a.lat);
    const dLng = toRad(b.lng - a.lng);
    const aa = Math.sin(dLat / 2) ** 2
      + Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(aa));
  }

  // Threshold (km) below which we assume the vehicle is "at" the pickup location.
  // 500 m is generous enough to cover warehouse yards without false positives.
  const START_GPS_THRESHOLD_KM = 0.5;
  // Fuel: acima desta distância entre o GPS do veículo e a partida FIXA
  // escolhida, avisa o operador no diálogo de arranque (só informativo).
  const FUEL_START_FAR_THRESHOLD_KM = 0.5;

  async function handleInlineRouteAction(order, targetStatus) {
    const routeId = order.assignedRouteId || order.route?.id;
    if (!routeId || !token) return;

    // Fuel (Move Express): a partida é a BASE (origem da rota, definida nas
    // Preferências do cliente), não o GPS do veículo. O botão "Iniciar" está
    // escondido nestas OT — o arranque faz-se pela bola "Saí da base", que
    // abre um diálogo com a rota planeada CORRECTA. Iniciar a rota auto-marca
    // o "Saí da base" no backend (routes.routes.js).
    if (targetStatus === 'in_progress' && order.serviceType === 'fuel') {
      await openFuelStartDialog(order, routeId);
      return;
    }

    // Special handling for "start": if the vehicle is not at the planned pickup, offer
    // the operator the choice of recalculating the route from the current GPS position.
    if (targetStatus === 'in_progress') {
      const vehicle = vehicles.find(v => String(v.id) === String(order.vehicleId));
      const vLat = vehicle?.position?.latitude;
      const vLng = vehicle?.position?.longitude;
      const pickupLat = Number(order.pickupLat || order.pickup?.lat);
      const pickupLng = Number(order.pickupLng || order.pickup?.lng);
      const hasValidGPS = Number.isFinite(vLat) && Number.isFinite(vLng)
        && vLat >= -90 && vLat <= 90 && vLng >= -180 && vLng <= 180
        && !(vLat === 0 && vLng === 0);
      const hasValidPickup = Number.isFinite(pickupLat) && Number.isFinite(pickupLng);
      if (hasValidGPS && hasValidPickup) {
        const km = haversineKm({ lat: vLat, lng: vLng }, { lat: pickupLat, lng: pickupLng });
        if (km > START_GPS_THRESHOLD_KM) {
          // Open confirm dialog — user picks "Iniciar na mesma", "Recalcular com posição actual" or "Cancelar"
          setStartRouteDialog({
            order,
            vehicle,
            routeId,
            vehicleCoords: { lat: vLat, lng: vLng },
            pickupCoords: { lat: pickupLat, lng: pickupLng },
            pickupName: order.pickupName || order.pickupAddress || '',
            distanceKm: km,
            busy: false,
          });
          return; // dialog handlers take it from here
        }
      }
    }

    await doRouteStatusChange(order, routeId, targetStatus);
  }

  // Extracted so both the direct path and the start-route dialog can call it.
  async function doRouteStatusChange(order, routeId, targetStatus) {
    setRouteActionBusyId(order._id || order.id);
    // Ação PRÓPRIA do operador (ex.: "Saída da base") — o backend transmite a
    // mudança por WS de volta a este cliente. Abre já a janela de supressão
    // (larga, cobre o tempo do pedido) para o botão Actualizar não piscar à toa.
    staleSuppressUntil.current = Date.now() + 5000;
    try {
      await dispatch(updateRouteStatus({ token, routeId, status: targetStatus })).unwrap();
      const actionLabels = {
        in_progress: lang === 'pt' ? 'Rota iniciada' : 'Route started',
        completed: lang === 'pt' ? 'Rota concluída' : 'Route completed',
        cancelled: lang === 'pt' ? 'OT libertada · rota volta a estar disponível' : 'Order released · route back to draft',
      };
      dispatch(addToast({ type: 'success', message: `${actionLabels[targetStatus]} · ${otLabel(order)}` }));
      doFetch();
    } catch (e) {
      dispatch(addToast({ type: 'error', message: (lang === 'pt' ? 'Erro: ' : 'Error: ') + (e?.message || e) }));
    } finally {
      setRouteActionBusyId(null);
    }
  }

  // Load an in-progress route into the planner for re-editing. The RouteForm detects
  // `replanningRouteId` and surfaces a "Guardar & Reenviar" action that PUTs the route
  // and re-dispatches to the assigned drivers.
  async function handleReplanRoute(order, opts) {
    if (!order?.assignedRouteId || !token) return;
    try {
      dispatch(clearRoute());
      // Set the replanning id BEFORE the fetch — fetchRouteDetail.fulfilled
      // checks this to decide whether the loaded route should be readOnly. If
      // we set it after, the route lands as view-only and the operator can't
      // touch it even though they came in via the replan flow.
      dispatch(setReplanningRouteId(order.assignedRouteId));
      const routeRes = await dispatch(fetchRouteDetail({ token, routeId: order.assignedRouteId })).unwrap();
      // Combustível: RECONSTRUIR as paragens a partir da OT quando o operador
      // vem pelo prompt "recalcular" (P.A. revelado no Carregou OU 2.º P.A.
      // gravado). O recálculo normal só refaz a geometria dos waypoints
      // existentes — não sabe do P.A. novo. Aqui montamos:
      //   origem (base, mantida) → terminal (recolha) → [P.A.1 se dividida] → destino (P.A. final)
      if (opts?.fuelRebuild && order?.serviceType === 'fuel') {
        // RE-BUSCA a OT fresca: o P.A. pode ter sido revelado AGORA no "Carregou"
        // (piloto automático) e o `order` da lista ainda não o ter. Sem isto, a
        // rota era reconstruída sem o P.A. (destino ficava no terminal).
        let fresh = order;
        try {
          const fr = await fetch(`/planner-api/transport-orders/${order.id}`, { headers: { Authorization: `Bearer ${token}` } });
          if (fr.ok) { const fj = await fr.json(); fresh = fj?.data || fj || order; }
        } catch { /* usa o order da lista */ }
        const num = (v) => (v != null ? Number(v) : null);
        const pickup = (fresh.pickupLat != null && fresh.pickupLng != null)
          ? { name: fresh.pickupName || 'Terminal', lng: num(fresh.pickupLng), lat: num(fresh.pickupLat) } : null;
        const pa1 = (fresh.deliveryLat != null && fresh.deliveryLng != null)
          ? { name: fresh.deliveryName || 'P.A.', lng: num(fresh.deliveryLng), lat: num(fresh.deliveryLat) } : null;
        const pa2 = (fresh.splitDelivery && fresh.deliveryLat2 != null && fresh.deliveryLng2 != null)
          ? { name: fresh.deliveryName2 || 'P.A. 2', lng: num(fresh.deliveryLng2), lat: num(fresh.deliveryLat2) } : null;
        const finalDest = pa2 || pa1;
        const curDestName = routeRes?.routeData?.destination?.name || '';
        if (finalDest && curDestName !== finalDest.name) {
          dispatch(setWaypoints([]));
          if (pickup) dispatch(addWaypoint({ name: pickup.name, coordinates: [pickup.lng, pickup.lat], waypointKind: 'pickup', otId: fresh.id, orderNumber: fresh.orderNumber, stopDuration: 15 }));
          if (pa2 && pa1) dispatch(addWaypoint({ name: pa1.name, coordinates: [pa1.lng, pa1.lat], waypointKind: 'delivery', otId: fresh.id, orderNumber: fresh.orderNumber, stopDuration: fresh.unloadingTime || 0 }));
          dispatch(setDestination({ name: finalDest.name, coordinates: [finalDest.lng, finalDest.lat], otId: fresh.id, orderNumber: fresh.orderNumber, waypointKind: 'fuel' }));
        }
      }
      // Garantir que o painel esquerdo (sidebar com RouteForm) está visível
      // e na tab "Rota". Quando o re-planear é despoletado da lista de
      // Ordens (não do mapa), o sidebar pode estar escondido. Sem isto, o
      // operador vê só o mapa com a rota mas sem controlos para editar.
      dispatch(setSidebarVisible(true));
      dispatch(setSidebarTab(0));
      dispatch(setActiveView('planner'));
      // Piloto automático (OT fuel): sinaliza que, assim que a rota recalcular,
      // deve gravar sozinha e voltar à cronologia — sem trabalho no planeador.
      if (opts?.autoSaveReturn) dispatch(setAutoSaveReturn(true));
      // Força recálculo da rota — destino pode ter mudado (caso fuel: PA
      // revelado depois do Carregou).
      dispatch(setNeedsRecalculation(true));
      // Painel inferior "Pontos da rota" (com reorder por arrasto) durante o
      // re-plano de assistência/entrega. Flag DEDICADA __replanning — NÃO
      // reutiliza __fromOTScreen (dispararia "voltar ao ecrã OT") nem entra no
      // memo otMonitoringActive (que colapsa os painéis laterais). Aqui o painel
      // ESQUERDO fica aberto para editar e o inferior mostra as caixinhas.
      if (order?.serviceType !== 'fuel') {
        window.__monitoringOT = {
          orderId: order.id || order._id,
          orderNumber: order.orderNumber,
          vehicleId: order.vehicleId,
          vehiclePlate: order.vehiclePlate,
          driverName: order.driverName,
          status: order.status,
          pickupName: order.pickupName || order.pickupAddress,
          deliveryName: order.deliveryName || order.deliveryAddress,
          deliveryWindowFrom: order.deliveryWindowFrom,
          deliveryWindowTo: order.deliveryWindowTo,
        };
        window.__replanning = true;
      }
      dispatch(addToast({
        type: 'info',
        message: opts?.autoSaveReturn
          ? (lang === 'pt' ? 'A calcular e gravar a rota…' : 'Calculating and saving the route…')
          : (lang === 'pt'
            ? 'Modo edição em execução: adiciona/remove paragens e clica "Guardar & Reenviar"'
            : 'In-execution edit mode: add/remove stops and click "Save & Resend"'),
      }));
    } catch (e) {
      dispatch(addToast({ type: 'error', message: (lang === 'pt' ? 'Erro: ' : 'Error: ') + (e?.message || e) }));
    }
  }

  // Show the phone preview of what the driver sees for this route. Loads the
  // route detail into local state (NOT Redux currentRoute) and renders a
  // standalone Dialog — so it doesn't hijack the planner view.
  // Open the DriverPdfPreviewDialog for a specific OT. Mirrors the data
  // shaping done by handleShowPhonePreview because the dialog expects a
  // currentRoute-like object. For consolidated routes the route already lists
  // every sibling OT in its waypoints/stops, so the PDF preview shows the
  // joint dispatch automatically — no special-casing needed here.
  async function handleShowDriverPdf(order) {
    if (!order?.assignedRouteId || !token) return;
    try {
      const res = await fetch(`/planner-api/routes/${order.assignedRouteId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error('Falha a carregar rota');
      const raw = await res.json();
      const rd = raw.routeData || {};
      setPdfPreviewRoute({
        ...rd,
        id: raw.id,
        name: raw.name,
        origin: raw.origin,
        destination: raw.destination,
        waypoints: raw.waypoints || [],
        computedRoute: rd.computedRoute,
        stops: rd.stops || [],
        vehicleId: raw.vehicleId,
        vehiclePlate: raw.vehiclePlate || order.vehiclePlate,
        driverName: raw.driverName || order.driverName,
        departureTime: raw.departureTime,
        fuelType: rd.fuelType,
        fuelConsumption: rd.fuelConsumption,
        fuelPrice: rd.fuelPrice,
        routeOptions: rd.routeOptions || {},
      });
      setPdfPreviewMeta({
        vehiclePlate: raw.vehiclePlate || order.vehiclePlate || '—',
        driverName: raw.driverName || order.driverName || '—',
      });
    } catch (e) {
      dispatch(addToast({ type: 'error', message: (lang === 'pt' ? 'Erro: ' : 'Error: ') + (e?.message || e) }));
    }
  }

  async function handleShowPhonePreview(order) {
    if (!order?.assignedRouteId || !token) return;
    try {
      const res = await fetch(`/planner-api/routes/${order.assignedRouteId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error('Falha a carregar rota');
      const raw = await res.json();
      // Shape the fetched route to match what PhonePreview expects (currentRoute-like)
      const rd = raw.routeData || {};
      setPhonePreviewRoute({
        ...rd,
        id: raw.id,
        name: raw.name,
        origin: raw.origin,
        destination: raw.destination,
        waypoints: raw.waypoints || [],
        computedRoute: rd.computedRoute,
        stops: rd.stops || [],
        vehicleId: raw.vehicleId,
        departureTime: raw.departureTime,
        fuelType: rd.fuelType,
        fuelConsumption: rd.fuelConsumption,
        fuelPrice: rd.fuelPrice,
        routeOptions: rd.routeOptions || {},
      });
    } catch (e) {
      dispatch(addToast({ type: 'error', message: (lang === 'pt' ? 'Erro: ' : 'Error: ') + (e?.message || e) }));
    }
  }

  // Jump directly to the driver app (mobile tab) in a new browser tab — the
  // operator sees what the motorista sees. Uses `/driver` hash route so the
  // session token stays with the admin tab.
  function handleOpenDriverApp() {
    const url = `${window.location.origin}/#/driver`;
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  // Recalculate route from the vehicle's current GPS position and then start it.
  //  1. Fetch current route
  //  2. New origin = vehicle GPS; old origin is pushed as the first waypoint
  //  3. Recalculate via HERE
  //  4. PUT /routes/:id with new origin + waypoints + computedRoute
  //  5. PATCH /routes/:id/status → in_progress
  async function startRouteWithRecalc() {
    if (!startRouteDialog || !token) return;
    const { order, routeId, vehicleCoords, pickupName } = startRouteDialog;
    setStartRouteDialog(s => ({ ...s, busy: true }));
    try {
      // New flow (2026-04-28 operator request): instead of auto-saving and
      // dispatching immediately, take the operator to the PLANNER with the
      // recalculated route loaded for review. They review the new origin +
      // geometry and decide via the existing replan bar:
      //   · "Guardar e Reenviar" — PUT route + re-dispatch + status=in_progress
      //   · "Só Guardar"          — PUT only, driver keeps current version
      //   · "Cancelar"            — discard, route remains as-is
      // This matches the operator's expectation of "see before sending" and
      // also avoids any perception of a "new" route being created (the same
      // routeId is updated by the existing replan handler).

      // 1. Set replan markers BEFORE fetchRouteDetail so the loaded route is
      //    editable (replanningRouteId clears the auto-readOnly flag) AND so
      //    the live panel reopens for this OT after Save / Cancel.
      dispatch(setReplanningRouteId(routeId));
      dispatch(setReplanReturnLiveOTId(order.id || order._id));

      // 2. Load the current route into Redux currentRoute.
      await dispatch(fetchRouteDetail({ token, routeId })).unwrap();

      // 3. Rewrite origin to the vehicle's current GPS position.
      const newOrigin = {
        name: lang === 'pt' ? 'Posição actual do veículo' : 'Current vehicle position',
        coordinates: [vehicleCoords.lng, vehicleCoords.lat],
      };

      // For DELIVERY/FUEL routes the original origin is a REAL pickup (warehouse,
      // fuel yard) — push it back as the first waypoint so the driver still
      // collects cargo. For ASSISTANCE the origin is just the technician's home
      // (not a real pickup) — drop it so the driver goes directly to the 1st OT.
      const isAssistanceRoute = (order?.serviceType === 'assistance');
      if (!isAssistanceRoute) {
        try {
          const r = await fetch(`/planner-api/routes/${routeId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const fresh = r.ok ? await r.json() : null;
          const oldOrigin = fresh?.origin;
          if (oldOrigin?.coordinates) {
            dispatch(insertWaypointAt({
              index: 0,
              waypoint: {
                name: oldOrigin.name || pickupName || 'Recolha',
                coordinates: oldOrigin.coordinates,
                stopDuration: 15,
                waypointKind: 'pickup',
              },
            }));
          }
        } catch { /* non-fatal — operator can add manually */ }
      }

      dispatch(setOrigin(newOrigin));
      dispatch(setNeedsRecalculation(true));

      // 4. Navigate to planner.
      setStartRouteDialog(null);
      dispatch(setSidebarVisible(true));
      dispatch(setSidebarTab(0));
      dispatch(navigateTo('planner'));

      dispatch(addToast({
        type: 'info',
        message: lang === 'pt'
          ? '🧭 Rota recalculada — revê e clica "Guardar e Reenviar"'
          : '🧭 Route recalculated — review and click "Save & Resend"',
      }));
    } catch (e) {
      setStartRouteDialog(s => ({ ...s, busy: false }));
      dispatch(addToast({ type: 'error', message: (lang === 'pt' ? 'Erro: ' : 'Error: ') + (e?.message || e) }));
    }
  }

  async function confirmAssign() {
    if (!assignOrderId || !assignRouteId) return;
    const routeId = parseInt(assignRouteId);
    try {
      // Opção A — "Preview antes de gravar":
      // NÃO chamamos o backend aqui. Carregamos a rota no planner com o
      // waypoint da nova OT em memória (Redux). Só "Gravar"/"Gravar e
      // Despachar" no planner é que persistem na BD. "Cancelar" descarta.
      const selectedOT = list.find(o => (o._id || o.id) === assignOrderId);
      if (!selectedOT) throw new Error('OT não encontrada na lista');

      // 1. Carregar a rota actual.
      dispatch(clearRoute());
      dispatch(setReplanningRouteId(routeId));
      const apiRoute = await dispatch(fetchRouteDetail({ token, routeId })).unwrap().catch(() => null);

      // 2. Adicionar a nova OT a sourceOTIds em Redux. saveRouteToAPI fará
      //    o assign de cada OT do array quando o operador gravar.
      const existingSourceOtIds = Array.isArray(apiRoute?.sourceOtIds) ? apiRoute.sourceOtIds : [];
      const newSourceOtIds = existingSourceOtIds.includes(selectedOT.id)
        ? existingSourceOtIds
        : [...existingSourceOtIds, selectedOT.id];
      dispatch(setSourceOTIds(newSourceOtIds));

      // 3. Adicionar o waypoint visual com a metadata da OT.
      const lat = Number(selectedOT.deliveryLat);
      const lng = Number(selectedOT.deliveryLng);
      if (Number.isFinite(lat) && Number.isFinite(lng)) {
        const wpKind = selectedOT.serviceType === 'assistance' ? 'service'
          : selectedOT.serviceType === 'fuel' ? 'fuel'
          : 'delivery';
        dispatch(addWaypoint({
          name: selectedOT.deliveryName || selectedOT.deliveryAddress || selectedOT.customRef || selectedOT.orderNumber || `OT-${selectedOT.id}`,
          coordinates: [lng, lat],
          otId: selectedOT.id,
          orderNumber: selectedOT.orderNumber,
          customRef: (selectedOT.customRef || '').trim() || null,
          waypointKind: wpKind,
          stopDuration: selectedOT.unloadingTime || 30,
        }));
        dispatch(setNeedsRecalculation(true));
      }

      const orderNumber = otLabel(selectedOT) || `OT-${selectedOT.id}`;
      const routeName = savedRoutes.find(r => Number(r.id || r.dbId) === Number(routeId))?.name || `Rota #${routeId}`;
      dispatch(addToast({
        type: 'info',
        message: lang === 'pt'
          ? `${orderNumber} adicionada em pré-visualização a ${routeName}. Re-otimize e clica "Gravar" para confirmar — "Cancelar" descarta.`
          : `${orderNumber} added as preview to ${routeName}. Re-optimize and click "Save" to confirm — "Cancel" discards.`,
        duration: 7000,
      }));

      setAssignOrderId(null);
      dispatch(setSidebarVisible(true));
      dispatch(setSidebarTab(0));
      dispatch(setShowDetails(true));
      dispatch(navigateTo('planner'));
    } catch (e) {
      console.error(e);
      dispatch(addToast({
        type: 'error',
        message: (lang === 'pt' ? 'Erro: ' : 'Error: ') + (e?.message || e),
      }));
    }
  }

  function openVehicleAssign(orderId, bulk = false) {
    setVehicleAssignOrderId(orderId);
    setBulkAssignMode(bulk);
    // Pre-seleccionar o veículo já atribuído à OT (se existir). Assim o botão
    // "Planificar Rota" / "Alterar Veículo" fica enabled imediatamente sem o
    // operador ter de clicar de novo no mesmo veículo na lista.
    const currentOT = list.find(o => String(o._id || o.id) === String(orderId));
    setSelectedVehicleId(currentOT?.vehicleId ? String(currentOT.vehicleId) : '');
    // Cisternas — pré-preenche se a OT já tem (modo "Alterar") e é fuel.
    // Usa o array `cisterns` (até 2); fallback ao campo singular antigo.
    setSelectedCisternIds(
      currentOT?.serviceType === 'fuel'
        ? (Array.isArray(currentOT?.cisterns) && currentOT.cisterns.length
            ? currentOT.cisterns.map(c => String(c.vehicleId)).filter(v => v && v !== 'null')
            : (currentOT?.cisternVehicleId ? [String(currentOT.cisternVehicleId)] : []))
        : []
    );
    setUnloadingTime('');
    setVehicleAssignWarning('');
    setVehicleSearch('');
    setVehicleFilterMode('inside');
    setVehicleAssignRadiusKm(5);
    setVehicleDialogPos(null);
    setOtAvailContext(null);
    setDriverDraft(null);
    // Bug fix: pre-select the OT's currently-assigned driver (manualDriverId)
    // so opening the dialog for an already-assigned OT shows the right
    // driver — was clearing it and the suggestions/auto-detect kicked in
    // and overrode the operator's previous choice on first render.
    setManualDriverId(currentOT?.driverId ? String(currentOT.driverId) : '');
    setDriverPanelExpanded(false);
    // Fetch drivers for the manual picker (when vehicle has no driver)
    if (token) dispatch(fetchDrivers(token));
    // Driver suggestions — read-only hints based on home distance + skills + load.
    // Failure is non-blocking (the existing manual flow keeps working).
    setDriverSuggestions([]);
    setDriverSuggestionsLoading(true);
    if (token) {
      fetch(`/planner-api/transport-orders/${orderId}/driver-suggestions`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(r => r.ok ? r.json() : { suggestions: [] })
        .then(d => setDriverSuggestions(Array.isArray(d?.suggestions) ? d.suggestions : []))
        .catch(() => setDriverSuggestions([]))
        .finally(() => setDriverSuggestionsLoading(false));
    }
    if (token) {
      // In bulk mode, send the full set of selected OT ids so the backend can exclude
      // ALL of them from its conflict test — otherwise moving 3 OTs from vehicle A to B
      // would incorrectly flag OTs #2 and #3 as "conflicting" when they're part of the move.
      const idsParam = bulk && selected.length > 1
        ? `&orderIds=${encodeURIComponent(selected.join(','))}`
        : '';
      fetch(`/planner-api/transport-orders/available-vehicles?orderId=${orderId}${idsParam}`, { headers: { Authorization: `Bearer ${token}` } })
        .then(r => r.json())
        .then(d => {
          if (Array.isArray(d)) {
            setAvailableVehicles(d);
            setOtAvailContext(null);
          } else if (d && Array.isArray(d.vehicles)) {
            setAvailableVehicles(d.vehicles);
            setOtAvailContext(d.context || null);
          } else {
            setAvailableVehicles([]);
          }
        })
        .catch(() => setAvailableVehicles([]));
    }
  }

  // Petrotec AO — antes de planificar rota, avisa o operador se o
  // veículo escolhido não tem stock atribuído (típico em intervenções
  // que vão precisar de peças). Outros tenants/tipos passam directo.
  const [noStockConfirm, setNoStockConfirm] = useState(null); // pending action

  async function handlePlanWithStockCheck() {
    const otIds = bulkAssignMode ? [...selected] : [vehicleAssignOrderId];
    const anyAssistanceAO = otIds.some(oid => {
      const o = list.find(x => String(x._id || x.id) === String(oid));
      return o && o.serviceType === 'assistance' && o.finalCustomerId;
    });
    // Diagnóstico temporário — remover depois de validar
    console.log('[stockCheck]', {
      clientExternalId, bulkAssignMode, otIds, anyAssistanceAO,
      selectedVehicleId, otsInList: otIds.map(oid => {
        const o = list.find(x => String(x._id || x.id) === String(oid));
        return o ? { id: o.id, serviceType: o.serviceType, finalCustomerId: o.finalCustomerId } : null;
      }),
    });
    // Gating: precisa de ser tenant Petrotec AO E pelo menos 1 OT de
    // assistência AO seleccionada (com finalCustomerId — caso contrário
    // é uma OT PT em ambiente AO ou um delivery/fuel que não cabe aqui).
    if (!isPetrotecTenant(clientExternalId, clientSettings) || !anyAssistanceAO || !selectedVehicleId) {
      return confirmVehicleAssign(true);
    }
    try {
      const r = await fetch(`/planner-api/vehicle-stock?vehicleId=${selectedVehicleId}`, {
        headers: { Authorization: `Bearer ${token}` },
        cache: 'no-store',
      });
      const data = r.ok ? await r.json() : null;
      const balances = Array.isArray(data?.balances) ? data.balances : [];
      const hasStock = balances.some(b => Number(b.quantity) > 0);
      console.log('[stockCheck] result', { balances, hasStock });
      if (hasStock) {
        return confirmVehicleAssign(true);
      }
    } catch (e) { console.log('[stockCheck] fetch error', e); }
    setNoStockConfirm(() => () => confirmVehicleAssign(true));
  }

  async function confirmVehicleAssign(andCreateRoute = false) {
    if (!vehicleAssignOrderId || !selectedVehicleId) return;
    setVehicleAssigning(true);
    const vehicle = availableVehicles.find(v => String(v.id) === selectedVehicleId);
    const plate = vehicle?.plate || null;
    // Use manually selected driver if set, otherwise auto-detect from vehicle
    const manualDriver = manualDriverId ? allDrivers.find(d => String(d.id) === String(manualDriverId)) : null;
    const driver = manualDriver?.name || vehicle?.driver?.name || vehicle?.tacho?.driverName || null;
    const driverExternalId = manualDriver?.externalId
      || (vehicle?.driver?.id ? String(vehicle.driver.id) : null)
      || (vehicle?.tacho?.driverId ? String(vehicle.tacho.driverId) : null);
    const driverTachoCard = manualDriver?.tachoCard || vehicle?.driver?.tachoCard || vehicle?.tacho?.tachoCard || null;

    // Build the list of OT IDs to assign — single OT or bulk selection
    const otIds = bulkAssignMode ? [...selected] : [vehicleAssignOrderId];

    try {
      // Assign each OT to the same vehicle/driver. Pass the full batch id list so the
      // backend doesn't warn about OTs already moved in this same bulk operation.
      let lastData = null;
      for (const otId of otIds) {
        const res = await fetch(`/planner-api/transport-orders/${otId}/assign-vehicle`, {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify({
            vehicleId: parseInt(selectedVehicleId),
            vehiclePlate: plate,
            driverName: driver,
            unloadingTime: unloadingTime ? parseInt(unloadingTime) : null,
            // When a driver was manually picked, ITS identity must win — the
            // panel's draft otherwise leaks the vehicle's auto-detected driver.
            // This was causing the backend lookup to resolve to a stale duplicate
            // (e.g. inactive driver_id=26 instead of the chosen driver_id=22).
            driverExternalId: manualDriver?.externalId || driverDraft?.externalId || driverExternalId,
            driverTachoCard: manualDriver?.tachoCard || driverDraft?.tachoCard || driverTachoCard,
            driverPhone: manualDriver?.phone || driverDraft?.phone || null,
            driverEmail: manualDriver?.email || driverDraft?.email || null,
            driverNotes: driverDraft?.notes || null,
            bulkOrderIds: bulkAssignMode && otIds.length > 1 ? otIds : undefined,
            // Cisterna atrelada — só envia quando a OT é fuel e foi escolhida.
            // Backend valida que a OT é fuel antes de gravar (zero impacto noutros tipos).
            ...(selectedCisternIds.length ? (() => {
              const chosen = selectedCisternIds.map(id => {
                // allVehicles (não `vehicles`): as cisternas são veículos
                // "disabled" e ficam de fora da lista filtrada `vehicles`.
                const cv = (allVehicles || []).find(x => String(x.id) === String(id));
                return {
                  vehicleId: parseInt(id),
                  plate: cv?.plate || cv?.name || null,
                  capacityM3: cv?.cisternCapacityM3 != null ? Number(cv.cisternCapacityM3) : null,
                };
              });
              const first = chosen[0];
              return {
                // 1ª cisterna nos campos singulares (compat); todas no array.
                cisternVehicleId: first.vehicleId,
                cisternPlate: first.plate,
                cisternCapacityM3: first.capacityM3,
                cisterns: chosen,
              };
            })() : {}),
          }),
        });
        lastData = await res.json();
      }
      const data = lastData;

      // If OT has a route, also update the route with new vehicle/driver info
      if (!andCreateRoute && data.order?.assignedRouteId) {
        await fetch(`/planner-api/routes/${data.order.assignedRouteId}`, {
          method: 'PUT',
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify({
            routeData: {
              vehicleId: parseInt(selectedVehicleId),
              vehiclePlate: plate,
              driverName: driver,
            },
          }),
        }).catch(() => {});
      }
      // Bulk mode toast + clear selection
      if (bulkAssignMode && otIds.length > 1) {
        dispatch(addToast({
          severity: 'success',
          message: lang === 'pt'
            ? `🚛 ${otIds.length} ordens atribuídas a ${plate || 'veículo'} · ${driver || 'sem motorista'}`
            : `🚛 ${otIds.length} orders assigned to ${plate || 'vehicle'} · ${driver || 'no driver'}`,
        }));
        setSelected([]);
      }

      doFetch();
      if (data.warning && !andCreateRoute) {
        setVehicleAssignWarning(data.warning);
      } else {
        setVehicleAssignOrderId(null);
      }

      // Bulk + Planificar Rota → run the same VRP flow as the orders-screen
      // "Otimizar Rota" button. Single-OT logic below can't sequence multiple
      // stops, so for 2+ OTs we hand off to handleConsolidateRoutes after
      // refreshing the records (the bulk loop just updated them server-side).
      if (andCreateRoute && bulkAssignMode && otIds.length >= 2) {
        try {
          const fresh = await Promise.all(otIds.map(otId =>
            fetch(`/planner-api/transport-orders/${otId}`, {
              headers: { Authorization: `Bearer ${token}` },
            }).then(r => r.ok ? r.json() : null).catch(() => null)
          ));
          const validOrders = fresh.filter(o => o && (o.id || o._id));
          if (validOrders.length >= 2) {
            setVehicleAssignOrderId(null);
            // Pass the pin/picker selections so the VRP honours the
            // operator's choice of starting OT and the dispatch flow can
            // apply the custom departure / arrival overrides.
            await handleConsolidateRoutes(otIds, validOrders, {
              firstStopOTId: customDepartureLocationId?.startsWith?.('ot:')
                ? customDepartureLocationId.slice(3)
                : null,
              customDepartureId: (customDepartureLocationId && !customDepartureLocationId.startsWith('ot:'))
                ? customDepartureLocationId : '',
              customArrivalId: customArrivalLocationId,
            });
            // IMPORTANTE: repor o estado de "a atribuir" antes de sair — sem
            // isto ficava preso em true e, ao reabrir o ecrã de atribuição,
            // os botões apareciam como "..." (estado de loading fantasma).
            setVehicleAssigning(false);
            return;
          }
        } catch (err) {
          console.warn('[Bulk Planificar] fallback to single-OT path:', err);
        }
      }

      // If "Assign + Create Route" — go straight to planner with all data
      if (andCreateRoute && data.order) {
        // Re-fetch the OT fresh from the API. `data.order` from `/assign-vehicle`
        // is authoritative in theory but we've seen occasional stale reads where
        // `serviceType` comes back as 'delivery' even though the DB has 'fuel'.
        // A cheap GET here makes the fuel-route path deterministic.
        let order = data.order;
        try {
          const freshRes = await fetch(`/planner-api/transport-orders/${order.id}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (freshRes.ok) {
            const fresh = await freshRes.json();
            if (fresh && fresh.id) order = fresh;
          }
        } catch { /* fall back to data.order */ }

        dispatch(clearRoute());
        dispatch(setSourceOTId(order.id));
        // Re-plano de OT de combustível: se a OT já tem uma rota, REUTILIZA
        // esse registo (dbId) para o gravar ser um UPDATE (PUT) em vez de
        // criar uma rota nova e deixar a antiga órfã. Gated a fuel: estas
        // OTs são sempre 1 OT ↔ 1 rota. Se a rota estiver terminal, o
        // backend devolve 409 (agora com toast) e o operador reabre.
        if (order.serviceType === 'fuel' && order.assignedRouteId) {
          dispatch(setRouteDbId(order.assignedRouteId));
        }
        dispatch(setRouteName(order.orderNumber || `OT-${order.id}`));
        if (order.cargoDescription) dispatch(setCargoRef(order.cargoDescription));

        const pLat = Number(order.pickupLat), pLng = Number(order.pickupLng);
        const dLat = Number(order.deliveryLat), dLng = Number(order.deliveryLng);
        const pName = order.pickupName || order.pickupAddress || '';
        const dName = order.deliveryName || order.deliveryAddress || '';

        // ─── New unified routing model ──────────────────────────────
        //   Origin    = customDepartureLocationId OR per-type default
        //   Waypoints = OT-specific intermediate points (pickup/delivery)
        //   Destination = customArrivalLocationId OR per-type default
        // The dropdowns in the assign-vehicle dialog populate the two
        // location ids; here we resolve them to coordinates and construct
        // the actual route array.
        const isFuel = order.serviceType === 'fuel';
        const isAssist = order.serviceType === 'assistance';

        // Driver picked manually in the dialog — the home is used as a
        // potential origin/destination for assistance OTs (and as fallback
        // when the OT carries an `assignedDriverId`).
        const otDriver = (manualDriverId && allDrivers.find(d => String(d.id) === String(manualDriverId)))
          || (order.driverId && allDrivers.find(d => Number(d.id) === Number(order.driverId)))
          || null;
        const driverHome = (otDriver?.homeLat && otDriver?.homeLng) ? {
          name: `🏠 ${(otDriver.name || '').split(/\s+/).slice(0, 2).join(' ').trim() || 'Motorista'}`,
          address: otDriver.homeAddress || null,
          lat: Number(otDriver.homeLat),
          lng: Number(otDriver.homeLng),
        } : null;

        // Base operacional do tenant — favorito tipo 'garage' (oficina/sede).
        // Preferimos o que tem `isPreferred=true`; senão, o primeiro activo.
        // Em tenants sem favorito tipo garage (todos os PT actuais), fica
        // null e o despacho volta ao comportamento original (GPS → driverHome).
        const garages = (allLocations || []).filter(l =>
          l.type === 'garage' && l.isActive !== false && l.latitude != null && l.longitude != null,
        );
        const garagePick = garages.find(l => l.isPreferred) || garages[0] || null;
        const tenantBase = garagePick ? {
          name: `🏢 ${garagePick.name || (lang === 'pt' ? 'Base' : 'Base')}`,
          address: garagePick.address || null,
          lat: Number(garagePick.latitude),
          lng: Number(garagePick.longitude),
        } : null;

        const serviceLocation = (dLat && dLng) ? {
          name: dName || 'Local de serviço',
          lat: dLat, lng: dLng,
        } : null;
        const otPickup = (pLat && pLng) ? {
          name: pName || 'Recolha', lat: pLat, lng: pLng,
        } : null;
        const otDelivery = serviceLocation; // alias for delivery/fuel
        // Fase B — 2.º P.A. de uma entrega dividida (só fuel + splitDelivery +
        // GPS do 2.º posto conhecido). A cisterna descarrega em P.A.1 e depois
        // P.A.2; P.A.1 passa a paragem intermédia e P.A.2 fica o destino.
        const otDelivery2 = (isFuel && order.splitDelivery
          && order.deliveryLat2 != null && order.deliveryLng2 != null) ? {
            name: order.deliveryName2 || 'P.A. 2',
            lat: Number(order.deliveryLat2), lng: Number(order.deliveryLng2),
          } : null;

        function resolveById(idStr) {
          if (!idStr) return null;
          if (idStr === 'service') return serviceLocation;
          if (idStr === 'driver-home') return driverHome;
          const loc = (allLocations || []).find(l => String(l.id) === String(idStr));
          if (loc?.latitude && loc?.longitude) {
            return { name: loc.name, address: loc.address || null, lat: Number(loc.latitude), lng: Number(loc.longitude) };
          }
          return null;
        }

        // Resolve origin: explicit picker > per-type default.
        //
        // For ASSISTANCE with no explicit picker:
        //   1) driverHome — if the picked driver has one registered
        //   2) live GPS of the picked vehicle — typical case when there's
        //      neither a registered home nor an explicit choice (the
        //      driver is wherever the truck is right now)
        //   3) serviceLocation — last resort, but produces a zero-km
        //      route (origin == destination); guarded below so the
        //      dispatch is aborted with a toast instead of saving
        //      garbage.
        let origin = resolveById(customDepartureLocationId);
        if (!origin) {
          // Helper: posição GPS actual do veículo via Redux vehicles slice
          // (alimentado por polling Traccar). Null quando o veículo nunca
          // reportou ou está offline há muito tempo.
          const liveVehicle = vehicle && vehicles.find(v => Number(v.id) === Number(vehicle.id));
          const livePos = liveVehicle?.position;
          const liveGPS = (livePos?.latitude != null && livePos?.longitude != null)
            ? {
                name: lang === 'pt' ? '🚗 Posição actual do veículo' : '🚗 Current vehicle position',
                lat: Number(livePos.latitude),
                lng: Number(livePos.longitude),
              }
            : null;
          if (customDepartureLocationId === 'vehicle' && liveGPS) {
            // Escolha EXPLÍCITA "Local atual do veículo" (dropdown = 'vehicle').
            // resolveById('vehicle') devolve null (não é favorito/service/
            // driver-home), por isso caía aqui. O GPS do veículo tem de ganhar
            // para TODOS os tipos, ANTES do default por tipo — caso contrário,
            // no fuel, fetchDepartureLocation() (a base) sobrepunha-se à escolha
            // do operador (bug: partida assumia a base e não o veículo).
            origin = liveGPS;
          }
          else if (isAssist) {
            // Assistência sem escolha explícita no dropdown ("Auto").
            // O default real foi aplicado no useEffect via Preferências →
            // "Local de partida por tipo de OT". Se chegámos aqui é porque
            // o operador limpou o dropdown propositadamente OU a preferência
            // resolveu para 'auto'. Fallback histórico: GPS > driver home.
            origin = liveGPS || driverHome || null;
          }
          else if (isFuel) {
            // Fuel com a dropdown em AUTO (""): o label promete "Local atual do
            // veículo, ou 1ª paragem" — por isso o GPS do veículo GANHA aqui.
            // A BASE (parque) NÃO desaparece como default: é aplicada como
            // escolha explícita via resolveDefaultDeparture (a dropdown abre
            // pré-seleccionada no favorito → resolvido por resolveById acima,
            // sem chegar a este ramo). Só quando o operador LIMPA para AUTO é
            // que caímos aqui, e aí a intenção é mesmo o veículo. Fallback à
            // base (veículo sem GPS) e depois ao pickup da OT.
            origin = liveGPS || (await fetchDepartureLocation()) || otPickup || null;
          }
          else {
            // Delivery: dropdown vazio → GPS do veículo, depois pickup.
            origin = liveGPS || otPickup || null;
          }
        }

        // Resolve destination: explicit picker > per-type default.
        // The arrival picker is the SOURCE OF TRUTH — operator's choice in
        // the dialog wins. The OT's legacy `returnHome` flag is only used
        // to pre-fill the dropdown when the dialog opens; once the dialog
        // is open the dropdown value is what dictates where the route ends.
        let destination = resolveById(customArrivalLocationId);
        if (!destination) {
          // No arrival override → end at OT delivery (the service location
          // for assistance, the customer for delivery/fuel). Entrega dividida:
          // termina no ÚLTIMO posto (P.A.2), com P.A.1 como paragem intermédia.
          destination = otDelivery2 || otDelivery || null;
        }
        // Fuel sem destino conhecido (PA por revelar no carregamento): o
        // terminal de carga vira destino — rota single-leg ZZE → TCPL.
        // Quando o operador preencher o PA depois, recalcula-se.
        if (isFuel && !destination && otPickup) {
          destination = otPickup;
        }

        // Build the intermediate waypoints needed between origin and destination.
        // For assistance: service location IF it is not already the origin/destination.
        // For delivery/fuel: pickup IF a different origin was chosen, then delivery
        // if a different destination was chosen (i.e. arrival is a warehouse).
        const samePoint = (a, b) => a && b && Math.abs(a.lat - b.lat) < 1e-6 && Math.abs(a.lng - b.lng) < 1e-6;

        const intermediates = [];
        if (isAssist) {
          if (serviceLocation && !samePoint(origin, serviceLocation) && !samePoint(destination, serviceLocation)) {
            intermediates.push({
              ...serviceLocation,
              // Assistência: local de SERVIÇO técnico (não entrega).
              // Operador agora vê "🔧 Assistência" em vez de "↓ Entrega".
              waypointKind: 'service',
              otId: order.id,
              orderNumber: order.orderNumber,
              stopDuration: order.unloadingTime || 30,
            });
          }
        } else {
          // Para fuel sem delivery, pickup já é destino acima — não
          // adicionar como intermediário (evita duplicar TCPL waypoint + destino).
          if (otPickup && !samePoint(origin, otPickup) && !samePoint(destination, otPickup)) {
            intermediates.push({
              ...otPickup,
              waypointKind: 'pickup',
              otId: order.id,
              orderNumber: order.orderNumber,
              stopDuration: 15,
            });
          }
          if (otDelivery && !samePoint(destination, otDelivery)) {
            intermediates.push({
              ...otDelivery,
              waypointKind: 'delivery',
              otId: order.id,
              orderNumber: order.orderNumber,
              stopDuration: order.unloadingTime || 0,
            });
          }
          // Fase B — 2.º P.A. da entrega dividida como paragem (fica após P.A.1).
          // É saltado quando já é o destino (samePoint) para não duplicar.
          if (otDelivery2 && !samePoint(destination, otDelivery2)) {
            intermediates.push({
              ...otDelivery2,
              waypointKind: 'delivery',
              otId: order.id,
              orderNumber: order.orderNumber,
              stopDuration: order.unloadingTime || 0,
            });
          }
        }

        // Guard: only abort when the route literally has no work to do
        // (origin == destination AND no intermediate stop in between). For
        // assistance with return-home (home → service → home), origin and
        // destination ARE intentionally the same point and the service
        // location lives in the intermediates — that's a valid 2×N route,
        // not a bug.
        if (origin && destination && samePoint(origin, destination) && intermediates.length === 0) {
          dispatch(addToast({
            type: 'warning',
            message: lang === 'pt'
              ? '⚠ A rota não tem paragens — origem, destino e local de serviço coincidem. Escolhe um Local de Partida diferente ou um Local de Chegada diferente.'
              : '⚠ The route has no stops — origin, destination and service location all coincide. Pick a different Departure or Arrival.',
            duration: 8000,
          }));
          setVehicleAssigning(false);
          return;
        }

        // Apply to Redux store
        if (origin) {
          dispatch(setOrigin({ name: origin.name, coordinates: [origin.lng, origin.lat] }));
        }
        intermediates.forEach(wp => {
          dispatch(addWaypoint({
            name: wp.name,
            coordinates: [wp.lng, wp.lat],
            stopDuration: wp.stopDuration || 0,
            waypointKind: wp.waypointKind,
            otId: wp.otId,
            orderNumber: wp.orderNumber,
          }));
        });
        if (destination) {
          // Quando o destino é o local de serviço/entrega da OT, anexa a
          // metadata (orderNumber/customRef/waypointKind) para o painel
          // mostrar o badge "OT XXXX" debaixo do destino — caso contrário
          // (favorito, casa do motorista) deixa só name+coordinates.
          const destIsOTDelivery = otDelivery
            && Math.abs(destination.lat - otDelivery.lat) < 1e-5
            && Math.abs(destination.lng - otDelivery.lng) < 1e-5;
          const wpKind = order.serviceType === 'assistance' ? 'service'
            : order.serviceType === 'fuel' ? 'fuel'
            : 'delivery';
          dispatch(setDestination({
            name: destination.name,
            coordinates: [destination.lng, destination.lat],
            ...(destIsOTDelivery ? {
              otId: order.id,
              orderNumber: order.orderNumber,
              customRef: (order.customRef || '').trim() || null,
              waypointKind: wpKind,
              stopDuration: order.unloadingTime || 0,
              agreedPrice: order.agreedPrice ? Number(order.agreedPrice) : null,
            } : {}),
          }));
        }
        if (order.vehicleId) dispatch(setVehicle({ id: order.vehicleId, plate: plate || '', type: '' }));
        // Cisternas atreladas (fuel, até 2) — para o resumo da rota mostrar
        // as cisternas além do tractor. Usa o array `cisterns` da OT fresca e
        // cai ao campo singular antigo quando não existe.
        if (isFuel) {
          const otCisterns = Array.isArray(order.cisterns) && order.cisterns.length
            ? order.cisterns
            : (order.cisternVehicleId
                ? [{ vehicleId: order.cisternVehicleId, plate: order.cisternPlate, capacityM3: order.cisternCapacityM3 != null ? Number(order.cisternCapacityM3) : null }]
                : []);
          dispatch(setRouteCisterns(otCisterns));
        }
        // Passar id + name para a MapToolbar saber que há motorista atribuído
        // (a condição "Gravar e Despachar" depende de route.driverId, não name).
        if (driver) {
          const driverId = manualDriver?.id || (order.driverId ? Number(order.driverId) : null);
          dispatch(setDriver({ id: driverId, name: driver }));
        }

        // Set delivery window for ETA comparison in header
        if (order.deliveryWindowFrom) {
          dispatch(require('../../store/slices/routesSlice').setArrivalTimeWindow({
            start: order.deliveryWindowFrom,
            end: order.deliveryWindowTo || null,
          }));
        }

        dispatch(setSidebarVisible(true));
        dispatch(setSidebarTab(0)); // Force "Rota" tab
        dispatch(navigateTo('planner'));
        // Auto-calculate as soon as the planner mounts. We trigger on the
        // RESOLVED origin/destination (driver home, custom favourite, etc.)
        // — not on the OT's legacy pickup/delivery fields, which are NULL
        // for assistance OTs. Without this, assistance routes landed in
        // the planner with empty geometry and no Save / Dispatch buttons.
        if (origin && destination) {
          setTimeout(() => dispatch(setNeedsRecalculation(true)), 200);
        }

        setVehicleAssignOrderId(null);
      }
    } catch (e) { console.error(e); }
    setVehicleAssigning(false);
  }

  // Track position — open map with route + vehicle position + monitoring panel
  // Shared helper: load route + open planner + pass OT monitoring context.
  // The `mode` parameter decides what happens to the map camera once everything is ready:
  //   'vehicle' — zoom/focus on the vehicle current position (used by "Consultar posição")
  //   'route'   — fit the camera to the full route bounds (used by "Ver rota no mapa")
  async function loadOTOnMap(order, mode = 'vehicle') {
    const routeId = order.assignedRouteId || order.route?.id;
    if (!routeId || !token) return;

    // Clear any lingering OT-leg highlight from a previous view, before loading the new route.
    window.dispatchEvent(new CustomEvent('highlightOTLeg', { detail: { orderId: null } }));

    // ── Build per-leg breakdown using the ROUTE's waypoint order (not OT
    // sort-by-window which is unreliable when all OTs share the same window).
    // We fetch the route directly so we have:
    //   · `waypoints` in the actual delivery order picked by the VRP
    //   · `routeData.computedRoute.geometry.coordinates` for cumulative km
    //   · `totalDurationS` to spread across legs proportionally to distance
    let routeRecord = null;
    try {
      const r = await fetch(`/planner-api/routes/${routeId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (r.ok) routeRecord = await r.json();
    } catch { /* fall back to OT-derived legs below */ }

    const siblings = list.filter(o => o.assignedRouteId === order.assignedRouteId);
    const otsById = new Map(siblings.map(o => [Number(o.id || o._id), o]));
    const coords = routeRecord?.routeData?.computedRoute?.geometry?.coordinates || [];

    // Cumulative km along the polyline (haversine, computed once).
    function haversineKm(a, b) {
      const R = 6371;
      const toRad = d => d * Math.PI / 180;
      const dLat = toRad(b[1] - a[1]);
      const dLng = toRad(b[0] - a[0]);
      const lat1 = toRad(a[1]), lat2 = toRad(b[1]);
      const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
      return 2 * R * Math.asin(Math.sqrt(h));
    }
    const cum = [];
    if (coords.length > 1) {
      cum[0] = 0;
      for (let i = 1; i < coords.length; i++) cum[i] = cum[i - 1] + haversineKm(coords[i - 1], coords[i]);
    }
    function nearestIdx(lng, lat) {
      if (coords.length === 0) return 0;
      let best = 0, bestD = Infinity;
      for (let i = 0; i < coords.length; i++) {
        const dx = coords[i][0] - lng;
        const dy = coords[i][1] - lat;
        const d = dx * dx + dy * dy;
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }

    // Walk the route's delivery waypoints (in order) and build legs whose
    // ORIGIN is the previous stop's name — exactly what the operator sees on
    // the road, not the OT's stored "pickup" (which is the route start in
    // shared-pickup workflows like Petrotec assistance).
    //
    // Distance/duration source priority (most accurate first):
    //   1. routeData.computedRoute.legs — HERE's per-section summary
    //      (length/baseDuration). Same source the backend uses in
    //      computeOTLegSummary. Aligns to actual route points 1:1, no
    //      polyline-snapping needed.
    //   2. Polyline-cumulative haversine + proportional time split.
    //      Used only if HERE legs are missing.
    //   3. Per-OT otLegDistanceM/otLegDurationS already on the order.
    const totalKm = cum.length ? cum[cum.length - 1] : 0;
    const totalDurationS = Number(routeRecord?.totalDurationS || routeRecord?.routeData?.computedRoute?.duration || 0);
    const routeOriginName = routeRecord?.origin?.text || routeRecord?.origin?.name || routeRecord?.origin?.address || 'Origem da rota';
    const deliveryWps = (routeRecord?.waypoints || []).filter(w => w?.waypointKind === 'delivery' && w?.otId && Array.isArray(w?.coordinates));

    // HERE legs (preferred). For N route points (origin + waypoints + destination)
    // HERE returns N-1 legs. Index of each delivery waypoint inside the full
    // `points` list lets us identify which legs to sum for each OT segment.
    const hereLegs = (() => {
      const rd = routeRecord?.routeData || {};
      const arr = (rd.computedRoute && Array.isArray(rd.computedRoute.legs))
        ? rd.computedRoute.legs
        : (Array.isArray(rd.legs) ? rd.legs : []);
      return Array.isArray(arr) ? arr : [];
    })();
    const allWaypoints = Array.isArray(routeRecord?.waypoints) ? routeRecord.waypoints : [];
    function legSumFromHere(fromIdx, toIdx) {
      if (!hereLegs.length || fromIdx >= toIdx) return null;
      let m = 0, s = 0;
      let any = false;
      for (let i = fromIdx; i < toIdx; i++) {
        const l = hereLegs[i];
        if (!l) continue;
        const lm = Number(l.summary?.length || 0);
        const ls = Number(l.summary?.baseDuration || l.summary?.duration || 0);
        m += lm; s += ls;
        if (lm > 0 || ls > 0) any = true;
      }
      return any ? { km: m / 1000, min: Math.round(s / 60) } : null;
    }

    let routeLegs = [];
    let orderedOTIds = [];
    if (deliveryWps.length > 0 && coords.length > 1) {
      // pointIdx 0 = origin, then each waypoint in order, last = destination.
      let prevPointIdx = 0;
      let prevIdx = 0;
      let prevName = routeOriginName;
      for (const wp of deliveryWps) {
        const otId = Number(wp.otId);
        const ot = otsById.get(otId);
        const [lng, lat] = wp.coordinates;
        const idx = nearestIdx(Number(lng), Number(lat));
        // Position of this waypoint inside the full points list (origin + wps + dest)
        const wpIdxInAll = allWaypoints.indexOf(wp);
        const pointIdx = wpIdxInAll >= 0 ? (wpIdxInAll + 1) : -1;
        // 1) Try HERE legs (most accurate)
        let legKm = null, legMin = null;
        if (pointIdx > prevPointIdx) {
          const here = legSumFromHere(prevPointIdx, pointIdx);
          if (here) { legKm = here.km; legMin = here.min; }
        }
        // 2) Fallback: polyline cumulative
        if (legKm == null) {
          legKm = Math.max(0, cum[idx] - cum[prevIdx]);
          const fracTime = totalKm > 0 ? legKm / totalKm : 0;
          legMin = totalDurationS > 0 ? Math.round((totalDurationS * fracTime) / 60) : null;
        }
        const deliveryName = ot?.deliveryName || ot?.deliveryAddress || wp.name || `OT ${ot?.orderNumber || otId}`;
        routeLegs.push({
          orderId: otId,
          orderNumber: ot?.orderNumber || `OT-${otId}`,
          distanceKm: legKm,
          durationMin: legMin,
          pickupName: prevName,
          deliveryName,
          status: ot?.status || 'unknown',
        });
        orderedOTIds.push(otId);
        prevName = deliveryName;
        prevIdx = idx;
        if (pointIdx > 0) prevPointIdx = pointIdx;
      }
      // Append the return leg (last delivery → route destination) when the
      // destination differs from the last waypoint. Typical in assistance
      // routes with return_home=true: the final card reads e.g. "BP
      // Constituição → 🏠 Regresso a casa de James".
      //
      // Edge case: when origin == destination (round-trip / return-home), the
      // polyline starts AND ends at home. Calling nearestIdx for the
      // destination coordinates would match index 0 (the home at the start),
      // making the leg "negative" → clamped to 0 km / 0 min. We use the LAST
      // index of the polyline instead since by construction the polyline ends
      // at the destination.
      const destCoords = routeRecord?.destination?.coordinates;
      const dest = routeRecord?.destination;
      if (Array.isArray(destCoords) && deliveryWps.length > 0 && coords.length > 1) {
        const lastWp = deliveryWps[deliveryWps.length - 1];
        const sameSpot =
          Math.abs(Number(lastWp.coordinates[0]) - Number(destCoords[0])) < 0.0001
          && Math.abs(Number(lastWp.coordinates[1]) - Number(destCoords[1])) < 0.0001;
        if (!sameSpot) {
          const destIdx = coords.length - 1;
          // 1) Prefer HERE legs (sum from last waypoint to end-of-route)
          const destPointIdx = allWaypoints.length + 1; // origin(0) + WPs + destination
          let legKm = null, legMin = null;
          if (destPointIdx > prevPointIdx) {
            const here = legSumFromHere(prevPointIdx, destPointIdx);
            if (here) { legKm = here.km; legMin = here.min; }
          }
          // 2) Fallback: polyline cumulative
          if (legKm == null) {
            legKm = Math.max(0, cum[destIdx] - cum[prevIdx]);
            const fracTime = totalKm > 0 ? legKm / totalKm : 0;
            legMin = totalDurationS > 0 ? Math.round((totalDurationS * fracTime) / 60) : null;
          }
          const destName = dest?.text || dest?.name || 'Regresso';
          // Se o destino tem metadata de OT (caso típico: a última OT
          // do consolidador vira o destino em vez de waypoint), trata-o
          // como leg normal de OT. Caso contrário é um regresso a casa
          // / parque (ex: shouldReturnHome=true acrescentou um arrival
          // sem orderNumber).
          const destOtId = dest?.otId ? Number(dest.otId) : null;
          if (destOtId) {
            const destOt = otsById.get(destOtId);
            routeLegs.push({
              orderId: destOtId,
              orderNumber: dest.orderNumber || destOt?.orderNumber || `OT-${destOtId}`,
              distanceKm: legKm,
              durationMin: legMin,
              pickupName: prevName,
              deliveryName: destName,
              status: destOt?.status || 'unknown',
            });
            orderedOTIds.push(destOtId);
          } else {
            routeLegs.push({
              orderId: '__return__',
              orderNumber: 'Regresso',
              distanceKm: legKm,
              durationMin: legMin,
              pickupName: prevName,
              deliveryName: destName,
              status: 'return',
              isReturn: true,
            });
          }
        }
      }
    } else {
      // Fallback (no waypoints metadata) — keep old behaviour but clearly mark
      // origin as "início da rota" to avoid the misleading "Casa do James → X"
      // for every leg.
      const sortedSiblings = [...siblings].sort((a, b) => {
        const ta = new Date(a.deliveryWindowFrom || a.pickupWindowFrom || a.createdAt || 0).getTime();
        const tb = new Date(b.deliveryWindowFrom || b.pickupWindowFrom || b.createdAt || 0).getTime();
        return ta - tb;
      });
      orderedOTIds = sortedSiblings.map(o => o.id || o._id);
      routeLegs = sortedSiblings.length > 1
        ? sortedSiblings.map((o, i) => ({
            orderId: o.id || o._id,
            orderNumber: o.orderNumber,
            distanceKm: o.otLegDistanceM != null ? o.otLegDistanceM / 1000 : null,
            durationMin: o.otLegDurationS != null ? Math.round(o.otLegDurationS / 60) : null,
            pickupName: i === 0 ? routeOriginName : (sortedSiblings[i - 1].deliveryName || sortedSiblings[i - 1].deliveryAddress || ''),
            deliveryName: o.deliveryName || o.deliveryAddress || '',
            status: o.status,
          }))
        : [];
    }

    // Clear current route first, then load
    dispatch(clearRoute());
    setTimeout(() => {
      dispatch(fetchRouteDetail({ token, routeId }));
      dispatch(setReadOnly(true));
      dispatch(setSidebarVisible(true));
      dispatch(setSidebarTab(0));
      dispatch(setShowDetails(true));
      dispatch(navigateTo('planner'));
      window.__fromOTScreen = true;
      window.__monitoringOT = {
        orderId: order.id || order._id,
        orderNumber: order.orderNumber,
        vehicleId: order.vehicleId,
        vehiclePlate: order.vehiclePlate,
        driverName: order.driverName,
        status: order.status,
        pickupName: order.pickupName || order.pickupAddress,
        deliveryName: order.deliveryName || order.deliveryAddress,
        deliveryWindowFrom: order.deliveryWindowFrom,
        deliveryWindowTo: order.deliveryWindowTo,
        estimatedArrival: order.estimatedArrival,
        distanceKm: order.distanceKm,
        actualStartAt: order.actualStartAt,
      };
      window.__monitoringRouteLegs = routeLegs;
    }, 100);

    if (mode === 'vehicle' && order.vehicleId) {
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('focusSingleVehicle', { detail: { id: order.vehicleId } }));
      }, 900);
    } else {
      // Na abertura NÃO destacamos nenhum troço a laranja — a rota inteira fica
      // azul (inRouteInspectMode via routeLegs). Só ao clicar num card de paragem
      // é que esse troço passa a laranja (highlightOTLeg disparado pelo AppLayout).
      const highlightDetail = { orderId: null, orderedOTIds, routeLegs };
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('focusSingleVehicle', { detail: { id: null } }));
        window.dispatchEvent(new CustomEvent('setVehiclesVisibility', { detail: { visible: false } }));
        window.dispatchEvent(new CustomEvent('highlightOTLeg', { detail: highlightDetail }));
        window.dispatchEvent(new CustomEvent('fitRouteBounds'));
      }, 900);
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('fitRouteBounds'));
        window.dispatchEvent(new CustomEvent('highlightOTLeg', { detail: highlightDetail }));
      }, 1600);
    }
  }

  function handleTrackPosition(order) {
    return loadOTOnMap(order, 'vehicle');
  }

  // Open the route-level live monitor for an OT. The "live" concept belongs
  // to a route (one or more OTs sharing a vehicle/driver/trajectory), not to
  // a single OT — so this helper navigates to Operações → Rotas and opens
  // the LiveRouteMonitor for the OT's assigned route. If the OT has no
  // route, falls back to a toast (operator probably needs to dispatch first).
  function goToLiveRouteMonitor(order) {
    const routeId = order?.assignedRouteId;
    if (!routeId) {
      dispatch(addToast({
        type: 'warning',
        message: lang === 'pt'
          ? 'OT sem rota associada — atribui um veículo e cria a rota primeiro.'
          : 'OT has no associated route — dispatch a vehicle first.',
      }));
      return;
    }
    // Navigate to Operações > Rotas with this route highlighted/scrolled
    // into view, but DON'T auto-open the live monitor. The operator
    // chooses whether to drill in (clicking "Ver em tempo real" on the
    // row) — auto-opening was disorienting and skipped the list view.
    window.__highlightRouteId = routeId;
    dispatch(navigateTo('manage'));
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('manageOpenSection', { detail: { section: 'routes-library' } }));
    }, 100);
  }

  function handleViewRouteOnMap(order) {
    return loadOTOnMap(order, 'route');
  }

  // Recalculate ETA for an in-transit order based on current vehicle position
  async function handleRecalcETA(order) {
    const oid = order.id || order._id;
    if (!token || !oid) return;
    try {
      // Get current vehicle position from the vehicles list
      const vehicleRes = await fetch('/planner-api/vehicles', { headers: { Authorization: `Bearer ${token}` } });
      const vehicles = await vehicleRes.json();
      const vehicle = vehicles.find(v => v.id === order.vehicleId);

      if (!vehicle?.position) return;

      const lat = vehicle.position.latitude;
      const lng = vehicle.position.longitude;
      const destLat = order.deliveryLat || order.delivery?.lat;
      const destLng = order.deliveryLng || order.delivery?.lng;

      if (!destLat || !destLng) return;

      // Calculate remaining distance (simple haversine)
      const R = 6371;
      const dLat = (Number(destLat) - lat) * Math.PI / 180;
      const dLng = (Number(destLng) - lng) * Math.PI / 180;
      const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat * Math.PI / 180) * Math.cos(Number(destLat) * Math.PI / 180) * Math.sin(dLng / 2) ** 2;
      const remainKm = Math.round(R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
      const remainMin = Math.round(remainKm / 1.1); // ~66 km/h avg for trucks
      const newETA = new Date(Date.now() + remainMin * 60000);

      // Update OT with recalculated data
      await fetch(`/planner-api/transport-orders/${oid}`, {
        method: 'PATCH',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          estimatedArrival: newETA.toISOString(),
          distanceKm: remainKm,
          drivingTimeMin: remainMin,
        }),
      });
      doFetch();
    } catch (e) { console.error('Recalc ETA error:', e); }
  }

  // Retirar OT de uma rota mantendo veículo/motorista atribuídos.
  // Abre um ConfirmDialog (profissional) com o detalhe — apenas dispara
  // a chamada API quando o operador confirma. Para o estado dos botões
  // do dialog usamos um state separado `removeFromRouteOT` que guarda a
  // OT em causa enquanto o popup está aberto.
  function handleRemoveOTFromRoute(order) {
    if (!order?.assignedRouteId) return;
    setRemoveFromRouteOT(order);
  }

  async function performRemoveOTFromRoute() {
    const order = removeFromRouteOT;
    if (!order) return;
    const oid = order.id || order._id;
    const otRef = order.customRef || order.orderNumber || `OT-${oid}`;
    const routeRef = order.routeName || order.assignedRoute?.name || `Rota #${order.assignedRouteId}`;
    try {
      const res = await fetch(`/planner-api/routes/${order.assignedRouteId}/remove-ot`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ otId: oid }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || 'Falha ao retirar OT da rota');
      }
      dispatch(addToast({
        type: 'success',
        message: lang === 'pt'
          ? `✓ ${otRef} retirada de ${routeRef}. Veículo/motorista mantidos.`
          : `✓ ${otRef} removed from ${routeRef}. Vehicle/driver kept.`,
        duration: 6000,
      }));
      doFetch();
      dispatch(fetchSavedRoutes(token));
    } catch (e) {
      dispatch(addToast({
        type: 'error',
        message: (lang === 'pt' ? 'Erro: ' : 'Error: ') + (e?.message || e),
      }));
    }
  }

  // Full workflow: Assign + Plan + Dispatch with confirmation dialog
  function prepareFullDispatch() {
    if (!vehicleAssignOrderId || !selectedVehicleId) return;
    const vehicle = availableVehicles.find(v => String(v.id) === selectedVehicleId);
    const order = list.find(o => String(o._id || o.id) === String(vehicleAssignOrderId));
    if (!order) { console.warn('Order not found for dispatch:', vehicleAssignOrderId); return; }

    // Driver — preferir o motorista escolhido manualmente; fallback ao
    // motorista já gravado na OT; fallback ao driver agregado ao veículo.
    const driverIdResolved = manualDriverId
      ? parseInt(manualDriverId)
      : (order.driverId || vehicle?.driver?.id || null);
    const driverRecord = driverIdResolved
      ? allDrivers.find(d => Number(d.id) === Number(driverIdResolved))
      : null;
    const driverNameResolved = driverRecord?.name
      || vehicle?.driver?.name
      || vehicle?.tacho?.driverName
      || '—';
    const driverPhoneResolved = driverRecord?.phone || vehicle?.driver?.phone || null;

    // Origin display — replicar a lógica de executeFullDispatch sem
    // disparar nada (apenas para mostrar nome+morada no popup).
    const livePos = vehicle?.position;
    const choice = customDepartureLocationId;
    let originName = null;
    let originAddress = null;
    if (choice === 'service' && order.deliveryLat && order.deliveryLng) {
      originName = order.deliveryName || order.deliveryAddress || (lang === 'pt' ? 'Local de serviço' : 'Service location');
      originAddress = order.deliveryAddress || null;
    } else if (choice === 'driver-home' && driverRecord?.homeLat && driverRecord?.homeLng) {
      originName = `🏠 ${driverRecord.name}`;
      originAddress = driverRecord.homeAddress || null;
    } else if (choice === 'vehicle' && livePos?.latitude != null && livePos?.longitude != null) {
      originName = lang === 'pt' ? '🚗 Posição actual do veículo' : '🚗 Current vehicle position';
      originAddress = livePos.address || livePos.formattedAddress || null;
    } else if (choice && (allLocations || []).length) {
      const loc = (allLocations || []).find(l => String(l.id) === String(choice));
      if (loc?.latitude && loc?.longitude) {
        originName = loc.name;
        originAddress = loc.address || null;
      }
    } else if (!choice && (order.serviceType === 'assistance' || order.serviceType === 'fuel') && livePos?.latitude != null) {
      // Auto em assistência E combustível: prefere GPS do veículo (o camião
      // parte de onde está → estimativa realista). Ver executeFullDispatch.
      originName = lang === 'pt' ? '🚗 Posição actual do veículo' : '🚗 Current vehicle position';
      originAddress = livePos.address || livePos.formattedAddress || null;
    }

    setConfirmDispatchData({
      orderId: vehicleAssignOrderId,
      orderNumber: order.orderNumber,
      pickupName: order.pickupName || order.pickupAddress || '—',
      deliveryName: order.deliveryName || order.deliveryAddress || '—',
      pickupWindow: order.pickupWindowFrom ? new Date(order.pickupWindowFrom).toLocaleString('pt-PT', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—',
      deliveryWindow: order.deliveryWindowFrom ? new Date(order.deliveryWindowFrom).toLocaleString('pt-PT', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—',
      vehicleId: parseInt(selectedVehicleId),
      vehiclePlate: vehicle?.plate || '—',
      driverName: driverNameResolved,
      driverId: driverIdResolved,
      driverPhone: driverPhoneResolved,
      originName,
      originAddress,
      unloadingTime: unloadingTime ? parseInt(unloadingTime) : 0,
      cargo: [order.cargoDescription, order.cargoWeight ? `${order.cargoWeight}kg` : '', order.cargoPallets ? `${order.cargoPallets}p` : ''].filter(Boolean).join(' · ') || '—',
      serviceType: order.serviceType || 'delivery',
    });
  }

  async function executeFullDispatch() {
    if (!confirmDispatchData) return;
    setVehicleAssigning(true);
    try {
      // Resolver a escolha do operador (dropdown "Local de partida") em
      // coordenadas concretas para enviar ao backend. Suporta:
      //   ''           → Auto: GPS do veículo > casa do motorista > null
      //   'service'    → coordenadas do local de serviço (assistência)
      //   'driver-home'→ coordenadas da casa do motorista escolhido
      //   'vehicle'    → posição GPS actual do veículo (slice vehicles)
      //   '<id>'       → favorito local pelos seus lat/lng
      // Sem isto, a escolha "driver-home"/"service"/"vehicle" era ignorada
      // (caía sempre no fallback do backend = pickup criado com a OT).
      let departureLocation = null;
      const order = list.find(o => String(o._id || o.id) === String(confirmDispatchData.orderId));
      const pickedDriver = manualDriverId
        ? allDrivers.find(d => String(d.id) === String(manualDriverId))
        : (order?.driverId ? allDrivers.find(d => String(d.id) === String(order.driverId)) : null);
      const liveVehicle = confirmDispatchData.vehicleId
        ? vehicles.find(v => Number(v.id) === Number(confirmDispatchData.vehicleId))
        : null;
      const livePos = liveVehicle?.position;

      const choice = customDepartureLocationId;
      if (choice === 'service' && order?.deliveryLat && order?.deliveryLng) {
        departureLocation = {
          name: order.deliveryName || order.deliveryAddress || 'Local de serviço',
          address: order.deliveryAddress || null,
          lat: Number(order.deliveryLat), lng: Number(order.deliveryLng),
        };
      } else if (choice === 'driver-home' && pickedDriver?.homeLat && pickedDriver?.homeLng) {
        departureLocation = {
          name: `🏠 ${pickedDriver.name}`,
          address: pickedDriver.homeAddress || null,
          lat: Number(pickedDriver.homeLat), lng: Number(pickedDriver.homeLng),
        };
      } else if (choice === 'vehicle' && livePos?.latitude != null && livePos?.longitude != null) {
        departureLocation = {
          name: lang === 'pt' ? '🚗 Posição actual do veículo' : '🚗 Current vehicle position',
          lat: Number(livePos.latitude), lng: Number(livePos.longitude),
        };
      } else if (choice && (allLocations || []).length) {
        const loc = allLocations.find(l => String(l.id) === String(choice));
        if (loc?.latitude && loc?.longitude) {
          departureLocation = {
            id: loc.id,
            name: loc.name,
            address: loc.address || null,
            lat: Number(loc.latitude),
            lng: Number(loc.longitude),
          };
        }
      } else if (!choice && (order?.serviceType === 'assistance' || order?.serviceType === 'fuel')) {
        // Auto em assistência E combustível: prefere GPS do veículo (típico no
        // campo; o camião fuel parte de onde está) → depois casa do motorista.
        // Sem nada, deixa null e o backend usa o que veio na criação da OT.
        if (livePos?.latitude != null && livePos?.longitude != null) {
          departureLocation = {
            name: lang === 'pt' ? '🚗 Posição actual do veículo' : '🚗 Current vehicle position',
            lat: Number(livePos.latitude), lng: Number(livePos.longitude),
          };
        } else if (pickedDriver?.homeLat && pickedDriver?.homeLng) {
          departureLocation = {
            name: `🏠 ${pickedDriver.name}`,
            address: pickedDriver.homeAddress || null,
            lat: Number(pickedDriver.homeLat), lng: Number(pickedDriver.homeLng),
          };
        }
      }
      const res = await fetch(`/planner-api/transport-orders/${confirmDispatchData.orderId}/plan-and-dispatch`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          vehicleId: confirmDispatchData.vehicleId,
          vehiclePlate: confirmDispatchData.vehiclePlate,
          driverName: confirmDispatchData.driverName,
          driverId: confirmDispatchData.driverId,
          unloadingTime: confirmDispatchData.unloadingTime,
          // Custom departure: when present, backend builds a 3-point route
          // [departure → pickup → delivery]. Ignored for assistance OTs.
          departureLocation,
        }),
      });
      const data = await res.json();
      if (data.ok) {
        doFetch();
        setVehicleAssignOrderId(null);
        setConfirmDispatchData(null);
        setCustomDepartureLocationId('');
      }
    } catch (e) { console.error(e); }
    setVehicleAssigning(false);
  }

  const [viewOnlyOrder, setViewOnlyOrder] = useState(false);
  function handleEdit(order, viewOnly = false) {
    // QUALQUER OT de combustível → abrir o wizard dedicado (em vez do OrderForm
    // genérico), tanto em edição como em CONSULTA: o form genérico não tem os
    // campos específicos de combustível. Em consulta o wizard abre em modo
    // read-only. DERIVA do tipo da OT, não da variante — antes exigia também
    // isMoveExpress, o que era um bug: um cliente multi-tipo que editasse uma
    // OT de combustível caía no form genérico e perdia os campos de combustível.
    if (order?.serviceType === 'fuel') {
      setEditOrder(order);
      setFuelWizardViewOnly(viewOnly);
      setFuelWizardOpen(true);
      return;
    }
    setEditOrder(order);
    setViewOnlyOrder(viewOnly);
    setFormOpen(true);
  }

  async function handleDuplicate(order) {
    try {
      // Duplicar = nova OT com EXACTAMENTE os mesmos campos da original
      // (excepto identificadores e estados operacionais: status volta a
      // 'pending', vehicleId/driverId/assignedRouteId/orderNumber/customRef
      // são gerados de novo). Sem isto, duplicar uma OT 'assistance'
      // criava uma OT 'delivery' (default do servidor) e o operador tinha
      // de mudar manualmente o tipo + repor campos como slaHours,
      // returnHome, requiredSkills, agreedPrice, etc.
      const data = {
        // Endereços + contactos + janelas
        pickupName: order.pickupName || undefined,
        pickupAddress: order.pickupAddress || undefined,
        pickupLat: order.pickupLat || undefined,
        pickupLng: order.pickupLng || undefined,
        pickupContact: order.pickupContact || undefined,
        pickupPhone: order.pickupPhone || undefined,
        pickupWindowFrom: order.pickupWindowFrom || undefined,
        pickupWindowTo: order.pickupWindowTo || undefined,
        pickupInstructions: order.pickupInstructions || undefined,
        deliveryName: order.deliveryName || undefined,
        deliveryAddress: order.deliveryAddress || undefined,
        deliveryLat: order.deliveryLat || undefined,
        deliveryLng: order.deliveryLng || undefined,
        deliveryContact: order.deliveryContact || undefined,
        deliveryPhone: order.deliveryPhone || undefined,
        deliveryWindowFrom: order.deliveryWindowFrom || undefined,
        deliveryWindowTo: order.deliveryWindowTo || undefined,
        deliveryInstructions: order.deliveryInstructions || undefined,
        // Carga
        cargoDescription: order.cargoDescription || undefined,
        cargoWeight: order.cargoWeight || undefined,
        cargoVolume: order.cargoVolume || undefined,
        cargoPallets: order.cargoPallets || undefined,
        cargoType: order.cargoType || undefined,
        // Tipo de serviço + workflow (assistance/fuel/delivery) + skills
        serviceType: order.serviceType || undefined,
        returnHome: order.returnHome != null ? order.returnHome : undefined,
        requiredSkills: order.requiredSkills || undefined,
        serviceDate: order.serviceDate || undefined,
        unloadingTime: order.unloadingTime || undefined,
        // Prioridade + SLA
        priority: order.priority || 0,
        slaHours: order.slaHours || undefined,
        // Comercial
        agreedPrice: order.agreedPrice || undefined,
        currency: order.currency || undefined,
        // Notas + ref externa
        notes: order.notes ? `(Cópia) ${order.notes}` : '(Cópia)',
        externalRef: order.externalRef || undefined,
      };
      await dispatch(createOrder({ token, data })).unwrap();
      doFetch();
    } catch (e) { console.error('Duplicate error:', e); }
  }

  function handleCreate() {
    setEditOrder(null);
    setFormOpen(true);
  }

  // Opens the live route panel for an OT — fetches the route geometry +
  // route-level metrics on the fly so we can render the polyline, waypoints
  // and total distance/duration inside the popup. Cheap call (cached on the
  // server) so doing it per click is fine.
  async function openLivePanel(order) {
    const routeId = order.assignedRouteId;
    let geometry = null;
    let routeMeta = null;
    if (routeId && token) {
      try {
        const res = await fetch(`/planner-api/routes/${routeId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          const data = await res.json();
          geometry = data?.routeData?.computedRoute?.geometry || null;
          routeMeta = {
            totalDistanceM: data?.totalDistanceM ?? data?.routeData?.computedRoute?.distance ?? null,
            totalDurationS: data?.totalDurationS ?? data?.routeData?.computedRoute?.duration ?? null,
            departureTime: data?.departureTime || data?.routeData?.departureTime || null,
          };
        }
      } catch { /* fall through — panel works without geometry */ }
    }
    setLivePanelState({ order, geometry, routeMeta });
  }

  // External trigger: ManageDialog → "Operações em curso" emits this event
  // when the dispatcher clicks a vehicle row. We resolve the right OT in the
  // current list and open the Live panel for it.
  useEffect(() => {
    function handler(e) {
      const d = e.detail || {};
      if (!d.vehicleId && !d.vehiclePlate && !d.currentOTId) return;
      const target = (() => {
        if (d.currentOTId) {
          const byId = list.find(o => Number(o.id || o._id) === Number(d.currentOTId));
          if (byId) return byId;
        }
        if (d.vehicleId) {
          const inTransit = list.find(o => Number(o.vehicleId) === Number(d.vehicleId) && o.status === 'in_transit');
          if (inTransit) return inTransit;
          const assigned = list.find(o => Number(o.vehicleId) === Number(d.vehicleId) && o.status === 'assigned');
          if (assigned) return assigned;
          const any = list.find(o => Number(o.vehicleId) === Number(d.vehicleId));
          if (any) return any;
        }
        if (d.vehiclePlate) {
          return list.find(o => (o.vehiclePlate || '').toUpperCase() === String(d.vehiclePlate).toUpperCase());
        }
        return null;
      })();
      if (target) openLivePanel(target);
    }
    window.addEventListener('openLiveForVehicle', handler);
    return () => window.removeEventListener('openLiveForVehicle', handler);
  }, [list]); // eslint-disable-line react-hooks/exhaustive-deps

  // After a Replan flow opened from the Live panel finishes (Save / Save&Resend
  // / Cancel — all of them navigate back to 'orders'), reopen the Live panel
  // for the OT we came from. The id was stashed in `replanReturnLiveOTId` when
  // the operator clicked "Editar rota". Cleared once consumed.
  useEffect(() => {
    if (activeView !== 'orders') return;
    if (!replanReturnLiveOTId) return;
    const ot = list.find(o => Number(o.id || o._id) === Number(replanReturnLiveOTId));
    if (ot) {
      openLivePanel(ot);
      dispatch(setReplanReturnLiveOTId(null));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeView, replanReturnLiveOTId, list]);

  // Fetch the client's "Local de partida" favourite fresh from the API. Avoids
  // a race where Redux state may not yet have loaded the locations list when
  // the operator hits "Atribuir e Planificar Rota" right after login/F5.
  //
  // Devolve EXACTAMENTE 1 favorito como parque ou null:
  //   • 0 departures  → null (operador escolhe origem na textbox/selector)
  //   • 1 departure   → esse (auto-fallback comportamento histórico)
  //   • 2+ departures → null (operador escolhe explicitamente o que usar
  //     no selector "Local de Partida" do diálogo, evitando ambiguidade)
  async function fetchDepartureLocation() {
    const pickUnique = (list) => {
      const matches = (list || []).filter(l => l.isDeparture && l.latitude && l.longitude);
      return matches.length === 1 ? matches[0] : null;
    };
    // Prefer the Redux cache if already populated (one less round-trip)
    const fromCache = pickUnique(allLocations);
    if (fromCache) return fromCache;
    // If we have any data in cache and exactly 0 or 2+ matches, no need
    // to refetch — the answer is null either way.
    if (Array.isArray(allLocations) && allLocations.length > 0) {
      const matches = allLocations.filter(l => l.isDeparture);
      if (matches.length !== 1) return null;
    }
    try {
      const res = await fetch('/planner-api/locations', { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) return null;
      const list = await res.json();
      return pickUnique(list);
    } catch {
      return null;
    }
  }

  async function handleCreateRouteFromOT(orderArg) {
    const oid = orderArg.id || orderArg._id;
    // Always refetch the OT fresh from the API. The order object passed in
    // comes from the Redux list which can lag the DB (e.g. right after the
    // operator saved the OT). For fuel OTs in particular, reading a stale
    // serviceType silently produces a 2-point route instead of a 3-point one.
    let order = orderArg;
    try {
      const freshRes = await fetch(`/planner-api/transport-orders/${oid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (freshRes.ok) {
        const fresh = await freshRes.json();
        if (fresh && fresh.id) order = fresh;
      }
    } catch { /* fall back to the passed-in order */ }

    // Clear existing route
    dispatch(clearRoute());

    // Link to source OT for auto-association when saved
    dispatch(setSourceOTId(oid));

    // Set route name from OT number
    dispatch(setRouteName(order.orderNumber || `OT-${oid}`));

    // Set cargo reference
    if (order.cargoDescription) dispatch(setCargoRef(order.cargoDescription));

    // Fuel-distribution orders have a 3-stop route: yard (client departure
    // favourite) → OT pickup (supplier depot) → OT delivery (customer).
    // Other order types keep the simple origin=pickup, destination=delivery.
    const isFuel = order.serviceType === 'fuel';
    const departure = isFuel ? await fetchDepartureLocation() : null;
    if (isFuel && !departure) {
      dispatch(addToast({
        severity: 'warning',
        message: lang === 'pt'
          ? '⚠ Nenhum favorito marcado como "Local de partida". Rota criada sem o parque.'
          : '⚠ No favourite marked as "Departure". Route created without yard.',
      }));
    }

    const pickupLat = Number(order.pickupLat || order.pickup?.lat);
    const pickupLng = Number(order.pickupLng || order.pickup?.lng);
    const pickupName = order.pickupName || order.pickupAddress || order.pickup?.name || order.pickup?.address || '';
    const deliveryLat = Number(order.deliveryLat || order.delivery?.lat);
    const deliveryLng = Number(order.deliveryLng || order.delivery?.lng);
    const deliveryName = order.deliveryName || order.deliveryAddress || order.delivery?.name || order.delivery?.address || '';

    // Resolve driverHome for assistance — same rule as confirmVehicleAssign
    // and handleConsolidateRoutes (origin = driver home, return-home only
    // for assistance OTs).
    const isAssistCR = order.serviceType === 'assistance';
    const otDriverCR = isAssistCR && order.driverId
      ? allDrivers.find(d => Number(d.id) === Number(order.driverId))
      : null;
    const driverHomeCR = (otDriverCR?.homeLat && otDriverCR?.homeLng) ? {
      lat: Number(otDriverCR.homeLat),
      lng: Number(otDriverCR.homeLng),
      driverName: otDriverCR.name || null,
      address: otDriverCR.homeAddress || null,
    } : null;
    // Tenant base — favorito tipo 'garage'. Quando o motorista não tem
    // morada própria, o despacho usa esta base como origem/destino.
    const garagesCR = (allLocations || []).filter(l =>
      l.type === 'garage' && l.isActive !== false && l.latitude != null && l.longitude != null,
    );
    const garageCR = garagesCR.find(l => l.isPreferred) || garagesCR[0] || null;
    const tenantBaseCR = garageCR ? {
      lat: Number(garageCR.latitude),
      lng: Number(garageCR.longitude),
      driverName: null,
      address: garageCR.address || null,
      isBase: true,
      baseName: garageCR.name || null,
    } : null;
    // "Home" efectivo: motorista tem prioridade. Em tenants com base
    // central configurada como default (Preferências → Local partida =
    // favorite:<id>), a base já está aplicada no dropdown ao chegar aqui,
    // por isso este fallback é o último recurso quando o motorista não
    // tem morada — usa a base APENAS se a OT é de assistência e a
    // preferência aponta explicitamente para ela.
    const assistanceDefault = clientSettings?.defaultDepartureByOrderType?.assistance;
    const useBaseFallback = assistanceDefault && assistanceDefault.startsWith('favorite:');
    const homeCR = driverHomeCR || (useBaseFallback ? tenantBaseCR : null);
    const buildHomeNameCR = (h, prefix) => {
      if (!h) return null;
      if (h.isBase) {
        return `🏢 ${prefix === 'Casa de' ? 'Base' : 'Regresso à base'}${h.baseName ? ` · ${h.baseName}` : ''}`;
      }
      const fname = (h.driverName || '').split(/\s+/).slice(0, 2).join(' ').trim();
      return fname
        ? `🏠 ${prefix} ${fname}${h.address ? ` · ${h.address}` : ''}`
        : (h.address || prefix);
    };

    if (isFuel && departure) {
      // ── Fuel (Move Express) ──────────────────────────────────────
      // Origem = base ZZE. Decisão sobre pickup/destino:
      //   • Tem pickup + delivery → ZZE → TCPL (waypoint) → PA (destino)
      //   • Só tem pickup (PA ainda por revelar no carregamento) →
      //     ZZE → TCPL (destino). Quando o operador preencher o PA
      //     depois, o sistema recalcula.
      //   • Sem pickup nem delivery → fica só com origem.
      dispatch(setOrigin({
        name: departure.name,
        coordinates: [Number(departure.longitude), Number(departure.latitude)],
      }));
      const hasPickup = !!(pickupLat && pickupLng);
      const hasDelivery = !!(deliveryLat && deliveryLng);
      if (hasPickup && hasDelivery) {
        dispatch(addWaypoint({
          name: pickupName || 'Recolha',
          coordinates: [pickupLng, pickupLat],
          stopDuration: 15,
          waypointKind: 'pickup',
          otId: oid,
          orderNumber: order.orderNumber,
        }));
        dispatch(setDestination({ name: deliveryName, coordinates: [deliveryLng, deliveryLat] }));
      } else if (hasPickup) {
        // PA ainda não conhecido — destino é o terminal de carga.
        dispatch(setDestination({ name: pickupName || 'Recolha', coordinates: [pickupLng, pickupLat] }));
      }
    } else if (isAssistCR && homeCR) {
      // Assistance: origem na "casa" do motorista (PT) ou base do tenant
      // (AO, fallback) — homeCR já reflete essa prioridade.
      dispatch(setOrigin({
        name: buildHomeNameCR(homeCR, 'Casa de'),
        coordinates: [homeCR.lng, homeCR.lat],
      }));
      if (deliveryLat && deliveryLng) {
        if (order.returnHome) {
          dispatch(addWaypoint({
            name: deliveryName,
            coordinates: [deliveryLng, deliveryLat],
            stopDuration: order.unloadingTime || 30,
            waypointKind: 'delivery',
            otId: oid,
            orderNumber: order.orderNumber,
          }));
          dispatch(setDestination({
            name: buildHomeNameCR(homeCR, 'Regresso a casa de'),
            coordinates: [homeCR.lng, homeCR.lat],
          }));
        } else {
          dispatch(setDestination({ name: deliveryName, coordinates: [deliveryLng, deliveryLat] }));
        }
      }
    } else {
      // Non-fuel, non-assistance (or assistance without resolvable driverHome):
      // classic 2-point route from OT's own pickup/delivery.
      if (pickupLat && pickupLng) {
        dispatch(setOrigin({ name: pickupName, coordinates: [pickupLng, pickupLat] }));
      }
      if (deliveryLat && deliveryLng) {
        dispatch(setDestination({ name: deliveryName, coordinates: [deliveryLng, deliveryLat] }));
      }
    }

    // Set vehicle + driver from OT if assigned.
    // Pull the full vehicle record so we can propagate type, dimensions and fuel to the route.
    if (order.vehicleId) {
      const fullVehicle = vehicles.find(v => String(v.id) === String(order.vehicleId));

      dispatch(setVehicle({
        id: order.vehicleId,
        plate: order.vehiclePlate || '',
        type: fullVehicle?.type || '',
      }));

      // Decide which sub-type preset to apply:
      //   1) the real category of the vehicle (car vs truck vs van), if Traccar reports it
      //   2) if it's a truck but we don't know the exact variant, fall back to the client's
      //      preferred sub-type (cisterna / frigorifico / ...) so HERE still gets dimensions
      //   3) last resort: generic "general_cargo" so HERE has *something* to plan a truck route
      const vehicleSubType = subTypeFromVehicleCategory(fullVehicle?.type || fullVehicle?.category);
      const clientSubType = clientSettings?.defaultVehicleSubType;
      let appliedSubType;
      if (vehicleSubType === 'car') {
        appliedSubType = 'car';
      } else if (vehicleSubType === 'general_cargo' || vehicleSubType === 'light_truck') {
        // Truck-like vehicle — prefer the client's more specific preset if it's also a truck
        appliedSubType = (clientSubType && clientSubType !== 'car') ? clientSubType : vehicleSubType;
      } else {
        // Unknown category — rely on the client's preference, or a generic cargo truck
        appliedSubType = clientSubType || 'general_cargo';
      }

      // Admin overrides for dimensions (if set in preferences) still win
      const dimOverrides = {
        truckWeight: clientSettings?.truckWeight,
        truckAxleLoad: clientSettings?.truckAxleLoad,
        truckHeight: clientSettings?.truckHeight,
        truckWidth: clientSettings?.truckWidth,
        truckLength: clientSettings?.truckLength,
      };
      const patch = buildPresetPatch(appliedSubType, dimOverrides);
      // Car shouldn't auto-apply tacho regardless of client preference
      if (patch.vehicleType === 'car') patch.useTachograph = false;
      dispatch(setRouteOptions(patch));

      // Consumption + fuel type come from the vehicle record when available
      if (fullVehicle?.fuelPer100km) {
        dispatch(setFuelConsumption(Number(fullVehicle.fuelPer100km)));
      }
      if (fullVehicle?.fuelType) {
        dispatch(setFuelType(fullVehicle.fuelType));
      }
    }
    if (order.driverName || order.driverId || order.driver?.id) {
      dispatch(setDriver({
        id: order.driverId || order.driver?.id || null,
        name: order.driverName || order.driver?.name || '',
      }));
    }

    // Set delivery window for ETA comparison in header
    if (order.deliveryWindowFrom) {
      const { setArrivalTimeWindow } = require('../../store/slices/routesSlice');
      dispatch(setArrivalTimeWindow({
        start: order.deliveryWindowFrom,
        end: order.deliveryWindowTo || null,
      }));
    }

    // Switch to planner view and force the "Rota" tab (otherwise the sidebar
    // stays on whatever tab was active before — e.g. "Gravadas")
    dispatch(setSidebarVisible(true));
    dispatch(setSidebarTab(0));
    dispatch(navigateTo('planner'));

    // Auto-calculate if both origin and destination are set
    if (pickupLat && pickupLng && deliveryLat && deliveryLng) {
      dispatch(setNeedsRecalculation(true));
    }
  }

  // Consolidate several selected OTs into a single route.
  // Common case: same warehouse pickup + N delivery points done by the same vehicle in one day.
  //
  // Two-step flow:
  //   1) Try to fetch a HERE travel-time matrix for the unique stops (road-accurate).
  //      If it fails (token issue, >15 points, network error) we fall back to Haversine.
  //   2) Run the timeline simulator. Clean → build route. Conflicts → open the preview dialog.
  async function handleConsolidateRoutes(orderIds, prefetchedOrders = null, options = {}) {
    const { firstStopOTId, customDepartureId, customArrivalId } = options;
    // When called from the bulk-assign dialog we pass `prefetchedOrders` because
    // the local `list` is still stale (just dispatched doFetch, results not in
    // yet) and would lack the new vehicleId/driverId — without them the assistance
    // path can't resolve driverHome, breaking the optimiser. Prefetched records
    // come straight from the API after the assigns succeed.
    const orders = prefetchedOrders && prefetchedOrders.length >= 2
      ? prefetchedOrders
      : list.filter(o => orderIds.includes(o._id || o.id));
    if (orders.length < 2) return;

    // Warning: heterogeneous pickups — when consolidating several OTs into one route,
    // operators typically expect all orders to start at the same warehouse. Multiple
    // distinct pickups often signals a mistake (wrong selection) so we flag it but
    // still let the flow continue (Casais pattern: same-warehouse → many deliveries).
    const pickupKeys = new Set();
    orders.forEach(o => {
      const lat = Number(o.pickupLat || o.pickup?.lat);
      const lng = Number(o.pickupLng || o.pickup?.lng);
      if (Number.isFinite(lat) && Number.isFinite(lng)) {
        // Round to ~110 m so near-duplicates collapse into one key
        pickupKeys.add(`${lat.toFixed(3)},${lng.toFixed(3)}`);
      }
    });
    if (pickupKeys.size > 1) {
      const names = [...new Set(orders.map(o =>
        (o.pickupName || o.pickupAddress || o.pickup?.name || '').split(',')[0].trim()
      ).filter(Boolean))].slice(0, 3);
      dispatch(addToast({
        type: 'warning',
        message: lang === 'pt'
          ? `⚠ ${pickupKeys.size} locais de recolha diferentes (${names.join(', ')}${names.length < pickupKeys.size ? '…' : ''}). Confirma se é intencional.`
          : `⚠ ${pickupKeys.size} different pickups (${names.join(', ')}${names.length < pickupKeys.size ? '…' : ''}). Confirm this is intentional.`,
      }));
    }

    // Look up the first assigned vehicle so the matrix honours truck dimensions
    const refOT = orders.find(o => o.vehicleId) || orders[0];
    const refVehicle = vehicles.find(v => String(v.id) === String(refOT.vehicleId));
    const isTruck = (refVehicle?.type || refVehicle?.category || '').toLowerCase() !== 'car';

    // Resolve a starting driverHome for assistance consolidations — when all
    // selected OTs are assistance AND share the same assigned driver, use the
    // driver's home as the route origin so the optimiser sequences the service
    // stops starting from home (matches the Petrotec workflow).
    let driverHome = null;
    const allAssistance = orders.every(o => o.serviceType === 'assistance');
    const driverIds = new Set(orders.map(o => o.driverId).filter(Boolean));
    if (allAssistance && driverIds.size === 1) {
      const did = [...driverIds][0];
      const d = allDrivers.find(x => Number(x.id) === Number(did));
      if (d?.homeLat && d?.homeLng) {
        // Build an explicit display name: "🏠 Casa de João Silva · Rua X, 123"
        // so the origin field on the planner makes it crystal clear that
        // this is the technician's home (was just the address before).
        const firstName = (d.name || '').split(/\s+/).slice(0, 2).join(' ').trim();
        const display = firstName
          ? `🏠 Casa de ${firstName}${d.homeAddress ? ` · ${d.homeAddress}` : ''}`
          : (d.homeAddress || 'Casa do motorista');
        driverHome = {
          lat: Number(d.homeLat),
          lng: Number(d.homeLng),
          name: display,
          driverName: d.name || null,
          address: d.homeAddress || null,
        };
      }
    }

    // Ponto de arranque do optimizador. Quando o operador escolhe uma
    // partida personalizada (favorito/local), é DESSE ponto que a rota
    // arranca — o optimizador tem de sequenciar as paragens a partir
    // dele. Sem isto, optimizava a partir da casa do motorista (ou de
    // lado nenhum) e a ordem das OT ficava errada face à partida real.
    let optimiserStart = driverHome;
    const refLivePos = refVehicle?.position;
    const refLiveGPS = (refLivePos?.latitude != null && refLivePos?.longitude != null)
      ? {
          lat: Number(refLivePos.latitude),
          lng: Number(refLivePos.longitude),
          name: lang === 'pt' ? '🚗 Posição actual do veículo' : '🚗 Current vehicle position',
        }
      : null;
    if (customDepartureId === 'vehicle') {
      // Escolha explícita do operador — usar sempre o GPS.
      if (refLiveGPS) optimiserStart = refLiveGPS;
    } else if (customDepartureId && customDepartureId !== 'driver-home' && customDepartureId !== 'service') {
      const depLoc = (allLocations || []).find(l => String(l.id) === String(customDepartureId));
      if (depLoc?.latitude && depLoc?.longitude) {
        optimiserStart = {
          lat: Number(depLoc.latitude),
          lng: Number(depLoc.longitude),
          name: depLoc.name || 'Partida',
        };
      }
    } else if (!customDepartureId && allAssistance && refLiveGPS) {
      // "Auto" + assistência: alinhar com o doConsolidateRoutes (que usa
      // liveGPS como origin visível). Sem isto, o optimizador sequenciava
      // a partir da casa do motorista enquanto a UI mostrava GPS — Cascais
      // ganhava Estoril porque a casa estava mais perto de Cascais que o
      // GPS real. Não afecta PT (preferência = 'driver-home', cai no else
      // explícito acima) nem delivery/fuel (allAssistance=false).
      optimiserStart = refLiveGPS;
    }

    // Traffic-aware matrix — pass a departureTime so HERE returns realistic
    // congested times. Prefer the earliest pickup window; fall back to now.
    const earliestDeparture = orders
      .map(o => o.pickupWindowFrom || o.deliveryWindowFrom)
      .filter(Boolean)
      .map(d => new Date(d).getTime())
      .sort((a, b) => a - b)[0];
    const departureTime = earliestDeparture
      ? new Date(earliestDeparture).toISOString()
      : new Date().toISOString();

    const matrixOpts = {
      vehicleType: isTruck ? 'hgv' : 'car',
      departureTime,
      ...(isTruck && clientSettings ? {
        truckWeight: clientSettings.truckWeight,
        truckAxleLoad: clientSettings.truckAxleLoad,
        truckHeight: clientSettings.truckHeight,
        truckWidth: clientSettings.truckWidth,
        truckLength: clientSettings.truckLength,
      } : {}),
    };

    let travelProvider = null;
    let matrixSource = 'haversine';
    // Include the optimiser start in the unique points so the matrix has a row/col for it
    const { points, lookup } = collectUniquePoints(
      optimiserStart ? [{ pickupLat: optimiserStart.lat, pickupLng: optimiserStart.lng, deliveryLat: null, deliveryLng: null }, ...orders] : orders
    );
    if (points.length >= 2 && points.length <= 15) {
      try {
        const matrix = await fetchTravelMatrix(points, matrixOpts);
        travelProvider = makeMatrixProvider(matrix, lookup, 60);
        matrixSource = 'here';
      } catch (err) {
        console.warn('[Optimize] HERE matrix indisponível, fallback Haversine:', err.message);
      }
    }

    // Optional pin: when the operator selects an OT as departure in the
    // bulk-assign dialog, force that OT as the first visited stop.
    const validation = validateConsolidation(orders, {
      travelProvider,
      driverHome: optimiserStart,
      firstStopOTId: firstStopOTId || undefined,
    });
    // Pré-resolve o parque (fuel-only sem partida explícita) ANTES do ramo de
    // conflitos — assim o "Criar rota mesmo assim"/"Reorganizar" do diálogo
    // têm todas as opções (doConsolidateRoutes não é async).
    const allFuelHere = orders.every(o => o.serviceType === 'fuel');
    const parqueForFuel = (allFuelHere && !customDepartureId && !firstStopOTId)
      ? await fetchDepartureLocation()
      : null;
    if (validation.hasConflicts) {
      // IMPORTANTE: guardar também as escolhas de partida/chegada do operador
      // (Local de Partida / Local de Chegada). Sem isto, ao "Criar rota mesmo
      // assim" a rota era construída com a origem/destino por defeito (casa do
      // motorista), ignorando o que o operador definiu no ecrã de atribuição.
      setConsolidationPreview({
        orders: validation.orderedOrders,
        timeline: validation.timeline,
        conflicts: validation.conflicts,
        travelProvider,
        matrixSource,
        driverHome,
        customDepartureId, customArrivalId, firstStopOTId, parqueForFuel,
      });
      return;
    }
    doConsolidateRoutes(validation.orderedOrders, driverHome, { customDepartureId, customArrivalId, firstStopOTId, parqueForFuel });
  }

  // Actually builds the consolidated route state from an ordered list of OTs.
  // `options.customDepartureId` and `options.customArrivalId` come from the
  // assign-vehicle dialog and override the default driver-home / OT pickup
  // logic. Conventions match `customDepartureLocationId`:
  //   '' / undefined → use legacy default (driverHome for assistance, etc.)
  //   'driver-home'  → driver's home (only valid when driverHome is set)
  //   '<numeric id>' → ClientLocation favourite
  function doConsolidateRoutes(sorted, driverHome = null, options = {}) {
    if (!sorted || sorted.length < 2) return;
    const { customDepartureId = '', customArrivalId = '', firstStopOTId = null, parqueForFuel = null } = options;

    // Helper to read coords/name from an OT pickup or delivery
    const pickup = (o) => ({
      lat: Number(o.pickupLat || o.pickup?.lat),
      lng: Number(o.pickupLng || o.pickup?.lng),
      name: o.pickupName || o.pickupAddress || o.pickup?.name || o.pickup?.address || '',
    });
    const delivery = (o) => ({
      lat: Number(o.deliveryLat || o.delivery?.lat),
      lng: Number(o.deliveryLng || o.delivery?.lng),
      name: o.deliveryName || o.deliveryAddress || o.delivery?.name || o.delivery?.address || '',
    });

    dispatch(clearRoute());
    dispatch(setSourceOTIds(sorted.map(o => o.id || o._id)));

    // Route name = "<plate> · <date> (N OTs)"
    // Operator-friendly: matches what dispatchers say out loud ("a rota da
    // CA-10-GZ para o dia 5"). Falls back to "—" for the plate when no OT
    // has a vehicle yet (very rare — usually consolidation runs on already-
    // assigned OTs). The date prefers serviceDate, falling back to the
    // earliest delivery window, then today.
    const plateForName = (sorted.find(o => o.vehiclePlate)?.vehiclePlate) || '—';
    const dateSrc = sorted.find(o => o.serviceDate)?.serviceDate
      || sorted.find(o => o.deliveryWindowFrom)?.deliveryWindowFrom
      || new Date().toISOString();
    const dateForName = new Date(dateSrc).toLocaleDateString('pt-PT', {
      day: '2-digit', month: '2-digit', year: '2-digit',
    });
    dispatch(setRouteName(`${plateForName} · ${dateForName} (${sorted.length} ${sorted.length === 1 ? 'ordem' : 'ordens'})`));
    const cargoSummary = sorted.map(o => o.cargoDescription).filter(Boolean).join(' + ');
    if (cargoSummary) dispatch(setCargoRef(cargoSummary));

    // Vehicle + driver from the first OT that has one assigned
    const withVehicle = sorted.find(o => o.vehicleId);
    if (withVehicle) {
      dispatch(setVehicle({ id: withVehicle.vehicleId, plate: withVehicle.vehiclePlate || '', type: '' }));
    }
    const withDriver = sorted.find(o => o.driverId || o.driver?.id || o.driverName);
    if (withDriver) {
      dispatch(setDriver({
        id: withDriver.driverId || withDriver.driver?.id || null,
        name: withDriver.driverName || withDriver.driver?.name || '',
      }));
    }

    // Resolve favourite by id (used by both departure and arrival overrides).
    const resolveFavById = (idStr) => {
      if (!idStr) return null;
      const loc = (allLocations || []).find(l => String(l.id) === String(idStr));
      if (loc?.latitude && loc?.longitude) {
        return { lat: Number(loc.latitude), lng: Number(loc.longitude), name: loc.name };
      }
      return null;
    };

    // ─── ORIGIN ─────────────────────────────────────────────────
    // Priority (highest first):
    //   1) customDepartureId set explicitly by the operator (favourite, service, driver-home)
    //   2) firstStopOTId set (operator pinned an OT as first visit) — origin = that OT's
    //      service location (delivery for assistance / fuel-discharge / cargo-delivery)
    //   3) driverHome derived from a unanimous-assistance group
    //   4) the first OT's pickup (fallback for delivery/fuel)
    let originLat, originLng, originName;
    let originOT = null; // tracked separately — quando a origem vem do serviço de uma OT, anexamos a sua metadata ao setOrigin para que o mobile saiba qual OT corresponde à origem
    let resolvedDeparture = null;
    if (customDepartureId === 'driver-home' && driverHome?.lat) {
      resolvedDeparture = { lat: driverHome.lat, lng: driverHome.lng, name: driverHome.name };
    } else if (customDepartureId === 'service' && sorted[0]?.deliveryLat) {
      // Single-OT semantic; in bulk this rarely triggers but keep for safety
      const d0 = delivery(sorted[0]);
      resolvedDeparture = { lat: d0.lat, lng: d0.lng, name: d0.name };
      originOT = sorted[0];
    } else if (customDepartureId === 'vehicle') {
      // Posição GPS actual do veículo de referência. Quando o operador
      // escolhe explicitamente "Posição do veículo" no dropdown de
      // partida, esta tem de ganhar à casa do motorista. Sem este ramo
      // caíamos em resolveFavById('vehicle') → null → fallback abaixo,
      // que para delivery/fuel ignora o GPS.
      const refVehicleId2 = sorted.find(o => o.vehicleId)?.vehicleId;
      const liveVehicle2 = refVehicleId2
        ? vehicles.find(v => Number(v.id) === Number(refVehicleId2))
        : null;
      const livePos2 = liveVehicle2?.position;
      if (livePos2?.latitude != null && livePos2?.longitude != null) {
        resolvedDeparture = {
          lat: Number(livePos2.latitude),
          lng: Number(livePos2.longitude),
          name: lang === 'pt' ? '🚗 Posição actual do veículo' : '🚗 Current vehicle position',
        };
      }
    } else if (customDepartureId) {
      resolvedDeparture = resolveFavById(customDepartureId);
    } else if (firstStopOTId) {
      // Operator picked one of the OTs as the starting point ("começa por
      // este serviço"). The route's origin is THAT OT's service location.
      // Validation already moved this OT to position 0 of `sorted`, so
      // sorted[0] is the pinned one.
      const pinned = sorted.find(o => String(o.id || o._id) === String(firstStopOTId)) || sorted[0];
      const d0 = delivery(pinned);
      if (d0.lat && d0.lng) {
        resolvedDeparture = { lat: d0.lat, lng: d0.lng, name: d0.name };
        originOT = pinned;
      }
    }
    if (resolvedDeparture) {
      originLat = resolvedDeparture.lat;
      originLng = resolvedDeparture.lng;
      originName = resolvedDeparture.name;
    } else {
      // Operator left the departure blank — fallback por tipo:
      //  · Assistência → GPS do veículo → casa do motorista → 1º serviço
      //  · Fuel (todas) → parque (favorito isDeparture único) → GPS → 1º pickup
      //  · Delivery/outras → GPS do veículo → 1º pickup
      // NOTA: a auto-fetch do parque para fuel é síncrona-async aqui mas
      // doConsolidateRoutes já é async, portanto seguro.
      const allAssistance = sorted.every(o => o.serviceType === 'assistance');
      const allFuel = sorted.every(o => o.serviceType === 'fuel');
      const first = sorted[0];
      const refVehicleId = sorted.find(o => o.vehicleId)?.vehicleId;
      const liveVehicle = refVehicleId
        ? vehicles.find(v => Number(v.id) === Number(refVehicleId))
        : null;
      const livePos = liveVehicle?.position;
      const liveGPS = (livePos?.latitude != null && livePos?.longitude != null)
        ? {
            lat: Number(livePos.latitude),
            lng: Number(livePos.longitude),
            name: lang === 'pt' ? '🚗 Posição actual do veículo' : '🚗 Current vehicle position',
          }
        : null;
      // Parque (auto-fetch) só para fuel — pré-resolvido em handleConsolidateRoutes
      // e passado via options (doConsolidateRoutes é síncrona).
      const parque = allFuel ? parqueForFuel : null;

      if (allAssistance && liveGPS) {
        originLat = liveGPS.lat; originLng = liveGPS.lng; originName = liveGPS.name;
      } else if (allAssistance && driverHome?.lat && driverHome?.lng) {
        // Rede de segurança: assistência sem GPS → casa do motorista
        originLat = driverHome.lat; originLng = driverHome.lng; originName = driverHome.name;
      } else if (allAssistance && first?.deliveryLat && first?.deliveryLng) {
        const d0 = delivery(first);
        originLat = d0.lat; originLng = d0.lng; originName = d0.name;
        originOT = first; // fallback assistência → 1º serviço; regista a OT
      } else if (allFuel && parque) {
        originLat = Number(parque.latitude); originLng = Number(parque.longitude); originName = parque.name;
      } else if (liveGPS) {
        // Delivery, ou fuel sem parque → GPS do veículo
        originLat = liveGPS.lat; originLng = liveGPS.lng; originName = liveGPS.name;
      } else {
        const firstPickup = pickup(first);
        originLat = firstPickup.lat; originLng = firstPickup.lng; originName = firstPickup.name;
        originOT = first; // fallback final → 1º pickup; regista a OT
      }
    }
    if (originLat && originLng) {
      // Anexar metadata da OT à origem quando a origem é o local de
      // serviço/pickup de uma OT. Sem isto o backend mobile não consegue
      // saber qual OT corresponde à origem (resultado: ordem das paragens
      // na app do motorista vinha por id em vez de pela sequência da rota).
      const wpKindOrigin = originOT
        ? (originOT.serviceType === 'assistance' ? 'service'
          : originOT.serviceType === 'fuel' ? 'fuel'
          : 'delivery')
        : null;
      dispatch(setOrigin({
        name: originName,
        coordinates: [originLng, originLat],
        ...(originOT ? {
          otId: originOT.id || originOT._id,
          orderNumber: originOT.orderNumber,
          customRef: (originOT.customRef || '').trim() || null,
          waypointKind: wpKindOrigin,
        } : {}),
      }));
    }

    // ─── ARRIVAL OVERRIDE ──────────────────────────────────────
    // The customArrivalId picker is the SOURCE OF TRUTH for the route's
    // final stop. The OT-level `returnHome` flag is only used as a
    // *pre-fill hint* on dialog open — once the operator confirms, what
    // the dropdown holds is what dictates the destination here.
    let arrivalOverride = null;
    if (customArrivalId === 'driver-home' && driverHome?.lat) {
      const firstName = (driverHome.driverName || '').split(/\s+/).slice(0, 2).join(' ').trim();
      const destName = firstName
        ? `🏠 Regresso a casa de ${firstName}${driverHome.address ? ` · ${driverHome.address}` : ''}`
        : (driverHome.address || 'Regresso a casa');
      arrivalOverride = { lat: driverHome.lat, lng: driverHome.lng, name: destName };
    } else if (customArrivalId) {
      arrivalOverride = resolveFavById(customArrivalId);
    }
    const shouldReturnHome = !!arrivalOverride; // any explicit arrival means we DO add a final stop

    // Build the chained sequence: for each OT, insert subsequent pickup (if different from previous)
    // and the delivery point as a waypoint with stopDuration = unloadingTime + metadata.
    // The very last OT's delivery becomes the destination.
    let prevLat = originLat;
    let prevLng = originLng;

    const COORD_EPS = 0.0001; // ~11 m — same point if within
    const sameAsPrev = (lat, lng) =>
      Math.abs(lat - prevLat) < COORD_EPS && Math.abs(lng - prevLng) < COORD_EPS;

    // When all selected OTs share the SAME pickup (e.g. assistance OTs all
    // starting from the driver's home), skip the intermediate "go back to
    // pickup" legs — the flow is simply origin → delivery1 → delivery2 → …
    // The old logic was inserting the pickup as a waypoint before each
    // delivery, producing "home → stop1 → home → stop2 → home → stop3"
    // which is nonsense for a technician doing rounds.
    const samePickupForAll = (() => {
      if (sorted.length < 2) return true;
      const first = pickup(sorted[0]);
      if (!first.lat || !first.lng) return false;
      return sorted.every(o => {
        const p = pickup(o);
        return p.lat && p.lng
          && Math.abs(p.lat - first.lat) < COORD_EPS
          && Math.abs(p.lng - first.lng) < COORD_EPS;
      });
    })();
    // When origin came from driverHome we also treat all pickups as the origin
    // (assistance workflow: every OT's pickup is the technician's home).
    const skipIntermediatePickups = samePickupForAll || !!driverHome;

    sorted.forEach((ot, idx) => {
      const isLast = idx === sorted.length - 1;
      const pk = pickup(ot);
      const dl = delivery(ot);

      // Insert pickup as waypoint only when it's meaningfully different from
      // the previous stop AND we're not in the "shared pickup" shortcut mode.
      if (!skipIntermediatePickups
          && idx > 0 && pk.lat && pk.lng && !sameAsPrev(pk.lat, pk.lng)) {
        dispatch(addWaypoint({
          name: pk.name,
          coordinates: [pk.lng, pk.lat],
          stopDuration: 15, // sensible default for loading
          otId: ot.id || ot._id,
          orderNumber: ot.orderNumber,
          waypointKind: 'pickup',
          agreedPrice: ot.agreedPrice ? Number(ot.agreedPrice) : null,
        }));
        prevLat = pk.lat; prevLng = pk.lng;
      }

      if (!dl.lat || !dl.lng) return;

      // Se a 1ª OT (idx=0) tem a mesma localização que a origem da rota,
      // significa que o operador escolheu este serviço como ponto de
      // partida (ou caímos no fallback "1º serviço" sem alternativa).
      // Saltamos — a origem já representa esta paragem, adicioná-la
      // outra vez como waypoint produzia duplicação visível no painel
      // e na geometria (a rota saltava 0 m no primeiro segmento).
      if (idx === 0 && sameAsPrev(dl.lat, dl.lng)) {
        return;
      }

      // Para OTs de assistência, o waypointKind correcto é 'service'
      // (local de serviço técnico) e não 'delivery'. Visualmente o
      // operador via "↓ Entrega" em todas as paragens de uma rota de
      // técnico, o que era confuso — agora vê "🔧 Assistência".
      const wpKind = ot.serviceType === 'assistance' ? 'service'
        : ot.serviceType === 'fuel' ? 'fuel'
        : 'delivery';

      if (isLast && !shouldReturnHome) {
        // Last stop = route destination (driver ends at the client).
        // Mantém a metadata da OT (otId, orderNumber, waypointKind) para
        // que o painel da rota mostre o badge da ordem no destino, à
        // semelhança dos waypoints intermédios.
        dispatch(setDestination({
          name: dl.name,
          coordinates: [dl.lng, dl.lat],
          otId: ot.id || ot._id,
          orderNumber: ot.orderNumber,
          customRef: (ot.customRef || '').trim() || null,
          waypointKind: wpKind,
          stopDuration: ot.unloadingTime || 30,
          agreedPrice: ot.agreedPrice ? Number(ot.agreedPrice) : null,
        }));
      } else {
        // All other stops are waypoints. When shouldReturnHome is true
        // the last stop is ALSO a waypoint — destination will be home.
        dispatch(addWaypoint({
          name: dl.name,
          coordinates: [dl.lng, dl.lat],
          stopDuration: ot.unloadingTime || 30,
          otId: ot.id || ot._id,
          orderNumber: ot.orderNumber,
          customRef: (ot.customRef || '').trim() || null,
          waypointKind: wpKind,
          agreedPrice: ot.agreedPrice ? Number(ot.agreedPrice) : null,
        }));
      }
      prevLat = dl.lat; prevLng = dl.lng;
    });

    // If the operator picked an explicit arrival, set it as the route's
    // destination. This may be the driver's home OR a favourite (warehouse,
    // garage…) — `arrivalOverride` already carries the correct lat/lng/name.
    if (shouldReturnHome && arrivalOverride) {
      dispatch(setDestination({
        name: arrivalOverride.name,
        coordinates: [arrivalOverride.lng, arrivalOverride.lat],
      }));
    }

    // Use the earliest delivery window for ETA framing
    const firstWindow = sorted.find(o => o.deliveryWindowFrom);
    if (firstWindow) {
      const { setArrivalTimeWindow } = require('../../store/slices/routesSlice');
      dispatch(setArrivalTimeWindow({
        start: firstWindow.deliveryWindowFrom,
        end: firstWindow.deliveryWindowTo || null,
      }));
    }

    dispatch(setSidebarVisible(true));
    dispatch(setSidebarTab(0));
    dispatch(navigateTo('planner'));
    // Ask the RouteForm to recalculate — two paths so we cover timing edge cases:
    //   (1) Redux flag (useEffect [needsRecalculation]) — works when RouteForm is already mounted.
    //   (2) CustomEvent — works even if RouteForm mounted with the flag already true.
    // Fire both at different delays so one of them will land after the mount.
    dispatch(setNeedsRecalculation(false));
    setTimeout(() => {
      dispatch(setNeedsRecalculation(true));
      window.dispatchEvent(new CustomEvent('requestRouteRecalc'));
    }, 350);
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('requestRouteRecalc'));
    }, 1200);
    setSelected([]);
  }

  function handleFormClose(refresh) {
    setFormOpen(false);
    setEditOrder(null);
    if (refresh) doFetch();
  }

  function toggleSelect(id) {
    setSelected(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  }

  function toggleSelectAll() {
    if (selected.length === list.length) {
      setSelected([]);
    } else {
      setSelected(list.map(o => o._id || o.id));
    }
  }

  // "Por atribuir" = ordens ainda SEM ROTA — sejam pendentes (sem veículo)
  // ou já atribuídas a veículo/motorista mas sem rota criada. São todas as
  // que o operador ainda tem de planificar/despachar. Exclui as que já têm
  // rota, entregues e canceladas.
  const isUnassignedOT = (o) => !o.assignedRouteId && (o.status === 'pending' || o.status === 'assigned');
  function toggleSelectUnassigned() {
    const ids = list.filter(isUnassignedOT).map(o => o._id || o.id);
    const allSelected = ids.length > 0 && ids.every(id => selected.includes(id));
    // Já estão exatamente as "por atribuir" selecionadas → limpa; senão
    // passa a seleção a ser só essas.
    if (allSelected && selected.length === ids.length) setSelected([]);
    else setSelected(ids);
  }

  const sortValue = sort.field === 'orderNumber' ? 'orderNumber' : sort.field === 'priority' ? 'priority' : 'date';

  return (
    <ThemeProvider theme={dlgTheme}>
    <Box className={classes.root} data-planner-theme={plannerTheme}>
      {/* Header */}
      <Box className={classes.header}>
        <Box className={classes.titleRow}>
          <IconButton size="small" onClick={() => dispatch(setActiveView('planner'))} style={{ color: '#64748b' }}>
            <ArrowBackIcon style={{ fontSize: 18 }} />
          </IconButton>
          <Typography style={{ fontWeight: 600, fontSize: '1.15rem', color: '#0f172a', letterSpacing: '-0.02em' }}>
            {lang === 'pt' ? 'Ordens de Serviço' : 'Service Orders'}
          </Typography>
          <Chip
            size="small"
            label={`${pagination.total || list.length}`}
            style={{ fontWeight: 500, fontSize: '0.72rem', background: '#f1f5f9', color: '#64748b', border: '1px solid #e2e8f0' }}
          />
        </Box>
        <Box style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
          {/* Refresh — manual trigger replaces the old auto-refresh-on-WS. A
              subtle dot lights up when WS fires so the operator knows there's
              something fresher on the server. */}
          <Tooltip title={lang === 'pt'
            ? (staleHint ? 'Há novidades · clica para actualizar' : 'Actualizar lista')
            : (staleHint ? 'New events · click to refresh' : 'Refresh list')}>
            <Button
              size="small"
              key={`refresh-${stalePulseKey}`}
              onClick={refreshOrders}
              startIcon={<RefreshIcon style={{ fontSize: staleHint ? 18 : 16 }} />}
              className={staleHint ? classes.refreshBtnStale : ''}
              style={{
                position: 'relative',
                fontSize: staleHint ? '0.78rem' : '0.72rem',
                fontWeight: staleHint ? 800 : 600, textTransform: 'none',
                color: staleHint ? '#ffffff' : '#475569',
                background: staleHint ? 'linear-gradient(135deg, #dc2626, #b91c1c)' : '#f8fafc',
                border: `1px solid ${staleHint ? '#991b1b' : '#e2e8f0'}`,
                borderRadius: 8, padding: staleHint ? '6px 16px' : '5px 12px',
                letterSpacing: staleHint ? '0.02em' : '-0.005em',
              }}
            >
              {staleHint
                ? (lang === 'pt' ? '⚡ Actualizar' : '⚡ Refresh')
                : (lang === 'pt' ? 'Actualizar' : 'Refresh')}
              {staleHint && (
                <Box className={classes.refreshDotStale} style={{
                  position: 'absolute', top: -4, right: -4,
                  width: 12, height: 12, borderRadius: '50%',
                  background: '#fbbf24',
                  border: '2px solid #fff',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                }} />
              )}
            </Button>
          </Tooltip>
          {onlyFuelOrders ? (
            <>
              {/* Só faz combustível → o botão "Nova Ordem" abre directamente o
                  wizard de combustível, sem menu intermédio a perguntar o tipo.
                  DERIVA de allowedOrderTypes === ['fuel'], não da variante. */}
              {canWrite && (
                <Button
                  className={classes.newBtn}
                  startIcon={<span style={{ fontSize: 16 }}>⛽</span>}
                  onClick={() => setFuelWizardOpen(true)}
                >
                  {lang === 'pt' ? 'Nova Ordem de Serviço' : 'New Service Order'}
                </Button>
              )}
              {/* Dashboard "Operações Combustível" agora vive no menu principal
                  Dashboard (variante fuel do Perfil) — botão removido daqui. */}
              {/* Listagem do dia para o cliente — PDF operacional (passo 2 do
                  processo). DESACTIVADO temporariamente. */}
              <Tooltip title={lang === 'pt'
                ? 'Em desenvolvimento — Listagem do dia (PDF) estará disponível em breve'
                : 'In development — Daily list PDF coming soon'}>
                <span>
                  <Button
                    size="small"
                    disabled
                    startIcon={<PictureAsPdfIcon style={{ fontSize: 15 }} />}
                    style={{
                      fontSize: '0.72rem', fontWeight: 600, textTransform: 'none',
                      color: '#cbd5e1', background: '#f8fafc',
                      border: '1px dashed #e2e8f0', borderRadius: 8,
                      padding: '5px 12px',
                      cursor: 'not-allowed',
                    }}
                  >
                    {lang === 'pt' ? 'Listagem do dia (PDF)' : 'Daily list (PDF)'}
                  </Button>
                </span>
              </Tooltip>
            </>
          ) : (
            canWrite && <Button className={classes.newBtn} startIcon={<AddIcon style={{ fontSize: 16 }} />} onClick={handleCreate}>
              {t(lang, 'createOrder')}
            </Button>
          )}
          {/* Casais/mercadoria: os Motoristas vivem em Manutenção → Motoristas,
              por isso escondemos aqui o atalho duplicado (barra mais limpa). */}
          {!isMercadoriaVariant && (
          <Tooltip title={lang === 'pt' ? 'Gerir motoristas · competências, morada, tacógrafo' : 'Manage drivers · skills, home, tachograph'}>
            <Button
              size="small"
              onClick={() => setShowManageDrivers(true)}
              startIcon={<PersonIcon style={{ fontSize: 15 }} />}
              style={{
                fontSize: '0.72rem', fontWeight: 500, letterSpacing: '-0.005em', textTransform: 'none',
                color: '#1e40af',
                background: showManageDrivers ? '#dbeafe' : '#eff6ff',
                border: `1px solid ${showManageDrivers ? '#93c5fd' : '#bfdbfe'}`,
                borderRadius: 8, padding: '5px 12px',
                boxShadow: 'none',
                transition: 'all 0.15s',
              }}
            >
              {lang === 'pt' ? `Motoristas (${allDrivers.length || 0})` : `Drivers (${allDrivers.length || 0})`}
            </Button>
          </Tooltip>
          )}
          <Box style={{ height: 24, width: 1, background: '#e2e8f0' }} />
          <Button
            size="small"
            onClick={e => setImportMenuAnchor(e.currentTarget)}
            startIcon={<GetAppIcon style={{ fontSize: 15 }} />}
            endIcon={<ExpandMoreIcon style={{ fontSize: 16, transform: importMenuAnchor ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }} />}
            style={{
              fontSize: '0.72rem', fontWeight: 500, letterSpacing: '-0.005em', textTransform: 'none',
              color: '#475569',
              background: importMenuAnchor ? '#f8fafc' : '#fff',
              border: `1px solid ${importMenuAnchor ? '#cbd5e1' : '#e2e8f0'}`,
              borderRadius: 8, padding: '5px 12px',
              boxShadow: 'none',
              transition: 'all 0.15s',
            }}
          >
            {lang === 'pt' ? (isMercadoriaVariant ? 'Importar Guias' : 'Importar') : (isMercadoriaVariant ? 'Import guias' : 'Import')}
          </Button>
          <Menu
            anchorEl={importMenuAnchor}
            open={Boolean(importMenuAnchor)}
            onClose={() => setImportMenuAnchor(null)}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
              style: {
                marginTop: 6, borderRadius: 12, minWidth: 260,
                boxShadow: '0 12px 32px rgba(15,23,42,0.12), 0 0 0 1px rgba(15,23,42,0.04)',
                padding: 4,
              },
            }}
          >
            <Box style={{ padding: '6px 10px 8px', borderBottom: '1px solid #f1f5f9', marginBottom: 4 }}>
              <Typography style={{ fontSize: '0.58rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                {lang === 'pt' ? 'Importar ordens' : 'Import orders'}
              </Typography>
              <Typography style={{ fontSize: '0.64rem', color: '#94a3b8', marginTop: 2 }}>
                {lang === 'pt' ? 'Escolhe a fonte dos dados' : 'Choose the data source'}
              </Typography>
            </Box>
            <MenuItem
              onClick={() => { setImportDialog('excel'); setImportMenuAnchor(null); }}
              style={{ borderRadius: 8, padding: '8px 10px', gap: 10 }}
            >
              <Box style={{
                width: 32, height: 32, borderRadius: 8,
                background: 'linear-gradient(135deg, #dcfce7, #bbf7d0)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0, fontSize: 16,
              }}>📊</Box>
              <Box style={{ flex: 1, minWidth: 0 }}>
                <Typography style={{ fontSize: '0.78rem', fontWeight: 700, color: '#0f172a' }}>
                  Excel / CSV
                </Typography>
                <Typography style={{ fontSize: '0.62rem', color: '#64748b' }}>
                  {lang === 'pt' ? 'Upload de ficheiro .xlsx ou .csv' : 'Upload .xlsx or .csv file'}
                </Typography>
              </Box>
            </MenuItem>
            <MenuItem
              onClick={() => { setImportDialog('api'); setImportMenuAnchor(null); }}
              style={{ borderRadius: 8, padding: '8px 10px', gap: 10 }}
            >
              <Box style={{
                width: 32, height: 32, borderRadius: 8,
                background: 'linear-gradient(135deg, #dbeafe, #bfdbfe)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0, fontSize: 16,
              }}>🔗</Box>
              <Box style={{ flex: 1, minWidth: 0 }}>
                <Typography style={{ fontSize: '0.78rem', fontWeight: 700, color: '#0f172a' }}>
                  API
                </Typography>
                <Typography style={{ fontSize: '0.62rem', color: '#64748b' }}>
                  {lang === 'pt' ? 'Integração com sistema externo' : 'External system integration'}
                </Typography>
              </Box>
            </MenuItem>
            {isMercadoriaVariant && (
              <MenuItem
                onClick={() => { setShowImportGuias(true); setImportMenuAnchor(null); }}
                style={{ borderRadius: 8, padding: '8px 10px', gap: 10 }}
              >
                <Box style={{ width: 32, height: 32, borderRadius: 8, background: 'linear-gradient(135deg, #e0f2fe, #bae6fd)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: 16 }}>📄</Box>
                <Box style={{ flex: 1, minWidth: 0 }}>
                  <Typography style={{ fontSize: '0.78rem', fontWeight: 700, color: '#0f172a' }}>
                    {lang === 'pt' ? 'Guias (Casais)' : 'Guias (Casais)'}
                  </Typography>
                  <Typography style={{ fontSize: '0.62rem', color: '#64748b' }}>
                    {lang === 'pt' ? 'Criar OTs a partir dos ficheiros das guias' : 'Create OTs from guia files'}
                  </Typography>
                </Box>
              </MenuItem>
            )}
          </Menu>
          <Box style={{ height: 24, width: 1, background: '#e2e8f0' }} />
          {/* Density toggle */}
          <Box style={{ display: 'flex', background: '#f1f5f9', borderRadius: 8, padding: 2, border: '1px solid #e2e8f0' }}>
            <Tooltip title={lang === 'pt' ? 'Tabela' : 'Table'}>
              <IconButton size="small" onClick={() => setDensity('compact')}
                style={{
                  padding: 5, borderRadius: 6,
                  background: density === 'compact' ? '#fff' : 'transparent',
                  color: density === 'compact' ? '#6366f1' : '#94a3b8',
                  boxShadow: density === 'compact' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                }}>
                <ViewCompactIcon style={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>
            <Tooltip title={lang === 'pt' ? 'Cards' : 'Cards'}>
              <IconButton size="small" onClick={() => setDensity('cards')}
                style={{
                  padding: 5, borderRadius: 6,
                  background: density === 'cards' ? '#fff' : 'transparent',
                  color: density === 'cards' ? '#6366f1' : '#94a3b8',
                  boxShadow: density === 'cards' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                }}>
                <ViewAgendaIcon style={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>
          </Box>
          <Tooltip title={lang === 'pt' ? 'Atalhos de teclado (?)' : 'Keyboard shortcuts (?)'}>
            <IconButton size="small" onClick={() => setShowShortcuts(s => !s)} style={{ padding: 5 }}>
              <Typography style={{ fontSize: '0.78rem', fontWeight: 800, color: '#64748b' }}>?</Typography>
            </IconButton>
          </Tooltip>
          {/* View mode toggle */}
          <Box style={{ display: 'flex', background: '#f1f5f9', borderRadius: 8, padding: 2, border: '1px solid #e2e8f0' }}>
            <Tooltip title={lang === 'pt' ? 'Vista tabela' : 'Table view'}>
              <IconButton size="small" onClick={() => setViewMode('table')}
                style={{
                  padding: 5, borderRadius: 6,
                  background: viewMode === 'table' ? '#fff' : 'transparent',
                  color: viewMode === 'table' ? '#6366f1' : '#94a3b8',
                  boxShadow: viewMode === 'table' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                }}>
                <TableChartIcon style={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>
            <Tooltip title={lang === 'pt' ? 'Vista timeline (Gantt)' : 'Timeline view (Gantt)'}>
              <IconButton size="small" onClick={() => setViewMode('gantt')}
                style={{
                  padding: 5, borderRadius: 6,
                  background: viewMode === 'gantt' ? '#fff' : 'transparent',
                  color: viewMode === 'gantt' ? '#6366f1' : '#94a3b8',
                  boxShadow: viewMode === 'gantt' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                }}>
                <ViewTimelineIcon style={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>
            {/* Shortcut to Operações → Rotas (live monitoring panel). The
                old embedded "operations" view here was removed — the new
                home is the enriched Routes panel inside the Operations
                screen. This button is a 1-click jump there. */}
            <Tooltip title={lang === 'pt' ? '🚚 Monitorizar rotas em curso (Operações → Rotas)' : '🚚 Monitor live routes (Operations → Routes)'}>
              <IconButton
                size="small"
                onClick={() => {
                  dispatch(navigateTo('manage'));
                  // Slight delay so the ManageDialog has time to mount
                  // before we tell it which section to land on.
                  setTimeout(() => {
                    window.dispatchEvent(new CustomEvent('manageOpenSection', {
                      detail: { section: 'routes-library' },
                    }));
                  }, 100);
                }}
                style={{
                  padding: 5, borderRadius: 6,
                  background: 'transparent',
                  color: '#1e40af',
                }}
              >
                <LocalShippingIcon style={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>
<Tooltip title={lang === 'pt' ? '✓ Resumo · todas as ordens entregues com métricas e rota' : '✓ Summary · all delivered orders with metrics and route'}>
              <IconButton size="small" onClick={() => setViewMode('live')}
                style={{
                  padding: 5, borderRadius: 6,
                  background: viewMode === 'live' ? '#fff' : 'transparent',
                  color: viewMode === 'live' ? '#16a34a' : '#94a3b8',
                  boxShadow: viewMode === 'live' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                }}>
                <DashboardIcon style={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Box>

      {/* Cartão KPI SLA — só aparece quando há OTs assistência com SLA
          (caso típico Petrotec). Mostra estados live + % cumprimento 30d
          com sinalização visual da meta 95%. Refresh 60s + on WS alert. */}
      {slaDashboard && (slaDashboard.live?.items?.length > 0 || slaDashboard.stats30d?.total > 0 || slaDashboard.stats30dResolution?.total > 0) && (() => {
        const live = slaDashboard.live?.tally || {};
        const liveR = slaDashboard.live?.tallyResolution || {};
        const stats = slaDashboard.stats30d || {};
        const statsR = slaDashboard.stats30dResolution || {};
        const pct = stats.pctCumprimento;
        const pctR = statsR.pctCumprimento;
        const target = stats.target ?? 95;
        const belowTarget = (pct != null && pct < target) || (pctR != null && pctR < target);
        const hasResolutionData = (liveR.ok || liveR.warning || liveR.critical || liveR.overdue || statsR.total) > 0;
        const Card = ({ label, value, color, bg, onClick, sub }) => (
          <Box
            onClick={onClick}
            style={{
              flex: '1 1 0', minWidth: 130, padding: '8px 12px', borderRadius: 10,
              background: bg, border: `1px solid ${color}33`,
              cursor: onClick ? 'pointer' : 'default',
              transition: 'all 0.12s',
            }}
            onMouseEnter={(e) => { if (onClick) e.currentTarget.style.borderColor = color; }}
            onMouseLeave={(e) => { if (onClick) e.currentTarget.style.borderColor = `${color}33`; }}
          >
            <Typography style={{ fontSize: '0.6rem', fontWeight: 800, color, textTransform: 'uppercase', letterSpacing: 0.4 }}>
              {label}
            </Typography>
            <Typography style={{
              fontSize: '1.15rem', fontWeight: 800, color: '#0f172a', lineHeight: 1.1,
              fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
            }}>
              {value}
            </Typography>
            {sub && (
              <Typography style={{ fontSize: '0.6rem', color: '#64748b', marginTop: 1 }}>
                {sub}
              </Typography>
            )}
          </Box>
        );
        return (
          <Box style={{ padding: '8px 24px 0' }}>
            <Box style={{
              display: 'flex', gap: 8, padding: 10, borderRadius: 12,
              background: belowTarget
                ? 'linear-gradient(135deg, #fef2f2 0%, #ffffff 60%)'
                : 'linear-gradient(135deg, #f0fdf4 0%, #ffffff 60%)',
              border: belowTarget ? '1px solid #fecaca' : '1px solid #bbf7d0',
              flexWrap: 'wrap', alignItems: 'stretch', flexDirection: 'column',
            }}>
              {/* Linha 1 — SLA Resposta */}
              <Box style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'stretch' }}>
                <Box style={{
                  display: 'flex', flexDirection: 'column', justifyContent: 'center',
                  paddingRight: 12, borderRight: '1px solid rgba(0,0,0,0.06)', minWidth: 110,
                }}>
                  <Typography style={{
                    fontSize: '0.66rem', fontWeight: 800, color: '#475569',
                    textTransform: 'uppercase', letterSpacing: 0.5,
                  }}>
                    {lang === 'pt' ? '⏱ SLA · Resposta' : '⏱ SLA · Response'}
                  </Typography>
                  <Typography style={{ fontSize: '0.6rem', color: '#94a3b8', marginTop: 1 }}>
                    {lang === 'pt' ? 'Até chegar' : 'Until arrival'}
                  </Typography>
                </Box>
                <Card
                  label={lang === 'pt' ? 'Vencidos AGORA' : 'Overdue NOW'}
                  value={live.overdue || 0}
                  color="#dc2626" bg="#fee2e2"
                  onClick={(live.overdue || 0) > 0 ? () => applyQuickFilter('slaOverdue') : null}
                  sub={lang === 'pt' ? 'A 0% restante' : 'At 0% remaining'}
                />
                <Card
                  label={lang === 'pt' ? 'Críticos' : 'Critical'}
                  value={live.critical || 0}
                  color="#ea580c" bg="#ffedd5"
                  onClick={((live.critical || 0) + (live.warning || 0)) > 0 ? () => applyQuickFilter('slaAtRisk') : null}
                  sub={lang === 'pt' ? '≥75% decorrido' : '≥75% elapsed'}
                />
                <Card
                  label={lang === 'pt' ? 'Atenção' : 'Warning'}
                  value={live.warning || 0}
                  color="#ca8a04" bg="#fef9c3"
                  sub={lang === 'pt' ? '≥50% decorrido' : '≥50% elapsed'}
                />
                <Card
                  label={lang === 'pt' ? 'No prazo' : 'On track'}
                  value={live.ok || 0}
                  color="#16a34a" bg="#dcfce7"
                  sub={lang === 'pt' ? '<50% decorrido' : '<50% elapsed'}
                />
                <Card
                  label={lang === 'pt' ? 'Cumprimento 30d' : 'Compliance 30d'}
                  value={pct != null ? `${pct}%` : '—'}
                  color={(pct != null && pct < target) ? '#dc2626' : '#16a34a'}
                  bg={(pct != null && pct < target) ? '#fee2e2' : '#dcfce7'}
                  sub={stats.total
                    ? (lang === 'pt'
                        ? `${stats.met}/${stats.total} · meta ${target}%`
                        : `${stats.met}/${stats.total} · target ${target}%`)
                    : (lang === 'pt' ? 'Sem dados 30d' : 'No data 30d')}
                />
              </Box>

              {/* Linha 2 — SLA Resolução (só quando há dados) */}
              {hasResolutionData && (
                <Box style={{
                  display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'stretch',
                  paddingTop: 8, marginTop: 4, borderTop: '1px dashed rgba(0,0,0,0.08)',
                }}>
                  <Box style={{
                    display: 'flex', flexDirection: 'column', justifyContent: 'center',
                    paddingRight: 12, borderRight: '1px solid rgba(0,0,0,0.06)', minWidth: 110,
                  }}>
                    <Typography style={{
                      fontSize: '0.66rem', fontWeight: 800, color: '#475569',
                      textTransform: 'uppercase', letterSpacing: 0.5,
                    }}>
                      {lang === 'pt' ? '✓ SLA · Resolução' : '✓ SLA · Resolution'}
                    </Typography>
                    <Typography style={{ fontSize: '0.6rem', color: '#94a3b8', marginTop: 1 }}>
                      {lang === 'pt' ? 'Até concluir' : 'Until completion'}
                    </Typography>
                  </Box>
                  <Card
                    label={lang === 'pt' ? 'Vencidos AGORA' : 'Overdue NOW'}
                    value={liveR.overdue || 0}
                    color="#dc2626" bg="#fee2e2"
                    sub={lang === 'pt' ? 'A 0% restante' : 'At 0% remaining'}
                  />
                  <Card
                    label={lang === 'pt' ? 'Críticos' : 'Critical'}
                    value={liveR.critical || 0}
                    color="#ea580c" bg="#ffedd5"
                    sub={lang === 'pt' ? '≥75% decorrido' : '≥75% elapsed'}
                  />
                  <Card
                    label={lang === 'pt' ? 'Atenção' : 'Warning'}
                    value={liveR.warning || 0}
                    color="#ca8a04" bg="#fef9c3"
                    sub={lang === 'pt' ? '≥50% decorrido' : '≥50% elapsed'}
                  />
                  <Card
                    label={lang === 'pt' ? 'No prazo' : 'On track'}
                    value={liveR.ok || 0}
                    color="#16a34a" bg="#dcfce7"
                    sub={lang === 'pt' ? '<50% decorrido' : '<50% elapsed'}
                  />
                  <Card
                    label={lang === 'pt' ? 'Cumprimento 30d' : 'Compliance 30d'}
                    value={pctR != null ? `${pctR}%` : '—'}
                    color={(pctR != null && pctR < target) ? '#dc2626' : '#16a34a'}
                    bg={(pctR != null && pctR < target) ? '#fee2e2' : '#dcfce7'}
                    sub={statsR.total
                      ? (lang === 'pt'
                          ? `${statsR.met}/${statsR.total} · meta ${target}%`
                          : `${statsR.met}/${statsR.total} · target ${target}%`)
                      : (lang === 'pt' ? 'Sem dados 30d' : 'No data 30d')}
                  />
                </Box>
              )}
            </Box>
          </Box>
        );
      })()}

      {/* Quick filter presets — main operator access for at-a-glance triage */}
      <Box style={{
        display: 'flex', alignItems: 'center', gap: 8, padding: '8px 24px 0',
        flexWrap: 'wrap',
      }}>
        {[
          // Quick filters por critérios COMBINADOS (não apenas status).
          // O filtro "Em Trânsito" foi removido daqui porque já existe
          // como chip de estado em baixo, e ter dois sítios para a
          // mesma coisa confundia o operador. Os que ficam aqui são
          // filtros compostos: data, atraso, falta de veículo, urgência.
          { key: 'today',       label: lang === 'pt' ? 'Hoje' : 'Today',               count: counts.today,     color: '#6366f1', icon: '📅' },
          { key: 'delayed',     label: lang === 'pt' ? 'Atrasadas' : 'Delayed',        count: counts.delayed,   color: '#ef4444', icon: '⚠' },
          { key: 'noVehicle',   label: lang === 'pt' ? 'Sem veículo' : 'No vehicle',   count: counts.noVehicle, color: '#94a3b8', icon: '❓' },
          { key: 'urgent',      label: lang === 'pt' ? 'Urgentes' : 'Urgent',          count: counts.urgent,    color: '#dc2626', icon: '🔴' },
          // Combustível — filtra OTs de distribuição fuel (Move Express).
          // Client-side (sobre lista visível). Só aparece quando há OTs fuel E
          // o tenant NÃO é da variante fuel (aí todas são combustível, o filtro
          // seria redundante).
          ...(!isMoveExpressTenant(clientExternalId, clientSettings) && (list || []).some(o => o.serviceType === 'fuel')
            ? [{ key: 'fuelOnly', label: lang === 'pt' ? 'Combustível' : 'Fuel', count: (list || []).filter(o => o.serviceType === 'fuel').length, color: '#ea580c', icon: '⛽' }]
            : []),
          // SLA: filtros client-side calculados sobre a lista visível.
          // Mostram só quando há ocorrências (chip irrelevante se 0).
          ...(slaCounts.atRisk > 0
            ? [{ key: 'slaAtRisk', label: lang === 'pt' ? 'SLA em risco' : 'SLA at risk',  count: slaCounts.atRisk, color: '#ea580c', icon: '⏱' }]
            : []),
          ...(slaCounts.overdue > 0
            ? [{ key: 'slaOverdue', label: lang === 'pt' ? 'SLA vencido' : 'SLA overdue',  count: slaCounts.overdue, color: '#dc2626', icon: '🚨' }]
            : []),
        ].map(qf => {
          const isActive = quickFilter === qf.key;
          return (
            <Box key={qf.key}
              onClick={() => applyQuickFilter(qf.key)}
              style={{
                display: 'flex', alignItems: 'center', gap: 8,
                padding: '6px 12px 6px 10px', borderRadius: 10, cursor: 'pointer',
                background: isActive ? `${qf.color}15` : '#fff',
                border: isActive ? `1.5px solid ${qf.color}` : '1.5px solid rgba(0,0,0,0.07)',
                boxShadow: isActive ? `0 2px 8px ${qf.color}30` : 'none',
                transition: 'all 0.15s',
              }}
              onMouseEnter={(e) => { if (!isActive) e.currentTarget.style.borderColor = `${qf.color}80`; }}
              onMouseLeave={(e) => { if (!isActive) e.currentTarget.style.borderColor = 'rgba(0,0,0,0.07)'; }}>
              <span style={{ fontSize: 13 }}>{qf.icon}</span>
              <Typography style={{ fontSize: '0.72rem', fontWeight: 700, color: isActive ? qf.color : '#475569' }}>
                {qf.label}
              </Typography>
              <Box style={{
                minWidth: 22, height: 18, padding: '0 6px',
                borderRadius: 9, display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: isActive ? qf.color : `${qf.color}15`,
                color: isActive ? '#fff' : qf.color,
                fontSize: '0.65rem', fontWeight: 800,
              }}>
                {qf.count}
              </Box>
            </Box>
          );
        })}
        {/* Custom date range chip */}
        {(() => {
          const isActive = quickFilter === 'custom' && (customDateFrom || customDateTo);
          const fmt = (s) => s ? new Date(s).toLocaleDateString(lang === 'pt' ? 'pt-PT' : 'en-GB', { day: '2-digit', month: '2-digit' }) : '?';
          const label = isActive
            ? `${fmt(customDateFrom)} → ${fmt(customDateTo)}`
            : (lang === 'pt' ? 'Período' : 'Date range');
          return (
            <Box
              onClick={(e) => setDateRangeAnchor(e.currentTarget)}
              style={{
                display: 'flex', alignItems: 'center', gap: 8,
                padding: '6px 12px 6px 10px', borderRadius: 10, cursor: 'pointer',
                background: isActive ? 'rgba(99,102,241,0.08)' : '#fff',
                border: isActive ? '1.5px solid #6366f1' : '1.5px solid rgba(0,0,0,0.07)',
                boxShadow: isActive ? '0 2px 8px rgba(99,102,241,0.2)' : 'none',
                transition: 'all 0.15s',
              }}
              onMouseEnter={(e) => { if (!isActive) e.currentTarget.style.borderColor = 'rgba(99,102,241,0.5)'; }}
              onMouseLeave={(e) => { if (!isActive) e.currentTarget.style.borderColor = 'rgba(0,0,0,0.07)'; }}
            >
              <span style={{ fontSize: 13 }}>📆</span>
              <Typography style={{ fontSize: '0.72rem', fontWeight: 700, color: isActive ? '#6366f1' : '#475569' }}>
                {label}
              </Typography>
              {isActive && (
                <span
                  onClick={(e) => { e.stopPropagation(); clearCustomDateRange(); }}
                  style={{ fontSize: '0.78rem', color: '#6366f1', cursor: 'pointer', fontWeight: 800, marginLeft: 2 }}
                >×</span>
              )}
            </Box>
          );
        })()}
        {/* Trigger "Fase da rota" — ao lado do Período. Abre o card
            expansível por baixo do toolbar. Só no contexto combustível. */}
        {fuelStageContext && fuelOrders.length > 0 && (() => {
          const activeBucket = fuelStageFilter
            ? FUEL_STAGE_BUCKETS.find(b => b.key === fuelStageFilter)
            : null;
          const isActive = !!activeBucket;
          const col = activeBucket?.color || '#ea580c';
          return (
            <Box
              onClick={() => setFuelStagePanelOpen(v => !v)}
              style={{
                display: 'flex', alignItems: 'center', gap: 8,
                padding: '6px 12px 6px 10px', borderRadius: 10, cursor: 'pointer',
                background: (isActive || fuelStagePanelOpen) ? `${col}15` : '#fff',
                border: `1.5px solid ${(isActive || fuelStagePanelOpen) ? col : 'rgba(0,0,0,0.07)'}`,
                boxShadow: isActive ? `0 2px 8px ${col}30` : 'none',
                transition: 'all 0.15s',
              }}
              onMouseEnter={(e) => { if (!isActive && !fuelStagePanelOpen) e.currentTarget.style.borderColor = `${col}80`; }}
              onMouseLeave={(e) => { if (!isActive && !fuelStagePanelOpen) e.currentTarget.style.borderColor = 'rgba(0,0,0,0.07)'; }}
            >
              <span style={{ fontSize: 13 }}>⛽</span>
              <Typography style={{ fontSize: '0.72rem', fontWeight: 700, color: (isActive || fuelStagePanelOpen) ? col : '#475569' }}>
                {isActive
                  ? `${activeBucket.emoji} ${lang === 'pt' ? activeBucket.pt : activeBucket.en}`
                  : (lang === 'pt' ? 'Fase da rota' : 'Route stage')}
              </Typography>
              {isActive ? (
                <span
                  onClick={(e) => { e.stopPropagation(); setFuelStageFilter(null); }}
                  style={{ fontSize: '0.78rem', color: col, cursor: 'pointer', fontWeight: 800, marginLeft: 2 }}
                >×</span>
              ) : (
                <span style={{
                  fontSize: '0.7rem', color: '#94a3b8', fontWeight: 800,
                  transform: fuelStagePanelOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.15s',
                }}>▾</span>
              )}
            </Box>
          );
        })()}
        <Popover
          open={Boolean(dateRangeAnchor)}
          anchorEl={dateRangeAnchor}
          onClose={() => setDateRangeAnchor(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          PaperProps={{ style: { marginTop: 6, borderRadius: 12, padding: 14, minWidth: 280, boxShadow: '0 12px 32px rgba(15,23,42,0.15)' } }}
        >
          <Typography style={{ fontSize: '0.62rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8 }}>
            {lang === 'pt' ? 'Período de entrega' : 'Delivery date range'}
          </Typography>
          <Box style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <Box>
              <Typography style={{ fontSize: '0.62rem', color: '#94a3b8', marginBottom: 2 }}>
                {lang === 'pt' ? 'De' : 'From'}
              </Typography>
              <input
                type="date"
                value={customDateFrom}
                onChange={(e) => setCustomDateFrom(e.target.value)}
                style={{
                  width: '100%', padding: '7px 10px', fontSize: '0.78rem',
                  border: '1px solid #e2e8f0', borderRadius: 8, color: '#0f172a',
                  background: '#f8fafc',
                }}
              />
            </Box>
            <Box>
              <Typography style={{ fontSize: '0.62rem', color: '#94a3b8', marginBottom: 2 }}>
                {lang === 'pt' ? 'Até' : 'To'}
              </Typography>
              <input
                type="date"
                value={customDateTo}
                onChange={(e) => setCustomDateTo(e.target.value)}
                min={customDateFrom || undefined}
                style={{
                  width: '100%', padding: '7px 10px', fontSize: '0.78rem',
                  border: '1px solid #e2e8f0', borderRadius: 8, color: '#0f172a',
                  background: '#f8fafc',
                }}
              />
            </Box>
          </Box>
          {/* Quick presets */}
          <Box style={{ display: 'flex', gap: 4, marginTop: 10, flexWrap: 'wrap' }}>
            {[
              { label: lang === 'pt' ? 'Esta semana' : 'This week', fn: () => {
                const now = new Date();
                const dow = now.getDay();
                const monday = new Date(now); monday.setDate(now.getDate() - (dow === 0 ? 6 : dow - 1));
                const sunday = new Date(monday); sunday.setDate(monday.getDate() + 6);
                setCustomDateFrom(monday.toISOString().slice(0, 10));
                setCustomDateTo(sunday.toISOString().slice(0, 10));
              }},
              { label: lang === 'pt' ? 'Este mês' : 'This month', fn: () => {
                const now = new Date();
                const first = new Date(now.getFullYear(), now.getMonth(), 1);
                const last = new Date(now.getFullYear(), now.getMonth() + 1, 0);
                setCustomDateFrom(first.toISOString().slice(0, 10));
                setCustomDateTo(last.toISOString().slice(0, 10));
              }},
              { label: lang === 'pt' ? 'Próx. 7 dias' : 'Next 7d', fn: () => {
                const now = new Date();
                const end = new Date(now); end.setDate(now.getDate() + 7);
                setCustomDateFrom(now.toISOString().slice(0, 10));
                setCustomDateTo(end.toISOString().slice(0, 10));
              }},
            ].map(p => (
              <Box key={p.label} onClick={p.fn} style={{
                padding: '4px 10px', borderRadius: 14, fontSize: '0.62rem', fontWeight: 600,
                background: '#f1f5f9', color: '#475569', cursor: 'pointer',
                border: '1px solid #e2e8f0',
              }}>{p.label}</Box>
            ))}
          </Box>
          <Box style={{ display: 'flex', gap: 6, justifyContent: 'flex-end', marginTop: 12 }}>
            <Button size="small" onClick={() => setDateRangeAnchor(null)}
              style={{ fontSize: '0.7rem', textTransform: 'none', color: '#64748b', fontWeight: 600 }}>
              {lang === 'pt' ? 'Cancelar' : 'Cancel'}
            </Button>
            <Button size="small" variant="contained" onClick={applyCustomDateRange}
              style={{
                fontSize: '0.7rem', textTransform: 'none', borderRadius: 8,
                background: 'linear-gradient(135deg, #6366f1, #4f46e5)',
                color: '#fff', fontWeight: 700, boxShadow: 'none', padding: '4px 14px',
              }}>
              {lang === 'pt' ? 'Aplicar' : 'Apply'}
            </Button>
          </Box>
        </Popover>

        {quickFilter && quickFilter !== 'custom' && (
          <Box
            onClick={() => applyQuickFilter(quickFilter)}
            style={{
              padding: '6px 10px', borderRadius: 10, cursor: 'pointer',
              fontSize: '0.68rem', fontWeight: 600, color: '#64748b',
              border: '1.5px dashed rgba(0,0,0,0.12)',
            }}>
            ✕ {lang === 'pt' ? 'Limpar filtro' : 'Clear filter'}
          </Box>
        )}
      </Box>

      {/* Filters */}
      <Box className={classes.filterBar}>
        <TextField
          inputRef={searchInputRef}
          className={classes.searchField}
          variant="outlined"
          size="small"
          placeholder={lang === 'pt' ? 'Pesquisar ordens, matrícula, motorista…   (f)' : 'Search orders, plate, driver…   (f)'}
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          InputProps={{
            startAdornment: <SearchIcon style={{ fontSize: 16, color: '#94a3b8', marginRight: 6 }} />,
          }}
        />
        {(() => {
          // Multi-select: filters.status pode conter vários estados
          // separados por vírgulas. Cada chip mostra-se "activo" se
          // estiver presente na lista. "Todas" só fica activo quando
          // não há nenhum estado seleccionado.
          const activeStatuses = filters.status
            ? filters.status.split(',').filter(Boolean)
            : [];
          const noneActive = activeStatuses.length === 0;
          return (
            <>
              <Chip
                className={classes.statusChip}
                label={lang === 'pt' ? 'Todas' : 'All'}
                onClick={() => dispatch(setFilters({ status: '' }))}
                style={{
                  background: noneActive ? '#1e293b' : 'transparent',
                  color: noneActive ? '#fff' : '#64748b',
                  border: `1.5px solid ${noneActive ? '#1e293b' : '#cbd5e1'}`,
                }}
              />
              {Object.entries(STATUS_KEYS).map(([key, labelKey]) => {
                const isActive = activeStatuses.includes(key);
                return (
                  <Chip
                    key={key}
                    className={classes.statusChip}
                    label={t(lang, labelKey)}
                    onClick={() => handleStatusFilter(key)}
                    icon={isActive ? <Box style={{
                      width: 12, height: 12, borderRadius: 3,
                      background: '#fff', color: STATUS_COLORS[key],
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 10, fontWeight: 800, marginLeft: 6,
                    }}>✓</Box> : undefined}
                    style={{
                      background: isActive ? STATUS_COLORS[key] : 'transparent',
                      color: isActive ? '#fff' : STATUS_COLORS[key],
                      border: `1.5px solid ${STATUS_COLORS[key]}`,
                    }}
                  />
                );
              })}
              {activeStatuses.length >= 2 && (
                <Box style={{
                  padding: '3px 8px', borderRadius: 999,
                  background: 'rgba(99,102,241,0.10)',
                  color: '#4338ca',
                  fontSize: '0.6rem', fontWeight: 800,
                  letterSpacing: '0.04em', textTransform: 'uppercase',
                  border: '1px solid rgba(99,102,241,0.3)',
                  display: 'inline-flex', alignItems: 'center',
                }}>
                  {activeStatuses.length} {lang === 'pt' ? 'estados' : 'states'}
                </Box>
              )}
            </>
          );
        })()}
        <FormControl variant="outlined" size="small" style={{ minWidth: 130 }}>
          <InputLabel style={{ fontSize: '0.78rem' }}>
            {lang === 'pt' ? 'Prioridade' : 'Priority'}
          </InputLabel>
          <Select
            value={filters.priority}
            onChange={(e) => dispatch(setFilters({ priority: e.target.value }))}
            label={lang === 'pt' ? 'Prioridade' : 'Priority'}
            style={{ height: 34, fontSize: '0.78rem' }}
          >
            <MenuItem value="">{lang === 'pt' ? 'Todas' : 'All'}</MenuItem>
            <MenuItem value="high">{t(lang, 'priorityHigh')}</MenuItem>
            <MenuItem value="normal">{t(lang, 'priorityNormal')}</MenuItem>
            <MenuItem value="low">{t(lang, 'priorityLow')}</MenuItem>
          </Select>
        </FormControl>
        <FormControl variant="outlined" size="small" style={{ minWidth: 130 }}>
          <InputLabel style={{ fontSize: '0.78rem' }}>
            {lang === 'pt' ? 'Ordenar' : 'Sort'}
          </InputLabel>
          <Select
            value={sortValue}
            onChange={handleSortChange}
            label={lang === 'pt' ? 'Ordenar' : 'Sort'}
            style={{ height: 34, fontSize: '0.78rem' }}
          >
            <MenuItem value="date">{lang === 'pt' ? 'Data' : 'Date'}</MenuItem>
            <MenuItem value="orderNumber">{t(lang, 'orderNumber')}</MenuItem>
            <MenuItem value="priority">{t(lang, 'priority')}</MenuItem>
          </Select>
        </FormControl>
      </Box>

      {/* Card expansível de pesquisa por fase da cronologia (só combustível).
          Aberto pelo trigger "Fase da rota" ao lado do Período. */}
      <Collapse in={fuelStagePanelOpen && fuelStageContext && fuelOrders.length > 0 && viewMode === 'table'} timeout={220} unmountOnExit>
        <Box style={{
          margin: '0 24px 12px', padding: '14px 16px', borderRadius: 14,
          background: 'linear-gradient(135deg, #fff7ed 0%, #ffffff 55%)',
          border: '1px solid #fed7aa', boxShadow: '0 4px 16px rgba(234,88,12,0.06)',
        }}>
          {/* Header */}
          <Box style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
            <Box style={{
              width: 30, height: 30, borderRadius: 8,
              background: 'linear-gradient(135deg, #fb923c, #f97316)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 2px 8px rgba(249,115,22,0.3)',
            }}>
              <span style={{ fontSize: 16 }}>⛽</span>
            </Box>
            <Box style={{ flex: 1, minWidth: 0 }}>
              <Typography style={{ fontSize: '0.82rem', fontWeight: 800, color: '#9a3412' }}>
                {lang === 'pt' ? 'Pesquisar por fase da rota' : 'Search by route stage'}
              </Typography>
              <Typography style={{ fontSize: '0.66rem', color: '#c2410c' }}>
                {lang === 'pt'
                  ? `${fuelOrders.length} OT de combustível · clica numa fase para filtrar`
                  : `${fuelOrders.length} fuel orders · click a stage to filter`}
              </Typography>
            </Box>
            {fuelStageFilter && (
              <Button size="small" onClick={() => setFuelStageFilter(null)}
                style={{ textTransform: 'none', fontSize: '0.7rem', color: '#9a3412', minWidth: 0, padding: '4px 10px' }}>
                {lang === 'pt' ? 'Limpar' : 'Clear'}
              </Button>
            )}
            <IconButton size="small" onClick={() => setFuelStagePanelOpen(false)}>
              <CloseIcon style={{ fontSize: 16, color: '#9a3412' }} />
            </IconButton>
          </Box>
          {/* Pills por fase */}
          <Box style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {[{ key: null, emoji: '📋', pt: 'Todas', en: 'All', color: '#9a3412', count: fuelOrders.length },
              ...FUEL_STAGE_BUCKETS.map(b => ({ ...b, count: fuelStageCounts[b.key] || 0 }))
            ].map(b => {
              const isActive = fuelStageFilter === b.key;
              return (
                <Box key={b.key || 'all'}
                  onClick={() => setFuelStageFilter(isActive ? null : b.key)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 8,
                    padding: '8px 12px', borderRadius: 10, cursor: 'pointer',
                    background: isActive ? b.color : '#fff',
                    border: `1.5px solid ${isActive ? b.color : b.color + '33'}`,
                    boxShadow: isActive ? `0 2px 8px ${b.color}44` : 'none',
                    opacity: b.count === 0 && !isActive && b.key != null ? 0.5 : 1,
                    transition: 'all 0.12s ease',
                  }}
                  onMouseEnter={(e) => { if (!isActive) e.currentTarget.style.borderColor = b.color + '99'; }}
                  onMouseLeave={(e) => { if (!isActive) e.currentTarget.style.borderColor = b.color + '33'; }}
                >
                  <span style={{ fontSize: 14 }}>{b.emoji}</span>
                  <Typography style={{ fontSize: '0.74rem', fontWeight: 700, color: isActive ? '#fff' : '#0f172a' }}>
                    {lang === 'pt' ? b.pt : b.en}
                  </Typography>
                  <Box style={{
                    minWidth: 20, height: 18, padding: '0 6px', borderRadius: 9,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: isActive ? 'rgba(255,255,255,0.25)' : `${b.color}15`,
                    color: isActive ? '#fff' : b.color,
                    fontSize: '0.64rem', fontWeight: 800,
                    fontFamily: 'ui-monospace, Menlo, monospace',
                  }}>
                    {b.count}
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      </Collapse>

      {/* Gantt view (alternative) */}
      {viewMode === 'gantt' && (
        <OrdersGanttView
          orders={list}
          lang={lang}
          onSelectOrder={(o) => {
            setViewMode('table');
            setExpandedOrderId(o.id || o._id);
          }}
        />
      )}

      {/* Delivered orders summary — replaces the old "live in-transit" map.
          Has its own data fetch (status=delivered, last 30 days by default),
          filters, KPIs and a detail pane with mini-map preview per OT. */}
      {viewMode === 'live' && (
        <OrdersDeliveredSummary lang={lang} />
      )}

      {/* Operations in course — one row per vehicle, dispatch overview.
          Aggregated server-side (1 row per vehicle, not per OT) so it
          scales cleanly to 100+ vehicles / 500+ OTs. Click a row to
          open the LiveRoutePanel for that vehicle's current OT. */}
      {viewMode === 'operations' && (
        <OrdersOperationsView
          lang={lang}
          onOpenLive={(entry) => {
            // Find the OT we want to open in Live: prefer the currently
            // in_transit one; fall back to the next assigned. If neither
            // exists (rota concluída), pick any OT belonging to that route
            // so the dispatcher still sees the route on the map.
            const target = list.find(o =>
              (o.vehicleId === entry.vehicleId || o.vehiclePlate === entry.vehiclePlate) &&
              (o.status === 'in_transit' || o.status === 'assigned')
            ) || list.find(o =>
              (o.vehicleId === entry.vehicleId || o.vehiclePlate === entry.vehiclePlate)
            );
            if (target) openLivePanel(target);
          }}
        />
      )}

      {/* Active-filter banner — surfaces every filter that is currently
          narrowing the list so the operator can never wonder "why don't I
          see my OTs?". Persisted filters in localStorage (quickFilter,
          status, priority…) survive logout, which is exactly the failure
          mode that prompted this banner. */}
      {(() => {
        const tags = [];
        if (filters.status) tags.push({ key: 'status', label: (lang === 'pt' ? 'Estado: ' : 'Status: ') + filters.status });
        if (filters.priority !== '' && filters.priority != null) tags.push({ key: 'priority', label: (lang === 'pt' ? 'Prioridade: ' : 'Priority: ') + filters.priority });
        if (filters.noVehicle) tags.push({ key: 'noVehicle', label: lang === 'pt' ? 'Sem veículo' : 'No vehicle' });
        if (filters.delayed) tags.push({ key: 'delayed', label: lang === 'pt' ? 'Atrasadas' : 'Delayed' });
        if (filters.deliveryFrom || filters.deliveryTo) {
          const fmt = (iso) => iso ? new Date(iso).toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit' }) : '…';
          tags.push({ key: 'date', label: (lang === 'pt' ? 'Data: ' : 'Date: ') + `${fmt(filters.deliveryFrom)} → ${fmt(filters.deliveryTo)}` });
        }
        if (filters.search) tags.push({ key: 'search', label: (lang === 'pt' ? 'Pesquisa: ' : 'Search: ') + `"${filters.search}"` });
        if (tags.length === 0) return null;
        return (
          <Box style={{
            margin: '0 0 8px 0', padding: '8px 12px',
            background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 10,
            display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap',
          }}>
            <span style={{ fontSize: 14 }}>⚠️</span>
            <Typography style={{ fontSize: '0.74rem', fontWeight: 700, color: '#92400e' }}>
              {lang === 'pt' ? 'Filtros activos:' : 'Active filters:'}
            </Typography>
            {tags.map(t => (
              <Chip key={t.key} size="small" label={t.label}
                style={{ background: '#fef3c7', color: '#78350f', fontSize: '0.66rem', fontWeight: 600, height: 22 }} />
            ))}
            <Box style={{ flex: 1 }} />
            <Button
              size="small"
              onClick={() => {
                setQuickFilter(null);
                setSearchInput('');
                setCustomDateFrom('');
                setCustomDateTo('');
                dispatch(setFilters({ search: '', status: '', priority: '', deliveryFrom: '', deliveryTo: '', noVehicle: false, delayed: false }));
              }}
              style={{ fontSize: '0.7rem', textTransform: 'none', color: '#92400e', fontWeight: 700, padding: '2px 10px' }}>
              {lang === 'pt' ? 'Limpar todos' : 'Clear all'}
            </Button>
          </Box>
        );
      })()}

      {/* Table view */}
      {viewMode === 'table' && (
      <Box className={classes.tableWrap} ref={tableWrapRef}>
        {/* Spinner de ecrã inteiro SÓ no 1.º carregamento (sem dados ainda).
            Nos refreshes de fundo mantemos a tabela montada — senão o painel
            expandido e os popups abertos (ex.: "Carregou" nas OT de combustível)
            desmontavam a cada atualização de posição das viaturas (~5s) e o
            operador perdia o que estava a fazer. */}
        {loading && list.length === 0 ? (
          <Box style={{ display: 'flex', justifyContent: 'center', paddingTop: 60 }}>
            <CircularProgress size={32} />
          </Box>
        ) : list.length === 0 ? (() => {
          // If any filter is active, the empty state must NOT say "create
          // your first OT" — that's misleading when there are OTs in the
          // DB but the filter is hiding them. Guide the operator to clear.
          const filterActive = !!(filters.search || filters.status || filters.priority
            || filters.deliveryFrom || filters.deliveryTo || filters.noVehicle || filters.delayed);
          return (
            <Box className={classes.emptyState}>
              {filterActive ? (
                <>
                  <Typography style={{ fontSize: '1rem', fontWeight: 600 }}>
                    {lang === 'pt' ? 'Sem resultados para o filtro actual' : 'No results for the current filter'}
                  </Typography>
                  <Typography style={{ fontSize: '0.82rem', marginBottom: 12 }}>
                    {lang === 'pt'
                      ? 'Pode haver OTs noutros estados/datas — limpa os filtros para as veres todas.'
                      : 'There may be OTs in other states/dates — clear the filters to see them all.'}
                  </Typography>
                  <Button
                    size="small" variant="contained"
                    onClick={() => {
                      setQuickFilter(null);
                      setSearchInput('');
                      setCustomDateFrom('');
                      setCustomDateTo('');
                      dispatch(setFilters({ search: '', status: '', priority: '', deliveryFrom: '', deliveryTo: '', noVehicle: false, delayed: false }));
                    }}
                    style={{ fontSize: '0.74rem', fontWeight: 700, textTransform: 'none', background: '#f59e0b', color: '#fff', borderRadius: 8 }}>
                    {lang === 'pt' ? 'Limpar todos os filtros' : 'Clear all filters'}
                  </Button>
                </>
              ) : (
                <>
                  <Typography style={{ fontSize: '1rem', fontWeight: 600 }}>
                    {lang === 'pt' ? 'Nenhuma ordem de transporte' : 'No transport orders'}
                  </Typography>
                  <Typography style={{ fontSize: '0.82rem' }}>
                    {lang === 'pt' ? 'Crie a primeira OT clicando em "Nova OT"' : 'Create your first TO by clicking "New TO"'}
                  </Typography>
                </>
              )}
            </Box>
          );
        })() : density === 'cards' ? (
          <Box style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(460px, 1fr))', gap: 16, padding: '4px 2px' }}>
            {displayedList.map((order) => (
              <OrderCard key={order._id || order.id} order={order} lang={lang} dark={plannerTheme === 'dark'}
                onOpen={() => handleEdit(order)} onMap={() => handleViewRouteOnMap(order)} />
            ))}
          </Box>
        ) : (
          <TableContainer
            component={Paper}
            elevation={0}
            style={{
              borderRadius: 10,
              border: '1px solid rgba(0,0,0,0.06)',
              // Deixa o tableWrap (parent) gerir o scroll horizontal —
              // sem isto, o TableContainer interno duplicaria a barra
              // e o utilizador via duas barras a competir entre si.
              overflowX: 'visible',
            }}
          >
            <Table className={`${classes.table} ${density === 'compact' ? classes.tableCompact : density === 'spacious' ? classes.tableSpacious : classes.tableComfortable} ${onlyFuelOrders ? classes.tableFuelTight : ''}`} size="small">
              <TableHead>
                {/* whiteSpace nowrap inline na linha do cabeçalho: herda para
                    todas as células-título e NÃO é sobreposto por nenhuma regra
                    (os títulos deixam de quebrar a 2 linhas feias). */}
                <TableRow style={{ whiteSpace: 'nowrap' }}>
                  <TableCell padding="checkbox">
                    {(() => {
                      const unassignedIds = list.filter(isUnassignedOT).map(o => o._id || o.id);
                      const unassignedChecked = unassignedIds.length > 0
                        && selected.length === unassignedIds.length
                        && unassignedIds.every(id => selected.includes(id));
                      const unassignedIndeterminate = unassignedIds.length > 0
                        && unassignedIds.some(id => selected.includes(id))
                        && !unassignedChecked;
                      return (
                        <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2, flexWrap: 'nowrap' }}>
                          <Tooltip title={lang === 'pt' ? 'Selecionar todas' : 'Select all'} placement="top">
                            <Checkbox
                              size="small"
                              checked={selected.length === list.length && list.length > 0}
                              indeterminate={selected.length > 0 && selected.length < list.length}
                              onChange={toggleSelectAll}
                              style={{ padding: 2 }}
                            />
                          </Tooltip>
                          <Tooltip
                            title={lang === 'pt'
                              ? `Selecionar só as ordens por atribuir (pendentes ou atribuídas, ainda sem rota)${unassignedIds.length ? ` — ${unassignedIds.length}` : ''}`
                              : `Select only orders without a route (pending or assigned)${unassignedIds.length ? ` — ${unassignedIds.length}` : ''}`}
                            placement="top">
                            <span>
                              <Checkbox
                                size="small"
                                disabled={unassignedIds.length === 0}
                                checked={unassignedChecked}
                                indeterminate={unassignedIndeterminate}
                                onChange={toggleSelectUnassigned}
                                style={{ padding: 2, color: unassignedIds.length === 0 ? '#cbd5e1' : '#d97706' }}
                              />
                            </span>
                          </Tooltip>
                        </Box>
                      );
                    })()}
                  </TableCell>
                  {(() => {
                    const sortableHeader = (field, label) => {
                      const dir = getSortDir(field);
                      const order = getSortOrder(field);
                      return (
                        <TableSortLabel
                          active={!!dir}
                          direction={dir || 'asc'}
                          onClick={(e) => handleHeaderSort(field, e)}
                          style={{ fontSize: 'inherit', fontWeight: 'inherit' }}
                        >
                          {label}
                          {order && (
                            <span style={{ marginLeft: 4, fontSize: '0.55rem', color: '#6366f1', fontWeight: 800 }}>({order})</span>
                          )}
                        </TableSortLabel>
                      );
                    };
                    return (<>
                      <TableCell>{sortableHeader('orderNumber', t(lang, 'orderNumber'))}</TableCell>
                      {/* Coluna "Datas" — funde Criação + Data serviço (condensação). */}
                      <TableCell>{sortableHeader('createdAt', lang === 'pt' ? 'Datas' : 'Dates')}</TableCell>
                      <TableCell>{sortableHeader('status', lang === 'pt' ? 'Estado' : 'Status')}</TableCell>
                      <TableCell>{sortableHeader('pickupWindowFrom', lang === 'pt' ? 'Recolha / Serviço' : 'Pickup / Service')}</TableCell>
                      <TableCell>{sortableHeader('deliveryWindowFrom', lang === 'pt' ? 'Entrega / Descarga' : 'Delivery / Unloading')}</TableCell>
                      <TableCell>{sortableHeader('vehiclePlate', lang === 'pt' ? 'Veículo / Motorista' : 'Vehicle / Driver')}</TableCell>
                      <TableCell>{sortableHeader('estimatedArrival', lang === 'pt' ? 'Execução' : 'Execution')}</TableCell>
                      <TableCell>{lang === 'pt' ? 'Progresso' : 'Progress'}</TableCell>
                      <TableCell align="right">
                        {lang === 'pt' ? 'Ações' : 'Actions'}</TableCell>
                    </>);
                  })()}
                </TableRow>
              </TableHead>
              <TableBody>
                {displayedList.map((order) => {
                  const oid = order._id || order.id;
                  const status = order.status || 'pending';
                  const priorityRaw = order.priority;
                  const priority = priorityRaw === 1 || priorityRaw === '1' ? 'high' : priorityRaw === -1 || priorityRaw === '-1' ? 'low' : typeof priorityRaw === 'string' && ['high','low','normal'].includes(priorityRaw) ? priorityRaw : 'normal';
                  const hasRoute = !!order.assignedRouteId;
                  const hasVehicle = !!order.vehiclePlate;
                  // Show the route's actual origin in the Recolha column when
                  // the operator did a recalc-on-start (route origin diverges
                  // from the OT pickup by >50m). Same condition as the expand
                  // panel so both views stay in sync.
                  const _ro = order.routeOrigin;
                  const _roCoords = Array.isArray(_ro?.coordinates) ? _ro.coordinates : null;
                  const _roLng = _roCoords?.[0];
                  const _roLat = _roCoords?.[1];
                  // Guard: `Number(null) === 0` (a finite number!), so the
                  // previous code thought assistance OTs had pickup at
                  // (0,0) — coast of Africa — and triggered recalc-GPS
                  // mode after delivery, replacing the service location
                  // with the route origin ("Casa de Sónia Blanco"). Use
                  // null-aware coercion that yields NaN for missing
                  // coordinates so isFinite filters them out.
                  const _pLng = order.pickupLng != null ? Number(order.pickupLng) : NaN;
                  const _pLat = order.pickupLat != null ? Number(order.pickupLat) : NaN;
                  const isRecalcGPS = (
                    !!order.actualStartAt &&
                    Number.isFinite(_roLng) && Number.isFinite(_roLat) &&
                    Number.isFinite(_pLng) && Number.isFinite(_pLat) &&
                    (Math.abs(_roLng - _pLng) > 0.0005 || Math.abs(_roLat - _pLat) > 0.0005)
                  );
                  // Assistance OTs only have a service location (= delivery).
                  // For those we surface the delivery in the "Recolha / Local
                  // serviço" column so the operator sees the address directly,
                  // and dash out the "Entrega / Descarga" column to make it
                  // clear there's no second leg. Delivery/fuel keep both.
                  const isAssistOTRow = order.serviceType === 'assistance';
                  const pickupName = isRecalcGPS
                    ? (_ro?.text || _ro?.name || _ro?.address || 'Posição actual do veículo')
                    : (isAssistOTRow
                        ? (order.deliveryName || order.deliveryAddress || '-')
                        : (order.pickupName || order.pickupAddress || '-'));
                  const deliveryName = isAssistOTRow ? '—' : (order.deliveryName || order.deliveryAddress || '-');
                  const fmtDate = (d) => d ? new Date(d).toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit' }) : '';
                  const fmtTime = (d) => d ? new Date(d).toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' }) : '';
                  const isExpanded = expandedOrderId === oid;
                  const vehicleLive = hasVehicle && order.vehicleId ? vehicles.find(v => v.id === order.vehicleId || String(v.id) === String(order.vehicleId)) : null;
                  return (
                    <React.Fragment key={oid}>
                    <TableRow hover
                      data-ot-id={oid}
                      onClick={() => setExpandedOrderId(isExpanded ? null : oid)}
                      style={{
                        cursor: 'pointer',
                        borderLeft: `3px solid ${STATUS_COLORS[status]}`,
                        background: isExpanded ? '#eef2ff' : undefined,
                      }}>
                      <TableCell padding="checkbox" onClick={(e) => e.stopPropagation()}>
                        <Checkbox size="small" checked={selected.includes(oid)} onChange={() => toggleSelect(oid)} />
                      </TableCell>

                      {/* OT Number + ref + priority + cargo */}
                      <TableCell onClick={(e) => e.stopPropagation()}>
                        <Box style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                          {/* Primary label = custom reference when set, falls
                              back to the auto-generated OT number. The official
                              number stays accessible as a small subtitle so the
                              operator can still cross-reference it. */}
                          <Tooltip title={otTooltip(order)}>
                            <Typography style={{ fontSize: '0.66rem', fontWeight: 700, color: '#0f172a' }}>
                              {otLabel(order)}
                            </Typography>
                          </Tooltip>
                          {order.customRef && order.orderNumber && (
                            <span style={{
                              fontSize: '0.55rem', fontWeight: 600,
                              color: '#94a3b8', whiteSpace: 'nowrap',
                            }}>
                              {order.orderNumber}
                            </span>
                          )}
                          {/* Código AT (guia Casais) — passou de coluna própria p/ aqui */}
                          {isMercadoriaVariant && order.codigoAT && (
                            <span style={{
                              fontSize: '0.52rem', fontWeight: 700, fontFamily: 'ui-monospace, Menlo, monospace',
                              color: '#92400e', background: '#fef3c7', border: '1px solid #fcd34d',
                              borderRadius: 4, padding: '0 5px', whiteSpace: 'nowrap',
                            }} title={`Código AT: ${order.codigoAT}`}>
                              AT {order.codigoAT}
                            </span>
                          )}
                          {/* Inline editable priority */}
                          {(() => {
                            const prColors = { 1: { bg: '#fef2f2', color: '#dc2626', label: lang === 'pt' ? 'URGENTE' : 'URGENT' },
                              0: { bg: '#f1f5f9', color: '#64748b', label: lang === 'pt' ? 'Normal' : 'Normal' },
                              '-1': { bg: '#eff6ff', color: '#2563eb', label: lang === 'pt' ? 'Baixa' : 'Low' } };
                            const key = priorityRaw === 1 || priorityRaw === '1' ? 1 : priorityRaw === -1 || priorityRaw === '-1' ? '-1' : 0;
                            const cfg = prColors[key];
                            return (
                              <Select value={key} disableUnderline
                                onChange={(e) => dispatch(updateOrder({ token, id: oid, data: { priority: parseInt(e.target.value) } })).then(() => doFetch())}
                                style={{ fontSize: '0.48rem', fontWeight: 800, background: cfg.bg, color: cfg.color, borderRadius: 4, padding: '0 5px', height: 16 }}
                                renderValue={() => cfg.label}
                                MenuProps={{ PaperProps: { style: { borderRadius: 10 } } }}>
                                <MenuItem value={1} style={{ fontSize: '0.6rem', color: '#dc2626' }}>🔴 {lang === 'pt' ? 'Urgente' : 'Urgent'}</MenuItem>
                                <MenuItem value={0} style={{ fontSize: '0.6rem' }}>⚪ {lang === 'pt' ? 'Normal' : 'Normal'}</MenuItem>
                                <MenuItem value={-1} style={{ fontSize: '0.6rem', color: '#2563eb' }}>🔵 {lang === 'pt' ? 'Baixa' : 'Low'}</MenuItem>
                              </Select>
                            );
                          })()}
                        </Box>
                        {order.externalRef && <Typography style={{ fontSize: '0.55rem', color: '#94a3b8' }}>Ref: {order.externalRef}</Typography>}
                        {/* Aborted-route badge — surfaces orphan OTs whose
                            previous route was killed by a driver breakdown.
                            Operator sees these in red so they get re-assigned
                            quickly. Backend returns abortedFromRouteId only
                            when the OT is currently pending+unassigned. */}
                        {order.abortedFromRouteId && order.status === 'pending' && !hasVehicle && (
                          <Tooltip title={order.abortedReason || (lang === 'pt' ? 'Rota anterior abortada por avaria — atribui um novo veículo' : 'Previous route aborted — assign a new vehicle')}>
                            <Box style={{
                              display: 'inline-flex', alignItems: 'center', gap: 3, marginTop: 2, marginRight: 4,
                              padding: '1px 6px', borderRadius: 4,
                              background: '#fef2f2', color: '#b91c1c',
                              border: '1px solid #fecaca',
                              fontSize: '0.54rem', fontWeight: 800, letterSpacing: '0.03em',
                              cursor: 'help',
                            }}>
                              <span>🚨</span>
                              <span>{lang === 'pt' ? 'Rota abortada' : 'Route aborted'}</span>
                              {order.abortedFromRouteName && (
                                <span style={{ opacity: 0.7, fontWeight: 700 }}>· {order.abortedFromRouteName}</span>
                              )}
                            </Box>
                          </Tooltip>
                        )}
                        {/* Service-type chip — only for assistance orders (delivery is default, no chip). */}
                        {order.serviceType === 'assistance' && (
                          <Tooltip title={lang === 'pt' ? 'Ordem de assistência técnica' : 'Technical assistance order'}>
                            <Box style={{
                              display: 'inline-flex', alignItems: 'center', gap: 3, marginTop: 2, marginRight: 4,
                              padding: '1px 6px', borderRadius: 4,
                              background: '#dcfce7', color: '#166534',
                              fontSize: '0.54rem', fontWeight: 800, letterSpacing: '0.03em',
                            }}>
                              <span style={{ fontSize: '0.56rem' }}>🔧</span>
                              <span>{lang === 'pt' ? 'Assistência' : 'Assistance'}</span>
                              {order.unloadingTime ? <span style={{ opacity: 0.7 }}>· {order.unloadingTime}min</span> : null}
                            </Box>
                          </Tooltip>
                        )}
                        {/* Petrotec Angola — selos cliente final/posto/tipo intervenção/SLA dinâmico.
                            Devolve null em OTs PT (sem finalCustomerId), logo é transparente. */}
                        <AOPetrotecOTBadges
                          order={order}
                          lang={lang}
                          size="small"
                          showBmButton={order.status !== 'delivered'}
                        />
                        {/* Chips SLA — Resposta + Resolução (quando ambos
                            estão definidos). Refresh 60s. */}
                        {(() => {
                          const renderChip = (sla, totalH, prefix, prefixEn) => {
                            const meta = SLA_META[sla.status];
                            const inProgressLabel = sla.remainingMs >= 0
                              ? `${lang === 'pt' ? 'Faltam' : 'In'} ${fmtSlaDuration(sla.remainingMs)}`
                              : `${lang === 'pt' ? 'Vencido há' : 'Overdue'} ${fmtSlaDuration(Math.abs(sla.remainingMs))}`;
                            const stoppedLabel = sla.status === 'met'
                              ? `${lang === 'pt' ? 'Cumprido em' : 'Met in'} ${fmtSlaDuration(sla.elapsedMs)}`
                              : `${lang === 'pt' ? 'Falhou por' : 'Missed by'} ${fmtSlaDuration(Math.abs(sla.remainingMs))}`;
                            const label = sla.stopped ? stoppedLabel : inProgressLabel;
                            const tip = lang === 'pt'
                              ? `${prefix} ${totalH}h — ${meta.label} · ${sla.pctElapsed}% decorrido`
                              : `${prefixEn} ${totalH}h — ${meta.labelEn} · ${sla.pctElapsed}% elapsed`;
                            return (
                              <Tooltip title={tip}>
                                <Box style={{
                                  display: 'inline-flex', alignItems: 'center', gap: 4, marginTop: 2,
                                  padding: '2px 8px', borderRadius: 6,
                                  background: meta.bg, color: meta.color,
                                  border: `1px solid ${meta.border}`,
                                  fontSize: '0.62rem', fontWeight: 800, letterSpacing: '0.02em',
                                  lineHeight: 1.1,
                                }}>
                                  <span>{meta.icon}</span>
                                  <span style={{ fontSize: '0.55rem', textTransform: 'uppercase', opacity: 0.85 }}>
                                    {prefix} {totalH}h
                                  </span>
                                  <span style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' }}>
                                    · {label}
                                  </span>
                                </Box>
                              </Tooltip>
                            );
                          };
                          const slaR = slaCountdown(order, slaNow);
                          const slaT = slaResolutionCountdown(order, slaNow);
                          if (!slaR && !slaT) return null;
                          return (
                            <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
                              {slaR && renderChip(slaR, Number(order.slaHours), 'Resposta', 'Response')}
                              {slaT && renderChip(slaT, Number(order.slaResolutionHours), 'Resolução', 'Resolution')}
                            </Box>
                          );
                        })()}
                        {(order.cargoDescription || order.cargoType) && (
                          <Typography style={{ fontSize: '0.55rem', color: '#64748b' }}>
                            {order.cargoDescription || ''} {order.cargoWeight ? `${order.cargoWeight}kg` : ''} {order.cargoPallets ? `${order.cargoPallets}p` : ''}
                          </Typography>
                        )}
                        {/* Observações da OT — sem o sufixo "· Cliente: X" (interno do wizard fuel) */}
                        {(() => {
                          const obs = String(order.notes || '').replace(/\s*·?\s*Cliente:.*$/i, '').trim();
                          if (!obs) return null;
                          return (
                            <Typography title={obs} style={{ fontSize: '0.55rem', color: '#b45309', maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              📝 {obs}
                            </Typography>
                          );
                        })()}
                        {/* Unloading time removed — editable in expanded inline detail panel */}
                      </TableCell>

                      {/* Datas — Criação (1.ª linha) + Data de serviço com selo
                          (2.ª linha). Funde 2 colunas (Criação + Data serviço)
                          para condensar a tabela; o Código AT passou p/ a célula Nº. */}
                      <TableCell>
                        <Box style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                          {order.createdAt ? (() => {
                            const d = new Date(order.createdAt);
                            const diffDays = Math.floor((new Date() - d) / 86400000);
                            const rel = diffDays === 0 ? (lang === 'pt' ? 'Hoje' : 'Today')
                              : diffDays === 1 ? (lang === 'pt' ? 'Ontem' : 'Yesterday')
                              : diffDays < 7 ? (lang === 'pt' ? `há ${diffDays}d` : `${diffDays}d ago`) : null;
                            return (
                              <Typography style={{ fontSize: '0.6rem', color: 'var(--surf-strong, #0f172a)', fontWeight: 600, whiteSpace: 'nowrap' }}>
                                {d.toLocaleDateString(lang === 'pt' ? 'pt-PT' : 'en-GB', { day: '2-digit', month: '2-digit', year: '2-digit' })}
                                <span style={{ color: '#94a3b8', fontWeight: 500, marginLeft: 4 }}>{d.toLocaleTimeString(lang === 'pt' ? 'pt-PT' : 'en-GB', { hour: '2-digit', minute: '2-digit' })}</span>
                                {rel && <span style={{ marginLeft: 4, color: '#3b82f6', fontWeight: 600 }}>· {rel}</span>}
                              </Typography>
                            );
                          })() : (
                            <Typography style={{ fontSize: '0.58rem', color: '#cbd5e1', fontStyle: 'italic' }}>—</Typography>
                          )}
                          {order.serviceDate && (() => {
                            const d = new Date(order.serviceDate);
                            const today = new Date(); today.setHours(0, 0, 0, 0);
                            const dDate = new Date(d); dDate.setHours(0, 0, 0, 0);
                            const diffDays = Math.round((dDate - today) / 86400000);
                            const isOpen = status === 'pending' || status === 'assigned';
                            const isClosed = status === 'completed' || status === 'cancelled' || status === 'delivered' || status === 'done';
                            let badge = null;
                            if (diffDays === 0) badge = { text: lang === 'pt' ? 'Hoje' : 'Today', color: '#16a34a' };
                            else if (diffDays === 1) badge = { text: lang === 'pt' ? 'Amanhã' : 'Tomorrow', color: '#3b82f6' };
                            else if (diffDays > 0 && diffDays < 7) badge = { text: `+${diffDays}d`, color: '#3b82f6' };
                            else if (diffDays < 0 && isOpen) badge = { text: isMercadoriaVariant ? (lang === 'pt' ? 'Não iniciada' : 'Not started') : (lang === 'pt' ? 'Atrasada' : 'Past'), color: '#ef4444' };
                            else if (diffDays < 0 && !isClosed) badge = isMercadoriaVariant ? { text: lang === 'pt' ? 'Não terminada' : 'Not finished', color: '#f59e0b' } : { text: lang === 'pt' ? 'Em curso' : 'In progress', color: '#3b82f6' };
                            return (
                              <Typography style={{ fontSize: '0.56rem', color: 'var(--surf-muted, #64748b)', fontWeight: 600, whiteSpace: 'nowrap' }}>
                                {lang === 'pt' ? 'Serv:' : 'Svc:'} {d.toLocaleDateString(lang === 'pt' ? 'pt-PT' : 'en-GB', { day: '2-digit', month: '2-digit' })}
                                {badge && <span style={{ marginLeft: 4, color: badge.color, fontWeight: 700 }}>· {badge.text}</span>}
                              </Typography>
                            );
                          })()}
                        </Box>
                      </TableCell>

                      {/* Status + route indicator */}
                      <TableCell onClick={(e) => e.stopPropagation()}>
                        {(() => {
                          // Only pending and assigned can change state manually
                          const canChange = status === 'pending' || status === 'assigned';
                          // Valid transitions: pending→cancelled, assigned→pending (with confirm), assigned→cancelled
                          const allowedTransitions = {
                            pending: ['pending', 'cancelled'],
                            assigned: ['assigned', 'pending', 'cancelled'],
                          };
                          const options = canChange ? (allowedTransitions[status] || [status]) : [status];
                          return (
                            <Select value={status} disableUnderline disabled={!canChange}
                              renderValue={(val) => {
                                // Pseudo-states em cima do in_transit (só em
                                // OTs de assistência):
                                //   • "Em serviço" — chegou + começou serviço
                                //   • "No local"   — chegou mas ainda não começou
                                // Ordem: serviceStartedAt vence arrivedAt.
                                if (val === 'in_transit'
                                    && order.serviceType !== 'fuel'
                                    && order.assistanceReport?.arrivedAt
                                    && order.assistanceReport?.serviceStartedAt) {
                                  return lang === 'pt' ? 'Em serviço' : 'In service';
                                }
                                if (val === 'in_transit'
                                    && order.serviceType !== 'fuel'
                                    && order.assistanceReport?.arrivedAt) {
                                  return lang === 'pt' ? 'No local' : 'On site';
                                }
                                // Assistance OTs use "Concluída" instead of
                                // "Entregue" in the status chip — same DB
                                // value, different operator vocabulary.
                                if (val === 'delivered' && order.serviceType === 'assistance') {
                                  return lang === 'pt' ? 'Concluída' : 'Completed';
                                }
                                return t(lang, STATUS_KEYS[val] || val);
                              }}
                              onChange={(e) => {
                                const newStatus = e.target.value;
                                if (newStatus === status) return;
                                // Going back to "pending": always strip vehicle/driver/route
                                // (the OT becomes truly unassigned, not "pending with a vehicle attached"
                                // which was the legacy bug). The confirm dialog opens whenever
                                // there's something to detach so the operator sees what's lost.
                                const hasAnyAssignment = !!(order.vehiclePlate || order.driverName || order.vehicleId || order.driverId || order.assignedRouteId);
                                if (newStatus === 'pending' && hasAnyAssignment) {
                                  setStatusChangeConfirm({ orderId: oid, newStatus, vehiclePlate: order.vehiclePlate, driverName: order.driverName, hasRoute: !!order.assignedRouteId });
                                } else if (newStatus === 'pending') {
                                  // No assignment to detach — flip directly but still ensure
                                  // any stale link is cleared (defensive).
                                  dispatch(updateOrder({
                                    token, id: oid,
                                    data: { status: 'pending', vehicleId: null, driverId: null, assignedRouteId: null },
                                  })).then(() => doFetch());
                                } else {
                                  dispatch(updateOrder({ token, id: oid, data: { status: newStatus } }))
                                    .then(() => doFetch());
                                }
                              }}
                              style={{
                                fontSize: '0.6rem', fontWeight: 700, color: '#fff',
                                // Cor pelo sub-estado da assistência:
                                //   • Em serviço → âmbar (#f59e0b)
                                //   • No local   → azul  (#0ea5e9)
                                //   • Em trânsito (a conduzir) → STATUS_COLORS
                                // Distingue à distância qual técnico já está
                                // a executar vs apenas a aguardar no local.
                                background: (() => {
                                  if (status === 'in_transit'
                                      && order.serviceType !== 'fuel'
                                      && order.assistanceReport?.arrivedAt
                                      && order.assistanceReport?.serviceStartedAt) {
                                    return '#f59e0b';
                                  }
                                  if (status === 'in_transit'
                                      && order.serviceType !== 'fuel'
                                      && order.assistanceReport?.arrivedAt) {
                                    return '#0ea5e9';
                                  }
                                  return STATUS_COLORS[status];
                                })(),
                                borderRadius: 6, padding: '0 6px', height: 20,
                              }}
                              MenuProps={{ PaperProps: { style: { borderRadius: 10 } } }}>
                              {options.map(key => (
                                <MenuItem key={key} value={key} style={{ fontSize: '0.62rem', fontWeight: 600, padding: '6px 12px' }}>
                                  <span style={{ width: 8, height: 8, borderRadius: '50%', background: STATUS_COLORS[key], display: 'inline-block', marginRight: 8 }} />
                                  {t(lang, STATUS_KEYS[key] || key)}
                                </MenuItem>
                              ))}
                            </Select>
                          );
                        })()}
                        <Box style={{ display: 'flex', gap: 2, marginTop: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                          {/* Selo "EM REGRESSO" — a ROTA está na sub-fase de
                              regresso a casa (todas as OT concluídas, motorista
                              ainda na estrada). Mostra-se na linha de cada OT
                              dessa rota para o operador perceber, ao olhar para
                              as OT "Concluída", que o veículo ainda anda a voltar. */}
                          {order.routeReturning && (
                            <Box style={{ fontSize: '0.46rem', fontWeight: 700, background: 'rgba(14,165,233,0.12)', color: '#0ea5e9', padding: '1px 5px', borderRadius: 4 }}
                              title={lang === 'pt' ? 'Motorista a regressar a casa (todas as OT desta rota concluídas)' : 'Driver returning home (all OTs on this route completed)'}>
                              🏠 EM REGRESSO
                            </Box>
                          )}
                          {/* Selo "TEMPO DE SERVIÇO" — distingue à vista o
                              tempo facturável (serviceStartedAt → completedAt).
                              Em curso: contador 1Hz "MMm SSs" âmbar. Em OT
                              concluída: total "X min" / "Xh Ym" cinza para
                              o operador rever quanto demorou. Em assistência E
                              entrega/mercadoria (fuel tem o seu próprio modelo). */}
                          {order.serviceType !== 'fuel'
                            && order.assistanceReport?.serviceStartedAt
                            && (() => {
                              const d = serviceDuration(order.assistanceReport, serviceNow);
                              if (!d) return null;
                              // Pílula destacada: verde pulsante (live) ou
                              // cinza (concluído). Maior, com fonte mono nos
                              // números, dot pulsante e label "Em serviço".
                              return (
                                <Box
                                  className={d.live ? classes.serviceChipLive : undefined}
                                  style={{
                                    display: 'inline-flex', alignItems: 'center', gap: 4,
                                    fontSize: '0.6rem', fontWeight: 700,
                                    background: d.live
                                      ? 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)'
                                      : '#e2e8f0',
                                    color: d.live ? '#ffffff' : '#475569',
                                    padding: '2px 7px', borderRadius: 8,
                                    border: d.live ? '1px solid #15803d' : '1px solid #cbd5e1',
                                    lineHeight: 1.1,
                                  }}
                                  title={lang === 'pt'
                                    ? (d.live ? 'A executar o serviço (tempo facturável a correr)' : 'Tempo facturável de serviço')
                                    : (d.live ? 'In service (billable time running)' : 'Billable service time')}
                                >
                                  {d.live && (
                                    <Box
                                      className={classes.serviceChipDot}
                                      style={{
                                        width: 7, height: 7, borderRadius: '50%',
                                        background: '#bbf7d0',
                                        boxShadow: '0 0 0 1.5px rgba(255,255,255,0.45)',
                                        flexShrink: 0,
                                      }}
                                    />
                                  )}
                                  <span style={{
                                    fontSize: '0.6rem', letterSpacing: 0.4,
                                    textTransform: 'uppercase', fontWeight: 800,
                                  }}>
                                    {d.live
                                      ? (lang === 'pt' ? 'Em serviço' : 'In service')
                                      : (lang === 'pt' ? 'Tempo' : 'Time')}
                                  </span>
                                  <span style={{
                                    fontFamily: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace',
                                    fontWeight: 700, letterSpacing: 0.2,
                                  }}>
                                    {fmtServiceDuration(d.ms, d.live)}
                                  </span>
                                </Box>
                              );
                            })()}
                          {/* P3 — selo de incoerência de janela: esta OT é servida
                              fora da ordem da sua janela horária (uma com janela
                              mais cedo ficou depois de outra mais tarde). Rede de
                              segurança para o operador detetar planos/edições que
                              não respeitam as janelas definidas. */}
                          {order.windowOutOfOrder && (
                            <Box style={{ fontSize: '0.46rem', fontWeight: 700, background: '#fef3c7', color: '#b45309', padding: '1px 5px', borderRadius: 4 }}
                              title={lang === 'pt' ? 'Esta OT é servida fora da ordem da sua janela horária — outra OT com janela mais tarde fica antes desta. Re-otimiza a rota para corrigir.' : 'This OT is served out of its time-window order — a later-window OT comes before it. Re-optimize the route to fix.'}>
                              ⚠ FORA DA JANELA
                            </Box>
                          )}
                          {hasRoute && <Box style={{ fontSize: '0.46rem', fontWeight: 700, background: '#dbeafe', color: '#2563eb', padding: '1px 5px', borderRadius: 4 }}>ROTA</Box>}
                          {hasVehicle && <Box style={{ fontSize: '0.46rem', fontWeight: 700, background: '#dcfce7', color: '#16a34a', padding: '1px 5px', borderRadius: 4 }}>VEÍCULO</Box>}
                          {/* Despacho rápido (Casais): OT automática com rota em
                              rascunho (não enviada) → selo clicável no mesmo
                              sítio do "ENVIADO" para a mandar para a app. */}
                          {isMercadoriaVariant && order.importRef && hasRoute && !order.route?.sentToVehicle && status !== 'in_transit' && status !== 'delivered' && status !== 'cancelled' && (
                            <Box onClick={(e) => { e.stopPropagation(); setQuickDispatchOT({ ot: order }); }}
                              style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: '0.46rem', fontWeight: 700, background: '#e0f2fe', color: '#0369a1', padding: '1px 5px', borderRadius: 4, cursor: 'pointer', border: '1px solid #bae6fd' }}
                              title={lang === 'pt' ? 'Despachar esta OT para a app do motorista' : 'Dispatch to driver app'}>
                              <SmartphoneIcon style={{ fontSize: 9 }} />➤ {lang === 'pt' ? 'DESPACHAR' : 'DISPATCH'}
                            </Box>
                          )}
                          {/* "ENVIADO" só quando a rota foi realmente despachada
                              (sent_to_vehicle=true). Antes mostrava sempre que a OT
                              estava 'assigned'/'in_transit' — o que dava falso positivo
                              quando o operador apenas gravava a rota sem despachar. */}
                          {hasRoute && hasVehicle && order.route?.sentToVehicle && (status === 'assigned' || status === 'in_transit') && (
                            <Box style={{ fontSize: '0.46rem', fontWeight: 700, background: '#faf5ff', color: '#7c3aed', padding: '1px 5px', borderRadius: 4, cursor: 'pointer' }}
                              title={lang === 'pt' ? 'Rota enviada à app do motorista' : 'Route sent to driver app'}>
                              📱 ENVIADO
                            </Box>
                          )}
                          {/* Badge "SEM ROTA" — agora mostra-se sempre que a OT
                              não tem rota associada (mesmo quando já tem
                              veículo+motorista). Distingue visualmente o
                              estado "assigned com rota" do "assigned sem
                              rota" que era ambíguo antes. */}
                          {!hasRoute && <Box style={{ fontSize: '0.46rem', fontWeight: 700, background: '#f1f5f9', color: '#94a3b8', padding: '1px 5px', borderRadius: 4 }}>SEM ROTA</Box>}
                        </Box>
                      </TableCell>

                      {/* Pickup */}
                      <TableCell>
                        <Box style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                          <Box style={{ width: 8, height: 8, borderRadius: '50%', background: '#22c55e', flexShrink: 0 }} />
                          <Typography style={{ fontSize: '0.68rem', fontWeight: 600, color: '#0f172a', maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{pickupName}</Typography>
                          {isRecalcGPS && (
                            <Tooltip title={lang === 'pt' ? `Saída planeada: ${order.pickupName}` : `Planned start: ${order.pickupName}`}>
                              <Box style={{ fontSize: '0.5rem', fontWeight: 800, background: '#fef3c7', color: '#92400e', padding: '0 4px', borderRadius: 3 }}>
                                GPS
                              </Box>
                            </Tooltip>
                          )}
                        </Box>
                        {order.pickupWindowFrom && (
                          <Typography style={{ fontSize: '0.55rem', color: '#64748b', marginLeft: 12 }}>
                            {fmtDate(order.pickupWindowFrom)} {fmtTime(order.pickupWindowFrom)}
                            {order.pickupWindowTo ? ` - ${fmtTime(order.pickupWindowTo)}` : ''}
                          </Typography>
                        )}
                      </TableCell>

                      {/* Delivery */}
                      <TableCell>
                        <Box style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                          <Box style={{ width: 8, height: 8, borderRadius: '50%', background: '#ef4444', flexShrink: 0 }} />
                          <Typography style={{ fontSize: '0.68rem', fontWeight: 600, color: '#0f172a', maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{deliveryName}</Typography>
                        </Box>
                        {/* Selo da obra (variante mercadoria Casais): quando a
                            entrega/descarga está ligada a uma obra, mostra o código. */}
                        {order.obra && (
                          <Tooltip title={order.obra.name ? `${order.obra.codigoObra} · ${order.obra.name}` : `Obra ${order.obra.codigoObra}`}>
                            <Box style={{ display: 'inline-flex', alignItems: 'center', gap: 3, marginLeft: 12, marginTop: 2, height: 16, padding: '0 7px', borderRadius: 999, background: '#fef3c7', border: '1px solid #fcd34d' }}>
                              <HomeWorkIcon style={{ fontSize: 10, color: '#92400e' }} />
                              <Typography style={{ fontSize: '0.56rem', fontWeight: 700, color: '#92400e', whiteSpace: 'nowrap' }}>
                                {lang === 'pt' ? 'Obra' : 'Work'} {order.obra.codigoObra}
                              </Typography>
                            </Box>
                          </Tooltip>
                        )}
                        {order.deliveryWindowFrom && (
                          <Typography style={{ fontSize: '0.55rem', color: '#64748b', marginLeft: 12 }}>
                            {fmtDate(order.deliveryWindowFrom)} {fmtTime(order.deliveryWindowFrom)}
                            {order.deliveryWindowTo ? ` - ${fmtTime(order.deliveryWindowTo)}` : ''}
                          </Typography>
                        )}
                      </TableCell>

                      {/* Vehicle / Driver */}
                      <TableCell>
                        {hasVehicle ? (() => {
                          // Some EcooGPS tenants put a friendly nickname in the
                          // device `name` and the licence plate in
                          // `attributes.license_plate`. The provider now exposes
                          // both as `vehicle.plate` (real plate) and `vehicle.name`
                          // (display name).
                          //
                          // CRITICAL: prefer `veh.plate` (live, from the slice)
                          // over `order.vehiclePlate` (cached at OT creation
                          // time — may pre-date the provider fix and still hold
                          // the device name instead of the licence plate).
                          // Otherwise we render "Carrinha · Carrinha" duplicated
                          // when both come from the same source.
                          const veh = order.vehicleId
                            ? vehicles.find(v => Number(v.id) === Number(order.vehicleId))
                            : (order.vehiclePlate
                                ? vehicles.find(v => (v.plate || '').toUpperCase() === order.vehiclePlate.toUpperCase()
                                    || (v.name || '').toUpperCase() === order.vehiclePlate.toUpperCase())
                                : null);
                          const realPlate = veh?.plate || order.vehiclePlate;
                          const displayName = veh?.name && veh.name !== realPlate ? veh.name : null;
                          return (
                            <Box>
                              <Box style={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                                <Typography style={{ fontSize: '0.62rem', fontWeight: 700, color: '#0f172a' }}>{realPlate}</Typography>
                                {displayName && (
                                  <Typography style={{ fontSize: '0.6rem', color: '#475569', fontWeight: 500 }}>
                                    · {displayName}
                                  </Typography>
                                )}
                              </Box>
                              {order.driverName && <Typography style={{ fontSize: '0.55rem', color: '#64748b' }}>👤 {order.driverName}</Typography>}
                            </Box>
                          );
                        })() : (
                          <Typography style={{ fontSize: '0.6rem', color: '#cbd5e1', fontStyle: 'italic' }}>{lang === 'pt' ? 'Sem veículo' : 'No vehicle'}</Typography>
                        )}
                      </TableCell>

                      {/* Execução: Início | ETA (live) | Chegada real + delta vs janela */}
                      <TableCell>
                        {(() => {
                          const hasAnyTimestamp = order.actualStartAt || order.estimatedArrival || order.deliveredAt;
                          // Numa rota conjunta, mostrar sempre o troço desta OT
                          // (mesmo sem timestamps), para o operador ver os km/min
                          // DESTA ordem e não o total da rota partilhada.
                          const hasSharedLeg = order.otLegIsShared && order.otLegDistanceM != null;
                          if (!hasAnyTimestamp && !hasSharedLeg) {
                            return <Typography style={{ fontSize: '0.58rem', color: '#cbd5e1', fontStyle: 'italic' }}>—</Typography>;
                          }
                          // Delay computation: ETA vs delivery window end
                          let delay = null;
                          if (order.estimatedArrival && order.deliveryWindowTo && !order.deliveredAt) {
                            const eta = new Date(order.estimatedArrival).getTime();
                            const win = new Date(order.deliveryWindowTo).getTime();
                            const diffMin = Math.round((eta - win) / 60000);
                            if (diffMin > 5) delay = { type: 'late', min: diffMin };
                            else if (diffMin < -15) delay = { type: 'early', min: -diffMin };
                            else delay = { type: 'onTime', min: 0 };
                          }
                          return (
                            <Box style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                              {order.actualStartAt && (
                                <Box style={{ display: 'flex', alignItems: 'center', gap: 3, fontSize: '0.58rem' }}>
                                  <span style={{ color: '#94a3b8', fontWeight: 600 }}>▶</span>
                                  <span style={{ color: '#22c55e', fontWeight: 700 }}>{fmtDate(order.actualStartAt)} {fmtTime(order.actualStartAt)}</span>
                                </Box>
                              )}
                              {order.estimatedArrival && !order.deliveredAt && (
                                <Tooltip title={lang === 'pt' ? 'Hora de chegada prevista — actualizada com a posição actual do veículo' : 'Estimated arrival — updated from current vehicle position'}>
                                  <Box style={{ display: 'flex', alignItems: 'center', gap: 3, fontSize: '0.58rem' }}>
                                    <span style={{ color: '#94a3b8', fontWeight: 600 }}>⏱</span>
                                    <span style={{ color: '#3b82f6', fontWeight: 700 }}>{fmtDate(order.estimatedArrival)} {fmtTime(order.estimatedArrival)}</span>
                                    {delay && delay.type === 'late' && (
                                      <Box style={{ fontSize: '0.48rem', fontWeight: 800, background: '#fef2f2', color: '#dc2626', padding: '1px 4px', borderRadius: 3 }}>+{delay.min}m</Box>
                                    )}
                                    {delay && delay.type === 'early' && (
                                      <Box style={{ fontSize: '0.48rem', fontWeight: 800, background: '#ecfdf5', color: '#16a34a', padding: '1px 4px', borderRadius: 3 }}>-{delay.min}m</Box>
                                    )}
                                    {delay && delay.type === 'onTime' && (
                                      <Box style={{ fontSize: '0.48rem', fontWeight: 800, background: '#eff6ff', color: '#2563eb', padding: '1px 4px', borderRadius: 3 }}>ok</Box>
                                    )}
                                  </Box>
                                </Tooltip>
                              )}
                              {order.deliveredAt && (
                                <Box style={{ display: 'flex', alignItems: 'center', gap: 3, fontSize: '0.58rem' }}>
                                  <span style={{ color: '#94a3b8', fontWeight: 600 }}>✔</span>
                                  <span style={{ color: '#16a34a', fontWeight: 700 }}>{fmtDate(order.deliveredAt)} {fmtTime(order.deliveredAt)}</span>
                                </Box>
                              )}
                              {/* Per-OT leg info for consolidated routes */}
                              {order.otLegIsShared && order.otLegDistanceM != null && (
                                <Tooltip title={lang === 'pt'
                                  ? `Troço desta ordem dentro de rota partilhada com ${order.otLegShareCount} ordens`
                                  : `This OT's leg within a route shared by ${order.otLegShareCount} OTs`}>
                                  <Box style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: '0.55rem', fontWeight: 700, background: '#fff7ed', color: '#c2410c', padding: '2px 6px', borderRadius: 4, border: '1px solid #fed7aa', marginTop: 2, alignSelf: 'flex-start' }}>
                                    <span>→</span>
                                    <span>{(order.otLegDistanceM / 1000).toFixed(1)} km</span>
                                    <span style={{ color: '#9a3412' }}>·</span>
                                    <span>{Math.round((order.otLegDurationS || 0) / 60)} min</span>
                                  </Box>
                                </Tooltip>
                              )}
                            </Box>
                          );
                        })()}
                      </TableCell>

                      {/* Progress: ETA + docs */}
                      <TableCell>
                        {/* 🏠 Regresso a casa — a rota está in_progress mas as OTs
                            já estão entregues; o motorista volta ao ponto final.
                            Mostrado mesmo em OTs concluídas para o operador não
                            ficar "às escuras". Clica para ver a posição no mapa. */}
                        {order.routePhase === 'returning' && order.routeStatus === 'in_progress' && (
                          <Tooltip title={lang === 'pt'
                            ? 'Entregas concluídas — motorista a regressar ao ponto final (casa/armazém). Clica para ver a posição no mapa.'
                            : 'Deliveries done — driver returning to final point. Click to view position on map.'}>
                            <Box onClick={(e) => { e.stopPropagation(); loadOTOnMap(order, 'vehicle'); }}
                              style={{ display: 'inline-flex', alignItems: 'center', gap: 3, cursor: 'pointer', fontSize: '0.58rem', fontWeight: 800, background: '#e0f2fe', color: '#0369a1', padding: '2px 6px', borderRadius: 4, border: '1px solid #bae6fd', marginBottom: 3 }}>
                              <span>🏠</span><span>{lang === 'pt' ? 'Motorista em regresso' : 'Driver returning'}</span>
                            </Box>
                          </Tooltip>
                        )}
                        {(order.status === 'delivered' || order.deliveredAt) ? (
                          // OT já ENTREGUE/concluída → mostrar a conclusão (hora
                          // real), não o "Previsto" (que já não faz sentido).
                          <Typography style={{ fontSize: '0.62rem', fontWeight: 700, color: '#16a34a' }}>
                            ✓ {lang === 'pt' ? 'Concluído' : 'Completed'}
                            {order.deliveredAt ? `: ${fmtDate(order.deliveredAt)} ${fmtTime(order.deliveredAt)}` : ''}
                          </Typography>
                        ) : order.estimatedArrival ? (
                          <Box>
                            <Typography style={{ fontSize: '0.62rem', fontWeight: 600, color: '#0f172a' }}>
                              Previsto: {fmtDate(order.estimatedArrival)} {fmtTime(order.estimatedArrival)}
                            </Typography>
                            {order.otLegIsShared && order.otLegDistanceM != null ? (
                              <Typography style={{ fontSize: '0.52rem', color: '#c2410c', fontWeight: 600 }}>
                                {lang === 'pt' ? 'Troço desta OT: ' : "This OT's leg: "}
                                {(order.otLegDistanceM / 1000).toFixed(0)} km · {Math.round((order.otLegDurationS || 0) / 60)} min
                              </Typography>
                            ) : order.distanceKm ? (
                              <Typography style={{ fontSize: '0.52rem', color: '#3b82f6' }}>{Number(order.distanceKm).toFixed(0)} km restantes</Typography>
                            ) : null}
                          </Box>
                        ) : hasRoute ? (
                          // OT adicionada à rota mas geometria por recalcular →
                          // ainda não tem ETA/troço como as irmãs. Selo claro e
                          // clicável que abre a rota no planner para re-otimizar.
                          order.routeGeometryStale && ['draft', 'planned', 'in_progress'].includes(order.routeStatus) ? (
                            <Tooltip title={lang === 'pt'
                              ? 'OT adicionada à rota mas a geometria não foi recalculada — clica para recalcular e obter ETA/distância/troço como as restantes OTs.'
                              : 'OT added but route geometry not recomputed — click to recompute and get ETA/distance/leg like the other OTs.'}>
                              <Box onClick={(e) => { e.stopPropagation(); handleReplanRoute(order); }}
                                style={{ display: 'inline-flex', alignItems: 'center', gap: 3, cursor: 'pointer', fontSize: '0.58rem', fontWeight: 700, background: '#fef3c7', color: '#b45309', padding: '2px 6px', borderRadius: 4, border: '1px solid #fde68a' }}>
                                <span>➕</span><span>{lang === 'pt' ? 'Adicionada — recalcular' : 'Added — recompute'}</span>
                              </Box>
                            </Tooltip>
                          ) : (
                            <Typography style={{ fontSize: '0.6rem', color: '#3b82f6' }}>{lang === 'pt' ? 'Ordem atribuída à rota' : 'Order assigned to route'}</Typography>
                          )
                        ) : (
                          <Typography style={{ fontSize: '0.6rem', color: '#cbd5e1' }}>—</Typography>
                        )}
                        {/* Docs inline */}
                        {Array.isArray(order.documents) && order.documents.length > 0 && (
                          <Box style={{ display: 'flex', gap: 2, marginTop: 2 }}>
                            {order.documents.map(doc => (
                              <Tooltip key={doc.id} title={doc.originalName || 'Documento'}>
                                <IconButton size="small" onClick={() => window.open(doc.url, '_blank')} style={{ padding: 1, color: '#3b82f6' }}>
                                  <AttachFileIcon style={{ fontSize: 12 }} />
                                </IconButton>
                              </Tooltip>
                            ))}
                          </Box>
                        )}
                        {order.actualStartAt && (
                          <Typography style={{ fontSize: '0.5rem', color: '#22c55e', fontWeight: 600 }}>
                            Início real: {new Date(order.actualStartAt).toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' })}
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell align="right" onClick={(e) => e.stopPropagation()}>
                        <Box style={{ display: 'flex', gap: 2, justifyContent: 'flex-end', alignItems: 'center' }}>
                          {/* 1. Expand/collapse — always visible */}
                          <Tooltip title={lang === 'pt' ? (isExpanded ? 'Fechar' : 'Detalhes') : (isExpanded ? 'Close' : 'Details')}>
                            <IconButton size="small" onClick={(e) => { e.stopPropagation(); setExpandedOrderId(isExpanded ? null : oid); }} style={{ padding: 3 }}>
                              <ExpandMoreIcon style={{ fontSize: 16, color: isExpanded ? '#6366f1' : '#94a3b8', transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }} />
                            </IconButton>
                          </Tooltip>
                          {/* 2. Assign/change vehicle — direct access (most frequent action) */}
                          {canWrite && (status === 'pending' || status === 'assigned') && (
                            <Tooltip title={hasVehicle ? (lang === 'pt' ? 'Alterar veículo' : 'Change vehicle') : (lang === 'pt' ? 'Atribuir veículo' : 'Assign vehicle')}>
                              <IconButton size="small" onClick={() => {
                                // Abre SEMPRE o diálogo "bulk" — é o mesmo UI que o botão azul
                                // "Alterar veículo e Planear rota" no rodapé, que é o caminho
                                // canónico (mostra origem/destino, planeamento da rota, etc.).
                                // Antes, clicar nesta linha quando não havia multi-selecção
                                // abria o diálogo single (mais limitado) — diferente do que o
                                // operador via via o botão azul. Se a OT já está numa multi-
                                // selecção, mantém-na; senão, faz como se o operador a tivesse
                                // só a esta selecionada.
                                if (!selected.includes(oid)) {
                                  setSelected([oid]);
                                }
                                openVehicleAssign(oid, true);
                              }} style={{ padding: 3 }}>
                                <LocalShippingIcon style={{ fontSize: 14, color: hasVehicle ? '#f59e0b' : '#22c55e' }} />
                              </IconButton>
                            </Tooltip>
                          )}
                          {/* 3a. Live monitor — opens the route-level live
                              view in Operações → Rotas. The "live" concept
                              belongs to a ROUTE (vehicle's trajectory), not
                              to a single OT — so this jumps the operator to
                              the right place instead of showing an OT-shaped
                              panel that conceptually held the same data. */}
                          {hasRoute && status === 'in_transit' && (() => {
                            // Alerta P.A. (fuel): 🟢 saiu do P.A. (serviço feito,
                            // falta concluir) tem prioridade sobre 🔴 chegou ao P.A.;
                            // sem sinais de P.A. (ou OT não-fuel) → ponto vermelho
                            // fixo, exactamente como antes.
                            const rep = order.assistanceReport;
                            const paDeparted = !!rep?.departedPaAt;
                            const paArrived = !!rep?.arrivedPaAt;
                            const isAlert = paDeparted || paArrived;
                            const dotRgb = paDeparted ? '34,197,94' : '239,68,68';
                            const dotColor = paDeparted ? '#22c55e' : '#ef4444';
                            const tip = paDeparted
                              ? (lang === 'pt' ? '🟢 Viatura saiu do P.A. — concluir serviço' : '🟢 Vehicle left delivery point — complete service')
                              : paArrived
                              ? (lang === 'pt' ? '🔴 Viatura no P.A. (chegou)' : '🔴 Vehicle at delivery point (arrived)')
                              : (lang === 'pt' ? '🔴 Ver rota em tempo real (Operações)' : '🔴 View route live (Operations)');
                            return (
                              <Tooltip title={tip}>
                                <IconButton size="small" onClick={() => goToLiveRouteMonitor(order)}
                                  style={{
                                    padding: 3, borderRadius: 6,
                                    background: `rgba(${dotRgb},0.08)`,
                                    border: `1px solid rgba(${dotRgb},0.20)`,
                                  }}
                                >
                                  <Box className={isAlert ? classes.paBlinkDot : undefined} style={{
                                    width: 8, height: 8, borderRadius: '50%',
                                    background: dotColor,
                                    boxShadow: `0 0 6px rgba(${dotRgb},0.6), 0 0 0 2px rgba(${dotRgb},0.25)`,
                                  }} />
                                </IconButton>
                              </Tooltip>
                            );
                          })()}
                          {/* 3b. View route on map — direct access (quick visual check) */}
                          {hasRoute && (
                            <Tooltip title={(status === 'delivered' || status === 'in_transit')
                              ? (lang === 'pt' ? 'Ver percurso real no mapa' : 'View actual route on map')
                              : (lang === 'pt' ? 'Ver rota no mapa' : 'View route on map')}>
                              <IconButton size="small" onClick={() => handleViewRouteOnMap(order)} style={{ padding: 3 }}>
                                <NearMeIcon style={{ fontSize: 14, color: '#8b5cf6' }} />
                              </IconButton>
                            </Tooltip>
                          )}
                          {/* 3c. Para Petrotec AO + assistência: substituir o
                              "Ver relatório" pelo "Boletim de Manutenção PDF"
                              (o BM oficial é o documento contratual; o popup
                              de relatório de entrega genérico não se aplica).
                              Para os restantes, manter o popup como antes. */}
                          {status === 'delivered' && (() => {
                            const isPetrotecAOAssist = isPetrotecTenant(clientExternalId, clientSettings)
                              && order.serviceType === 'assistance'
                              && !!order.finalCustomerId;
                            if (isPetrotecAOAssist) {
                              return (
                                <Tooltip title={lang === 'pt' ? 'Gerar Boletim de Manutenção em PDF' : 'Generate BM PDF'}>
                                  <IconButton
                                    size="small"
                                    onClick={async (e) => {
                                      e.stopPropagation();
                                      try {
                                        const r = await fetch(`/planner-api/transport-orders/${oid}/bm-pdf`, {
                                          headers: { Authorization: `Bearer ${token}` },
                                        });
                                        if (!r.ok) {
                                          const j = await r.json().catch(() => ({}));
                                          alert(j.error || `Erro a gerar BM (HTTP ${r.status})`);
                                          return;
                                        }
                                        const blob = await r.blob();
                                        const url = URL.createObjectURL(blob);
                                        window.open(url, '_blank');
                                        setTimeout(() => URL.revokeObjectURL(url), 30000);
                                      } catch (err) {
                                        alert(err.message || 'Erro a abrir BM');
                                      }
                                    }}
                                    style={{
                                      padding: 3, borderRadius: 6,
                                      background: 'rgba(22,163,74,0.10)',
                                      border: '1px solid rgba(22,163,74,0.20)',
                                    }}
                                  >
                                    <PrintIcon style={{ fontSize: 14, color: '#16a34a' }} />
                                  </IconButton>
                                </Tooltip>
                              );
                            }
                            return (
                              <Tooltip title={lang === 'pt' ? 'Ver relatório de entrega' : 'View delivery report'}>
                                <IconButton
                                  size="small"
                                  onClick={(e) => { e.stopPropagation(); setReportOrderId(oid); }}
                                  style={{
                                    padding: 3, borderRadius: 6,
                                    background: 'rgba(22,163,74,0.10)',
                                    border: '1px solid rgba(22,163,74,0.20)',
                                  }}
                                >
                                  <AssignmentTurnedInIcon style={{ fontSize: 14, color: '#16a34a' }} />
                                </IconButton>
                              </Tooltip>
                            );
                          })()}
                          {/* Overflow menu — remaining actions */}
                          <IconButton size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              setRowMenuAnchor({ el: e.currentTarget, order, oid, status, hasRoute, hasVehicle });
                            }}
                            style={{
                              padding: 3, borderRadius: 6,
                              background: rowMenuAnchor?.oid === oid ? '#eef2ff' : 'transparent',
                              border: rowMenuAnchor?.oid === oid ? '1px solid #c7d2fe' : '1px solid transparent',
                            }}>
                            <MoreVertIcon style={{ fontSize: 16, color: rowMenuAnchor?.oid === oid ? '#4338ca' : '#64748b' }} />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* Inline expanded panel — mini-map + docs + execution timeline */}
                    <TableRow>
                      <TableCell colSpan={10} style={{ padding: 0, background: '#f8fafc', borderBottom: isExpanded ? '1px solid #e2e8f0' : 'none' }}>
                        <Collapse in={isExpanded} timeout={250} unmountOnExit>
                          {/* Fuel — painel cronologia distribuição. Só para OTs
                              serviceType='fuel'. Mostra-se ANTES do detail
                              padrão para o operador ter logo acesso aos marcos. */}
                          {order.serviceType === 'fuel' && (
                            <Box style={{ padding: '8px 16px 0' }}>
                              <FuelOTPanel
                                order={order}
                                lang={lang}
                                vehiclePos={(() => {
                                  // Posição ao vivo da viatura (WS) — alimenta o gate
                                  // da "Chegada ao P.A." (só desbloqueia na zona do P.A.).
                                  const v = order.vehicleId
                                    ? vehicles.find(x => Number(x.id) === Number(order.vehicleId))
                                    : null;
                                  const p = v?.position;
                                  return (p && p.latitude != null && p.longitude != null)
                                    ? { lat: Number(p.latitude), lng: Number(p.longitude) }
                                    : null;
                                })()}
                                onUpdated={() => { try { refreshOrders(); } catch {} }}
                                onReplan={(rid, replanOpts) => handleReplanRoute(order, replanOpts)}
                                onStartRoute={() => handleInlineRouteAction(order, 'in_progress')}
                                onInteractingChange={setPanelInteracting}
                              />
                            </Box>
                          )}
                          {(() => {
                            // Service-type aware labels: assistance OTs use "Saída"
                            // (departure point) and "Local de serviço" (where the
                            // technician performs the work) instead of "Recolha"/"Entrega".
                            const isAssistOT = order.serviceType === 'assistance';
                            const pickupLabel = isAssistOT
                              ? (lang === 'pt' ? 'Saída' : 'Departure')
                              : (lang === 'pt' ? 'Recolha' : 'Pickup');
                            const deliveryLabel = isAssistOT
                              ? (lang === 'pt' ? 'Local de serviço' : 'Service location')
                              : (lang === 'pt' ? 'Entrega' : 'Delivery');
                            const pickupWindowLabel = isAssistOT
                              ? (lang === 'pt' ? 'Janela saída' : 'Departure window')
                              : (lang === 'pt' ? 'Janela recolha' : 'Pickup window');
                            const deliveryWindowLabel = isAssistOT
                              ? (lang === 'pt' ? 'Prazo serviço' : 'Service deadline')
                              : (lang === 'pt' ? 'Janela entrega' : 'Delivery window');
                            // Detect recalc-on-start: route origin diverges from OT pickup
                            // (operator hit "recalcular com posição actual"). When that
                            // happens, the displayed pickup is the planned address but the
                            // route actually started elsewhere — surface that to the user.
                            const ro = order.routeOrigin;
                            const roCoords = Array.isArray(ro?.coordinates) ? ro.coordinates : null;
                            const roLng = roCoords?.[0];
                            const roLat = roCoords?.[1];
                            // Same null-aware coercion as the row-level
                            // check (see comment on line 3604) — without
                            // it assistance OTs land in the "Início real"
                            // path and replace the service site with the
                            // route's origin name in the expanded panel.
                            const pLng = order.pickupLng != null ? Number(order.pickupLng) : NaN;
                            const pLat = order.pickupLat != null ? Number(order.pickupLat) : NaN;
                            const routeOriginDiverged = (
                              order.actualStartAt && // only meaningful once the route has started
                              Number.isFinite(roLng) && Number.isFinite(roLat) &&
                              Number.isFinite(pLng) && Number.isFinite(pLat) &&
                              (Math.abs(roLng - pLng) > 0.0005 || Math.abs(roLat - pLat) > 0.0005)
                            );
                            const routeOriginName = ro?.text || ro?.name || ro?.address || '';
                          return (
                          <Box style={{ display: 'flex', gap: 12, padding: '14px 18px' }}>
                            {/* Left — mini map */}
                            <Box style={{ flex: '0 0 360px', height: 220 }}>
                              <OrderMiniMap order={order} vehiclePosition={vehicleLive?.position} />
                            </Box>

                            {/* Right — details panels */}
                            <Box style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 10, minWidth: 0 }}>
                              {/* Top row: addresses on the left, execution timeline on the right */}
                              <Box style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                                {/* Addresses column (pickup stacked above delivery) */}
                                <Box style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                                  {/* For assistance OTs the "pickup" field on
                                      the OT is meaningless — there's nothing
                                      to pick up. The actual departure is
                                      decided at route planning (driver home
                                      / vehicle GPS / warehouse). So instead
                                      of showing the legacy pickupName (which
                                      may carry a stale warehouse default and
                                      duplicate the service site), we surface
                                      the route's real origin. */}
                                  <Box style={{ background: '#f0fdf4', borderRadius: 10, padding: '8px 12px', border: '1px solid #bbf7d0' }}>
                                    <Box style={{ display: 'flex', alignItems: 'center', gap: 4, marginBottom: 3 }}>
                                      <Box style={{ width: 8, height: 8, borderRadius: '50%', background: '#22c55e' }} />
                                      <Typography style={{ fontSize: '0.56rem', fontWeight: 800, color: '#166534', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        {routeOriginDiverged ? (lang === 'pt' ? 'Início real' : 'Actual start') : pickupLabel}
                                      </Typography>
                                      {routeOriginDiverged && (
                                        <Box style={{ fontSize: '0.5rem', fontWeight: 800, background: '#fef3c7', color: '#92400e', padding: '0 5px', borderRadius: 4, marginLeft: 4 }}>
                                          ⚠ recalc GPS
                                        </Box>
                                      )}
                                    </Box>
                                    {(() => {
                                      // Pick the right "origin" to show.
                                      //   - Started + diverged → the live recalc origin
                                      //   - Assistance with a planned route → routeOrigin (driver home, etc.)
                                      //   - Otherwise (delivery / fuel) → OT's own pickup
                                      let displayName, displayAddress, isPlannedOrigin = false, isPlaceholder = false;
                                      if (routeOriginDiverged) {
                                        displayName = routeOriginName || (lang === 'pt' ? 'Posição actual do veículo' : 'Vehicle current position');
                                      } else if (isAssistOT) {
                                        if (routeOriginName) {
                                          displayName = routeOriginName;
                                          isPlannedOrigin = true;
                                        } else {
                                          displayName = lang === 'pt'
                                            ? 'Definida ao planear (casa do motorista / GPS do veículo)'
                                            : 'Set at planning (driver home / vehicle GPS)';
                                          isPlaceholder = true;
                                        }
                                      } else {
                                        displayName = order.pickupName || '—';
                                        displayAddress = order.pickupAddress && order.pickupAddress !== order.pickupName ? order.pickupAddress : null;
                                      }
                                      return (
                                        <>
                                          <Typography style={{ fontSize: '0.72rem', fontWeight: isPlaceholder ? 500 : 700, fontStyle: isPlaceholder ? 'italic' : 'normal', color: isPlaceholder ? '#475569' : '#14532d', lineHeight: 1.2 }}>
                                            {displayName}
                                          </Typography>
                                          {isPlannedOrigin && (
                                            <Typography style={{ fontSize: '0.55rem', color: '#15803d', marginTop: 2, fontWeight: 600 }}>
                                              {lang === 'pt' ? 'Definido pela rota planeada' : 'Set by planned route'}
                                            </Typography>
                                          )}
                                          {displayAddress && (
                                            <Typography style={{ fontSize: '0.62rem', color: '#166534', marginTop: 1 }}>
                                              {displayAddress}
                                            </Typography>
                                          )}
                                        </>
                                      );
                                    })()}
                                    {!routeOriginDiverged && !isAssistOT && (order.pickupContact || order.pickupPhone) && (
                                      <Typography style={{ fontSize: '0.58rem', color: '#15803d', marginTop: 2 }}>
                                        👤 {order.pickupContact || '—'}{order.pickupPhone ? ` · ${order.pickupPhone}` : ''}
                                      </Typography>
                                    )}
                                    {routeOriginDiverged && (
                                      <Box style={{ marginTop: 4, paddingTop: 4, borderTop: '1px dashed #bbf7d0' }}>
                                        <Typography style={{ fontSize: '0.52rem', color: '#94a3b8', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                          {pickupLabel} {lang === 'pt' ? 'planeada' : 'planned'}
                                        </Typography>
                                        <Typography style={{ fontSize: '0.62rem', color: '#475569', lineHeight: 1.2 }}>
                                          {isAssistOT ? (routeOriginName || '—') : (order.pickupName || '—')}
                                        </Typography>
                                      </Box>
                                    )}
                                  </Box>
                                  <Box style={{ background: '#fef2f2', borderRadius: 10, padding: '8px 12px', border: '1px solid #fecaca' }}>
                                    <Box style={{ display: 'flex', alignItems: 'center', gap: 4, marginBottom: 3 }}>
                                      <Box style={{ width: 8, height: 8, borderRadius: '50%', background: '#ef4444' }} />
                                      <Typography style={{ fontSize: '0.56rem', fontWeight: 800, color: '#991b1b', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        {deliveryLabel}
                                      </Typography>
                                    </Box>
                                    <Typography style={{ fontSize: '0.72rem', fontWeight: 700, color: '#7f1d1d', lineHeight: 1.2 }}>
                                      {order.deliveryName || '—'}
                                    </Typography>
                                    {order.deliveryAddress && order.deliveryAddress !== order.deliveryName && (
                                      <Typography style={{ fontSize: '0.62rem', color: '#991b1b', marginTop: 1 }}>
                                        {order.deliveryAddress}
                                      </Typography>
                                    )}
                                    {(order.deliveryContact || order.deliveryPhone) && (
                                      <Typography style={{ fontSize: '0.58rem', color: '#b91c1c', marginTop: 2 }}>
                                        👤 {order.deliveryContact || '—'}{order.deliveryPhone ? ` · ${order.deliveryPhone}` : ''}
                                      </Typography>
                                    )}
                                  </Box>
                                </Box>

                              {/* Execution timeline */}
                              <Box style={{ background: '#fff', borderRadius: 10, padding: '10px 14px', border: '1px solid #e2e8f0' }}>
                                <Typography style={{ fontSize: '0.58rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6 }}>
                                  Linha temporal de execução
                                </Typography>
                                <Box style={{ display: 'grid', gridTemplateColumns: 'auto 1fr auto', gap: '4px 10px', fontSize: '0.68rem' }}>
                                  {order.createdAt && (<>
                                    <span style={{ color: '#94a3b8' }}>Criada</span>
                                    <span style={{ color: '#0f172a' }}>{new Date(order.createdAt).toLocaleString('pt-PT', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' })}</span>
                                    <span />
                                  </>)}
                                  {order.pickupWindowFrom && (<>
                                    <span style={{ color: '#94a3b8' }}>{pickupWindowLabel}</span>
                                    <span style={{ color: '#22c55e', fontWeight: 600 }}>{fmtDate(order.pickupWindowFrom)} {fmtTime(order.pickupWindowFrom)}{order.pickupWindowTo ? ` → ${fmtTime(order.pickupWindowTo)}` : ''}</span>
                                    <span />
                                  </>)}
                                  {order.deliveryWindowFrom && (<>
                                    <span style={{ color: '#94a3b8' }}>{deliveryWindowLabel}</span>
                                    <span style={{ color: '#ef4444', fontWeight: 600 }}>{fmtDate(order.deliveryWindowFrom)} {fmtTime(order.deliveryWindowFrom)}{order.deliveryWindowTo ? ` → ${fmtTime(order.deliveryWindowTo)}` : ''}</span>
                                    <span />
                                  </>)}
                                  {order.actualStartAt && (<>
                                    <span style={{ color: '#94a3b8' }}>Início real</span>
                                    <span style={{ color: '#22c55e', fontWeight: 700 }}>▶ {fmtDate(order.actualStartAt)} {fmtTime(order.actualStartAt)}</span>
                                    <span />
                                  </>)}
                                  {order.assistanceReport?.arrivedAt && !order.deliveredAt && (<>
                                    <span style={{ color: '#94a3b8' }}>Chegou ao local</span>
                                    <span style={{ color: '#0ea5e9', fontWeight: 700 }}>📍 {fmtDate(order.assistanceReport.arrivedAt)} {fmtTime(order.assistanceReport.arrivedAt)}</span>
                                    <span />
                                  </>)}
                                  {/* Início efectivo do serviço — separa o tempo
                                      facturável do tempo de espera (arrivedAt →
                                      serviceStartedAt). Fica visível tanto durante
                                      a execução como após a conclusão da OT. */}
                                  {order.assistanceReport?.serviceStartedAt && (<>
                                    <span style={{ color: '#94a3b8' }}>Iniciou serviço</span>
                                    <span style={{ color: '#f59e0b', fontWeight: 700 }}>🛠 {fmtDate(order.assistanceReport.serviceStartedAt)} {fmtTime(order.assistanceReport.serviceStartedAt)}</span>
                                    <span />
                                  </>)}
                                  {/* Tempo de serviço — duração do bloco facturável.
                                      Live (1Hz) enquanto a OT não está concluída,
                                      total formatado quando há completedAt. */}
                                  {order.assistanceReport?.serviceStartedAt && (() => {
                                    const d = serviceDuration(order.assistanceReport, serviceNow);
                                    if (!d) return null;
                                    return (<>
                                      <span style={{ color: '#94a3b8' }}>Tempo de serviço</span>
                                      <span style={{ color: d.live ? '#b45309' : '#0f172a', fontWeight: 700 }}>
                                        🛠 {fmtServiceDuration(d.ms, d.live)}{d.live ? ' · em curso' : ''}
                                      </span>
                                      <span />
                                    </>);
                                  })()}
                                  {/* "Previsto chegada" is the live ETA computed
                                      from current GPS — only meaningful while
                                      the OT is actually in transit. For other
                                      states the field, if present from a past
                                      run, is misleading. */}
                                  {order.status === 'in_transit' && order.estimatedArrival && !order.deliveredAt && (<>
                                    <span style={{ color: '#94a3b8' }}>Previsto chegada</span>
                                    <span style={{ color: '#3b82f6', fontWeight: 700 }}>
                                      ⏱ {fmtDate(order.estimatedArrival)} {fmtTime(order.estimatedArrival)}
                                      {order.unloadingTime > 0 && (
                                        <span style={{
                                          marginLeft: 6, fontSize: '0.56rem', fontWeight: 700,
                                          background: 'rgba(245,158,11,0.12)', color: '#d97706',
                                          padding: '1px 6px', borderRadius: 8,
                                        }}>+{order.unloadingTime}min descarga</span>
                                      )}
                                    </span>
                                    <span />
                                  </>)}
                                  {order.deliveredAt && (<>
                                    <span style={{ color: '#94a3b8' }}>
                                      {order.serviceType === 'assistance' ? 'Concluído' : 'Entregue'}
                                    </span>
                                    <span style={{ color: '#16a34a', fontWeight: 800 }}>✔ {fmtDate(order.deliveredAt)} {fmtTime(order.deliveredAt)}</span>
                                    <span />
                                  </>)}
                                  {/* Route-level completion — shown when the WHOLE
                                      route was closed (auto-completed after the
                                      last OT report or via the operator's
                                      "Concluir rota" button). Distinct from the
                                      per-OT "Concluído" line above so the
                                      operator can see both moments. */}
                                  {order.routeCompletedAt && (<>
                                    <span style={{ color: '#94a3b8' }}>Rota concluída</span>
                                    <span style={{ color: '#0f766e', fontWeight: 800 }}>🏁 {fmtDate(order.routeCompletedAt)} {fmtTime(order.routeCompletedAt)}</span>
                                    <span />
                                  </>)}
                                  {/* Distance: while in transit show the live
                                      remaining distance; in other states fall
                                      back to the route's TOTAL planned distance
                                      (so the operator sees 381 km, not the 8 km
                                      haversine artefact). */}
                                  {(() => {
                                    if (order.status === 'in_transit' && order.distanceKm) {
                                      return (<>
                                        <span style={{ color: '#94a3b8' }}>Distância restante</span>
                                        <span style={{ color: '#0f172a' }}>{Number(order.distanceKm).toFixed(1)} km</span>
                                        <span />
                                      </>);
                                    }
                                    if (order.route?.totalDistanceM) {
                                      const km = order.route.totalDistanceM / 1000;
                                      const hours = order.route.totalDurationS ? Math.floor(order.route.totalDurationS / 3600) : null;
                                      const mins = order.route.totalDurationS ? Math.round((order.route.totalDurationS % 3600) / 60) : null;
                                      return (<>
                                        <span style={{ color: '#94a3b8' }}>Rota planeada</span>
                                        <span style={{ color: '#0f172a' }}>
                                          {km.toFixed(1)} km
                                          {hours != null && (<>
                                            {' · '}{hours > 0 ? `${hours}h${String(mins).padStart(2, '0')}` : `${mins} min`}
                                          </>)}
                                        </span>
                                        <span />
                                      </>);
                                    }
                                    return null;
                                  })()}
                                </Box>
                              </Box>
                              </Box>{/* end of 2-column grid (addresses | timeline) */}

                              {/* ═══════ Estado & Operações — acções inline ═══════ */}
                              {(() => {
                                const hasRoute = !!order.assignedRouteId;
                                const hasVehicle = !!(order.vehicleId || order.vehiclePlate);
                                const otStatus = order.status;
                                const busy = routeActionBusyId === (order._id || order.id);
                                // When several OTs share the same route (consolidation), only the
                                // "primary" OT surfaces the Start/Complete/Cancel buttons — otherwise
                                // the operator sees 3× "Iniciar" as if they needed to click each one.
                                // Cascade still happens backend-side (a single click updates all OTs).
                                // Primary = earliest by delivery window (same sort used at consolidation time).
                                let isPrimaryOfRoute = true;
                                if (hasRoute) {
                                  const siblings = list.filter(o => o.assignedRouteId === order.assignedRouteId);
                                  if (siblings.length > 1) {
                                    const scoreFor = (o) => new Date(o.deliveryWindowFrom || o.pickupWindowFrom || 0).getTime() * 1e6
                                      + (o.id || o._id || 0);
                                    const primary = siblings.reduce((a, b) => scoreFor(a) <= scoreFor(b) ? a : b);
                                    isPrimaryOfRoute = (primary.id || primary._id) === (order.id || order._id);
                                  }
                                }
                                // OT state → allowed actions (cascade via /routes/:id/status)
                                const canStart = hasRoute && otStatus === 'assigned' && isPrimaryOfRoute;
                                const canComplete = hasRoute && otStatus === 'in_transit' && isPrimaryOfRoute;
                                const canCancel = hasRoute && (otStatus === 'assigned' || otStatus === 'in_transit') && isPrimaryOfRoute;
                                // Re-plan in-execution: operator can edit an in-progress route (add/remove waypoints)
                                // and resend to the driver. Only surfaced on the primary OT of the route.
                                // Fuel (Move Express): sem "Re-planear" — a rota
                                // (base→terminal→cliente) não se edita em execução
                                // como as de assistência/entrega.
                                const canReplan = hasRoute && otStatus === 'in_transit' && isPrimaryOfRoute && order.serviceType !== 'fuel';
                                const isFinal = otStatus === 'delivered' || otStatus === 'cancelled';

                                // Step progress: Criada → Veículo → Rota → Iniciada → Concluída
                                const steps = [
                                  { key: 'created', label: lang === 'pt' ? 'Criada' : 'Created', done: true },
                                  { key: 'vehicle', label: lang === 'pt' ? 'Veículo' : 'Vehicle', done: hasVehicle || otStatus !== 'pending' },
                                  { key: 'route', label: lang === 'pt' ? 'Rota' : 'Route', done: hasRoute },
                                  { key: 'started', label: lang === 'pt' ? 'Iniciada' : 'Started', done: otStatus === 'in_transit' || otStatus === 'delivered' },
                                  { key: 'completed', label: lang === 'pt' ? 'Concluída' : 'Completed', done: otStatus === 'delivered' },
                                ];
                                const isCancelledFlow = otStatus === 'cancelled';

                                let stateLabel, stateColor, stateIcon, stateHelper;
                                if (otStatus === 'cancelled') {
                                  stateLabel = lang === 'pt' ? 'Cancelada' : 'Cancelled';
                                  stateColor = '#ef4444';
                                  stateIcon = '✕';
                                  stateHelper = lang === 'pt' ? 'Operação cancelada.' : 'Operation cancelled.';
                                } else if (otStatus === 'delivered') {
                                  // Assistance OTs are "Concluída" (the technician
                                  // finished the on-site service); delivery/fuel OTs
                                  // are "Entregue" (the cargo was handed over). Same
                                  // underlying status, different operator vocabulary.
                                  const isAssistance = order.serviceType === 'assistance';
                                  stateLabel = lang === 'pt'
                                    ? (isAssistance ? 'Concluída' : 'Entregue')
                                    : (isAssistance ? 'Completed' : 'Delivered');
                                  stateColor = '#22c55e';
                                  stateIcon = '✔';
                                  stateHelper = lang === 'pt' ? 'Operação concluída com sucesso.' : 'Operation completed successfully.';
                                } else if (otStatus === 'in_transit') {
                                  stateLabel = lang === 'pt' ? 'Em trânsito' : 'In transit';
                                  stateColor = '#f59e0b';
                                  stateIcon = '▶';
                                  stateHelper = lang === 'pt' ? 'Viagem em curso. Aguarda entrega.' : 'Trip in progress. Awaiting delivery.';
                                } else if (otStatus === 'pending' && !hasVehicle && order.abortedFromRouteId) {
                                  // Pending because the prior route was aborted by the driver
                                  // (breakdown). Surface this loudly so the operator doesn't
                                  // mistake it for a brand-new OT in the queue.
                                  stateLabel = lang === 'pt' ? 'Rota abortada · re-atribuir' : 'Route aborted · re-assign';
                                  stateColor = '#dc2626';
                                  stateIcon = '🚨';
                                  stateHelper = lang === 'pt'
                                    ? `Motorista reportou avaria${order.abortedFromRouteName ? ` na rota "${order.abortedFromRouteName}"` : ''}. Atribui um novo veículo.`
                                    : `Driver reported a breakdown${order.abortedFromRouteName ? ` on route "${order.abortedFromRouteName}"` : ''}. Assign a new vehicle.`;
                                } else if (otStatus === 'pending' && !hasVehicle) {
                                  stateLabel = lang === 'pt' ? 'Pendente' : 'Pending';
                                  stateColor = '#94a3b8';
                                  stateIcon = '○';
                                  stateHelper = lang === 'pt' ? 'Passo 1 · Atribui um veículo/motorista à OT.' : 'Step 1 · Assign a vehicle/driver to this order.';
                                } else if (!hasRoute) {
                                  // Vehicle attributed but no route yet — the "falta rota" step
                                  stateLabel = lang === 'pt' ? 'Falta atribuir rota' : 'Route missing';
                                  stateColor = '#f59e0b';
                                  stateIcon = '◔';
                                  stateHelper = lang === 'pt' ? 'Passo 2 · Associa uma rota existente ou cria uma a partir desta OT.' : 'Step 2 · Link an existing route or create one from this order.';
                                } else if (otStatus === 'assigned') {
                                  stateLabel = lang === 'pt' ? 'Pronta para iniciar' : 'Ready to start';
                                  stateColor = '#3b82f6';
                                  stateIcon = '◉';
                                  stateHelper = lang === 'pt' ? 'Passo 3 · Veículo e rota atribuídos. Clica "Iniciar" para arrancar.' : 'Step 3 · Vehicle and route assigned. Click "Start" to begin.';
                                } else {
                                  stateLabel = otStatus;
                                  stateColor = '#94a3b8';
                                  stateIcon = '○';
                                  stateHelper = '';
                                }

                                return (
                                  <Box style={{
                                    background: '#fff', borderRadius: 10, padding: '10px 14px',
                                    border: '1px solid #e2e8f0',
                                  }}>
                                    <Typography style={{ fontSize: '0.58rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>
                                      {lang === 'pt' ? 'Estado da operação' : 'Operation state'}
                                    </Typography>

                                    {/* Step progress bar */}
                                    <Box style={{ display: 'flex', alignItems: 'center', gap: 0, marginBottom: 10, opacity: isCancelledFlow ? 0.45 : 1 }}>
                                      {steps.map((step, idx) => {
                                        const isCurrent = !isCancelledFlow && !step.done && (idx === 0 || steps[idx - 1].done);
                                        const isLast = idx === steps.length - 1;
                                        const dotColor = step.done ? '#22c55e' : isCurrent ? stateColor : '#e2e8f0';
                                        return (
                                          <React.Fragment key={step.key}>
                                            <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', zIndex: 1 }}>
                                              <Box style={{
                                                width: isCurrent ? 16 : 12, height: isCurrent ? 16 : 12, borderRadius: '50%',
                                                background: dotColor,
                                                border: isCurrent ? `2px solid ${stateColor}` : 'none',
                                                boxShadow: isCurrent ? `0 0 0 3px ${stateColor}25` : 'none',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                color: '#fff', fontSize: 8, fontWeight: 800,
                                                transition: 'all 0.2s',
                                              }}>
                                                {step.done && '✓'}
                                              </Box>
                                              <Typography style={{
                                                fontSize: '0.54rem', color: step.done ? '#16a34a' : isCurrent ? stateColor : '#94a3b8',
                                                fontWeight: isCurrent ? 700 : 600, marginTop: 3, whiteSpace: 'nowrap',
                                              }}>
                                                {step.label}
                                              </Typography>
                                            </Box>
                                            {!isLast && (
                                              <Box style={{
                                                flex: 1, height: 2, marginTop: -14,
                                                background: step.done ? '#22c55e' : '#e2e8f0',
                                                transition: 'background 0.2s',
                                              }} />
                                            )}
                                          </React.Fragment>
                                        );
                                      })}
                                    </Box>

                                    {/* Per-OT leg summary — shown when this OT is part of a consolidated route.
                                        Gives the operator an idea of how much of the whole route belongs to this OT. */}
                                    {order.otLegIsShared && order.otLegDistanceM != null && (
                                      <Box style={{
                                        marginBottom: 12, padding: '10px 14px',
                                        background: 'linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)',
                                        border: '1px solid #fdba74',
                                        borderRadius: 10,
                                      }}>
                                        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
                                          <Typography style={{ fontSize: '0.58rem', fontWeight: 800, color: '#9a3412', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                            {lang === 'pt' ? 'Esta OT na rota conjunta' : "This OT's share of the route"}
                                          </Typography>
                                          <Typography style={{ fontSize: '0.6rem', fontWeight: 700, color: '#c2410c' }}>
                                            {lang === 'pt' ? `${order.otLegShareCount} ordens partilham rota` : `${order.otLegShareCount} orders share this route`}
                                          </Typography>
                                        </Box>
                                        <Box style={{ display: 'flex', gap: 20, flexWrap: 'wrap', marginTop: 4 }}>
                                          <Box>
                                            <Typography style={{ fontSize: '0.58rem', color: '#9a3412', fontWeight: 600 }}>
                                              {lang === 'pt' ? 'Distância' : 'Distance'}
                                            </Typography>
                                            <Typography style={{ fontSize: '0.82rem', fontWeight: 800, color: '#7c2d12' }}>
                                              {(order.otLegDistanceM / 1000).toFixed(1)} km
                                            </Typography>
                                          </Box>
                                          <Box>
                                            <Typography style={{ fontSize: '0.58rem', color: '#9a3412', fontWeight: 600 }}>
                                              {lang === 'pt' ? 'Tempo previsto' : 'Estimated time'}
                                            </Typography>
                                            <Typography style={{ fontSize: '0.82rem', fontWeight: 800, color: '#7c2d12' }}>
                                              {(() => {
                                                const m = Math.round((order.otLegDurationS || 0) / 60);
                                                const h = Math.floor(m / 60);
                                                const mm = m % 60;
                                                return h > 0 ? `${h}h${String(mm).padStart(2,'0')}` : `${mm} min`;
                                              })()}
                                            </Typography>
                                          </Box>
                                          {(() => {
                                            // % da rota total = leg desta OT / distância total da rota consolidada.
                                            // Antes usava-se order.distanceKm (campo histórico, pode estar
                                            // desactualizado depois de optimizar a rota), o que produzia
                                            // valores >100% quando o leg era maior que a estimativa antiga.
                                            const routeTotalKm = order.routeTotalDistanceM
                                              ? order.routeTotalDistanceM / 1000
                                              : null;
                                            const legKm = order.otLegDistanceM
                                              ? order.otLegDistanceM / 1000
                                              : null;
                                            if (!routeTotalKm || !legKm || routeTotalKm === 0) return null;
                                            const pct = Math.min(100, Math.round((legKm / routeTotalKm) * 100));
                                            return (
                                              <Box>
                                                <Typography style={{ fontSize: '0.58rem', color: '#9a3412', fontWeight: 600 }}>
                                                  {lang === 'pt' ? '% da rota total' : '% of total route'}
                                                </Typography>
                                                <Typography style={{ fontSize: '0.82rem', fontWeight: 800, color: '#7c2d12' }}>
                                                  {pct}%
                                                </Typography>
                                              </Box>
                                            );
                                          })()}
                                        </Box>
                                      </Box>
                                    )}

                                    {/* TripProgressBar removed from the Orders details — it
                                        showed elapsed wall-clock time vs ETA, which confused
                                        operators (the truck was parked but the bar still moved).
                                        Real-time progress lives in Operações > Rotas →
                                        "Ver em tempo real" with actual GPS-vs-polyline tracking. */}

                                    <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
                                      <Box style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                                        <Box style={{
                                          display: 'inline-flex', alignItems: 'center', gap: 6,
                                          padding: '4px 10px', borderRadius: 14,
                                          background: `${stateColor}18`, color: stateColor,
                                          fontSize: '0.72rem', fontWeight: 700,
                                        }}>
                                          <span style={{ fontSize: '0.8rem' }}>{stateIcon}</span>
                                          {stateLabel}
                                        </Box>
                                        <Typography style={{ fontSize: '0.62rem', color: '#64748b' }}>
                                          {stateHelper}
                                        </Typography>
                                      </Box>

                                      <Box style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
                                        <Button
                                          size="small"
                                          variant="outlined"
                                          onClick={() => openOTHistory(order)}
                                          startIcon={<HistoryIcon style={{ fontSize: 14 }} />}
                                          style={{
                                            fontSize: '0.66rem', fontWeight: 700, textTransform: 'none',
                                            borderRadius: 8, padding: '4px 12px',
                                            borderColor: '#c7d2fe', color: '#4338ca', background: '#fff',
                                          }}
                                        >
                                          {lang === 'pt' ? 'Histórico' : 'History'}
                                        </Button>
                                        {/* Fuel: "Iniciar" escondido — o arranque
                                            faz-se pela bola "Saí da base" na
                                            cronologia (FuelOTPanel), que abre o
                                            diálogo com a rota planeada correcta. */}
                                        {!isFinal && hasRoute && canStart && order.serviceType !== 'fuel' && (
                                          <Button
                                            size="small"
                                            variant="contained"
                                            disabled={busy}
                                            onClick={() => handleInlineRouteAction(order, 'in_progress')}
                                            startIcon={<PlayArrowIcon style={{ fontSize: 14 }} />}
                                            style={{
                                              fontSize: '0.68rem', fontWeight: 700, textTransform: 'none',
                                              borderRadius: 8, padding: '4px 14px',
                                              background: busy ? '#cbd5e1' : 'linear-gradient(135deg, #22c55e, #16a34a)',
                                              color: '#fff', boxShadow: busy ? 'none' : '0 2px 6px rgba(34,197,94,0.3)',
                                            }}
                                          >
                                            {lang === 'pt' ? 'Iniciar' : 'Start'}
                                          </Button>
                                        )}
                                        {/* "Concluir" manual removido: a rota fecha
                                            automaticamente quando o motorista
                                            entrega a última OT (per-OT delivery
                                            model). Para fechos anómalos o motorista
                                            usa "Reportar avaria" na app, que liberta
                                            as OTs por entregar. */}
                                        {!isFinal && canReplan && (
                                          <Tooltip title={lang === 'pt'
                                            ? 'Abrir rota em modo edição para acrescentar/remover paragens e reenviar ao motorista'
                                            : 'Open route in edit mode to add/remove stops and resend to driver'}>
                                            <Button
                                              size="small"
                                              variant="outlined"
                                              disabled={busy}
                                              onClick={() => handleReplanRoute(order)}
                                              startIcon={<EditIcon style={{ fontSize: 14 }} />}
                                              style={{
                                                fontSize: '0.68rem', fontWeight: 700, textTransform: 'none',
                                                borderRadius: 8, padding: '4px 14px',
                                                borderColor: '#f59e0b', color: '#92400e', background: '#fffbeb',
                                              }}
                                            >
                                              {lang === 'pt' ? 'Re-planear' : 'Re-plan'}
                                            </Button>
                                          </Tooltip>
                                        )}
                                        {!isFinal && hasRoute && canCancel && (
                                          <Button
                                            size="small"
                                            variant="outlined"
                                            disabled={busy}
                                            onClick={() => handleInlineRouteAction(order, 'cancelled')}
                                            startIcon={<CloseIcon style={{ fontSize: 14 }} />}
                                            style={{
                                              fontSize: '0.68rem', fontWeight: 700, textTransform: 'none',
                                              borderRadius: 8, padding: '4px 14px',
                                              borderColor: '#fecaca', color: '#dc2626', background: '#fff',
                                            }}
                                          >
                                            {lang === 'pt' ? 'Cancelar' : 'Cancel'}
                                          </Button>
                                        )}
                                        {/* Helper note for non-primary OTs of a consolidated route */}
                                        {hasRoute && !isPrimaryOfRoute && !isFinal && (
                                          <Typography style={{
                                            fontSize: '0.62rem', color: '#64748b', fontStyle: 'italic',
                                            padding: '4px 8px', background: '#f8fafc', borderRadius: 6,
                                            border: '1px dashed #cbd5e1',
                                          }}>
                                            {lang === 'pt'
                                              ? 'Controlada pela OT principal desta rota'
                                              : 'Controlled by the route\'s primary OT'}
                                          </Typography>
                                        )}
                                      </Box>
                                    </Box>
                                  </Box>
                                );
                              })()}

                              {/* Assistance report — compact 2-column layout to avoid stretching the
                                  expanded panel. Left column: metadata (times, materials, cliente).
                                  Right column: rich content (work, photos, signature). */}
                              {order.assistanceReport && (() => {
                                const r = order.assistanceReport;
                                const OUTCOME_MAP = {
                                  resolved:        { label: lang === 'pt' ? 'Resolvido' : 'Resolved',          dot: '#22c55e' },
                                  partial:         { label: lang === 'pt' ? 'Parcial' : 'Partial',              dot: '#f59e0b' },
                                  followup_needed: { label: lang === 'pt' ? 'Nova visita' : 'Follow-up',        dot: '#3b82f6' },
                                  customer_absent: { label: lang === 'pt' ? 'Ausente' : 'Absent',               dot: '#64748b' },
                                  cancelled:       { label: lang === 'pt' ? 'Cancelada' : 'Cancelled',          dot: '#dc2626' },
                                };
                                const outcome = OUTCOME_MAP[r.outcome] || OUTCOME_MAP.resolved;
                                const fmtShort = (iso) => iso ? new Date(iso).toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' }) : '—';
                                const fmtDate = (iso) => iso ? new Date(iso).toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit' }) : '';
                                const materials = Array.isArray(r.materialsUsed) ? r.materialsUsed : [];
                                const photos = Array.isArray(r.photos) ? r.photos : [];
                                const LABEL_STYLE = { color: '#94a3b8', fontSize: '0.54rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' };
                                return (
                                  <Box style={{
                                    background: '#fff', borderRadius: 10, padding: '10px 12px',
                                    border: '1px solid #e2e8f0', marginTop: 10,
                                  }}>
                                    {/* Header — single row: icon + title + outcome + submit time */}
                                    <Box style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, paddingBottom: 8, borderBottom: '1px solid #f1f5f9' }}>
                                      <span style={{ fontSize: 13 }}>📝</span>
                                      <Typography style={{ fontSize: '0.74rem', fontWeight: 600, color: '#0f172a', letterSpacing: '-0.01em' }}>
                                        {lang === 'pt' ? 'Relatório do motorista' : 'Driver report'}
                                      </Typography>
                                      <Box style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '1px 8px', borderRadius: 10, background: '#f8fafc', border: '1px solid #e2e8f0' }}>
                                        <Box style={{ width: 6, height: 6, borderRadius: '50%', background: outcome.dot }} />
                                        <Typography style={{ fontSize: '0.6rem', fontWeight: 600, color: '#334155' }}>{outcome.label}</Typography>
                                      </Box>
                                      <Box style={{ flex: 1 }} />
                                      <Typography style={{ fontSize: '0.6rem', color: '#94a3b8' }}>
                                        {fmtDate(r.updatedAt || r.createdAt)} · {fmtShort(r.updatedAt || r.createdAt)}
                                      </Typography>
                                    </Box>

                                    {/* Horizontal 3-column layout — assinaturas e fotos foram
                                        movidas para uma row separada abaixo (mais espaço para
                                        os 3 cartões ficarem lado a lado e fotos ampliadas). */}
                                    <Box style={{ display: 'grid', gridTemplateColumns: '130px 1fr 170px', gap: 14, alignItems: 'start' }}>
                                      {/* Col 1 — Execution times + internal notes */}
                                      <Box style={{ display: 'flex', flexDirection: 'column', gap: 8, minWidth: 0 }}>
                                        <Box>
                                          <Typography style={LABEL_STYLE}>{lang === 'pt' ? 'Execução' : 'Execution'}</Typography>
                                          <Typography style={{ fontSize: '0.7rem', color: '#334155', marginTop: 2, whiteSpace: 'nowrap' }}>
                                            <span style={{ fontWeight: 600 }}>{fmtShort(r.arrivedAt)}</span>
                                            <span style={{ color: '#94a3b8' }}> → </span>
                                            <span style={{ fontWeight: 600 }}>{fmtShort(r.completedAt)}</span>
                                          </Typography>
                                          {r.actualDurationMin != null && (() => {
                                            // Label honesto: a partir da Fase 1A
                                            // o backend computa actualDurationMin
                                            // como tempo facturável (serviceStarted
                                            // → completed). Fallback retro-compat
                                            // (relatórios antigos sem serviceStarted)
                                            // ainda usa arrived → completed e nesses
                                            // mostramos "no local" — não tens forma
                                            // melhor de o saber sem o flag.
                                            const isBillable = !!r.serviceStartedAt;
                                            return (
                                              <Typography style={{ fontSize: '0.64rem', color: '#64748b', marginTop: 1 }}>
                                                {r.actualDurationMin} min {lang === 'pt'
                                                  ? (isBillable ? 'de serviço' : 'no local')
                                                  : (isBillable ? 'in service' : 'on site')}
                                              </Typography>
                                            );
                                          })()}
                                        </Box>
                                        {r.notes && (
                                          <Typography style={{ fontSize: '0.64rem', color: '#64748b', fontStyle: 'italic', lineHeight: 1.35,
                                            display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden',
                                          }}>
                                            💬 {r.notes}
                                          </Typography>
                                        )}
                                      </Box>

                                      {/* Col 2 — Work performed (wide) + follow-up */}
                                      <Box style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 }}>
                                        {r.workPerformed && (
                                          <Box>
                                            <Typography style={LABEL_STYLE}>
                                              {lang === 'pt' ? 'Trabalho realizado' : 'Work performed'}
                                            </Typography>
                                            <Typography style={{
                                              fontSize: '0.7rem', color: '#1e293b', lineHeight: 1.4,
                                              whiteSpace: 'pre-line', marginTop: 3,
                                              display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical',
                                              overflow: 'hidden',
                                            }}>
                                              {r.workPerformed}
                                            </Typography>
                                          </Box>
                                        )}
                                        {r.followUpNotes && (
                                          <Box style={{
                                            padding: '4px 7px', background: '#fffbeb',
                                            borderLeft: '2px solid #f59e0b', borderRadius: 3,
                                          }}>
                                            <Typography style={{ fontSize: '0.54rem', fontWeight: 700, color: '#92400e', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                              {lang === 'pt' ? 'Nova visita' : 'Follow-up'}
                                            </Typography>
                                            <Typography style={{ fontSize: '0.66rem', color: '#78350f', marginTop: 1,
                                              display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden',
                                            }}>{r.followUpNotes}</Typography>
                                          </Box>
                                        )}
                                      </Box>

                                      {/* Col 3 — Materials */}
                                      <Box style={{ minWidth: 0 }}>
                                        {materials.length > 0 ? (
                                          <>
                                            <Typography style={LABEL_STYLE}>
                                              {lang === 'pt' ? `Materiais (${materials.length})` : `Materials (${materials.length})`}
                                            </Typography>
                                            <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 3, marginTop: 3 }}>
                                              {materials.map((m, i) => (
                                                <Box key={i} style={{
                                                  padding: '2px 6px', borderRadius: 4,
                                                  background: '#f8fafc', border: '1px solid #e2e8f0',
                                                  fontSize: '0.62rem', color: '#334155',
                                                }}>
                                                  <span style={{ fontWeight: 600 }}>{m.name}</span>
                                                  {m.qty != null && <span style={{ color: '#64748b' }}> · {m.qty}{m.unit ? ` ${m.unit}` : ''}</span>}
                                                </Box>
                                              ))}
                                            </Box>
                                          </>
                                        ) : (
                                          <>
                                            <Typography style={LABEL_STYLE}>{lang === 'pt' ? 'Materiais' : 'Materials'}</Typography>
                                            <Typography style={{ fontSize: '0.64rem', color: '#cbd5e1', marginTop: 2, fontStyle: 'italic' }}>
                                              {lang === 'pt' ? 'Nenhum usado' : 'None used'}
                                            </Typography>
                                          </>
                                        )}
                                      </Box>

                                    </Box>

                                    {/* Row full-width abaixo do grid: assinaturas e fotos.
                                        Sai da Col 4 estreita para ter espaço a horizontal —
                                        3 cartões de assinatura sempre lado a lado e fotos
                                        com tamanho maior. Click amplia em lightbox. */}
                                    {(r.driverSignature || r.customerSignature || r.petrotecSignature || r.customerName || r.petrotecSignerName || photos.length > 0) && (
                                      <Box style={{ marginTop: 12, paddingTop: 10, borderTop: '1px solid #f1f5f9', display: 'grid', gridTemplateColumns: photos.length > 0 ? '1.4fr 1fr' : '1fr', gap: 14, alignItems: 'start' }}>
                                        {/* Assinaturas — 3 cartões lado a lado */}
                                        {(r.driverSignature || r.customerSignature || r.petrotecSignature || r.customerName || r.petrotecSignerName) && (
                                          <Box>
                                            <Typography style={LABEL_STYLE}>{lang === 'pt' ? 'Assinaturas' : 'Signatures'}</Typography>
                                            <Box style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8, marginTop: 6 }}>
                                              {[
                                                { key: 'driver', label: lang === 'pt' ? 'Técnico' : 'Technician', sig: r.driverSignature, name: null, color: '#0284c7' },
                                                { key: 'customer', label: lang === 'pt' ? 'Cliente' : 'Customer', sig: r.customerSignature, name: r.customerName, color: '#475569' },
                                                { key: 'petrotec', label: 'Petrotec', sig: r.petrotecSignature, name: r.petrotecSignerName, color: '#dc2626' },
                                              ].map(sb => (
                                                <Box key={sb.key} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8, padding: '6px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: 110 }}>
                                                  <Typography style={{ fontSize: '0.58rem', fontWeight: 800, color: sb.color, textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>
                                                    {sb.label}
                                                  </Typography>
                                                  {sb.sig ? (
                                                    <Box
                                                      onClick={() => setLightboxSrc(sb.sig)}
                                                      style={{ width: '100%', height: 70, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'zoom-in' }}
                                                    >
                                                      <img src={sb.sig} alt={`assinatura ${sb.label}`}
                                                        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                                                    </Box>
                                                  ) : (
                                                    <Box style={{ width: '100%', height: 70, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#cbd5e1', fontSize: '0.66rem', fontStyle: 'italic', border: '1px dashed #e2e8f0', borderRadius: 4 }}>
                                                      {lang === 'pt' ? 'Sem assinatura' : 'No signature'}
                                                    </Box>
                                                  )}
                                                  {sb.name && (
                                                    <Typography style={{ fontSize: '0.66rem', color: '#0f172a', fontWeight: 700, marginTop: 4, textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
                                                      {sb.name}
                                                    </Typography>
                                                  )}
                                                </Box>
                                              ))}
                                            </Box>
                                          </Box>
                                        )}
                                        {photos.length > 0 && (
                                          <Box>
                                            <Typography style={LABEL_STYLE}>
                                              {lang === 'pt' ? `Fotos (${photos.length})` : `Photos (${photos.length})`}
                                            </Typography>
                                            <Box style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 6 }}>
                                              {photos.map((p, i) => {
                                                const src = p.dataUrl || p.url || '';
                                                if (!src) return null;
                                                return (
                                                  <Box key={i}
                                                    onClick={() => setLightboxSrc(src)}
                                                    style={{ width: 110, height: 110, borderRadius: 8, border: '1px solid #e2e8f0', overflow: 'hidden', cursor: 'zoom-in', flexShrink: 0, position: 'relative', background: '#f8fafc' }}
                                                  >
                                                    <img src={src} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                  </Box>
                                                );
                                              })}
                                            </Box>
                                          </Box>
                                        )}
                                      </Box>
                                    )}
                                  </Box>
                                );
                              })()}

                              {/* Docs + notes row */}
                              <Box style={{ display: 'flex', gap: 10, flex: 1 }}>
                                {/* Documents */}
                                <Box style={{ flex: 1, background: '#fff', borderRadius: 10, padding: '10px 14px', border: '1px solid #e2e8f0', minWidth: 0 }}>
                                  <Typography style={{ fontSize: '0.58rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6 }}>
                                    Documentos ({Array.isArray(order.documents) ? order.documents.length : 0})
                                  </Typography>
                                  {Array.isArray(order.documents) && order.documents.length > 0 ? (
                                    <Box style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                      {order.documents.map(doc => (
                                        <Box key={doc.id}
                                          onClick={() => window.open(doc.url, '_blank')}
                                          style={{
                                            display: 'flex', alignItems: 'center', gap: 6,
                                            padding: '4px 8px', borderRadius: 6, cursor: 'pointer',
                                            background: '#f8fafc', border: '1px solid #e2e8f0',
                                            fontSize: '0.66rem', color: '#3b82f6',
                                          }}>
                                          <AttachFileIcon style={{ fontSize: 12 }} />
                                          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{doc.originalName || doc.filename}</span>
                                        </Box>
                                      ))}
                                    </Box>
                                  ) : (
                                    <Typography style={{ fontSize: '0.64rem', color: '#cbd5e1', fontStyle: 'italic' }}>
                                      Sem documentos anexados
                                    </Typography>
                                  )}
                                </Box>

                                {/* Cargo + notes + agreed price (receita — da OT) */}
                                <Box style={{ flex: 1, background: '#fff', borderRadius: 10, padding: '10px 14px', border: '1px solid #e2e8f0', minWidth: 0 }}>
                                  <Typography style={{ fontSize: '0.58rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6 }}>
                                    Carga · Notas
                                  </Typography>
                                  <Box style={{ display: 'flex', flexDirection: 'column', gap: 2, fontSize: '0.68rem' }}>
                                    {order.cargoDescription && <span style={{ color: '#0f172a' }}>{order.cargoDescription}</span>}
                                    <Box style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 2 }}>
                                      {order.cargoWeight && <span style={{ color: '#64748b' }}>⚖ {order.cargoWeight} kg</span>}
                                      {order.cargoVolume && <span style={{ color: '#64748b' }}>📦 {order.cargoVolume} m³</span>}
                                      {order.cargoPallets && <span style={{ color: '#64748b' }}>🪜 {order.cargoPallets} paletes</span>}
                                      {order.agreedPrice && <span style={{ color: '#15803d', fontWeight: 700 }}>💶 € {Number(order.agreedPrice).toFixed(2)}</span>}
                                    </Box>

                                    {/* Tempo de descarga — visível e editável aqui também */}
                                    <Box style={{
                                      marginTop: 6, padding: '6px 10px',
                                      background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 6,
                                      display: 'flex', alignItems: 'center', gap: 8,
                                    }}>
                                      <Box style={{
                                        width: 22, height: 22, borderRadius: 6,
                                        background: 'linear-gradient(135deg, #f59e0b, #d97706)',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        flexShrink: 0,
                                      }}>
                                        <span style={{ fontSize: 11, color: '#fff' }}>⏱</span>
                                      </Box>
                                      <Box style={{ flex: 1, minWidth: 0 }}>
                                        <Typography style={{ fontSize: '0.6rem', fontWeight: 700, color: '#475569', lineHeight: 1.2 }}>
                                          {lang === 'pt' ? 'Tempo de descarga no destino' : 'Unloading time at destination'}
                                        </Typography>
                                        <Typography style={{ fontSize: '0.56rem', color: '#94a3b8', lineHeight: 1.2 }}>
                                          {lang === 'pt'
                                            ? 'Acrescentado à hora prevista de chegada'
                                            : 'Added to the estimated arrival time'}
                                        </Typography>
                                      </Box>
                                      <input
                                        type="number" min="0" step="5"
                                        value={order.unloadingTime || ''}
                                        onClick={(e) => e.stopPropagation()}
                                        onChange={(e) => {
                                          const v = e.target.value;
                                          const val = v === '' ? null : Math.max(0, parseInt(v));
                                          dispatch(updateOrder({ token, id: oid, data: { unloadingTime: val } }));
                                        }}
                                        onBlur={() => doFetch()}
                                        placeholder="0"
                                        style={{
                                          width: 56, fontSize: '0.74rem', fontWeight: 700,
                                          border: '1px solid #cbd5e1', borderRadius: 6,
                                          padding: '4px 8px', textAlign: 'center',
                                          background: '#fff', color: '#0f172a',
                                        }}
                                      />
                                      <Typography style={{ fontSize: '0.62rem', color: '#64748b', fontWeight: 600 }}>
                                        min
                                      </Typography>
                                    </Box>

                                    {order.notes && (
                                      <Typography style={{ fontSize: '0.64rem', color: '#475569', marginTop: 6, padding: '6px 8px', background: '#fef3c7', borderRadius: 6, borderLeft: '2px solid #f59e0b' }}>
                                        {order.notes}
                                      </Typography>
                                    )}
                                    {!order.cargoDescription && !order.notes && !order.agreedPrice && !order.unloadingTime && (
                                      <Typography style={{ fontSize: '0.64rem', color: '#cbd5e1', fontStyle: 'italic' }}>
                                        Sem detalhes de carga ou notas
                                      </Typography>
                                    )}
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                          );
                          })()}
                        </Collapse>
                      </TableCell>
                    </TableRow>
                    </React.Fragment>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
      )}{/* end viewMode === 'table' */}

      {/* Bulk actions */}
      {selected.length > 0 && (
        <Box style={{
          display: 'flex', alignItems: 'center', gap: 12,
          padding: '8px 24px', background: '#eff6ff', borderTop: '1px solid #bfdbfe',
        }}>
          <Typography style={{ fontSize: '0.78rem', fontWeight: 600, color: '#1e40af' }}>
            {selected.length} {lang === 'pt' ? 'selecionada(s)' : 'selected'}
          </Typography>
          {/* Atribuir veículo (bulk) — botão único que abre o dialog completo.
              O label muda quando todas as OTs seleccionadas já têm veículo+motorista
              e nenhuma tem rota: passa a "Alterar veículo e Planear rota" para
              indicar que o passo seguinte do dialog será a planificação directa.
              O botão "Planificar rota" standalone foi removido — a UI de origem/
              destino vive só dentro do dialog para evitar dois caminhos divergentes. */}
          {canWrite && (() => {
            const selOrders = list.filter(o => selected.includes(o._id || o.id));
            const fullSelection = selOrders.length === selected.length;
            const allHaveVehicle = fullSelection && selOrders.length > 0 && selOrders.every(o => o.vehicleId);
            const allHaveDriver = fullSelection && selOrders.every(o => o.driverId);
            const noneHasRoute = fullSelection && selOrders.every(o => !o.assignedRouteId);
            const readyForRoute = allHaveVehicle && allHaveDriver && noneHasRoute && selected.length >= 1;
            const label = readyForRoute
              ? (lang === 'pt' ? `Alterar veículo e Planear rota (${selected.length})` : `Change vehicle & Plan route (${selected.length})`)
              : (lang === 'pt' ? `Atribuir veículo (${selected.length})` : `Assign vehicle (${selected.length})`);
            const tooltip = readyForRoute
              ? (lang === 'pt'
                  ? 'Todas as ordens já têm veículo/motorista — confirma origem/destino e cria a rota optimizada'
                  : 'All orders already have vehicle/driver — confirm origin/destination and create the optimised route')
              : (lang === 'pt'
                  ? 'Atribuir o mesmo veículo/motorista a todas as ordens seleccionadas'
                  : 'Assign the same vehicle/driver to all selected orders');
            return (
              <Tooltip title={tooltip}>
                <Button size="small" variant="contained"
                  onClick={() => openVehicleAssign(selected[0], true)}
                  startIcon={readyForRoute ? <NearMeIcon style={{ fontSize: 14 }} /> : <LocalShippingIcon style={{ fontSize: 14 }} />}
                  style={{
                    fontSize: '0.72rem', fontWeight: 700, textTransform: 'none',
                    background: readyForRoute
                      ? 'linear-gradient(135deg, #6366f1, #4338ca)'
                      : 'linear-gradient(135deg, #22c55e, #16a34a)',
                    color: '#fff', borderRadius: 8, padding: '5px 14px',
                    boxShadow: readyForRoute
                      ? '0 2px 6px rgba(99,102,241,0.30)'
                      : '0 2px 6px rgba(34,197,94,0.3)',
                  }}>
                  {label}
                </Button>
              </Tooltip>
            );
          })()}
          {/* Removed standalone "Otimizar rota" button — duplicated the
              VRP that already runs inside Atribuir Veículo's "Atribuir e
              planificar" flow. Operators always assign vehicle+driver
              before planning, so the optimiser-only button was redundant. */}
          {(() => {
            // OTs em estado terminal (delivered / cancelled) não podem
            // mudar de estado sem passar por "Reabrir" (admin). Esconde
            // este Select quando todas as selecionadas já estão terminais
            // — evita re-pôr em "Em trânsito" por engano e desalinhar
            // facturação (a Petrotec só facturação após delivered).
            const selectedOrders = list.filter(o => selected.includes(o._id || o.id));
            const TERMINAL = ['delivered', 'cancelled'];
            const allTerminal = selectedOrders.length > 0
              && selectedOrders.every(o => TERMINAL.includes(o.status));
            if (allTerminal) {
              return (
                <Tooltip title={lang === 'pt' ? 'OTs em estado terminal — usa "Reabrir" (admin) para corrigir.' : 'Terminal state — use Reopen (admin).'}>
                  <Box style={{
                    padding: '4px 10px', borderRadius: 8,
                    background: '#f8fafc', border: '1px solid #e2e8f0',
                    color: '#94a3b8', fontSize: '0.7rem', fontWeight: 700,
                    display: 'flex', alignItems: 'center', gap: 6,
                  }}>
                    🔒 {lang === 'pt' ? 'OT concluída — não editável' : 'OT closed — not editable'}
                  </Box>
                </Tooltip>
              );
            }
            return (
              <FormControl variant="outlined" size="small" style={{ minWidth: 140 }}>
                <Select
                  value=""
                  displayEmpty
                  onChange={(e) => {
                    if (!e.target.value) return;
                    const newStatus = e.target.value;
                    Promise.all(selected.map(oid =>
                      dispatch(updateOrder({ token, id: oid, data: { status: newStatus } })).unwrap().catch(() => {})
                    )).then(() => { doFetch(); setSelected([]); });
                  }}
                  style={{ height: 30, fontSize: '0.75rem' }}
                >
                  <MenuItem value="" disabled>{lang === 'pt' ? 'Alterar estado...' : 'Change status...'}</MenuItem>
                  {Object.entries(STATUS_KEYS)
                    // Esconder também as opções 'delivered' e 'cancelled' do
                    // dropdown — só admin via "Reabrir" deve pôr ou tirar
                    // dessas. Permite todas as outras transições válidas.
                    .filter(([key]) => !TERMINAL.includes(key))
                    .map(([key, labelKey]) => (
                      <MenuItem key={key} value={key}>{t(lang, labelKey)}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            );
          })()}
          {canDeleteOrders && (
          <Button size="small" variant="outlined"
            onClick={() => setBulkDeleteConfirm(true)}
            style={{ fontSize: '0.72rem', textTransform: 'none', borderColor: '#fecaca', color: '#dc2626', borderRadius: 8 }}>
            {lang === 'pt' ? 'Eliminar selecionadas' : 'Delete selected'}
          </Button>
          )}
        </Box>
      )}

      {/* Pagination — professional bar with page-size selector */}
      <Box style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '8px 24px', borderTop: '1px solid #e2e8f0', background: '#fafbfc',
        flexWrap: 'wrap', gap: 8,
      }}>
        {/* Left: record info */}
        <Box style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Typography style={{ fontSize: '0.72rem', color: '#64748b' }}>
            {lang === 'pt' ? 'Registos por página' : 'Rows per page'}
          </Typography>
          <Select
            value={pagination.limit >= 999 ? 999 : pagination.limit}
            disableUnderline
            onChange={(e) => {
              dispatch(setLimit(e.target.value));
              dispatch(setPage(1));
            }}
            style={{
              fontSize: '0.78rem', fontWeight: 700, color: '#0f172a',
              background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8,
              padding: '0 8px', height: 30,
            }}
            MenuProps={{ PaperProps: { style: { borderRadius: 10 } } }}
          >
            {[10, 25, 50, 100].map(n => (
              <MenuItem key={n} value={n} style={{ fontSize: '0.78rem' }}>{n}</MenuItem>
            ))}
            <MenuItem value={999} style={{ fontSize: '0.78rem' }}>{lang === 'pt' ? 'Todas' : 'All'}</MenuItem>
          </Select>
          <Typography style={{ fontSize: '0.72rem', color: '#94a3b8' }}>
            {(() => {
              const total = pagination.total || list.length;
              const from = Math.min((pagination.page - 1) * pagination.limit + 1, total);
              const to = Math.min(pagination.page * pagination.limit, total);
              return `${from}–${to} ${lang === 'pt' ? 'de' : 'of'} ${total}`;
            })()}
          </Typography>
        </Box>

        {/* Right: page navigation */}
        <Box style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          {/* First page */}
          <IconButton size="small" disabled={pagination.page <= 1}
            onClick={() => dispatch(setPage(1))}
            style={{ padding: 4, color: pagination.page > 1 ? '#475569' : '#cbd5e1' }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"/></svg>
          </IconButton>
          {/* Previous */}
          <IconButton size="small" disabled={pagination.page <= 1}
            onClick={() => dispatch(setPage(pagination.page - 1))}
            style={{ padding: 4, color: pagination.page > 1 ? '#475569' : '#cbd5e1' }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
          </IconButton>
          {/* Page indicator */}
          <Box style={{
            display: 'flex', alignItems: 'center', gap: 2,
            padding: '0 8px', minWidth: 80, justifyContent: 'center',
          }}>
            <Typography style={{ fontSize: '0.78rem', fontWeight: 700, color: '#0f172a' }}>
              {pagination.page}
            </Typography>
            <Typography style={{ fontSize: '0.68rem', color: '#94a3b8' }}>
              / {pagination.totalPages || 1}
            </Typography>
          </Box>
          {/* Next */}
          <IconButton size="small" disabled={pagination.page >= pagination.totalPages}
            onClick={() => dispatch(setPage(pagination.page + 1))}
            style={{ padding: 4, color: pagination.page < pagination.totalPages ? '#475569' : '#cbd5e1' }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
          </IconButton>
          {/* Last page */}
          <IconButton size="small" disabled={pagination.page >= pagination.totalPages}
            onClick={() => dispatch(setPage(pagination.totalPages))}
            style={{ padding: 4, color: pagination.page < pagination.totalPages ? '#475569' : '#cbd5e1' }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"/></svg>
          </IconButton>
        </Box>
      </Box>

      {/* Order Form Modal */}
      <OrderForm
        open={formOpen}
        onClose={(refresh) => { handleFormClose(refresh); setViewOnlyOrder(false); }}
        order={editOrder}
        lang={lang}
        viewOnly={viewOnlyOrder}
      />

      {/* Wizard dedicado — só Move Express. Não toca no OrderForm.
          Suporta criação (editOrder=null) e edição (editOrder=OT actual). */}
      <FuelOrderWizard
        open={fuelWizardOpen}
        editOrder={editOrder}
        viewOnly={fuelWizardViewOnly}
        lang={lang}
        onClose={(refresh) => {
          setFuelWizardOpen(false);
          setEditOrder(null);
          setFuelWizardViewOnly(false);
          if (refresh) refreshOrders();
        }}
      />

      {/* Import de guias → OTs (Casais / variante mercadoria). */}
      <ImportGuiasDialog
        open={showImportGuias}
        lang={lang}
        onClose={() => setShowImportGuias(false)}
        onImported={() => { refreshOrders(); }}
      />

      {/* Despacho rápido de OT automática (Casais) — confirmação + resultado */}
      <ConfirmDialog
        open={!!quickDispatchOT}
        onClose={() => { if (!quickDispatchBusy) setQuickDispatchOT(null); }}
        onConfirm={() => doQuickDispatch(quickDispatchOT?.ot)}
        title={lang === 'pt' ? 'Despachar para a app do motorista?' : 'Dispatch to driver app?'}
        message={lang === 'pt'
          ? `A rota da ${quickDispatchOT?.ot?.orderNumber || 'OT'} vai ser enviada para a app do motorista (fica em "planeada"). Confirmas?`
          : 'The route will be sent to the driver app.'}
        confirmLabel={lang === 'pt' ? 'Despachar' : 'Dispatch'}
        cancelLabel={lang === 'pt' ? 'Cancelar' : 'Cancel'}
        severity="info"
      />
      <ConfirmDialog
        open={!!quickDispatchAlert}
        onClose={() => setQuickDispatchAlert(null)}
        title={lang === 'pt' ? 'Despacho' : 'Dispatch'}
        message={quickDispatchAlert || ''}
      />

      {/* Dialog temporário — Dashboard ainda não disponível ao cliente.
          Remover este Dialog (e voltar ao setActiveView('fuel-ops') no botão)
          quando a feature for validada pelo operador. */}
      <Dialog
        open={dashboardWipOpen}
        onClose={() => setDashboardWipOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ style: { borderRadius: 14, overflow: 'hidden' } }}
      >
        <Box style={{
          padding: '18px 22px',
          background: 'linear-gradient(135deg, #fff7ed 0%, #ffffff 60%)',
          borderBottom: '1px solid #fed7aa',
          display: 'flex', alignItems: 'center', gap: 12,
        }}>
          <Box style={{
            width: 40, height: 40, borderRadius: 10,
            background: '#fff', border: '1px solid #fed7aa', color: '#ea580c',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <DashboardIcon style={{ fontSize: 22 }} />
          </Box>
          <Box style={{ flex: 1 }}>
            <Typography style={{ fontSize: '1.02rem', fontWeight: 800, color: '#9a3412', letterSpacing: '-0.005em' }}>
              {lang === 'pt' ? 'Dashboard em desenvolvimento' : 'Dashboard in development'}
            </Typography>
            <Typography style={{ fontSize: '0.62rem', fontWeight: 800, color: '#c2410c', textTransform: 'uppercase', letterSpacing: 0.5, marginTop: 2 }}>
              {lang === 'pt' ? 'Em breve' : 'Coming soon'}
            </Typography>
          </Box>
        </Box>
        <Box style={{ padding: '20px 22px', background: '#fafafa' }}>
          <Typography style={{ fontSize: '0.86rem', color: '#475569', lineHeight: 1.55 }}>
            {lang === 'pt'
              ? 'Os indicadores operacionais (taxa de utilização, litros carregados, entregas por posto…) estão a ser finalizados. Esta secção será activada após validação interna.'
              : 'The operational indicators (utilization rate, loaded litres, deliveries by station…) are being finalised. This section will be enabled after internal validation.'}
          </Typography>
          <Box style={{
            marginTop: 14, padding: '10px 12px',
            background: '#fff7ed', border: '1px dashed #fdba74',
            borderRadius: 8,
            fontSize: '0.74rem', color: '#9a3412',
          }}>
            <strong>{lang === 'pt' ? 'O que vai incluir:' : 'Will include:'}</strong>
            <ul style={{ margin: '6px 0 0', paddingLeft: 18, lineHeight: 1.55 }}>
              <li>{lang === 'pt' ? 'Taxa de utilização das viaturas' : 'Vehicle utilization rate'}</li>
              <li>{lang === 'pt' ? 'Média de paragens por rota' : 'Average stops per route'}</li>
              <li>{lang === 'pt' ? 'Litros carregados por terminal (TCPL, IBV…)' : 'Loaded litres by terminal (TCPL, IBV…)'}</li>
              <li>{lang === 'pt' ? 'Litros entregues por posto e cliente final' : 'Delivered litres by station and final customer'}</li>
            </ul>
          </Box>
        </Box>
        <Box style={{
          padding: '12px 22px', background: '#fff',
          borderTop: '1px solid #e2e8f0',
          display: 'flex', justifyContent: 'flex-end',
        }}>
          <Button
            onClick={() => setDashboardWipOpen(false)}
            variant="contained"
            style={{
              textTransform: 'none', fontWeight: 700,
              background: 'linear-gradient(135deg, #fb923c, #f97316)',
              color: '#fff',
              padding: '6px 22px', borderRadius: 8,
              boxShadow: '0 2px 6px rgba(249,115,22,0.25)',
            }}
          >
            {lang === 'pt' ? 'Compreendi' : 'Got it'}
          </Button>
        </Box>
      </Dialog>

      {/* Dialog de selecção de cisterna — popup profissional para escolher
          a cisterna atrelada ao tractor (Move Express). */}
      <Dialog
        open={cisternPickerOpen}
        onClose={() => setCisternPickerOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ style: { borderRadius: 14, overflow: 'hidden', maxHeight: '85vh' } }}
      >
        {(() => {
          const currentOT = list.find(o => String(o._id || o.id) === String(vehicleAssignOrderId));
          const cisterns = (allVehicles || []).filter(v => v.vehicleKind === 'trailer_cistern');
          const wantedCap = currentOT?.cisternCapacityM3 != null ? Number(currentOT.cisternCapacityM3) : null;
          const q = String(cisternSearch || '').trim().toLowerCase();
          const filtered = cisterns.filter(c => {
            if (!q) return true;
            return String(c.plate || '').toLowerCase().includes(q)
              || String(c.name || '').toLowerCase().includes(q)
              || String(c.model || '').toLowerCase().includes(q)
              || String(c.cisternCapacityM3 || '').includes(q);
          });
          const sorted = [...filtered].sort((a, b) => {
            const am = wantedCap != null && Number(a.cisternCapacityM3) === wantedCap ? 0 : 1;
            const bm = wantedCap != null && Number(b.cisternCapacityM3) === wantedCap ? 0 : 1;
            if (am !== bm) return am - bm;
            return String(a.plate || a.name || '').localeCompare(String(b.plate || b.name || ''));
          });
          const matching = wantedCap != null ? sorted.filter(c => Number(c.cisternCapacityM3) === wantedCap).length : 0;
          return (
            <>
              {/* Header */}
              <Box style={{
                background: 'linear-gradient(135deg, #fff7ed 0%, #ffffff 60%)',
                borderBottom: '1px solid #fed7aa',
                padding: '16px 22px',
                display: 'flex', alignItems: 'center', gap: 14,
              }}>
                <Box style={{
                  width: 38, height: 38, borderRadius: 10,
                  background: '#fff', border: '1px solid #fed7aa', color: '#ea580c',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 20,
                }}>🛢</Box>
                <Box style={{ flex: 1 }}>
                  <Typography style={{ fontSize: '1.02rem', fontWeight: 800, color: '#9a3412', letterSpacing: '-0.005em' }}>
                    {lang === 'pt' ? 'Escolher cisternas atreladas' : 'Select attached cisterns'} <span style={{ fontSize: '0.72rem', fontWeight: 800, color: '#c2410c' }}>· {lang === 'pt' ? 'até 2' : 'up to 2'} ({selectedCisternIds.length}/2)</span>
                  </Typography>
                  <Typography style={{ fontSize: '0.62rem', fontWeight: 800, color: '#c2410c', textTransform: 'uppercase', letterSpacing: 0.5, marginTop: 2 }}>
                    {lang === 'pt'
                      ? (wantedCap != null
                          ? `Pedido: ${wantedCap} m³ · ${matching} compatível${matching !== 1 ? 'is' : ''} · ${cisterns.length} cisterna${cisterns.length !== 1 ? 's' : ''} no total`
                          : `${cisterns.length} cisterna${cisterns.length !== 1 ? 's' : ''} no total`)
                      : (wantedCap != null
                          ? `Requested: ${wantedCap} m³ · ${matching} matching · ${cisterns.length} cistern${cisterns.length !== 1 ? 's' : ''} total`
                          : `${cisterns.length} cistern${cisterns.length !== 1 ? 's' : ''} total`)}
                  </Typography>
                </Box>
                <IconButton size="small" onClick={() => setCisternPickerOpen(false)}>
                  <CloseIcon style={{ fontSize: 18 }} />
                </IconButton>
              </Box>

              {/* Search */}
              <Box style={{ padding: '14px 22px', background: '#fafafa', borderBottom: '1px solid #f1f5f9' }}>
                <Box style={{
                  background: '#fff', border: '1.5px solid #fed7aa', borderRadius: 10,
                  display: 'flex', alignItems: 'center', gap: 8, padding: '6px 12px',
                }}>
                  <SearchIcon style={{ fontSize: 18, color: '#fb923c' }} />
                  <input
                    type="text"
                    value={cisternSearch}
                    onChange={e => setCisternSearch(e.target.value)}
                    placeholder={lang === 'pt' ? 'Pesquisar matrícula, modelo ou capacidade…' : 'Search plate, model or capacity…'}
                    autoFocus
                    style={{
                      border: 'none', outline: 'none', flex: 1,
                      fontSize: '0.86rem', background: 'transparent',
                      color: '#0f172a', fontFamily: 'inherit',
                    }}
                  />
                  {cisternSearch && (
                    <CloseIcon onClick={() => setCisternSearch('')}
                      style={{ fontSize: 16, color: '#94a3b8', cursor: 'pointer' }} />
                  )}
                  <span style={{
                    fontSize: '0.66rem', color: '#94a3b8', fontWeight: 800,
                    fontFamily: 'ui-monospace, Menlo, monospace',
                    padding: '2px 8px', background: '#f1f5f9', borderRadius: 999,
                  }}>
                    {sorted.length}/{cisterns.length}
                  </span>
                </Box>
              </Box>

              {/* Lista */}
              <Box style={{ padding: '8px 14px', overflowY: 'auto', maxHeight: '52vh', background: '#fafafa' }}>
                {sorted.length === 0 ? (
                  <Box style={{ padding: '40px 20px', textAlign: 'center' }}>
                    <Typography style={{ fontSize: '0.86rem', color: '#94a3b8', fontStyle: 'italic' }}>
                      {lang === 'pt' ? 'Sem cisternas para a pesquisa.' : 'No cisterns match the search.'}
                    </Typography>
                  </Box>
                ) : sorted.map(c => {
                  const isSel = selectedCisternIds.includes(String(c.id));
                  const matchesCap = wantedCap != null && Number(c.cisternCapacityM3) === wantedCap;
                  return (
                    <Box key={c.id}
                      onClick={() => {
                        // Toggle (máx 2). NÃO fecha o picker — permite escolher a
                        // 2ª cisterna. O operador fecha em "Fechar". Ao exceder 2,
                        // substitui a mais antiga.
                        setSelectedCisternIds(prev => {
                          const id = String(c.id);
                          if (prev.includes(id)) return prev.filter(x => x !== id);
                          if (prev.length >= 2) return [prev[1], id];
                          return [...prev, id];
                        });
                      }}
                      style={{
                        display: 'flex', alignItems: 'center', gap: 12,
                        padding: '12px 14px', borderRadius: 10,
                        background: isSel ? 'linear-gradient(135deg, #f97316, #ea580c)' : '#fff',
                        border: `1.5px solid ${isSel ? '#ea580c' : (matchesCap ? '#bbf7d0' : '#e2e8f0')}`,
                        color: isSel ? '#fff' : '#0f172a',
                        boxShadow: isSel ? '0 4px 12px rgba(234,88,12,0.30)' : '0 1px 2px rgba(15,23,42,0.03)',
                        marginBottom: 6,
                        cursor: 'pointer',
                        transition: 'all 0.12s',
                      }}
                      onMouseEnter={e => {
                        if (!isSel) {
                          e.currentTarget.style.borderColor = matchesCap ? '#15803d' : '#fb923c';
                          e.currentTarget.style.transform = 'translateY(-1px)';
                          e.currentTarget.style.boxShadow = '0 4px 10px rgba(15,23,42,0.06)';
                        }
                      }}
                      onMouseLeave={e => {
                        if (!isSel) {
                          e.currentTarget.style.borderColor = matchesCap ? '#bbf7d0' : '#e2e8f0';
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 1px 2px rgba(15,23,42,0.03)';
                        }
                      }}>
                      <Box style={{
                        width: 36, height: 36, borderRadius: 8,
                        background: isSel ? 'rgba(255,255,255,0.18)' : (matchesCap ? '#dcfce7' : '#f1f5f9'),
                        color: isSel ? '#fff' : (matchesCap ? '#15803d' : '#64748b'),
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 18, flexShrink: 0,
                      }}>🛢</Box>
                      <Box style={{ flex: 1, minWidth: 0 }}>
                        <Typography style={{
                          fontSize: '0.94rem', fontWeight: 800,
                          fontFamily: 'ui-monospace, Menlo, monospace',
                          letterSpacing: '-0.01em',
                        }}>
                          {c.plate || c.name}
                        </Typography>
                        <Typography style={{
                          fontSize: '0.7rem', opacity: isSel ? 0.92 : 0.65,
                          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                          marginTop: 1,
                        }}>
                          {c.model || '—'}
                        </Typography>
                      </Box>
                      <Box style={{
                        padding: '5px 14px', borderRadius: 999,
                        background: isSel ? 'rgba(255,255,255,0.22)' : (matchesCap ? '#16a34a' : '#f1f5f9'),
                        color: isSel ? '#fff' : (matchesCap ? '#fff' : '#475569'),
                        fontSize: '0.78rem', fontWeight: 800,
                        fontFamily: 'ui-monospace, Menlo, monospace',
                      }}>
                        {c.cisternCapacityM3 != null ? `${c.cisternCapacityM3} m³` : '—'}
                      </Box>
                      {isSel && <CheckCircleIcon style={{ fontSize: 22 }} />}
                    </Box>
                  );
                })}
              </Box>

              {/* Footer */}
              <Box style={{
                padding: '12px 22px', background: '#fff',
                borderTop: '1px solid #e2e8f0',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              }}>
                <Typography style={{ fontSize: '0.7rem', color: '#94a3b8' }}>
                  {lang === 'pt'
                    ? 'As cisternas com capacidade pedida aparecem primeiro (border verde).'
                    : 'Cisterns matching the requested capacity appear first (green border).'}
                </Typography>
                <Button onClick={() => setCisternPickerOpen(false)} style={{ textTransform: 'none', color: '#64748b' }}>
                  {lang === 'pt' ? 'Fechar' : 'Close'}
                </Button>
              </Box>
            </>
          );
        })()}
      </Dialog>

      {/* Delivery report viewer — popup profissional para ordens entregues. */}
      {/* Relatório: OT de combustível usa o relatório de entrega dedicado
          (FuelDeliveryReport); os outros tipos usam o genérico. */}
      {(() => {
        const reportOrder = (list || []).find(o => String(o._id || o.id) === String(reportOrderId));
        if (reportOrder?.serviceType === 'fuel') {
          return (
            <FuelDeliveryReport
              open={!!reportOrderId}
              order={reportOrder}
              lang={lang}
              onClose={() => setReportOrderId(null)}
            />
          );
        }
        return (
          <OrderReportDialog
            open={!!reportOrderId}
            orderId={reportOrderId}
            onClose={() => setReportOrderId(null)}
          />
        );
      })()}

      {/* Mão-de-obra (Petrotec AO) — repartição de horas por código contabilístico */}
      <OrderLaborDialog
        open={!!laborDialog}
        orderId={laborDialog?.orderId}
        orderRef={laborDialog?.orderRef}
        lang={lang}
        onClose={() => setLaborDialog(null)}
      />

      {/* Assign to Vehicle Dialog — split layout with integrated map + street view */}
      {vehicleAssignOrderId && (() => {
        const currentOT = list.find(o => String(o._id || o.id) === String(vehicleAssignOrderId));
        const isAlreadyAssigned = currentOT?.status === 'assigned' || !!currentOT?.vehiclePlate;
        const dialogTitle = isAlreadyAssigned
          ? (lang === 'pt' ? 'Alterar Veículo' : 'Change Vehicle')
          : (lang === 'pt' ? 'Atribuir Veículo' : 'Assign Vehicle');
        return (
        <>
          <Box style={{ position: 'fixed', inset: 0, zIndex: 1200, background: 'rgba(15,23,42,0.5)', backdropFilter: 'blur(2px)' }}
            onClick={() => setVehicleAssignOrderId(null)} />
          <Box ref={vehicleDragRef} style={{
            position: 'fixed',
            // Default position: sit above the planner header (top 50px)
            // and use most of the available height. Wider (1700px capped
            // at 100vw - 24px) and taller (calc(100vh - 70px)) so the
            // map breathes and the vehicle list shows more rows.
            ...(vehicleDialogPos
              ? { top: vehicleDialogPos.top, left: vehicleDialogPos.left, transform: 'none' }
              : { top: 50, left: '50%', transform: 'translateX(-50%)' }),
            zIndex: 1201,
            width: 1700, maxWidth: 'calc(100vw - 24px)',
            height: 'calc(100vh - 70px)', maxHeight: 'calc(100vh - 70px)',
            background: '#fff', borderRadius: 16, boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
            display: 'flex', flexDirection: 'column', overflow: 'hidden',
          }}>
            {/* Header — draggable */}
            <Box
              onMouseDown={handleVehicleDialogDragStart}
              style={{
                padding: '8px 16px', display: 'flex', alignItems: 'center', gap: 10,
                background: 'linear-gradient(180deg, #fff 0%, #dbeafe 100%)', borderBottom: '1px solid #bfdbfe',
                cursor: 'move', userSelect: 'none',
                flexShrink: 0,
              }}>
              <Box style={{ width: 28, height: 28, borderRadius: 8, background: 'linear-gradient(135deg, #22c55e, #16a34a)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 8px rgba(34,197,94,0.3)', flexShrink: 0 }}>
                <LocalShippingIcon style={{ fontSize: 14, color: '#fff' }} />
              </Box>
              <Box style={{ minWidth: 0 }}>
                <Typography style={{ fontSize: '0.84rem', fontWeight: 800, color: '#1e40af', lineHeight: 1.1 }}>
                  {dialogTitle}
                </Typography>
                {currentOT && (
                  <Typography style={{ fontSize: '0.66rem', color: '#475569', fontWeight: 700 }}
                    title={otTooltip(currentOT)}>
                    {otLabel(currentOT)}
                    {currentOT.serviceType && (
                      <span style={{ marginLeft: 6, fontSize: '0.58rem', fontWeight: 700, padding: '1px 6px', borderRadius: 4, background: currentOT.serviceType === 'assistance' ? '#dcfce7' : currentOT.serviceType === 'fuel' ? '#fef3c7' : '#dbeafe', color: currentOT.serviceType === 'assistance' ? '#166534' : currentOT.serviceType === 'fuel' ? '#92400e' : '#1e40af' }}>
                        {currentOT.serviceType === 'assistance' ? '🔧 Assistência' : currentOT.serviceType === 'fuel' ? '⛽ Combustível' : '📦 Entrega'}
                      </span>
                    )}
                  </Typography>
                )}
              </Box>
              {/* Mid-header context — compact pickup/delivery + meta chips.
                  Tighter than the previous version so the header stays
                  scannable; the full text is in the OT's row in the orders
                  list anyway. */}
              {currentOT && (
                <Box style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 6, marginLeft: 10, minWidth: 0, overflow: 'hidden' }}>
                  {/* Assistance OTs only have a single relevant location —
                      the service site. Pickup = origin (driver home / GPS)
                      and destination = next service or driver home, both
                      decided at route planning, not at OT level. So showing
                      pickup→delivery here makes no sense and risks showing
                      the same address twice. */}
                  {currentOT.serviceType === 'assistance' ? (
                    <Box style={{ background: '#ecfdf5', border: '1px solid #a7f3d0', borderRadius: 6, padding: '2px 8px', minWidth: 0, flex: 1, display: 'flex', alignItems: 'center', gap: 6 }}>
                      <span style={{ fontSize: 11 }}>🔧</span>
                      <Typography style={{ fontSize: '0.6rem', fontWeight: 800, color: '#065f46', textTransform: 'uppercase', letterSpacing: '0.04em', flexShrink: 0 }}>
                        {lang === 'pt' ? 'Local serviço' : 'Service site'}
                      </Typography>
                      <Typography noWrap style={{ fontSize: '0.66rem', fontWeight: 700, color: '#064e3b' }}>
                        {currentOT.deliveryName || currentOT.deliveryAddress || '—'}
                      </Typography>
                    </Box>
                  ) : (
                    <>
                      <Box style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, padding: '2px 8px', minWidth: 0, flex: 1, display: 'flex', alignItems: 'center', gap: 4 }}>
                        <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#22c55e', flexShrink: 0 }} />
                        <Typography noWrap style={{ fontSize: '0.66rem', fontWeight: 700, color: '#14532d' }}>
                          {currentOT.pickupName || currentOT.pickupAddress || '—'}
                        </Typography>
                      </Box>
                      <Box style={{ color: '#94a3b8', fontSize: 12, flexShrink: 0 }}>→</Box>
                      <Box style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 6, padding: '2px 8px', minWidth: 0, flex: 1, display: 'flex', alignItems: 'center', gap: 4 }}>
                        <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#ef4444', flexShrink: 0 }} />
                        <Typography noWrap style={{ fontSize: '0.66rem', fontWeight: 700, color: '#7f1d1d' }}>
                          {currentOT.deliveryName || currentOT.deliveryAddress || '—'}
                        </Typography>
                      </Box>
                    </>
                  )}
                  {currentOT.deliveryWindowFrom && (
                    <Box style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 5, padding: '2px 6px', flexShrink: 0, fontSize: '0.6rem', fontWeight: 700, color: '#1e40af' }}>
                      🕐 {new Date(currentOT.deliveryWindowFrom).toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' })}
                      {currentOT.deliveryWindowTo ? `–${new Date(currentOT.deliveryWindowTo).toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' })}` : ''}
                    </Box>
                  )}
                  {currentOT.slaHours != null && (
                    <Box style={{ background: '#fef3c7', border: '1px solid #fde68a', borderRadius: 5, padding: '2px 6px', flexShrink: 0, fontSize: '0.6rem', fontWeight: 700, color: '#92400e' }}>
                      SLA {currentOT.slaHours}h
                    </Box>
                  )}
                  {/* Driver chip — visible only when the OT already has an
                      assigned driver. Pulls name/phone/tacho-card from the
                      local drivers cache so we show a useful subtitle. */}
                  {(currentOT.driverId || currentOT.driverName) && (() => {
                    const drv = currentOT.driverId
                      ? allDrivers.find(d => Number(d.id) === Number(currentOT.driverId))
                      : null;
                    const drvName = drv?.name || currentOT.driverName || '';
                    const drvPhone = drv?.phone || null;
                    const drvTacho = !!(drv?.tachoCard);
                    return (
                      <Box style={{ background: '#ede9fe', border: '1px solid #ddd6fe', borderRadius: 5, padding: '2px 8px', flexShrink: 0, display: 'flex', alignItems: 'center', gap: 6 }}>
                        <span style={{ fontSize: 11 }}>👤</span>
                        <Typography style={{ fontSize: '0.66rem', fontWeight: 700, color: '#5b21b6' }}>
                          {drvName.split(/\s+/).slice(0, 2).join(' ') || '—'}
                        </Typography>
                        {drvPhone && (
                          <Typography style={{ fontSize: '0.58rem', color: '#7c3aed', fontFamily: 'Roboto Mono, monospace' }}>
                            📞 {drvPhone}
                          </Typography>
                        )}
                        {drvTacho && (
                          <Tooltip title={lang === 'pt' ? 'Cartão tacógrafo registado' : 'Tacho card registered'}>
                            <span style={{ fontSize: '0.55rem', fontWeight: 800, padding: '1px 5px', borderRadius: 3, background: '#7c3aed', color: '#fff' }}>TACHO</span>
                          </Tooltip>
                        )}
                      </Box>
                    );
                  })()}
                  {currentOT.vehiclePlate && (
                    <Box style={{ background: '#dbeafe', border: '1px solid #bfdbfe', borderRadius: 5, padding: '2px 8px', flexShrink: 0, display: 'flex', alignItems: 'center', gap: 4 }}>
                      <span style={{ fontSize: 11 }}>🚛</span>
                      <Typography style={{ fontSize: '0.66rem', fontWeight: 800, color: '#1e40af', fontFamily: 'Roboto Mono, monospace' }}>
                        {currentOT.vehiclePlate}
                      </Typography>
                    </Box>
                  )}
                </Box>
              )}
              {/* "Retirar atribuição" — opens a polished confirmation dialog
                  (no native window.confirm). After the unassign succeeds we
                  STAY in the assign dialog with the OT now in "pending"
                  state, so the operator can immediately pick a new vehicle. */}
              {isAlreadyAssigned && (
                <Tooltip title={lang === 'pt'
                  ? `Retirar atribuição actual (${currentOT?.vehiclePlate || ''}${currentOT?.driverName ? ' · ' + currentOT.driverName : ''})`
                  : 'Remove current assignment'}>
                  <Button
                    size="small"
                    onMouseDown={e => e.stopPropagation()}
                    onClick={() => setUnassignConfirm({
                      orderId: currentOT?.id,
                      vehiclePlate: currentOT?.vehiclePlate,
                      driverName: currentOT?.driverName,
                      orderNumber: currentOT?.orderNumber,
                    })}
                    style={{
                      fontSize: '0.7rem', fontWeight: 700, textTransform: 'none',
                      color: '#991b1b', background: '#fee2e2',
                      border: '1px solid #fecaca', borderRadius: 8,
                      padding: '4px 12px', flexShrink: 0,
                      marginRight: 4,
                    }}>
                    🗑 {lang === 'pt' ? 'Retirar atribuição' : 'Remove assignment'}
                  </Button>
                </Tooltip>
              )}
              <Tooltip title={lang === 'pt' ? 'Arrastar para mover' : 'Drag to move'}>
                <Box style={{ padding: '4px 8px', color: '#94a3b8', fontSize: 18, lineHeight: 1, flexShrink: 0 }}>⋮⋮</Box>
              </Tooltip>
              <Tooltip title={lang === 'pt' ? 'Fechar' : 'Close'}>
                <IconButton size="small" onClick={() => setVehicleAssignOrderId(null)} onMouseDown={e => e.stopPropagation()}>
                  <CloseIcon style={{ fontSize: 18, color: '#64748b' }} />
                </IconButton>
              </Tooltip>
            </Box>

            {/* Toolbar — runs full-width below the header. Holds the
                departure picker, filter chips, search and driver
                suggestions so they don't crowd the vehicle list panel. */}
            <Box style={{
              flexShrink: 0, padding: '10px 16px',
              background: 'linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)',
              borderBottom: '1px solid #e2e8f0',
              display: 'flex', flexDirection: 'column', gap: 8,
            }}>
            {/* Warning */}
            {vehicleAssignWarning && (
              <Box style={{ margin: '12px 20px 0', padding: '8px 14px', background: '#fef3c7', border: '1px solid #fde68a', borderRadius: 8 }}>
                <Typography style={{ fontSize: '0.72rem', color: '#92400e', fontWeight: 600 }}>
                  ⚠ {vehicleAssignWarning}
                </Typography>
                <Typography style={{ fontSize: '0.62rem', color: '#a16207', marginTop: 2 }}>
                  {lang === 'pt' ? 'Pode continuar, mas verifique se é necessário.' : 'You can proceed, but please verify.'}
                </Typography>
              </Box>
            )}

            {/* OT context — janela e SLA já vivem no header do dialog. Aqui
                fica apenas a duração estimada de condução (vem do backend
                e é específica deste planeamento), quando disponível. */}
            {otAvailContext?.durationMin && (
              <Box style={{ margin: '10px 16px 0', padding: '6px 10px', background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 12 }}>⏱</span>
                <Typography style={{ fontSize: '0.66rem', fontWeight: 700, color: '#9a3412' }}>
                  {lang === 'pt'
                    ? `Duração estimada: ${Math.floor(otAvailContext.durationMin / 60)}h${String(otAvailContext.durationMin % 60).padStart(2, '0')} de condução`
                    : `Estimated drive: ${Math.floor(otAvailContext.durationMin / 60)}h${String(otAvailContext.durationMin % 60).padStart(2, '0')}`}
                </Typography>
              </Box>
            )}

            {/* 3-column row: [Departure picker] | [Filters + Search] | [Suggestions]
                Keeps everything visible without stacking, freeing vertical
                space for the map and vehicle list. (Unloading time was
                moved down next to the driver picker — see footer.) */}
            {(() => {
              // Availability predicate — prefers the backend's schedule-aware flag
              // `availableForOT` when present (set when the endpoint is called with
              // ?orderId=X). Falls back to the frontend heuristic when the backend
              // didn't compute the flag (null).
              function isVehicleAvailableForOT(v) {
                if (v.availableForOT === true) return true;
                if (v.availableForOT === false) return false;
                // Fallback heuristic (backward compatible with old responses)
                if (!v.available) return false;
                if (!v.driver && !v.tacho?.driverName) return false;
                const cond = v.driverCondition;
                if (cond === 'driving' || cond === 'exceeded' || cond === 'resting') return false;
                const act = v.tacho?.activity;
                if (act === 'Condução' || act === 'Descanso') return false;
                if (v.tacho?.dailyDriveMin != null && v.tacho.dailyDriveMin >= 480) return false;
                return true;
              }
              // Haversine distance from the pickup point (in km) — used for the "inside circle" filter.
              const pickupForDist = window.__otPickupPoint;
              function distanceToPickup(v) {
                if (!pickupForDist || !v.position) return Infinity;
                const R = 6371;
                const toRad = (d) => d * Math.PI / 180;
                const dLat = toRad(v.position.latitude - pickupForDist.lat);
                const dLng = toRad(v.position.longitude - pickupForDist.lng);
                const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(pickupForDist.lat)) * Math.cos(toRad(v.position.latitude)) * Math.sin(dLng / 2) ** 2;
                return 2 * R * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
              }
              function isInsideCircle(v) {
                return distanceToPickup(v) <= vehicleAssignRadiusKm;
              }
              const totalCount = availableVehicles.length;
              const tachoCount = availableVehicles.filter(v => v.driver || v.tacho?.driverName).length;
              const availCount = availableVehicles.filter(isVehicleAvailableForOT).length;
              const insideCount = availableVehicles.filter(isInsideCircle).length;
              // Petrotec AO — filtro extra "Com stock": viaturas que têm pelo
              // menos 1 referência material disponível. Só visível se a OT é AO.
              const otForFilters = list.find(o => String(o._id || o.id) === String(vehicleAssignOrderId));
              const isPetrotecAOFilter = !!otForFilters?.finalCustomerId;
              const stockCount = isPetrotecAOFilter
                ? availableVehicles.filter(v => (vehicleStockMap[v.id]?.items || 0) > 0).length
                : 0;
              // Hide tacho-specific filters when the tenant isn't using a tachograph
              const tachoEnabled = clientSettings?.useTachograph !== false;
              const filtersMeta = [
                { id: 'inside', label: lang === 'pt' ? `Dentro do círculo (${vehicleAssignRadiusKm} km)` : `Inside circle (${vehicleAssignRadiusKm} km)`, color: '#3b82f6', count: insideCount,
                  tip: lang === 'pt'
                    ? `Apenas veículos a menos de ${vehicleAssignRadiusKm} km do ponto de recolha. Ajusta o raio no mapa à direita.`
                    : `Only vehicles within ${vehicleAssignRadiusKm} km of the pickup point. Adjust the radius on the map.` },
                tachoEnabled && { id: 'tacho', label: lang === 'pt' ? 'Com tacógrafo' : 'With tacho', color: '#8b5cf6', count: tachoCount,
                  tip: lang === 'pt' ? 'Apenas veículos com motorista (cartão ou associado na BD)' : 'Only vehicles with driver (card or DB-associated)' },
                { id: 'available', label: lang === 'pt' ? 'Disponíveis' : 'Available', color: '#22c55e', count: availCount,
                  tip: lang === 'pt'
                    ? 'Disponibilidade real para esta OT: sem OTs activas + sem conflito horário com outras OTs planeadas + motorista com cartão + não está em condução/descanso/limite + tempo de condução restante ≥ duração da OT'
                    : 'Real availability for this OT: no active OTs + no schedule conflict with other planned OTs + has driver card + not driving/resting/exceeded + remaining drive time ≥ OT duration' },
                // Petrotec AO — filtro de stock só aparece em OTs AO. PT nem
                // vê este chip nem o respectivo modo de filtragem.
                isPetrotecAOFilter && { id: 'stock', label: lang === 'pt' ? '📦 Com stock' : '📦 With stock', color: '#16a34a', count: stockCount,
                  tip: lang === 'pt'
                    ? 'Apenas viaturas com pelo menos 1 referência de material disponível. Útil para garantir que o técnico vai com peças.'
                    : 'Only vehicles with at least 1 material reference. Helps ensure the technician has parts.' },
                { id: 'all', label: lang === 'pt' ? 'Todos' : 'All', color: '#64748b', count: totalCount,
                  tip: lang === 'pt' ? 'Toda a frota' : 'Entire fleet' },
              ].filter(Boolean);
              // Expose predicates for list filter below
              window.__otAvailPredicate = isVehicleAvailableForOT;
              window.__otInsideCirclePredicate = isInsideCircle;
              const showSuggestions = !bulkAssignMode;
              const ot = list.find(o => String(o._id || o.id) === String(vehicleAssignOrderId));
              const stype = ot?.serviceType || 'delivery';
              const isAssist = stype === 'assistance';
              // Bulk OTs — used to populate the Departure dropdown when the
              // operator has selected multiple orders. Each one becomes an
              // option that pins itself as the first stop in the VRP.
              const bulkOTs = bulkAssignMode
                ? selected.map(id => list.find(o => Number(o._id || o.id) === Number(id))).filter(Boolean)
                : [];
              // Favourites available as departure: any location flagged
              // `isDeparture` (typically the truck yard / parking).
              const departureFavs = (allLocations || []).filter(l =>
                l.isDeparture && Number.isFinite(Number(l.latitude)) && Number.isFinite(Number(l.longitude)));
              // Favourites available as arrival: warehouse or garage type
              // (return-base destinations).
              const arrivalFavs = (allLocations || []).filter(l =>
                (l.type === 'warehouse' || l.type === 'garage') &&
                Number.isFinite(Number(l.latitude)) && Number.isFinite(Number(l.longitude)));
              // Manually picked driver (if any) — its home is offered as a
              // "driver-home" option in BOTH pickers when the OT is assistance.
              const pickedDriver = manualDriverId
                ? allDrivers.find(d => String(d.id) === String(manualDriverId))
                : null;
              const driverHomeAvailable = isAssist && pickedDriver?.homeLat && pickedDriver?.homeLng;
              return (
            <Box style={{
              padding: '6px 10px',
              background: '#f8fafc', borderBottom: '1px solid #e2e8f0',
              display: 'grid',
              // Layout: locais (partida + chegada) ocupam a esquerda;
              // o filtro de veículos é o card mais largo (mais usado) e
              // junta-se ao bloco de motoristas na mesma linha. O alargar
              // do filtro evita que os chips quebrem para 2 linhas e
              // encurta a altura da secção como um todo.
              // Filtrar veículos (largo) fica À ESQUERDA; depois partida,
              // chegada e sugestões. A ordem visual é controlada por `order`
              // em cada coluna (ver COL 1..4), independente da ordem no JSX.
              gridTemplateColumns: 'minmax(340px, 1.8fr) minmax(180px, 0.8fr) minmax(180px, 0.8fr) minmax(200px, 1fr)',
              gap: 6,
              alignItems: 'stretch',
            }}>
              {/* COL 1 — Departure picker. Always visible. Options change
                  based on OT type: assistance defaults to "service" and
                  offers "driver-home" once the operator picks one;
                  delivery/fuel default to OT pickup. */}
              <Box style={{
                padding: '4px 8px', borderRadius: 6,
                background: 'linear-gradient(135deg, #fff7ed, #ffedd5)',
                border: '1px solid #fed7aa',
                display: 'flex', flexDirection: 'column', gap: 3,
                order: 2,
              }}>
                <Box style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  <span style={{ fontSize: 11 }}>🏁</span>
                  <Typography style={{ fontSize: '0.6rem', fontWeight: 800, color: '#9a3412', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                    {lang === 'pt' ? 'Local de partida' : 'Departure'}
                  </Typography>
                  <Tooltip
                    arrow
                    placement="bottom-start"
                    title={
                      <Box style={{ padding: '4px 2px', maxWidth: 340 }}>
                        <Typography style={{ fontSize: '0.78rem', fontWeight: 800, marginBottom: 6, color: '#fff' }}>
                          {lang === 'pt' ? 'De onde sai o motorista?' : 'Where does the driver start?'}
                        </Typography>
                        <Typography component="div" style={{ fontSize: '0.72rem', lineHeight: 1.5, color: '#fff' }}>
                          {lang === 'pt' ? (
                            <>
                              É o <b>ponto onde a rota começa</b>.
                              <Box style={{ marginTop: 6 }}>
                                Se deixares em <b>Auto</b>, o sistema escolhe pela seguinte ordem:
                                <ol style={{ margin: '4px 0 6px 18px', padding: 0 }}>
                                  <li>Casa do motorista (se estiver na ficha dele)</li>
                                  <li>Onde o veículo está agora (GPS)</li>
                                  <li>Se nada disto existir, avisa-te para escolheres</li>
                                </ol>
                              </Box>
                              <Box style={{ marginTop: 4 }}>
                                Também podes escolher <b>uma garagem ou armazém</b> da lista, ou — quando estás a juntar várias OTs — dizer qual é a <b>primeira paragem</b>.
                              </Box>
                            </>
                          ) : (
                            <>
                              This is <b>where the route starts</b>.
                              <Box style={{ marginTop: 6 }}>
                                If you leave it on <b>Auto</b>, the system picks in this order:
                                <ol style={{ margin: '4px 0 6px 18px', padding: 0 }}>
                                  <li>Driver's home address (if on file)</li>
                                  <li>Where the vehicle is right now (GPS)</li>
                                  <li>If neither exists, asks you to choose</li>
                                </ol>
                              </Box>
                              <Box style={{ marginTop: 4 }}>
                                You can also pick a <b>garage or warehouse</b> from the list, or — when grouping several OTs — say which one is the <b>first stop</b>.
                              </Box>
                            </>
                          )}
                        </Typography>
                      </Box>
                    }>
                    <Box style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 14, height: 14, borderRadius: '50%', background: '#fed7aa', color: '#9a3412', fontSize: '0.6rem', fontWeight: 800, cursor: 'help' }}>?</Box>
                  </Tooltip>
                </Box>
                <FormControl size="small" variant="outlined" fullWidth>
                  <Select
                    value={customDepartureLocationId}
                    MenuProps={{ autoFocus: false, PaperProps: { style: { maxHeight: 360 } } }}
                    onChange={(e) => {
                      const v = e.target.value;
                      setCustomDepartureLocationId(v);
                      setDepartureUserOverride(true);
                      // Center the map on the new departure point.
                      let lat = null, lng = null, name = null;
                      if (v === 'service' && ot) {
                        lat = Number(ot.deliveryLat); lng = Number(ot.deliveryLng);
                        name = ot.deliveryName || ot.deliveryAddress;
                      } else if (v === 'driver-home' && pickedDriver) {
                        lat = Number(pickedDriver.homeLat); lng = Number(pickedDriver.homeLng);
                        name = `🏠 ${pickedDriver.name}`;
                      } else if (v === 'vehicle') {
                        const sel = selectedVehicleId
                          ? vehicles.find(x => String(x.id) === String(selectedVehicleId))
                          : null;
                        if (sel?.position?.latitude != null && sel?.position?.longitude != null) {
                          lat = Number(sel.position.latitude); lng = Number(sel.position.longitude);
                          name = `🚗 ${sel.plate || (lang === 'pt' ? 'Veículo' : 'Vehicle')}`;
                        }
                      } else if (typeof v === 'string' && v.startsWith('ot:')) {
                        // Bulk: pin a specific OT as the first stop.
                        const pinnedOT = bulkOTs.find(o => String(o.id || o._id) === v.slice(3));
                        if (pinnedOT) {
                          const isPinAssist = pinnedOT.serviceType === 'assistance';
                          lat = Number(isPinAssist ? pinnedOT.deliveryLat : pinnedOT.pickupLat);
                          lng = Number(isPinAssist ? pinnedOT.deliveryLng : pinnedOT.pickupLng);
                          name = isPinAssist ? (pinnedOT.deliveryName || pinnedOT.deliveryAddress) : (pinnedOT.pickupName || pinnedOT.pickupAddress);
                        }
                      } else if (v) {
                        const loc = departureFavs.find(l => String(l.id) === String(v));
                        if (loc) { lat = Number(loc.latitude); lng = Number(loc.longitude); name = loc.name; }
                      } else if (ot) {
                        // empty → default focus per OT type
                        if (isAssist) { lat = Number(ot.deliveryLat); lng = Number(ot.deliveryLng); }
                        else { lat = Number(ot.pickupLat); lng = Number(ot.pickupLng); }
                      }
                      if (Number.isFinite(lat) && Number.isFinite(lng)) {
                        window.dispatchEvent(new CustomEvent('assignDialogFocusLocation', { detail: { lat, lng, name } }));
                      }
                    }}
                    displayEmpty
                    style={{ background: '#fff', fontSize: '0.74rem', height: 30 }}
                  >
                    {/* Default option — communicates the AUTO fallback that
                        will be used if the operator leaves it blank. The
                        previous label looked like the service location was
                        already selected, which confused operators (they saw
                        the warehouse name and thought THAT was the chosen
                        departure). Now it's explicitly described as "auto". */}
                    <MenuItem value="" style={{ fontSize: '0.74rem' }}>
                      {bulkAssignMode
                        ? <span style={{ color: '#64748b' }}>🚗 {lang === 'pt' ? 'Local atual do veículo, ou 1ª paragem da rota optimizada' : 'Current vehicle location, or first stop of optimised route'}</span>
                        : isAssist
                          ? <span style={{ color: '#64748b' }}>
                              🚗 {lang === 'pt' ? 'Auto: casa do motorista ou GPS do veículo' : 'Auto: driver home or vehicle GPS'}
                            </span>
                          : <>📍 {ot?.pickupName || ot?.pickupAddress || (lang === 'pt' ? 'Recolha da ordem' : 'Pickup')}<span style={{ marginLeft: 6, color: '#94a3b8', fontSize: '0.66rem' }}>({lang === 'pt' ? 'recolha' : 'pickup'})</span></>}
                    </MenuItem>
                    {/* Bulk: list each selected OT so the operator can pick
                        a specific one as the first stop. The VRP optimises
                        the remaining order, then the route can still go
                        back to home or a depot at the end. */}
                    {bulkAssignMode && bulkOTs.length > 0 && (
                      <Box style={{ padding: '4px 12px', fontSize: '0.55rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em', borderTop: '1px solid #f1f5f9', marginTop: 4 }}>
                        {lang === 'pt' ? 'Escolher como primeira paragem' : 'Choose as first stop'}
                      </Box>
                    )}
                    {bulkAssignMode && bulkOTs.map(o => {
                      const otSType = o.serviceType || 'delivery';
                      const stopName = otSType === 'assistance'
                        ? (o.deliveryName || o.deliveryAddress || '—')
                        : (o.pickupName || o.pickupAddress || '—');
                      const icon = otSType === 'assistance' ? '🔧' : (otSType === 'fuel' ? '⛽' : '📦');
                      return (
                        <MenuItem key={`ot:${o.id || o._id}`} value={`ot:${o.id || o._id}`} style={{ fontSize: '0.74rem' }}>
                          {icon} {otLabel(o)} · {stopName}
                        </MenuItem>
                      );
                    })}
                    {/* Single-OT only: explicit service / vehicle GPS / driver-home */}
                    {!bulkAssignMode && isAssist && (
                      <MenuItem value="service" style={{ fontSize: '0.74rem' }}>
                        🔧 {lang === 'pt' ? 'Local de serviço' : 'Service location'}
                      </MenuItem>
                    )}
                    {!bulkAssignMode && (() => {
                      // Mostra a opção GPS só se o veículo tem posição recente
                      // no Redux. Para assistência PT é o típico "local atual
                      // do veículo" — fácil de escolher para o operador.
                      const sel = selectedVehicleId
                        ? vehicles.find(v => String(v.id) === String(selectedVehicleId))
                        : null;
                      const hasLivePos = sel?.position?.latitude != null && sel?.position?.longitude != null;
                      return hasLivePos ? (
                        <MenuItem value="vehicle" style={{ fontSize: '0.74rem' }}>
                          🚗 {lang === 'pt' ? `Local atual do veículo (${sel.plate || ''})` : `Current vehicle location (${sel.plate || ''})`}
                        </MenuItem>
                      ) : null;
                    })()}
                    {driverHomeAvailable && (
                      <MenuItem value="driver-home" style={{ fontSize: '0.74rem' }}>
                        🏠 {lang === 'pt' ? 'Casa de' : 'Home of'} {pickedDriver.name}
                      </MenuItem>
                    )}
                    {departureFavs.length > 0 && (
                      <Box style={{ padding: '4px 12px', fontSize: '0.55rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em', borderTop: '1px solid #f1f5f9', marginTop: 4 }}>
                        {lang === 'pt' ? 'Favoritos de partida' : 'Departure favourites'}
                      </Box>
                    )}
                    {departureFavs.length > 5 && (
                      <Box style={{ padding: '4px 8px', position: 'sticky', top: 0, background: '#fff', zIndex: 1 }}
                        onClickCapture={e => e.stopPropagation()} onKeyDown={e => e.stopPropagation()}>
                        <input autoFocus placeholder={lang === 'pt' ? 'Pesquisar favorito...' : 'Search favourite...'}
                          value={depFavQuery} onChange={e => setDepFavQuery(e.target.value)}
                          style={{ width: '100%', boxSizing: 'border-box', padding: '5px 8px', fontSize: '0.72rem', border: '1px solid #e2e8f0', borderRadius: 6, outline: 'none' }} />
                      </Box>
                    )}
                    {departureFavs
                      .filter(loc => !depFavQuery || (loc.name || '').toLowerCase().includes(depFavQuery.toLowerCase()))
                      .map(loc => (
                      <MenuItem key={loc.id} value={String(loc.id)} style={{ fontSize: '0.74rem' }}>
                        🏁 {loc.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              {/* COL 2 — Arrival picker. Always visible. Optional override
                  for the route's last stop. Default empty → route ends at
                  OT delivery (or at OT pickup for departure-customised
                  delivery routes). For assistance with returnHome=true the
                  default is auto-set to the picked driver's home. */}
              <Box style={{
                padding: '4px 8px', borderRadius: 6,
                background: 'linear-gradient(135deg, #ecfeff, #cffafe)',
                border: '1px solid #67e8f9',
                display: 'flex', flexDirection: 'column', gap: 3,
                order: 3,
              }}>
                <Box style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  <span style={{ fontSize: 11 }}>🏁</span>
                  <Typography style={{ fontSize: '0.6rem', fontWeight: 800, color: '#155e75', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                    {lang === 'pt' ? 'Local de chegada' : 'Arrival'}
                  </Typography>
                  <Tooltip title={lang === 'pt'
                    ? 'Destino final da rota. Se vazio, a rota termina onde a entrega da OT exige. Se preenchido (armazém/garagem ou casa do motorista), a rota inclui-o como último ponto.'
                    : 'Final destination. Empty → route ends at OT delivery. Filled (warehouse/garage or driver home) → route ends there.'}>
                    <Box style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 12, height: 12, borderRadius: '50%', background: '#67e8f9', color: '#155e75', fontSize: '0.55rem', fontWeight: 800, cursor: 'help' }}>?</Box>
                  </Tooltip>
                </Box>
                <FormControl size="small" variant="outlined" fullWidth>
                  <Select
                    value={customArrivalLocationId}
                    MenuProps={{ autoFocus: false, PaperProps: { style: { maxHeight: 360 } } }}
                    onChange={(e) => setCustomArrivalLocationId(e.target.value)}
                    displayEmpty
                    style={{ background: '#fff', fontSize: '0.74rem', height: 30 }}
                  >
                    <MenuItem value="" style={{ fontSize: '0.74rem' }}>
                      {isAssist
                        ? <span style={{ color: '#64748b' }}>— {lang === 'pt' ? 'Termina no local de serviço' : 'Ends at service location'} —</span>
                        : <span style={{ color: '#64748b' }}>— {lang === 'pt' ? 'Termina na entrega da OT' : 'Ends at OT delivery'} —</span>}
                    </MenuItem>
                    {driverHomeAvailable && (
                      <MenuItem value="driver-home" style={{ fontSize: '0.74rem' }}>
                        🏠 {lang === 'pt' ? 'Casa de' : 'Home of'} {pickedDriver.name}
                      </MenuItem>
                    )}
                    {(arrivalFavs.length + departureFavs.length) > 5 && (
                      <Box style={{ padding: '4px 8px', position: 'sticky', top: 0, background: '#fff', zIndex: 1 }}
                        onClickCapture={e => e.stopPropagation()} onKeyDown={e => e.stopPropagation()}>
                        <input autoFocus placeholder={lang === 'pt' ? 'Pesquisar favorito...' : 'Search favourite...'}
                          value={arrFavQuery} onChange={e => setArrFavQuery(e.target.value)}
                          style={{ width: '100%', boxSizing: 'border-box', padding: '5px 8px', fontSize: '0.72rem', border: '1px solid #e2e8f0', borderRadius: 6, outline: 'none' }} />
                      </Box>
                    )}
                    {arrivalFavs.length === 0 && departureFavs.length === 0 && !driverHomeAvailable && (
                      <MenuItem value="" disabled style={{ fontSize: '0.66rem', color: '#94a3b8' }}>
                        {lang === 'pt' ? '(sem armazéns/garagens/partidas nos favoritos)' : '(no warehouses/garages in favourites)'}
                      </MenuItem>
                    )}
                    {arrivalFavs
                      .filter(loc => !arrFavQuery || (loc.name || '').toLowerCase().includes(arrFavQuery.toLowerCase()))
                      .map(loc => (
                      <MenuItem key={loc.id} value={String(loc.id)} style={{ fontSize: '0.74rem' }}>
                        {loc.type === 'warehouse' ? '📦' : '🔧'} {loc.name}
                      </MenuItem>
                    ))}
                    {/* #7 — favoritos marcados como "Partida" também podem
                        ser escolhidos como local de chegada. Exclui os que
                        já apareceram acima (armazém/garagem). */}
                    {(() => {
                      const arrivalIds = new Set(arrivalFavs.map(l => String(l.id)));
                      const depAsArrival = departureFavs
                        .filter(l => !arrivalIds.has(String(l.id)))
                        .filter(l => !arrFavQuery || (l.name || '').toLowerCase().includes(arrFavQuery.toLowerCase()));
                      if (depAsArrival.length === 0) return null;
                      return [
                        <Box key="__dephdr" style={{ padding: '4px 12px', fontSize: '0.55rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em', borderTop: '1px solid #f1f5f9', marginTop: 4 }}>
                          {lang === 'pt' ? 'Favoritos de partida' : 'Departure favourites'}
                        </Box>,
                        ...depAsArrival.map(loc => (
                          <MenuItem key={loc.id} value={String(loc.id)} style={{ fontSize: '0.74rem' }}>
                            🏁 {loc.name}
                          </MenuItem>
                        )),
                      ];
                    })()}
                  </Select>
                </FormControl>
              </Box>

              {/* COL 3 — Filter chips + search. Painel realçado (azul) — é o
                  mais usado pelos operadores na atribuição de veículo. */}
              <Box style={{
                padding: '7px 10px', borderRadius: 8,
                background: 'linear-gradient(135deg, #eff6ff, #dbeafe)',
                border: '2px solid #3b82f6',
                boxShadow: '0 2px 12px rgba(59,130,246,0.20)',
                display: 'flex', flexDirection: 'column', gap: 7,
                order: 1,
              }}>
                <Box style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                  <span style={{ fontSize: 14 }}>🚚</span>
                  <Typography style={{ fontSize: '0.72rem', fontWeight: 900, color: '#1e40af', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                    {lang === 'pt' ? 'Filtrar veículos' : 'Filter vehicles'}
                  </Typography>
                </Box>
                {/* Pesquisa (esquerda) + chips de filtro (direita) na MESMA linha
                    → card mais baixo, sobra espaço para o mapa e a lista de veículos. */}
                <Box style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                  <Box style={{ flex: '1 1 220px', minWidth: 200, display: 'flex', alignItems: 'center', gap: 8, background: '#fff', borderRadius: 8, padding: '9px 12px', border: '1.5px solid #bfdbfe' }}>
                    <SearchIcon style={{ fontSize: 18, color: '#3b82f6' }} />
                    <input placeholder={lang === 'pt' ? 'Pesquisar matrícula, motorista, tipo...' : 'Search plate, driver, type...'} value={vehicleSearch}
                      onChange={e => setVehicleSearch(e.target.value)}
                      style={{ border: 'none', outline: 'none', flex: 1, minWidth: 0, fontSize: '0.85rem', color: '#334155', background: 'transparent' }} />
                    {vehicleSearch && <span onClick={() => setVehicleSearch('')} style={{ cursor: 'pointer', color: '#94a3b8', fontSize: 14 }}>✕</span>}
                  </Box>
                  <Box style={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                    {filtersMeta.map(f => (
                      <Tooltip key={f.id} title={f.tip}>
                        <Chip label={`${f.label} · ${f.count}`} size="small" onClick={() => setVehicleFilterMode(f.id)}
                          style={{
                            height: 24, fontSize: '0.64rem', fontWeight: vehicleFilterMode === f.id ? 800 : 600, cursor: 'pointer',
                            background: vehicleFilterMode === f.id ? f.color : '#fff',
                            color: vehicleFilterMode === f.id ? '#fff' : f.color,
                            border: `1.5px solid ${vehicleFilterMode === f.id ? f.color : f.color + '66'}`,
                            boxShadow: vehicleFilterMode === f.id ? `0 2px 6px ${f.color}40` : 'none',
                          }} />
                      </Tooltip>
                    ))}
                  </Box>
                </Box>
              </Box>

              {/* COL 4 — Driver suggestions */}
              {showSuggestions && (
                <Box style={{
                  padding: '4px 8px', borderRadius: 6,
                  background: 'linear-gradient(135deg, #ecfdf5, #d1fae5)',
                  border: '1px solid #a7f3d0',
                  display: 'flex', flexDirection: 'column', gap: 3, minWidth: 0,
                  order: 4,
                }}>
                  <Box style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <span style={{ fontSize: 11 }}>💡</span>
                    <Typography style={{ fontSize: '0.6rem', fontWeight: 800, color: '#065f46', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                      {lang === 'pt' ? 'Sugestões para esta ordem' : 'Suggestions for this order'}
                    </Typography>
                    <Tooltip title={lang === 'pt'
                      ? 'Critério: 1) competências (skills) compatíveis 2) menor distância casa→cliente 3) menos OTs já atribuídas hoje.'
                      : 'Criteria: 1) skills match 2) shortest home→customer 3) fewest OTs assigned today.'}>
                      <Box style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 12, height: 12, borderRadius: '50%', background: '#a7f3d0', color: '#065f46', fontSize: '0.55rem', fontWeight: 800, cursor: 'help' }}>?</Box>
                    </Tooltip>
                    {driverSuggestionsLoading && (
                      <Typography style={{ fontSize: '0.58rem', color: '#047857' }}>a calcular…</Typography>
                    )}
                  </Box>
                  {/* Tiny legend so the ranking number isn't cryptic. */}
                  {driverSuggestions.length > 0 && (
                    <Typography style={{ fontSize: '0.55rem', color: '#047857', fontStyle: 'italic', marginBottom: 2 }}>
                      {lang === 'pt'
                        ? 'Por ordem de adequação · 1.º = melhor candidato'
                        : 'Ranked by suitability · 1st = best match'}
                    </Typography>
                  )}
                  <Box style={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap', minHeight: 22 }}>
                    {driverSuggestions.length === 0 && !driverSuggestionsLoading && (
                      <Typography style={{ fontSize: '0.62rem', color: '#047857', fontStyle: 'italic' }}>
                        {lang === 'pt' ? 'Sem sugestões disponíveis.' : 'No suggestions.'}
                      </Typography>
                    )}
                    {driverSuggestions.slice(0, 3).map((s, idx) => {
                      const isSelected = String(manualDriverId) === String(s.driverId);
                      // Clickable as long as the driver's skills match the
                      // OT's requirements. The score is for ranking only —
                      // the operator may still pick a far-away driver with
                      // a low score if they know the context (e.g. only
                      // technician available for that brand).
                      const ok = s.skillsOk;
                      const isFar = s.distanceKm != null && s.distanceKm > 80;
                      const rankLabel = lang === 'pt'
                        ? (idx === 0 ? '1.º melhor' : idx === 1 ? '2.º' : '3.º')
                        : (idx === 0 ? '1st best' : idx === 1 ? '2nd' : '3rd');
                      return (
                        <Box key={s.driverId}
                          onClick={() => {
                            if (!ok) return;
                            setManualDriverId(String(s.driverId));
                            // Mirror the suggestion into the contact draft so
                            // the picker pill can render the chosen driver
                            // even when the global drivers cache (truncated
                            // by the `maxDrivers` quota) doesn't include it.
                            setDriverDraft({
                              id: s.driverId,
                              name: s.name,
                              phone: s.phone,
                              externalId: s.externalId,
                              tachoCard: s.tachoCard,
                            });
                          }}
                          style={{
                            display: 'flex', alignItems: 'center', gap: 4,
                            padding: '2px 7px',
                            borderRadius: 999,
                            background: isSelected ? '#10b981' : (!ok ? '#f3f4f6' : isFar ? '#fff7ed' : '#fff'),
                            color: isSelected ? '#fff' : (!ok ? '#9ca3af' : isFar ? '#9a3412' : '#065f46'),
                            border: `1px solid ${isSelected ? '#059669' : (!ok ? '#e5e7eb' : isFar ? '#fdba74' : '#a7f3d0')}`,
                            cursor: ok ? 'pointer' : 'not-allowed',
                            fontSize: '0.6rem', fontWeight: 600,
                          }}
                          title={ok
                            ? `${rankLabel} · ${lang === 'pt' ? 'Distância casa→cliente' : 'Home→customer distance'}: ${s.distanceKm != null ? s.distanceKm + ' km' : (lang === 'pt' ? 'sem morada registada' : 'no home on file')} · ${lang === 'pt' ? 'Carga hoje' : 'Load today'}: ${s.loadToday}${s.skills?.length ? ' · ' + s.skills.join('+') : ''}${isFar ? (lang === 'pt' ? ' · ⚠ longe do cliente' : ' · ⚠ far from customer') : ''}`
                            : `${lang === 'pt' ? 'Sem competências' : 'Missing skills'}: ${s.missingSkills?.join('+') || ''}`}
                        >
                          <span style={{
                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                            minWidth: 18, height: 13, borderRadius: 7,
                            padding: '0 4px',
                            background: isSelected ? 'rgba(255,255,255,0.25)' : '#10b981',
                            color: '#fff', fontSize: 9, fontWeight: 800,
                          }}>{idx + 1}.º</span>
                          <span style={{ fontWeight: 700 }}>{s.name || `#${s.driverId}`}</span>
                          {s.distanceKm != null && (
                            <span style={{ fontSize: '0.55rem', opacity: 0.8 }}>
                              {s.distanceKm.toFixed(1)}km
                            </span>
                          )}
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              )}
            </Box>
              );
            })()}

            {/* Driver contact panel — collapsed by default to a one-line pill
                so the vehicle list above stays visible and the operator can
                easily switch vehicles without scrolling. Click the pill to
                expand and see/edit phone, email, etc. */}
            {selectedVehicleId && (() => {
              const sel = availableVehicles.find(v => String(v.id) === selectedVehicleId);
              if (!sel) return null;
              const manual = manualDriverId ? allDrivers.find(d => String(d.id) === String(manualDriverId)) : null;
              const drvName = manual?.name || sel.driver?.name || sel.tacho?.driverName || '';
              if (!drvName) return null;
              const extId = manual?.externalId
                || (sel.driver?.id ? String(sel.driver.id) : null)
                || (sel.tacho?.driverId ? String(sel.tacho.driverId) : null);
              const tacho = manual?.tachoCard || sel.driver?.tachoCard || sel.tacho?.tachoCard || null;
              const phoneHint = manual?.phone || sel.driver?.phone || null;
              return (
                <Box style={{ padding: '6px 12px 0' }}>
                  {!driverPanelExpanded ? (
                    <Box
                      onClick={() => setDriverPanelExpanded(true)}
                      style={{
                        display: 'flex', alignItems: 'center', gap: 8,
                        padding: '6px 10px',
                        background: '#fff',
                        border: '1px solid #e2e8f0',
                        borderRadius: 999,
                        cursor: 'pointer',
                        transition: 'border-color 0.12s, box-shadow 0.12s',
                        boxShadow: '0 1px 2px rgba(15,23,42,0.04)',
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#c7d2fe'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#e2e8f0'; }}
                    >
                      <Box style={{
                        width: 22, height: 22, borderRadius: 11,
                        background: 'linear-gradient(135deg, #ede9fe, #ddd6fe)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                      }}>
                        <PersonIcon style={{ fontSize: 13, color: '#7c3aed' }} />
                      </Box>
                      <Typography style={{ fontSize: '0.74rem', fontWeight: 700, color: '#0f172a', flexShrink: 0 }}>
                        {drvName}
                      </Typography>
                      {phoneHint && (
                        <Typography style={{ fontSize: '0.62rem', color: '#64748b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          📞 {phoneHint}
                        </Typography>
                      )}
                      {tacho && (
                        <Box style={{
                          fontSize: '0.55rem', fontWeight: 700, color: '#7c3aed',
                          background: '#faf5ff', border: '1px solid #e9d5ff',
                          padding: '1px 6px', borderRadius: 999, flexShrink: 0,
                        }}>Tacógrafo</Box>
                      )}
                      <Box style={{ flex: 1 }} />
                      <Typography style={{ fontSize: '0.6rem', color: '#94a3b8', fontStyle: 'italic', flexShrink: 0 }}>
                        clica para editar contactos ↓
                      </Typography>
                    </Box>
                  ) : (
                    <Box>
                      <Box style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 2 }}>
                        <Typography
                          onClick={() => setDriverPanelExpanded(false)}
                          style={{ fontSize: '0.6rem', color: '#6366f1', cursor: 'pointer', fontWeight: 600 }}
                        >
                          ↑ recolher
                        </Typography>
                      </Box>
                      <DriverEditPanel
                        driverName={drvName}
                        driverExternalId={extId}
                        driverTachoCard={tacho}
                        lang={lang}
                        onChange={setDriverDraft}
                      />
                    </Box>
                  )}
                </Box>
              );
            })()}

            </Box>{/* end toolbar */}

            {/* Body: split into vehicle list (left) + integrated map (right) */}
            <Box style={{ flex: 1, display: 'flex', minHeight: 0, overflow: 'hidden' }}>
            <Box style={{ width: vehicleSplitLeftPx, flexShrink: 0, display: 'flex', flexDirection: 'column', background: '#fff', minHeight: 0 }}>
            {/* Vehicle list */}
            <Box style={{ flex: 1, overflow: 'auto', padding: '8px 12px' }}>
              {availableVehicles.length === 0 ? (
                <Box style={{ padding: 32, textAlign: 'center' }}>
                  <Typography style={{ fontSize: '0.82rem', color: '#94a3b8' }}>
                    {lang === 'pt' ? 'A carregar veículos...' : 'Loading vehicles...'}
                  </Typography>
                </Box>
              ) : availableVehicles.filter(v => {
                // Filter by mode
                if (vehicleFilterMode === 'inside') {
                  const pred = window.__otInsideCirclePredicate;
                  if (pred && !pred(v)) return false;
                }
                if (vehicleFilterMode === 'tacho' && !v.driver && !v.tacho?.driverName) return false;
                if (vehicleFilterMode === 'available') {
                  const pred = window.__otAvailPredicate;
                  if (pred && !pred(v)) return false;
                }
                // Petrotec AO — filtro "Com stock". Em modos onde o stock
                // map ainda não carregou, o filtro é permissivo (mostra tudo)
                // para não esconder viaturas enquanto o fetch corre.
                if (vehicleFilterMode === 'stock') {
                  if (!vehicleStockMap[v.id]) return true; // ainda a carregar
                  if ((vehicleStockMap[v.id].items || 0) === 0) return false;
                }
                // Search
                if (!vehicleSearch) return true;
                const q = vehicleSearch.toLowerCase();
                return (v.plate || '').toLowerCase().includes(q) || (v.driver?.name || '').toLowerCase().includes(q) || (v.tacho?.driverName || '').toLowerCase().includes(q) || (v.type || '').toLowerCase().includes(q);
              }).map(v => {
                const isSelected = selectedVehicleId === String(v.id);
                const hasPosition = !!v.position;
                const speed = v.speed || 0;
                const isMoving = speed > 3;
                const condColors = { ready: '#22c55e', available: '#3b82f6', resting: '#8b5cf6', driving: '#f59e0b', exceeded: '#ef4444', unknown: '#94a3b8' };
                const condBgs = { ready: '#dcfce7', available: '#eff6ff', resting: '#faf5ff', driving: '#fef3c7', exceeded: '#fef2f2', unknown: '#f1f5f9' };
                return (
                  <Box key={v.id}
                    ref={isSelected ? selectedVehicleRowRef : null}
                    onClick={() => pickVehicleForAssign(v.id)}
                    style={{
                      padding: '12px 14px', borderRadius: 12, marginBottom: 8, cursor: 'pointer',
                      background: isSelected ? '#eff6ff' : v.availableForOT === false ? '#fef2f2' : v.available ? '#fff' : '#fefce8',
                      border: isSelected ? '2px solid #3b82f6' : v.availableForOT === false ? '1px solid #fecaca' : '1px solid #e2e8f0',
                      transition: 'all 0.15s',
                      opacity: v.availableForOT === false ? 0.88 : 1,
                    }}>
                    {/* Row 1: Vehicle + status */}
                    <Box style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <Box style={{ width: 12, height: 12, borderRadius: '50%', flexShrink: 0, background: isMoving ? '#22c55e' : hasPosition ? '#f59e0b' : '#94a3b8' }} />
                      <Typography style={{ fontSize: '0.88rem', fontWeight: 700, color: '#0f172a' }}>{v.plate}</Typography>
                      <Typography style={{ fontSize: '0.62rem', color: '#64748b' }}>{v.type || ''}</Typography>
                      <Box style={{ marginLeft: 'auto', display: 'flex', gap: 4 }}>
                        {v.available ? (
                          <Box style={{ fontSize: '0.52rem', fontWeight: 700, background: '#dcfce7', color: '#16a34a', padding: '2px 8px', borderRadius: 6 }}>
                            {lang === 'pt' ? 'Disponível' : 'Available'}
                          </Box>
                        ) : (
                          <Box style={{ fontSize: '0.52rem', fontWeight: 700, background: '#fef3c7', color: '#d97706', padding: '2px 8px', borderRadius: 6 }}>
                            {v.activeOrders} OT
                          </Box>
                        )}
                        {/* Driver condition badge */}
                        {v.driverCondition && v.driverCondition !== 'unknown' && (
                          <Box style={{ fontSize: '0.52rem', fontWeight: 700, background: condBgs[v.driverCondition], color: condColors[v.driverCondition], padding: '2px 8px', borderRadius: 6 }}>
                            {v.conditionDetail}
                          </Box>
                        )}
                      </Box>
                      {/* Select radio */}
                      <Box style={{ width: 22, height: 22, borderRadius: '50%', flexShrink: 0, border: isSelected ? '2px solid #3b82f6' : '2px solid #e2e8f0', background: isSelected ? '#3b82f6' : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {isSelected && <span style={{ color: '#fff', fontSize: 11, fontWeight: 800 }}>✓</span>}
                      </Box>
                    </Box>

                    {/* Row 2: Driver + position (map shown integrated on the right) */}
                    <Box style={{ display: 'flex', gap: 8, marginTop: 6, fontSize: '0.62rem', color: '#475569', alignItems: 'center' }}>
                      {v.driver && <span style={{ fontWeight: 600 }}>👤 {v.driver.name}</span>}
                      {!v.driver && v.tacho?.driverName && <span style={{ fontWeight: 600 }}>👤 {v.tacho.driverName}</span>}
                      {hasPosition && <span>📍 {speed} km/h</span>}
                      {v.position?.address && <span style={{ maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#94a3b8' }}>{v.position.address}</span>}
                    </Box>

                    {/* Petrotec AO — chip de stock por viatura. Renderiza só
                        quando a OT é AO (finalCustomerId) E o stock foi
                        carregado para esta viatura. Click abre popover. */}
                    {(() => {
                      const ot = list.find(o => String(o._id || o.id) === String(vehicleAssignOrderId));
                      if (!ot?.finalCustomerId) return null;
                      const stk = vehicleStockMap[v.id];
                      if (!stk) return null;
                      const hasStock = stk.items > 0;
                      return (
                        <Box
                          onClick={(e) => {
                            e.stopPropagation();
                            setStockPopoverVehicleId(v.id);
                            setStockPopoverAnchor(e.currentTarget);
                          }}
                          style={{
                            display: 'inline-flex', alignItems: 'center', gap: 5,
                            marginTop: 6, padding: '3px 9px', borderRadius: 6,
                            background: hasStock ? '#dcfce7' : '#f1f5f9',
                            border: `1px solid ${hasStock ? '#bbf7d0' : '#e2e8f0'}`,
                            cursor: hasStock ? 'pointer' : 'default',
                            fontSize: '0.6rem', fontWeight: 700,
                            color: hasStock ? '#166534' : '#94a3b8',
                          }}>
                          <span>📦</span>
                          {hasStock ? (
                            <>
                              <span>{stk.items} refs · {stk.units} un</span>
                              <span style={{ fontSize: '0.55rem', opacity: 0.8 }}>· ver →</span>
                            </>
                          ) : (
                            <span>{lang === 'pt' ? 'sem stock' : 'no stock'}</span>
                          )}
                        </Box>
                      );
                    })()}

                    {/* Row 3 — Predictive recalc warning. The "Iniciar rota"
                        flow recalculates the route when the vehicle's GPS is
                        more than 500 m from the pickup; this badge tells the
                        operator UPFRONT (at assignment time) whether starting
                        with this vehicle will trigger that recalc + re-dispatch.
                        Distance is recomputed locally because `distanceToPickup`
                        lives in a sibling IIFE and isn't in scope here.
                        Em OTs fuel a "casa do motorista" não se aplica — o
                        motorista parte da base (ZZE), não de casa. Esconder. */}
                    {(() => {
                      const _curOT = list.find(o => String(o._id || o.id) === String(vehicleAssignOrderId));
                      if (_curOT?.serviceType === 'fuel') return null;
                      const pickupPt = window.__otPickupPoint;
                      if (!hasPosition || !pickupPt || !v.position) return null;
                      const R = 6371;
                      const toRad = (d) => d * Math.PI / 180;
                      const dLat = toRad(v.position.latitude - pickupPt.lat);
                      const dLng = toRad(v.position.longitude - pickupPt.lng);
                      const a = Math.sin(dLat / 2) ** 2
                        + Math.cos(toRad(pickupPt.lat)) * Math.cos(toRad(v.position.latitude))
                        * Math.sin(dLng / 2) ** 2;
                      const distKm = 2 * R * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                      if (!Number.isFinite(distKm)) return null;
                      const distM = Math.round(distKm * 1000);
                      const willRecalc = distKm > 0.5;
                      // Rótulo correto consoante o PONTO de referência (deixou de
                      // ser sempre "casa do motorista" — isso só vale p/ assistência).
                      const _kind = window.__otPickupKind;
                      const refLabel = _kind === 'driver-home'
                        ? (lang === 'pt' ? 'da casa do motorista' : 'from driver home')
                        : _kind === 'service'
                          ? (lang === 'pt' ? 'do local de serviço' : 'from service site')
                          : _kind === 'departure'
                            ? (lang === 'pt' ? 'do local de partida' : 'from departure')
                            : _kind === 'pickup'
                              ? (lang === 'pt' ? 'do local de carga' : 'from pickup')
                              : (lang === 'pt' ? 'do ponto de partida' : 'from start point');
                      return (
                        <Box style={{
                          display: 'flex', alignItems: 'center', gap: 6,
                          marginTop: 6,
                          padding: '4px 8px',
                          background: willRecalc ? '#fffbeb' : '#f0fdf4',
                          border: `1px solid ${willRecalc ? '#fde68a' : '#bbf7d0'}`,
                          borderRadius: 8,
                          fontSize: '0.6rem', fontWeight: 600,
                          color: willRecalc ? '#92400e' : '#16a34a',
                        }}>
                          <span style={{ fontSize: 11 }}>{willRecalc ? '⚠' : '✓'}</span>
                          <span>
                            {distM < 1000 ? `${distM} m` : `${distKm.toFixed(1)} km`} {refLabel}
                          </span>
                          {willRecalc && (
                            <span style={{ marginLeft: 'auto', fontSize: '0.55rem', opacity: 0.85 }}>
                              {lang === 'pt' ? 'recalcula ao iniciar' : 'will recalc on start'}
                            </span>
                          )}
                        </Box>
                      );
                    })()}

                    {/* Row 3: Tachograph data — hidden when the client doesn't use a tachograph */}
                    {clientSettings?.useTachograph !== false && v.tacho && (v.tacho.activity || v.tacho.continuousDrive) && (
                      <Box style={{ marginTop: 6, padding: '6px 10px', background: '#faf5ff', borderRadius: 8, border: '1px solid #ede9fe' }}>
                        <Box style={{ display: 'flex', alignItems: 'center', gap: 4, marginBottom: 4 }}>
                          <Typography style={{ fontSize: '0.55rem', fontWeight: 800, color: '#7c3aed', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                            Tacógrafo
                          </Typography>
                          {v.tacho.cardInserted != null && (
                            <Box style={{ fontSize: '0.48rem', fontWeight: 700, background: v.tacho.cardInserted ? '#dcfce7' : '#fef2f2', color: v.tacho.cardInserted ? '#16a34a' : '#dc2626', padding: '1px 5px', borderRadius: 4 }}>
                              Cartão: {v.tacho.cardInserted ? 'Inserido' : 'Não inserido'}
                            </Box>
                          )}
                          {v.tacho.activity && (
                            <Box style={{ fontSize: '0.48rem', fontWeight: 700, background: v.tacho.activity === 'Condução' ? '#fef3c7' : v.tacho.activity === 'Descanso' ? '#dbeafe' : '#f1f5f9', color: v.tacho.activity === 'Condução' ? '#d97706' : v.tacho.activity === 'Descanso' ? '#2563eb' : '#64748b', padding: '1px 5px', borderRadius: 4 }}>
                              {v.tacho.activity}
                            </Box>
                          )}
                        </Box>
                        <Box style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '2px 12px', fontSize: '0.55rem', color: '#475569' }}>
                          {v.tacho.continuousDrive && <span>Condução contínua: <b>{v.tacho.continuousDrive}</b></span>}
                          {v.tacho.driveAccum && <span>Condução diária: <b>{v.tacho.driveAccum}</b></span>}
                          {v.tacho.breakAccum && <span>Pausa acumulada: <b>{v.tacho.breakAccum}</b></span>}
                          {v.tacho.dailyRest && <span>Descanso diário: <b>{v.tacho.dailyRest}</b></span>}
                          {v.tacho.weeklyRest && <span>Descanso semanal: <b>{v.tacho.weeklyRest}</b></span>}
                          {v.tacho.nextBreak && <span>Próx. pausa: <b style={{ color: '#f59e0b' }}>{v.tacho.nextBreak}</b></span>}
                        </Box>
                      </Box>
                    )}
                    {/* No tacho data — only show the empty-state hint when the client uses a tachograph */}
                    {clientSettings?.useTachograph !== false && (!v.tacho || (!v.tacho.activity && !v.tacho.continuousDrive)) && (
                      <Box style={{ marginTop: 4, fontSize: '0.55rem', color: '#94a3b8', fontStyle: 'italic' }}>
                        {v.tacho?.cardInserted === false ? 'Cartão de motorista não inserido' : 'Sem dados de tacógrafo disponíveis'}
                      </Box>
                    )}
                    {/* Availability reasons — only when backend marked the vehicle as non-available for this OT */}
                    {v.availableForOT === false && Array.isArray(v.availabilityReasons) && v.availabilityReasons.length > 0 && (
                      <Box style={{ marginTop: 6, padding: '6px 10px', background: '#fef2f2', borderRadius: 8, border: '1px solid #fecaca' }}>
                        <Typography style={{ fontSize: '0.52rem', fontWeight: 800, color: '#b91c1c', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 2 }}>
                          {lang === 'pt' ? 'Não disponível para esta OT' : 'Unavailable for this OT'}
                        </Typography>
                        <Box component="ul" style={{ margin: 0, paddingLeft: 14, fontSize: '0.55rem', color: '#991b1b' }}>
                          {v.availabilityReasons.map((r, i) => (
                            <li key={i}>{r}</li>
                          ))}
                        </Box>
                      </Box>
                    )}
                  </Box>
                );
              })}
            </Box>
            </Box>{/* end left column */}

            {/* Resize handle — drag to reshape left/right panels */}
            <Box
              onMouseDown={handleVehicleSplitDragStart}
              title={lang === 'pt' ? 'Arrastar para redimensionar' : 'Drag to resize'}
              style={{
                width: 6, flexShrink: 0, cursor: 'ew-resize',
                background: '#e2e8f0',
                position: 'relative',
                transition: 'background 0.15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = '#6366f1'; }}
              onMouseLeave={e => { e.currentTarget.style.background = '#e2e8f0'; }}>
              <Box style={{
                position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                width: 4, height: 40, borderRadius: 2, background: 'rgba(99,102,241,0.5)',
                pointerEvents: 'none',
              }} />
            </Box>

            {/* Right column — integrated map + street view.
                When a pickup point is known, show overview mode: all vehicles
                plus a blue radius circle centered on the pickup, so the operator
                can immediately see which vehicles are physically near. */}
            {(() => {
              const currentOT = list.find(o => String(o._id || o.id) === String(vehicleAssignOrderId));
              const isAssistOT = currentOT?.serviceType === 'assistance';
              // Default focus: assistance OTs centre on the SERVICE LOCATION
              // (delivery point) instead of the pickup, since for assistance
              // the pickup is just the driver's home (or null in the new
              // schema). Delivery / fuel keep the OT pickup as the default.
              const defaultLat = isAssistOT
                ? Number(currentOT?.deliveryLat)
                : Number(currentOT?.pickupLat || currentOT?.pickup?.lat);
              const defaultLng = isAssistOT
                ? Number(currentOT?.deliveryLng)
                : Number(currentOT?.pickupLng || currentOT?.pickup?.lng);
              const defaultName = isAssistOT
                ? (currentOT?.deliveryName || currentOT?.deliveryAddress || '')
                : (currentOT?.pickupName || currentOT?.pickupAddress || '');
              const otAnchorPoint = (Number.isFinite(defaultLat) && Number.isFinite(defaultLng))
                ? { lat: defaultLat, lng: defaultLng, name: defaultName }
                : null;

              // When the operator picks a custom departure (favourite, driver
              // home, or service location), the map's anchor follows.
              let focusPoint = otAnchorPoint;
              let focusKind = isAssistOT ? 'service' : 'pickup';
              if (customDepartureLocationId === 'driver-home') {
                const drv = manualDriverId
                  ? allDrivers.find(d => String(d.id) === String(manualDriverId))
                  : null;
                if (drv?.homeLat && drv?.homeLng) {
                  focusPoint = { lat: Number(drv.homeLat), lng: Number(drv.homeLng), name: `🏠 ${drv.name}` };
                  focusKind = 'driver-home';
                }
              } else if (customDepartureLocationId === 'service' && currentOT?.deliveryLat && currentOT?.deliveryLng) {
                focusPoint = { lat: Number(currentOT.deliveryLat), lng: Number(currentOT.deliveryLng), name: currentOT.deliveryName || 'Local de serviço' };
                focusKind = 'service';
              } else if (customDepartureLocationId && (allLocations || []).length) {
                const loc = allLocations.find(l => String(l.id) === String(customDepartureLocationId));
                if (loc?.latitude && loc?.longitude) {
                  focusPoint = {
                    lat: Number(loc.latitude),
                    lng: Number(loc.longitude),
                    name: loc.name || (lang === 'pt' ? 'Local de partida' : 'Departure'),
                  };
                  focusKind = 'departure';
                }
              }
              window.__otPickupPoint = focusPoint;
              // Que PONTO é a referência da distância, p/ o badge rotular certo
              // (o badge vive numa IIFE irmã e não vê focusKind). 'driver-home'
              // = casa do motorista (assistência); 'pickup' = origem/carga da OT
              // (mercadoria, ex.: Casais Sede); 'service'/'departure' = outros.
              window.__otPickupKind = focusKind;
              return (
                <Box style={{ flex: 1, minWidth: 0, padding: 12, background: 'linear-gradient(180deg, #f1f5f9 0%, #e2e8f0 100%)', display: 'flex', position: 'relative' }}>
                  {vehicleAssignMapReady ? (
                    <VehicleLocationPreview
                      vehicle={availableVehicles.find(v => String(v.id) === selectedVehicleId) || null}
                      allVehicles={availableVehicles}
                      pickupPoint={focusPoint}
                      pickupKind={focusKind}
                      radiusKm={vehicleAssignRadiusKm}
                      onRadiusChange={setVehicleAssignRadiusKm}
                      onSelectVehicle={(id) => pickVehicleForAssign(id)}
                    />
                  ) : (
                    <Box style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 12, background: '#e2e8f0', color: '#64748b', fontSize: '0.78rem' }}>
                      {lang === 'pt' ? 'A preparar mapa...' : 'Loading map...'}
                    </Box>
                  )}
                  {/* Fullscreen toggle — opens a blow-up of the same map in a
                      modal so the operator can pick vehicles from a much
                      bigger canvas without losing the assign-vehicle dialog
                      underneath. */}
                  {vehicleAssignMapReady && (
                    <Tooltip title={lang === 'pt' ? 'Abrir mapa em ecrã grande' : 'Open map in full screen'}>
                      <IconButton
                        size="small"
                        onClick={() => setMapFullscreenOpen(true)}
                        style={{
                          position: 'absolute', top: 18, right: 18, zIndex: 5,
                          background: '#fff', boxShadow: '0 2px 8px rgba(15,23,42,0.18)',
                          border: '1px solid #e2e8f0', padding: 6, borderRadius: 8,
                        }}>
                        <FullscreenIcon style={{ fontSize: 18, color: '#1e293b' }} />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
              );
            })()}
            </Box>{/* end split body */}

            {/* Driver picker — shown when a vehicle is selected, pre-filled if vehicle has driver */}
            {selectedVehicleId && (() => {
              const selVehicle = availableVehicles.find(v => String(v.id) === selectedVehicleId);
              const autoDriver = selVehicle?.driver?.name || selVehicle?.tacho?.driverName || '';
              const hasAutoDriver = !!autoDriver;
              // Motorista da NOSSA BD com o mesmo nome do detectado (tacógrafo).
              // Damos-lhe prevalência: tem morada registada, necessária para o
              // "local de partida = casa" nas assistências. A entrada "Detectado
              // do veículo" passa a selecioná-lo (em vez do registo só-tacógrafo).
              const autoDriverDbMatch = autoDriver
                ? allDrivers.find(d => (d.name || '').trim().toLowerCase() === autoDriver.trim().toLowerCase())
                : null;
              const autoDriverHasHome = !!(autoDriverDbMatch && autoDriverDbMatch.homeLat && autoDriverDbMatch.homeLng);
              return (
                <Box style={{
                  padding: '10px 20px',
                  borderTop: '1px solid #f1f5f9', background: '#f8fafc',
                  display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
                }}>
                  <Box style={{
                    width: 28, height: 28, borderRadius: 8,
                    background: hasAutoDriver && !manualDriverId ? '#dcfce7' : (manualDriverId ? '#dbeafe' : '#fef3c7'),
                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                  }}>
                    <PersonIcon style={{ fontSize: 14, color: hasAutoDriver && !manualDriverId ? '#16a34a' : (manualDriverId ? '#2563eb' : '#d97706') }} />
                  </Box>
                  <Box style={{ flex: 1, minWidth: 180 }}>
                    <Typography style={{ fontSize: '0.6rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 3 }}>
                      {lang === 'pt' ? 'Motorista' : 'Driver'}
                      {hasAutoDriver && !manualDriverId && (
                        <span style={{ marginLeft: 6, fontSize: '0.52rem', color: '#16a34a', fontWeight: 700, textTransform: 'none', letterSpacing: 0 }}>
                          {lang === 'pt' ? '(detectado do veículo)' : '(auto-detected)'}
                        </span>
                      )}
                      {!hasAutoDriver && !manualDriverId && (
                        <span style={{ marginLeft: 6, fontSize: '0.52rem', color: '#d97706', fontWeight: 700, textTransform: 'none', letterSpacing: 0 }}>
                          {lang === 'pt' ? '⚠ veículo sem motorista — escolha manualmente' : '⚠ vehicle has no driver — pick manually'}
                        </span>
                      )}
                    </Typography>
                    {/* Custom searchable driver picker */}
                    <Box>
                      {/* Trigger button */}
                      <Box
                        onClick={(e) => { setDriverPickerAnchor(driverPickerAnchor ? null : e.currentTarget); setDriverPickerSearch(''); }}
                        style={{
                          width: '100%', height: 34, display: 'flex', alignItems: 'center',
                          gap: 8, padding: '0 10px',
                          background: '#fff', border: driverPickerOpen ? '1.5px solid #6366f1' : '1px solid #e2e8f0',
                          borderRadius: 10, cursor: 'pointer',
                          boxShadow: driverPickerOpen ? '0 0 0 3px rgba(99,102,241,0.1)' : 'none',
                          transition: 'all 0.15s',
                        }}
                      >
                        {(() => {
                          // Look up the chosen driver. `allDrivers` is the
                          // primary source, but it gets truncated to
                          // `client.maxDrivers` rows on the backend. If the
                          // operator picked a driver from the suggestions
                          // panel that fell outside that window, the picker
                          // would render empty — so we fall back to
                          // `driverDraft` (which the suggestion click now
                          // populates) and finally to driverSuggestions.
                          let selected = manualDriverId ? allDrivers.find(d => String(d.id) === String(manualDriverId)) : null;
                          if (!selected && manualDriverId && driverDraft && String(driverDraft.id) === String(manualDriverId)) {
                            selected = driverDraft;
                          }
                          if (!selected && manualDriverId) {
                            const sug = driverSuggestions.find(s => String(s.driverId) === String(manualDriverId));
                            if (sug) selected = { id: sug.driverId, name: sug.name, phone: sug.phone };
                          }
                          if (selected) return (
                            <Box style={{ display: 'flex', alignItems: 'center', gap: 6, flex: 1, minWidth: 0 }}>
                              <Box style={{ width: 22, height: 22, borderRadius: 6, background: '#eff6ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                <PersonIcon style={{ fontSize: 12, color: '#2563eb' }} />
                              </Box>
                              <Typography style={{ fontSize: '0.78rem', fontWeight: 700, color: '#0f172a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{selected.name}</Typography>
                              {selected.phone && <Typography style={{ fontSize: '0.6rem', color: '#94a3b8' }}>· {selected.phone}</Typography>}
                            </Box>
                          );
                          if (hasAutoDriver) return (
                            <Box style={{ display: 'flex', alignItems: 'center', gap: 6, flex: 1, minWidth: 0 }}>
                              <Box style={{ width: 6, height: 6, borderRadius: '50%', background: '#22c55e', flexShrink: 0 }} />
                              <Typography style={{ fontSize: '0.78rem', fontWeight: 600, color: '#0f172a' }}>{autoDriver}</Typography>
                              <Typography style={{ fontSize: '0.56rem', color: '#94a3b8' }}>(detectado)</Typography>
                            </Box>
                          );
                          return <Typography style={{ fontSize: '0.74rem', color: '#94a3b8', fontStyle: 'italic' }}>{lang === 'pt' ? 'Selecionar motorista...' : 'Select driver...'}</Typography>;
                        })()}
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="#94a3b8" style={{ flexShrink: 0, transform: driverPickerOpen ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform 0.2s' }}>
                          <path d="M7 10l5 5 5-5z"/>
                        </svg>
                      </Box>
                      {/* Dropdown — rendered via Popover so it escapes modal overflow */}
                      <Popover
                        open={driverPickerOpen}
                        anchorEl={driverPickerAnchor}
                        onClose={() => setDriverPickerAnchor(null)}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                        PaperProps={{ style: {
                          marginTop: 4, borderRadius: 12,
                          width: driverPickerAnchor?.offsetWidth || 340,
                          maxHeight: 380, display: 'flex', flexDirection: 'column',
                          boxShadow: '0 16px 40px rgba(15,23,42,0.18)',
                          overflow: 'hidden',
                        } }}
                        style={{ zIndex: 10200 }}
                      >
                          {/* Search input */}
                          <Box style={{ padding: '8px 10px', borderBottom: '1px solid #f1f5f9', flexShrink: 0 }}>
                            <Box style={{
                              display: 'flex', alignItems: 'center', gap: 6,
                              background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8,
                              padding: '5px 10px',
                            }}>
                              <SearchIcon style={{ fontSize: 14, color: '#94a3b8' }} />
                              <input
                                type="text"
                                value={driverPickerSearch}
                                onChange={(e) => setDriverPickerSearch(e.target.value)}
                                placeholder={lang === 'pt' ? 'Pesquisar motorista...' : 'Search driver...'}
                                autoFocus
                                style={{
                                  flex: 1, border: 'none', outline: 'none', background: 'transparent',
                                  fontSize: '0.78rem', color: '#0f172a',
                                }}
                              />
                              {driverPickerSearch && (
                                <CloseIcon onClick={() => setDriverPickerSearch('')} style={{ fontSize: 14, color: '#94a3b8', cursor: 'pointer' }} />
                              )}
                            </Box>
                          </Box>
                          {/* Auto-detected option — seleciona o motorista da NOSSA
                              BD com o mesmo nome (tem morada), não o registo só
                              do tacógrafo. Assim a partida-casa das assistências
                              funciona. */}
                          {hasAutoDriver && (() => {
                            const autoVal = autoDriverDbMatch ? String(autoDriverDbMatch.id) : '';
                            const autoActive = autoDriverDbMatch ? String(manualDriverId) === autoVal : !manualDriverId;
                            return (
                            <Box
                              onClick={() => {
                                setManualDriverId(autoVal);
                                setDriverPickerAnchor(null);
                                // Se o motorista detectado ainda não tem coordenadas de
                                // casa, abre o popup para o operador as confirmar.
                                if (autoDriverDbMatch) maybePromptAddress(autoDriverDbMatch);
                              }}
                              style={{
                                padding: '8px 12px', cursor: 'pointer',
                                display: 'flex', alignItems: 'center', gap: 8,
                                background: autoActive ? '#f0fdf4' : 'transparent',
                                borderBottom: '1px solid #f1f5f9',
                                transition: 'background 0.12s',
                              }}
                              onMouseEnter={(e) => { if (!autoActive) e.currentTarget.style.background = '#f8fafc'; }}
                              onMouseLeave={(e) => { if (!autoActive) e.currentTarget.style.background = 'transparent'; }}
                            >
                              <Box style={{ width: 30, height: 30, borderRadius: 8, background: '#dcfce7', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                <PersonIcon style={{ fontSize: 14, color: '#16a34a' }} />
                              </Box>
                              <Box style={{ flex: 1, minWidth: 0 }}>
                                <Typography style={{ fontSize: '0.78rem', fontWeight: 700, color: '#0f172a' }}>{autoDriver}</Typography>
                                <Typography style={{ fontSize: '0.58rem', color: '#16a34a' }}>
                                  {lang === 'pt' ? 'Detectado do veículo' : 'Auto-detected from vehicle'}
                                  {autoDriverHasHome ? (lang === 'pt' ? ' · casa registada' : ' · home on file') : ''}
                                </Typography>
                              </Box>
                              {autoActive && <Box style={{ width: 8, height: 8, borderRadius: '50%', background: '#22c55e' }} />}
                            </Box>
                            );
                          })()}
                          {/* Skill-match banner — shows required skills from the active OT(s) */}
                          {(() => {
                            const activeIds = bulkAssignMode ? [...selected] : (vehicleAssignOrderId ? [vehicleAssignOrderId] : []);
                            const activeOTs = list.filter(o => activeIds.includes(o.id || o._id));
                            const req = [...new Set(activeOTs.flatMap(o => (Array.isArray(o.requiredSkills) ? o.requiredSkills : [])))];
                            if (req.length === 0) return null;
                            return (
                              <Box style={{
                                padding: '6px 12px',
                                background: '#eff6ff', borderBottom: '1px solid #dbeafe',
                                display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap',
                              }}>
                                <Typography style={{ fontSize: '0.62rem', fontWeight: 700, color: '#1e40af' }}>
                                  🎯 {lang === 'pt' ? 'Apenas motoristas com:' : 'Only drivers with:'}
                                </Typography>
                                {req.map(s => (
                                  <Box key={s} style={{
                                    padding: '1px 6px', borderRadius: 10,
                                    background: '#2563eb', color: '#fff',
                                    fontSize: '0.58rem', fontWeight: 700,
                                  }}>{s}</Box>
                                ))}
                              </Box>
                            );
                          })()}
                          {/* Driver list */}
                          <Box style={{ flex: 1, overflowY: 'auto' }}>
                            {(() => {
                              const q = driverPickerSearch.trim().toLowerCase();
                              // Compute required skills from the OT(s) being assigned
                              const activeIds = bulkAssignMode ? [...selected] : (vehicleAssignOrderId ? [vehicleAssignOrderId] : []);
                              const activeOTs = list.filter(o => activeIds.includes(o.id || o._id));
                              const req = [...new Set(activeOTs.flatMap(o => (Array.isArray(o.requiredSkills) ? o.requiredSkills : [])))];
                              const filtered = allDrivers.filter(d => {
                                // Não repetir o motorista já mostrado em cima como
                                // "Detectado do veículo" — senão aparece 2x (ex.: Carlos Horta).
                                if (hasAutoDriver && (d.name || '').trim().toLowerCase() === autoDriver.trim().toLowerCase()) return false;
                                if (req.length > 0) {
                                  const drvSkills = Array.isArray(d.skills) ? d.skills : [];
                                  const missing = req.filter(s => !drvSkills.includes(s));
                                  if (missing.length > 0) return false;
                                }
                                if (!q) return true;
                                return (d.name || '').toLowerCase().includes(q) || (d.phone || '').includes(q) || (d.email || '').toLowerCase().includes(q) || (d.tachoCard || '').includes(q);
                              });
                              // Cap at 50 to avoid rendering 1500+ DOM nodes — user must search to narrow
                              const capped = filtered.slice(0, 50);
                              const hasMore = filtered.length > 50;
                              if (filtered.length === 0) return (
                                <Box style={{ padding: '20px 12px', textAlign: 'center' }}>
                                  <Typography style={{ fontSize: '0.74rem', color: '#94a3b8' }}>
                                    {lang === 'pt' ? 'Nenhum motorista encontrado' : 'No drivers found'}
                                  </Typography>
                                </Box>
                              );
                              return (<>{capped.map(d => {
                                const isActive = String(manualDriverId) === String(d.id);
                                return (
                                  <Box key={d.id}
                                    onClick={() => {
                                      setManualDriverId(String(d.id));
                                      setDriverPickerAnchor(null);
                                      // Mesmo trigger da "Detectado do veículo": se este
                                      // motorista ainda não tem coordenadas de casa,
                                      // abre o popup para o operador as confirmar.
                                      maybePromptAddress(d);
                                    }}
                                    style={{
                                      padding: '8px 12px', cursor: 'pointer',
                                      display: 'flex', alignItems: 'center', gap: 8,
                                      background: isActive ? '#eff6ff' : 'transparent',
                                      borderBottom: '1px solid #f8fafc',
                                      transition: 'background 0.12s',
                                    }}
                                    onMouseEnter={(e) => { if (!isActive) e.currentTarget.style.background = '#f8fafc'; }}
                                    onMouseLeave={(e) => { if (!isActive) e.currentTarget.style.background = isActive ? '#eff6ff' : 'transparent'; }}
                                  >
                                    <Box style={{
                                      width: 30, height: 30, borderRadius: 8,
                                      background: isActive ? '#dbeafe' : '#f1f5f9',
                                      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                    }}>
                                      <PersonIcon style={{ fontSize: 14, color: isActive ? '#2563eb' : '#8b5cf6' }} />
                                    </Box>
                                    <Box style={{ flex: 1, minWidth: 0 }}>
                                      <Typography style={{ fontSize: '0.78rem', fontWeight: 700, color: '#0f172a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {d.name}
                                      </Typography>
                                      <Box style={{ display: 'flex', gap: 8, fontSize: '0.6rem', color: '#64748b' }}>
                                        {d.phone && <span>{d.phone}</span>}
                                        {d.email && <span>{d.email}</span>}
                                        {d.tachoCard && <span style={{ fontFamily: 'monospace', fontSize: '0.56rem', color: '#94a3b8' }}>{d.tachoCard}</span>}
                                      </Box>
                                    </Box>
                                    {isActive && <Box style={{ width: 8, height: 8, borderRadius: '50%', background: '#3b82f6' }} />}
                                  </Box>
                                );
                              })}
                              {hasMore && (
                                <Box style={{ padding: '10px 12px', textAlign: 'center', background: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
                                  <Typography style={{ fontSize: '0.68rem', color: '#6366f1', fontWeight: 600 }}>
                                    {lang === 'pt'
                                      ? `A mostrar 50 de ${filtered.length} · pesquise para refinar`
                                      : `Showing 50 of ${filtered.length} · search to refine`}
                                  </Typography>
                                </Box>
                              )}
                              </>);
                            })()}
                          </Box>
                          {/* Footer count */}
                          <Box style={{ padding: '6px 12px', borderTop: '1px solid #f1f5f9', background: '#fafbfc', flexShrink: 0 }}>
                            <Typography style={{ fontSize: '0.62rem', color: '#94a3b8' }}>
                              {allDrivers.length} {lang === 'pt' ? 'motoristas na base de dados' : 'drivers in database'}
                            </Typography>
                          </Box>
                      </Popover>
                    </Box>
                  </Box>
                  {/* Tempo de descarga — alongside the driver picker so the
                      operator sets both before confirming. Compact card.
                      Hidden for assistance OTs: those don't have an unload
                      step (the technician's stop time is tracked separately
                      via `assistanceTime` in the OT, not via descarga). */}
                  {currentOT?.serviceType !== 'assistance' && (
                    <Box style={{
                      padding: '4px 10px', borderRadius: 8,
                      background: '#fffbeb', border: '1px solid #fde68a',
                      display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0,
                    }}>
                      <Box style={{ width: 22, height: 22, borderRadius: 6, background: '#f59e0b', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <span style={{ fontSize: 12, color: '#fff' }}>⏱</span>
                      </Box>
                      <Box>
                        <Typography style={{ fontSize: '0.55rem', fontWeight: 800, color: '#92400e', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                          {lang === 'pt' ? 'Tempo descarga' : 'Unloading time'}
                        </Typography>
                        <Box style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                          <input
                            type="number" min="0" step="5" placeholder="0"
                            value={unloadingTime}
                            onChange={e => setUnloadingTime(e.target.value)}
                            style={{ width: 56, border: '1px solid #fde68a', borderRadius: 6, padding: '3px 8px', fontSize: '0.74rem', fontWeight: 700, textAlign: 'center', background: '#fff', color: '#78350f' }}
                          />
                          <Typography style={{ fontSize: '0.62rem', color: '#92400e', fontWeight: 700 }}>min</Typography>
                        </Box>
                      </Box>
                    </Box>
                  )}
                  {/* Bulk mode indicator */}
                  {bulkAssignMode && (
                    <Box style={{
                      padding: '4px 10px', borderRadius: 8,
                      background: '#eef2ff', border: '1px solid #c7d2fe',
                      fontSize: '0.62rem', fontWeight: 700, color: '#4338ca',
                      display: 'flex', alignItems: 'center', gap: 4,
                    }}>
                      {lang === 'pt' ? `${selected.length} OTs serão atribuídas` : `${selected.length} OTs will be assigned`}
                    </Box>
                  )}
                </Box>
              );
            })()}

            {/* Cisterna atrelada — só para OTs fuel (Move Express). Trigger
                compacto que abre o Dialog dedicado. Não empurra os tractores
                para fora da viewport. */}
            {(() => {
              const currentOT = list.find(o => String(o._id || o.id) === String(vehicleAssignOrderId));
              if (currentOT?.serviceType !== 'fuel') return null;
              const cisterns = (allVehicles || []).filter(v => v.vehicleKind === 'trailer_cistern');
              const wantedCap = currentOT?.cisternCapacityM3 != null ? Number(currentOT.cisternCapacityM3) : null;
              const selectedList = cisterns.filter(c => selectedCisternIds.includes(String(c.id)));
              const totalCap = selectedList.reduce((s, c) => s + (Number(c.cisternCapacityM3) || 0), 0);
              const capShort = wantedCap != null && totalCap > 0 && totalCap < wantedCap;
              const hasSel = selectedList.length > 0;
              if (!selectedVehicleId) {
                return (
                  <Box style={{
                    margin: '12px 20px', padding: '12px 14px', borderRadius: 10,
                    background: '#fff', border: '1px dashed #e2e8f0',
                    display: 'flex', alignItems: 'center', gap: 10,
                  }}>
                    <Box style={{
                      width: 28, height: 28, borderRadius: 8,
                      background: '#f1f5f9', color: '#94a3b8',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 16,
                    }}>🛢</Box>
                    <Typography style={{ fontSize: '0.72rem', color: '#94a3b8', fontStyle: 'italic' }}>
                      {lang === 'pt'
                        ? <>Escolhe primeiro o <strong>tractor</strong> acima — depois podes escolher as cisternas.</>
                        : <>First choose the <strong>tractor</strong> above — then you can pick the cisterns.</>}
                    </Typography>
                  </Box>
                );
              }
              if (cisterns.length === 0) return null;
              // Trigger compacto — botão grande que abre o picker (até 2 cisternas).
              return (
                <Box style={{
                  margin: '12px 20px', padding: '14px 16px', borderRadius: 12,
                  background: 'linear-gradient(135deg, #fff7ed 0%, #ffffff 60%)',
                  border: '1px solid #fed7aa',
                  boxShadow: '0 1px 2px rgba(15,23,42,0.03)',
                }}>
                  <Box style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <Box style={{
                      width: 36, height: 36, borderRadius: 9, flexShrink: 0,
                      background: hasSel ? 'linear-gradient(135deg, #16a34a, #15803d)' : '#fff7ed',
                      color: hasSel ? '#fff' : '#ea580c',
                      border: `1px solid ${hasSel ? '#15803d' : '#fed7aa'}`,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                      {hasSel ? <CheckCircleIcon style={{ fontSize: 20 }} /> : <span style={{ fontSize: 18 }}>🛢</span>}
                    </Box>
                    <Box style={{ flex: 1, minWidth: 0 }}>
                      <Typography style={{
                        fontSize: '0.64rem', fontWeight: 800, color: '#9a3412',
                        textTransform: 'uppercase', letterSpacing: 0.6,
                      }}>
                        {lang === 'pt' ? 'Cisternas atreladas' : 'Attached cisterns'} {wantedCap != null && (<span style={{ color: '#94a3b8' }}>· {lang === 'pt' ? 'pedido' : 'requested'} <span style={{ color: '#15803d', fontFamily: 'ui-monospace, Menlo, monospace' }}>{wantedCap} m³</span></span>)}
                      </Typography>
                      {hasSel ? (
                        <Box style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 4, flexWrap: 'wrap' }}>
                          {selectedList.map(c => (
                            <span key={c.id} style={{
                              display: 'inline-flex', alignItems: 'center', gap: 6,
                              padding: '3px 10px', borderRadius: 999,
                              background: '#fff', border: '1px solid #bbf7d0',
                              fontSize: '0.82rem', fontWeight: 800, color: '#0f172a',
                              fontFamily: 'ui-monospace, Menlo, monospace',
                            }}>
                              {c.plate || c.name}
                              <span style={{ color: '#15803d', fontSize: '0.66rem' }}>{c.cisternCapacityM3} m³</span>
                            </span>
                          ))}
                          <span style={{
                            padding: '3px 10px', borderRadius: 999,
                            background: capShort ? '#fef3c7' : '#dcfce7',
                            color: capShort ? '#b45309' : '#15803d',
                            border: `1px solid ${capShort ? '#fde68a' : '#bbf7d0'}`,
                            fontSize: '0.7rem', fontWeight: 800,
                            fontFamily: 'ui-monospace, Menlo, monospace',
                          }}>
                            {lang === 'pt' ? 'total' : 'total'} {totalCap} m³
                          </span>
                        </Box>
                      ) : (
                        <Typography style={{ fontSize: '0.78rem', color: '#9a3412', fontStyle: 'italic', marginTop: 2 }}>
                          {lang === 'pt'
                            ? `Por escolher — clica para abrir a lista (${cisterns.length} cisternas · até 2)`
                            : `Not selected — click to open list (${cisterns.length} cisterns · up to 2)`}
                        </Typography>
                      )}
                    </Box>
                    <Box style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                      {hasSel && (
                        <Button
                          size="small"
                          onClick={() => setSelectedCisternIds([])}
                          style={{
                            textTransform: 'none', fontSize: '0.7rem',
                            color: '#9a3412', minWidth: 0, padding: '4px 10px',
                          }}>
                          {lang === 'pt' ? 'Limpar' : 'Clear'}
                        </Button>
                      )}
                      <Button
                        size="small"
                        variant="contained"
                        onClick={() => { setCisternSearch(''); setCisternPickerOpen(true); }}
                        style={{
                          textTransform: 'none', fontSize: '0.72rem', fontWeight: 700,
                          background: hasSel ? '#fff' : 'linear-gradient(135deg, #fb923c, #f97316)',
                          color: hasSel ? '#9a3412' : '#fff',
                          border: hasSel ? '1px solid #fed7aa' : 'none',
                          boxShadow: hasSel ? 'none' : '0 2px 6px rgba(249,115,22,0.25)',
                          padding: '6px 14px', borderRadius: 8,
                        }}>
                        {hasSel
                          ? (lang === 'pt' ? (selectedList.length < 2 ? 'Alterar / + 2ª' : 'Alterar') : 'Change')
                          : (lang === 'pt' ? 'Escolher cisternas →' : 'Select cisterns →')}
                      </Button>
                    </Box>
                  </Box>
                  {capShort && (
                    <Typography style={{ marginTop: 8, fontSize: '0.72rem', fontWeight: 700, color: '#b45309' }}>
                      ⚠ {lang === 'pt'
                        ? `As cisternas escolhidas somam ${totalCap} m³, menos que o pedido (${wantedCap} m³). Podes juntar outra cisterna.`
                        : `Selected cisterns total ${totalCap} m³, less than requested (${wantedCap} m³).`}
                    </Typography>
                  )}
                </Box>
              );
            })()}
            {/* Bloco antigo — substituído pelo trigger acima + dialog. */}
            {false && (() => {
              const currentOT = list.find(o => String(o._id || o.id) === String(vehicleAssignOrderId));
              if (currentOT?.serviceType !== 'fuel') return null;
              // Gate: só aparece quando o operador já escolheu um tractor.
              if (!selectedVehicleId) {
                return (
                  <Box style={{
                    margin: '12px 20px', padding: '12px 14px', borderRadius: 10,
                    background: '#fff', border: '1px dashed #e2e8f0',
                    display: 'flex', alignItems: 'center', gap: 10,
                  }}>
                    <Box style={{
                      width: 28, height: 28, borderRadius: 8,
                      background: '#f1f5f9', color: '#94a3b8',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 16,
                    }}>🛢</Box>
                    <Typography style={{ fontSize: '0.72rem', color: '#94a3b8', fontStyle: 'italic' }}>
                      Escolhe primeiro o <strong>tractor</strong> acima — a lista de cisternas aparece a seguir.
                    </Typography>
                  </Box>
                );
              }
              const cisterns = (allVehicles || []).filter(v => v.vehicleKind === 'trailer_cistern');
              if (cisterns.length === 0) return null;
              const wantedCap = currentOT?.cisternCapacityM3 != null ? Number(currentOT.cisternCapacityM3) : null;
              const q = String(cisternSearch || '').trim().toLowerCase();
              const filtered = cisterns.filter(c => {
                if (!q) return true;
                return String(c.plate || '').toLowerCase().includes(q)
                  || String(c.name || '').toLowerCase().includes(q)
                  || String(c.model || '').toLowerCase().includes(q)
                  || String(c.cisternCapacityM3 || '').includes(q);
              });
              const sorted = [...filtered].sort((a, b) => {
                const am = wantedCap != null && Number(a.cisternCapacityM3) === wantedCap ? 0 : 1;
                const bm = wantedCap != null && Number(b.cisternCapacityM3) === wantedCap ? 0 : 1;
                if (am !== bm) return am - bm;
                return String(a.plate || a.name || '').localeCompare(String(b.plate || b.name || ''));
              });
              const selected = cisterns.find(c => String(c.id) === String(selectedCisternIds[0] || ''));
              return (
                <Box style={{
                  margin: '12px 20px', padding: '14px 16px', borderRadius: 12,
                  background: 'linear-gradient(135deg, #fff7ed 0%, #ffffff 60%)',
                  border: '1px solid #fed7aa',
                  boxShadow: '0 1px 2px rgba(15,23,42,0.03)',
                }}>
                  {/* Header */}
                  <Box style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                    <Box style={{
                      width: 28, height: 28, borderRadius: 8,
                      background: '#fff7ed', color: '#ea580c',
                      border: '1px solid #fed7aa',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                      <span style={{ fontSize: 14 }}>🛢</span>
                    </Box>
                    <Box style={{ flex: 1 }}>
                      <Typography style={{ fontSize: '0.66rem', fontWeight: 800, color: '#9a3412', textTransform: 'uppercase', letterSpacing: 0.6 }}>
                        Cisterna atrelada
                      </Typography>
                      {wantedCap != null && (
                        <Typography style={{ fontSize: '0.6rem', color: '#94a3b8', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.4 }}>
                          pedido: <span style={{ color: '#15803d', fontFamily: 'ui-monospace, Menlo, monospace' }}>{wantedCap} m³</span>
                        </Typography>
                      )}
                    </Box>
                    {selected && (
                      <Box style={{
                        padding: '4px 10px', borderRadius: 999,
                        background: '#dcfce7', color: '#15803d',
                        fontSize: '0.62rem', fontWeight: 800,
                        display: 'flex', alignItems: 'center', gap: 4,
                      }}>
                        <CheckCircleIcon style={{ fontSize: 12 }} />
                        {selected.plate || selected.name}
                      </Box>
                    )}
                    {selectedCisternIds.length > 0 && (
                      <Button size="small" onClick={() => setSelectedCisternIds([])}
                        style={{ textTransform: 'none', fontSize: '0.66rem', color: '#9a3412', minWidth: 0, padding: '2px 8px' }}>
                        Limpar
                      </Button>
                    )}
                  </Box>
                  {/* Search input */}
                  <Box style={{
                    background: '#fff', border: '1px solid #fed7aa', borderRadius: 8,
                    display: 'flex', alignItems: 'center', gap: 6, padding: '4px 10px', marginBottom: 8,
                  }}>
                    <SearchIcon style={{ fontSize: 16, color: '#fb923c' }} />
                    <input
                      type="text"
                      value={cisternSearch}
                      onChange={e => setCisternSearch(e.target.value)}
                      placeholder="Pesquisar matrícula, modelo ou capacidade…"
                      style={{
                        border: 'none', outline: 'none', flex: 1,
                        fontSize: '0.78rem', background: 'transparent',
                        color: '#0f172a',
                        fontFamily: 'inherit',
                      }}
                    />
                    {cisternSearch && (
                      <CloseIcon onClick={() => setCisternSearch('')}
                        style={{ fontSize: 14, color: '#94a3b8', cursor: 'pointer' }} />
                    )}
                    <span style={{ fontSize: '0.62rem', color: '#94a3b8', fontWeight: 700, fontFamily: 'ui-monospace, Menlo, monospace' }}>
                      {sorted.length}/{cisterns.length}
                    </span>
                  </Box>
                  {/* Lista — altura limitada a 3 cisternas visíveis para não
                      empurrar os tractores acima fora da viewport. Operador
                      faz scroll dentro da lista. */}
                  <Box style={{ maxHeight: 140, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 4 }}>
                    {sorted.length === 0 ? (
                      <Typography style={{ fontSize: '0.72rem', color: '#94a3b8', fontStyle: 'italic', padding: '12px 0', textAlign: 'center' }}>
                        Sem cisternas para a pesquisa.
                      </Typography>
                    ) : sorted.map(c => {
                      const isSel = String(c.id) === String(selectedCisternIds[0] || '');
                      const matchesCap = wantedCap != null && Number(c.cisternCapacityM3) === wantedCap;
                      return (
                        <Box key={c.id}
                          onClick={() => setSelectedCisternIds(isSel ? [] : [String(c.id)])}
                          style={{
                            display: 'flex', alignItems: 'center', gap: 10,
                            padding: '8px 12px', borderRadius: 8, cursor: 'pointer',
                            background: isSel ? 'linear-gradient(135deg, #f97316, #ea580c)' : '#fff',
                            border: `1px solid ${isSel ? '#ea580c' : (matchesCap ? '#bbf7d0' : '#e2e8f0')}`,
                            color: isSel ? '#fff' : '#0f172a',
                            boxShadow: isSel ? '0 2px 6px rgba(234,88,12,0.25)' : 'none',
                            transition: 'all 0.12s',
                          }}>
                          <span style={{
                            fontWeight: 800, fontFamily: 'ui-monospace, Menlo, monospace',
                            minWidth: 100, fontSize: '0.82rem',
                          }}>
                            {c.plate || c.name}
                          </span>
                          <span style={{
                            padding: '2px 10px', borderRadius: 999,
                            background: isSel ? 'rgba(255,255,255,0.25)' : (matchesCap ? '#dcfce7' : '#f1f5f9'),
                            color: isSel ? '#fff' : (matchesCap ? '#15803d' : '#475569'),
                            fontSize: '0.62rem', fontWeight: 800,
                            fontFamily: 'ui-monospace, Menlo, monospace',
                          }}>
                            {c.cisternCapacityM3 != null ? `${c.cisternCapacityM3} m³` : '—'}
                          </span>
                          <span style={{
                            flex: 1, fontSize: '0.66rem',
                            opacity: isSel ? 0.95 : 0.6,
                            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                          }}>
                            {c.model || ''}
                          </span>
                          {isSel && (
                            <CheckCircleIcon style={{ fontSize: 16, opacity: 0.95 }} />
                          )}
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              );
            })()}

            {/* Footer — context-aware actions.
                Logic:
                  - Sem veículo + sem rota → "Só Atribuir" + "Atribuir e Planificar Rota"
                  - Com veículo + sem rota → "Alterar Veículo" + "Planificar Rota" (novo)
                  - Com veículo + com rota → só "Alterar Veículo"
                "Planificar Rota" usa o mesmo flow do "Atribuir e Planificar"
                (que já aplica origem=casa do motorista p/ assistência, return-home,
                fuel 3-stop, etc.) — o /assign-vehicle é idempotente, então passar
                pela mesma rota funciona sem efeitos colaterais. */}
            {(() => {
              const currentOT = list.find(o => String(o._id || o.id) === String(vehicleAssignOrderId));
              const isAlreadyAssigned = currentOT?.status === 'assigned' || !!currentOT?.vehiclePlate;
              const hasRoute = !!currentOT?.assignedRouteId;
              return (
                <Box style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 20px', borderTop: '1px solid #e2e8f0', background: '#fafbfc' }}>
                  <Button size="small" onClick={() => {
                    // Defensive reset — ensures no in-memory state leaks into
                    // the next dialog open, even though "Cancelar" already
                    // doesn't trigger any persistence.
                    setSelectedVehicleId('');
                    setManualDriverId('');
                    setDriverDraft(null);
                    setUnloadingTime('');
                    setCustomDepartureLocationId('');
                    setCustomArrivalLocationId('');
                    setVehicleAssignOrderId(null);
                  }}
                    variant="outlined"
                    startIcon={<span style={{ fontSize: 14 }}>✕</span>}
                    style={{
                      fontSize: '0.78rem', fontWeight: 700, textTransform: 'none',
                      color: '#dc2626', borderColor: '#fecaca',
                      background: '#fef2f2', borderRadius: 10, padding: '6px 18px',
                    }}>
                    {lang === 'pt' ? 'Cancelar' : 'Cancel'}
                  </Button>
                  <Box style={{ display: 'flex', gap: 8 }}>
                    {isAlreadyAssigned && (<>
                      {/* OT já atribuída — sempre mostrar BOTH "Alterar Veículo"
                          E "Planificar Rota" (ou "Re-Planificar" se já existe).
                          O fluxo de planificação é o único caminho para gerar/
                          regenerar a rota; escondê-lo quando já há rota deixava
                          o operador sem forma de a refazer a partir deste ecrã. */}
                      <Button size="small" variant="outlined" disabled={!selectedVehicleId || vehicleAssigning}
                        onClick={() => confirmVehicleAssign(false)}
                        style={{
                          fontSize: '0.72rem', fontWeight: 600, textTransform: 'none',
                          borderColor: '#e2e8f0', color: '#64748b', borderRadius: 10, padding: '6px 16px',
                        }}>
                        {vehicleAssigning ? '...' : (lang === 'pt' ? 'Alterar Veículo' : 'Change Vehicle')}
                      </Button>
                      <Button size="small" variant="contained" disabled={!selectedVehicleId || vehicleAssigning}
                        onClick={handlePlanWithStockCheck}
                        style={{
                          fontSize: '0.72rem', fontWeight: 700, textTransform: 'none',
                          background: selectedVehicleId ? 'linear-gradient(135deg, #3b82f6, #2563eb)' : '#e2e8f0',
                          color: '#fff', borderRadius: 10, padding: '6px 20px',
                          boxShadow: selectedVehicleId ? '0 2px 8px rgba(59,130,246,0.3)' : 'none',
                        }}>
                        {vehicleAssigning
                          ? '...'
                          : (lang === 'pt'
                              ? (hasRoute ? 'Re-Planificar Rota' : 'Planificar Rota')
                              : (hasRoute ? 'Re-Plan Route' : 'Plan Route'))}
                      </Button>
                    </>)}
                    {!isAlreadyAssigned && (<>
                      {/* OT pendente — mostra os 2 botões originais. */}
                      <Button size="small" variant="outlined" disabled={!selectedVehicleId || vehicleAssigning}
                        onClick={() => confirmVehicleAssign(false)}
                        style={{
                          fontSize: '0.72rem', fontWeight: 600, textTransform: 'none',
                          borderColor: '#e2e8f0', color: '#64748b', borderRadius: 10, padding: '6px 16px',
                        }}>
                        {vehicleAssigning ? '...' : (lang === 'pt' ? 'Só Atribuir' : 'Assign Only')}
                      </Button>
                      <Button size="small" variant="contained" disabled={!selectedVehicleId || vehicleAssigning}
                        onClick={handlePlanWithStockCheck}
                        style={{
                          fontSize: '0.72rem', fontWeight: 700, textTransform: 'none',
                          background: selectedVehicleId ? 'linear-gradient(135deg, #3b82f6, #2563eb)' : '#e2e8f0',
                          color: '#fff', borderRadius: 10, padding: '6px 20px',
                          boxShadow: selectedVehicleId ? '0 2px 8px rgba(59,130,246,0.3)' : 'none',
                        }}>
                        {vehicleAssigning ? '...' : (lang === 'pt' ? 'Atribuir e Planificar Rota' : 'Assign & Plan Route')}
                      </Button>
                    </>)}
                  </Box>
                </Box>
              );
            })()}
          </Box>
        </>
        );
      })()}

      {/* Fullscreen vehicle-assign map. The card map in the dialog is
          small — when the operator is hunting for vehicles in / out of
          the radius, this modal blows the same map up to nearly the full
          viewport. State (selected vehicle, radius) is shared, so picking
          a vehicle here updates the assign dialog underneath; closing
          returns to the dialog with the choice already made. */}

      {/* Petrotec AO — Popover de stock por viatura. Aberto quando o
          operador clica no chip 📦 num card de viatura no dialog de
          atribuição. Mostra a lista do material disponível. */}
      <Popover
        open={!!stockPopoverVehicleId && !!stockPopoverAnchor}
        anchorEl={stockPopoverAnchor}
        onClose={() => { setStockPopoverVehicleId(null); setStockPopoverAnchor(null); }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ style: { padding: 0, maxWidth: 380, minWidth: 320 } }}
      >
        {(() => {
          if (!stockPopoverVehicleId) return null;
          const stk = vehicleStockMap[stockPopoverVehicleId];
          const vehicle = availableVehicles.find(v => String(v.id) === String(stockPopoverVehicleId));
          const balances = stk?.balances || [];
          // Agrupar por categoria
          const byCategory = balances.reduce((acc, b) => {
            const cat = b.category || (lang === 'pt' ? 'Sem categoria' : 'Uncategorised');
            if (!acc[cat]) acc[cat] = [];
            acc[cat].push(b);
            return acc;
          }, {});
          const categories = Object.keys(byCategory).sort();
          return (
            <Box>
              <Box style={{
                padding: '12px 14px',
                background: 'linear-gradient(135deg, #f0fdf4, #dcfce7)',
                borderBottom: '1px solid #bbf7d0',
              }}>
                <Box style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ fontSize: 14 }}>📦</span>
                  <Typography style={{ fontSize: '0.8rem', fontWeight: 800, color: '#166534' }}>
                    {lang === 'pt' ? 'Stock disponível' : 'Stock available'} · {vehicle?.plate}
                  </Typography>
                </Box>
                <Typography style={{ fontSize: '0.66rem', color: '#166534', marginTop: 2 }}>
                  {stk?.items || 0} {lang === 'pt' ? 'refs distintas' : 'distinct refs'} · {stk?.units || 0} {lang === 'pt' ? 'unidades' : 'units'}
                </Typography>
              </Box>
              <Box style={{ maxHeight: 360, overflowY: 'auto' }}>
                {balances.length === 0 ? (
                  <Box style={{ padding: '24px 14px', textAlign: 'center' }}>
                    <Typography style={{ fontSize: '0.78rem', color: '#94a3b8' }}>
                      {lang === 'pt' ? 'Esta viatura não tem stock.' : 'No stock.'}
                    </Typography>
                  </Box>
                ) : categories.map(cat => (
                  <Box key={cat}>
                    <Box style={{
                      padding: '6px 14px', background: '#f8fafc',
                      borderBottom: '1px solid #f1f5f9',
                      fontSize: '0.58rem', fontWeight: 800,
                      color: '#64748b', textTransform: 'uppercase',
                      letterSpacing: '0.04em',
                    }}>{cat}</Box>
                    {byCategory[cat].map(b => (
                      <Box key={b.stockItemId} style={{
                        display: 'flex', alignItems: 'center', gap: 8,
                        padding: '8px 14px', borderBottom: '1px solid #f1f5f9',
                      }}>
                        <Box style={{ flex: 1, minWidth: 0 }}>
                          <Typography style={{
                            fontSize: '0.74rem', fontWeight: 700, color: '#0f172a',
                            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                          }}>
                            {b.name}
                          </Typography>
                          <Typography style={{ fontSize: '0.6rem', color: '#94a3b8' }}>
                            {b.code}
                          </Typography>
                        </Box>
                        <Box style={{
                          padding: '3px 8px', borderRadius: 6,
                          background: '#eff6ff', color: '#1d4ed8',
                          fontSize: '0.7rem', fontWeight: 800,
                        }}>
                          {b.quantity} {b.unit}
                        </Box>
                      </Box>
                    ))}
                  </Box>
                ))}
              </Box>
            </Box>
          );
        })()}
      </Popover>

      {mapFullscreenOpen && vehicleAssignOrderId && (() => {
        const currentOT = list.find(o => String(o._id || o.id) === String(vehicleAssignOrderId));
        const isAssistOT = currentOT?.serviceType === 'assistance';
        const defaultLat = isAssistOT
          ? Number(currentOT?.deliveryLat)
          : Number(currentOT?.pickupLat || currentOT?.pickup?.lat);
        const defaultLng = isAssistOT
          ? Number(currentOT?.deliveryLng)
          : Number(currentOT?.pickupLng || currentOT?.pickup?.lng);
        const defaultName = isAssistOT
          ? (currentOT?.deliveryName || currentOT?.deliveryAddress || '')
          : (currentOT?.pickupName || currentOT?.pickupAddress || '');
        const otAnchorPoint = (Number.isFinite(defaultLat) && Number.isFinite(defaultLng))
          ? { lat: defaultLat, lng: defaultLng, name: defaultName }
          : null;
        let focusPoint = otAnchorPoint;
        let focusKind = isAssistOT ? 'service' : 'pickup';
        if (customDepartureLocationId === 'driver-home') {
          const drv = manualDriverId
            ? allDrivers.find(d => String(d.id) === String(manualDriverId))
            : null;
          if (drv?.homeLat && drv?.homeLng) {
            focusPoint = { lat: Number(drv.homeLat), lng: Number(drv.homeLng), name: `🏠 ${drv.name}` };
            focusKind = 'driver-home';
          }
        } else if (customDepartureLocationId === 'service' && currentOT?.deliveryLat && currentOT?.deliveryLng) {
          focusPoint = { lat: Number(currentOT.deliveryLat), lng: Number(currentOT.deliveryLng), name: currentOT.deliveryName || 'Local de serviço' };
          focusKind = 'service';
        } else if (customDepartureLocationId && (allLocations || []).length) {
          const loc = allLocations.find(l => String(l.id) === String(customDepartureLocationId));
          if (loc?.latitude && loc?.longitude) {
            focusPoint = {
              lat: Number(loc.latitude),
              lng: Number(loc.longitude),
              name: loc.name || (lang === 'pt' ? 'Local de partida' : 'Departure'),
            };
            focusKind = 'departure';
          }
        }
        return (
          <Dialog
            open
            maxWidth={false}
            fullWidth
            onClose={() => setMapFullscreenOpen(false)}
            PaperProps={{ style: { width: '94vw', height: '92vh', margin: 0, borderRadius: 14, overflow: 'hidden' } }}>
            <Box style={{
              padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 12,
              borderBottom: '1px solid #e2e8f0', background: '#f8fafc', flexShrink: 0,
            }}>
              <FullscreenIcon style={{ fontSize: 20, color: '#3b82f6' }} />
              <Typography style={{ fontSize: '0.92rem', fontWeight: 800, color: '#0f172a' }}>
                {lang === 'pt' ? 'Escolher veículo no mapa' : 'Pick vehicle on map'}
              </Typography>
              {focusPoint?.name && (
                <Typography style={{ fontSize: '0.72rem', color: '#64748b', marginLeft: 4 }}>
                  · {lang === 'pt' ? 'Centrado em' : 'Centred on'} <b style={{ color: '#0f172a' }}>{focusPoint.name}</b>
                </Typography>
              )}
              <Box style={{ flex: 1 }} />
              <Typography style={{ fontSize: '0.7rem', color: '#64748b' }}>
                {lang === 'pt' ? 'Clica num veículo para o seleccionar' : 'Click a vehicle to select it'}
              </Typography>
              <IconButton size="small" onClick={() => setMapFullscreenOpen(false)} title={lang === 'pt' ? 'Fechar' : 'Close'}>
                <CloseIcon style={{ fontSize: 18 }} />
              </IconButton>
            </Box>
            <Box style={{ flex: 1, minHeight: 0, padding: 12, background: 'linear-gradient(180deg, #f1f5f9 0%, #e2e8f0 100%)', display: 'flex' }}>
              <VehicleLocationPreview
                vehicle={availableVehicles.find(v => String(v.id) === selectedVehicleId) || null}
                allVehicles={availableVehicles}
                pickupPoint={focusPoint}
                pickupKind={focusKind}
                radiusKm={vehicleAssignRadiusKm}
                onRadiusChange={setVehicleAssignRadiusKm}
                onSelectVehicle={(id) => {
                  pickVehicleForAssign(id);
                  setMapFullscreenOpen(false);
                }}
              />
            </Box>
          </Dialog>
        );
      })()}

      {/* Unassign confirmation dialog — opens above the assign-vehicle
          dialog with a polished card (icon, summary, two clear buttons).
          On confirm we keep the assign dialog open so the operator can
          pick a new vehicle without re-navigating. */}
      {unassignConfirm && (
        <>
          <Box style={{
            position: 'fixed', inset: 0, zIndex: 1300, background: 'rgba(15,23,42,0.55)', backdropFilter: 'blur(2px)',
          }} onClick={() => !unassignBusy && setUnassignConfirm(null)} />
          <Box style={{
            position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
            zIndex: 1301, width: 460, maxWidth: 'calc(100vw - 24px)',
            background: '#fff', borderRadius: 16,
            boxShadow: '0 24px 80px rgba(15,23,42,0.35)',
            overflow: 'hidden',
          }}>
            <Box style={{
              padding: '18px 22px', display: 'flex', alignItems: 'center', gap: 12,
              borderBottom: '1px solid #fecaca',
              background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
            }}>
              <Box style={{
                width: 40, height: 40, borderRadius: 10,
                background: 'linear-gradient(135deg, #dc2626, #991b1b)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(220,38,38,0.3)',
              }}>
                <Typography style={{ fontSize: 20, color: '#fff' }}>🗑</Typography>
              </Box>
              <Box style={{ flex: 1 }}>
                <Typography style={{ fontSize: '1rem', fontWeight: 800, color: '#991b1b' }}>
                  {lang === 'pt' ? 'Retirar atribuição' : 'Remove assignment'}
                </Typography>
                <Typography style={{ fontSize: '0.68rem', color: '#7f1d1d' }}>
                  {lang === 'pt' ? 'A OT volta a "Por atribuir"' : 'The OT returns to "Unassigned"'}
                </Typography>
              </Box>
            </Box>
            <Box style={{ padding: '18px 22px' }}>
              <Typography style={{ fontSize: '0.84rem', color: '#0f172a', marginBottom: 12 }}>
                {lang === 'pt'
                  ? 'Confirmas que queres retirar a atribuição actual? Vais poder escolher um novo veículo no mesmo ecrã.'
                  : 'Confirm you want to remove the current assignment? You can pick a new vehicle on the same screen.'}
              </Typography>
              {/* Summary box — what's being undone */}
              <Box style={{
                padding: '10px 14px', borderRadius: 10,
                background: '#f8fafc', border: '1px solid #e2e8f0',
                display: 'flex', flexDirection: 'column', gap: 4,
              }}>
                <Box style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <Typography style={{ fontSize: '0.6rem', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em', minWidth: 60 }}>OT</Typography>
                  <Typography style={{ fontSize: '0.8rem', fontWeight: 700, color: '#0f172a' }}>
                    {unassignConfirm.orderNumber || `#${unassignConfirm.orderId}`}
                  </Typography>
                </Box>
                <Box style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <Typography style={{ fontSize: '0.6rem', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em', minWidth: 60 }}>Veículo</Typography>
                  <Typography style={{ fontSize: '0.8rem', fontWeight: 700, color: '#0f172a', fontFamily: 'Roboto Mono, monospace', background: '#fef3c7', padding: '1px 8px', borderRadius: 5 }}>
                    {unassignConfirm.vehiclePlate || '—'}
                  </Typography>
                </Box>
                {unassignConfirm.driverName && (
                  <Box style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <Typography style={{ fontSize: '0.6rem', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em', minWidth: 60 }}>{lang === 'pt' ? 'Motorista' : 'Driver'}</Typography>
                    <Typography style={{ fontSize: '0.78rem', color: '#0f172a' }}>
                      👤 {unassignConfirm.driverName}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
            <Box style={{
              display: 'flex', gap: 8, padding: '12px 22px',
              borderTop: '1px solid #e2e8f0', background: '#fafbfc',
            }}>
              <Button
                onClick={() => setUnassignConfirm(null)}
                disabled={unassignBusy}
                style={{
                  flex: 1, padding: '10px', textTransform: 'none',
                  fontSize: '0.84rem', fontWeight: 700,
                  color: '#475569', background: '#f1f5f9', borderRadius: 10,
                }}>
                {lang === 'pt' ? 'Cancelar' : 'Cancel'}
              </Button>
              <Button
                onClick={executeUnassign}
                disabled={unassignBusy}
                variant="contained"
                style={{
                  flex: 2, padding: '10px', textTransform: 'none',
                  fontSize: '0.84rem', fontWeight: 800,
                  background: unassignBusy ? '#cbd5e1' : 'linear-gradient(135deg, #dc2626, #991b1b)',
                  color: '#fff',
                  borderRadius: 10,
                  boxShadow: unassignBusy ? 'none' : '0 2px 8px rgba(220,38,38,0.35)',
                }}>
                {unassignBusy
                  ? (lang === 'pt' ? 'A retirar...' : 'Removing...')
                  : (lang === 'pt' ? '🗑 Confirmar e retirar' : '🗑 Confirm and remove')}
              </Button>
            </Box>
          </Box>
        </>
      )}

      {/* Import dialog */}
      {/* Keyboard shortcuts help — toggled via '?' */}
      {showShortcuts && (
        <Box style={{
          position: 'fixed', inset: 0, zIndex: 1500,
          background: 'rgba(15,23,42,0.55)', backdropFilter: 'blur(4px)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }} onClick={() => setShowShortcuts(false)}>
          <Box style={{
            background: '#fff', borderRadius: 14, padding: '20px 28px',
            boxShadow: '0 20px 60px rgba(0,0,0,0.28)', maxWidth: 420, width: '90vw',
          }} onClick={(e) => e.stopPropagation()}>
            <Typography style={{ fontSize: '0.95rem', fontWeight: 800, color: '#1e293b', marginBottom: 14 }}>
              ⌨ {lang === 'pt' ? 'Atalhos de teclado' : 'Keyboard shortcuts'}
            </Typography>
            {[
              { keys: ['N'],      label: lang === 'pt' ? 'Nova ordem de transporte' : 'New transport order' },
              { keys: ['F'],      label: lang === 'pt' ? 'Focar campo de pesquisa' : 'Focus search' },
              { keys: ['G'],      label: lang === 'pt' ? 'Alternar Tabela / Gantt' : 'Toggle Table / Gantt' },
              { keys: ['?'],      label: lang === 'pt' ? 'Mostrar / esconder esta ajuda' : 'Toggle this help' },
              { keys: ['Esc'],    label: lang === 'pt' ? 'Fechar expansões, diálogos, ajuda' : 'Close expand, dialogs, help' },
              { keys: ['Shift', 'Clique'], label: lang === 'pt' ? 'Adicionar coluna ao ordenamento (multi-sort)' : 'Add column to sort (multi-sort)' },
            ].map((row, i) => (
              <Box key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                <Box style={{ display: 'flex', gap: 4, minWidth: 110 }}>
                  {row.keys.map((k, j) => (
                    <React.Fragment key={j}>
                      <Box style={{
                        padding: '3px 8px', background: '#f1f5f9',
                        border: '1px solid #cbd5e1', borderRadius: 5,
                        fontSize: '0.66rem', fontWeight: 800, color: '#334155',
                        fontFamily: 'monospace',
                        boxShadow: '0 1px 0 rgba(0,0,0,0.15)',
                      }}>{k}</Box>
                      {j < row.keys.length - 1 && <Typography style={{ color: '#94a3b8', fontSize: '0.68rem' }}>+</Typography>}
                    </React.Fragment>
                  ))}
                </Box>
                <Typography style={{ fontSize: '0.76rem', color: '#475569', flex: 1 }}>{row.label}</Typography>
              </Box>
            ))}
            <Typography style={{ fontSize: '0.62rem', color: '#94a3b8', marginTop: 10, textAlign: 'center', fontStyle: 'italic' }}>
              {lang === 'pt' ? 'Prime ? novamente ou Esc para fechar' : 'Press ? again or Esc to close'}
            </Typography>
          </Box>
        </Box>
      )}

      {/* Driver contact dialog — one-click messaging via WhatsApp/SMS/Email */}
      <DriverContactDialog
        open={!!contactOrder}
        order={contactOrder}
        lang={lang}
        onClose={() => setContactOrder(null)}
      />

      {importDialog && (
        <>
          <Box style={{ position: 'fixed', inset: 0, zIndex: 1300, background: 'rgba(15,23,42,0.4)', backdropFilter: 'blur(2px)' }}
            onClick={() => setImportDialog(null)} />
          <Box style={{
            position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
            zIndex: 1301, width: 420, background: '#fff', borderRadius: 16,
            boxShadow: '0 20px 60px rgba(0,0,0,0.2)', overflow: 'hidden',
          }}>
            <Box style={{
              padding: '20px 24px',
              background: importDialog === 'excel' ? 'linear-gradient(180deg, #fff 0%, #dcfce7 100%)' : 'linear-gradient(180deg, #fff 0%, #dbeafe 100%)',
              borderBottom: importDialog === 'excel' ? '1px solid #bbf7d0' : '1px solid #bfdbfe',
              display: 'flex', alignItems: 'center', gap: 14,
            }}>
              <Box style={{
                width: 44, height: 44, borderRadius: 12,
                background: importDialog === 'excel' ? 'linear-gradient(135deg, #22c55e, #16a34a)' : 'linear-gradient(135deg, #3b82f6, #2563eb)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: importDialog === 'excel' ? '0 4px 12px rgba(34,197,94,0.3)' : '0 4px 12px rgba(59,130,246,0.3)',
              }}>
                <Typography style={{ fontSize: 22, color: '#fff' }}>
                  {importDialog === 'excel' ? '📊' : '🔗'}
                </Typography>
              </Box>
              <Box>
                <Typography style={{ fontSize: '1rem', fontWeight: 700, color: importDialog === 'excel' ? '#166534' : '#1e40af' }}>
                  {importDialog === 'excel'
                    ? (lang === 'pt' ? 'Importar de Excel' : 'Import from Excel')
                    : (lang === 'pt' ? 'Importar via API' : 'Import via API')}
                </Typography>
                <Typography style={{ fontSize: '0.68rem', color: '#64748b' }}>
                  {lang === 'pt' ? 'Funcionalidade em desenvolvimento' : 'Feature under development'}
                </Typography>
              </Box>
            </Box>
            <Box style={{ padding: '20px 24px' }}>
              {importDialog === 'excel' ? (
                <Box>
                  <Typography style={{ fontSize: '0.8rem', color: '#475569', lineHeight: 1.6, marginBottom: 12 }}>
                    {lang === 'pt'
                      ? 'A importação de OTs por Excel está em fase de implementação. O formato do ficheiro será definido em conjunto com o cliente para garantir compatibilidade com os seus sistemas.'
                      : 'Excel OT import is being implemented. The file format will be defined together with the client to ensure compatibility.'}
                  </Typography>
                  <Box style={{ padding: '12px 16px', background: '#f0fdf4', borderRadius: 10, border: '1px solid #dcfce7' }}>
                    <Typography style={{ fontSize: '0.68rem', fontWeight: 600, color: '#166534', marginBottom: 4 }}>
                      {lang === 'pt' ? 'Campos previstos:' : 'Expected fields:'}
                    </Typography>
                    <Typography style={{ fontSize: '0.62rem', color: '#475569', lineHeight: 1.5 }}>
                      Referência, Recolha (local, morada, contacto, janela horária), Entrega (local, morada, contacto, janela horária), Carga (descrição, peso, paletes, tipo), Prioridade, Notas
                    </Typography>
                  </Box>
                </Box>
              ) : (
                <Box>
                  <Typography style={{ fontSize: '0.8rem', color: '#475569', lineHeight: 1.6, marginBottom: 12 }}>
                    {lang === 'pt'
                      ? 'A integração via API permitirá receber OTs automaticamente do software de gestão do cliente. O endpoint e formato serão definidos em conjunto com o fornecedor de software.'
                      : 'API integration will allow automatic OT reception from the client\'s management software. The endpoint and format will be defined with the software vendor.'}
                  </Typography>
                  <Box style={{ padding: '12px 16px', background: '#eff6ff', borderRadius: 10, border: '1px solid #dbeafe' }}>
                    <Typography style={{ fontSize: '0.68rem', fontWeight: 600, color: '#1e40af', marginBottom: 4 }}>
                      {lang === 'pt' ? 'Integração prevista:' : 'Planned integration:'}
                    </Typography>
                    <Typography style={{ fontSize: '0.62rem', color: '#475569', lineHeight: 1.5 }}>
                      REST API · POST /planner-api/transport-orders/import · JSON · Autenticação por token · Webhook de notificação
                    </Typography>
                  </Box>
                </Box>
              )}
            </Box>
            <Box style={{ display: 'flex', justifyContent: 'flex-end', padding: '12px 24px', borderTop: '1px solid #f1f5f9', background: '#fafbfc' }}>
              <Button size="small" onClick={() => setImportDialog(null)}
                style={{ fontSize: '0.78rem', fontWeight: 600, textTransform: 'none', color: '#475569', borderRadius: 8, padding: '6px 20px' }}>
                {lang === 'pt' ? 'Fechar' : 'Close'}
              </Button>
            </Box>
          </Box>
        </>
      )}

      {/* Confirmation dialog — Plan & Dispatch */}
      {confirmDispatchData && (
        <>
          <Box style={{ position: 'fixed', inset: 0, zIndex: 1300, background: 'rgba(15,23,42,0.6)', backdropFilter: 'blur(3px)' }}
            onClick={() => setConfirmDispatchData(null)} />
          <Box style={{
            position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
            zIndex: 1301, width: 480, maxWidth: '95vw',
            background: '#fff', borderRadius: 16, boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
            overflow: 'hidden',
          }}>
            {/* Header — blue gradient */}
            <Box style={{ padding: '16px 20px', background: 'linear-gradient(180deg, #ffffff 0%, #dbeafe 100%)', borderBottom: '1px solid #bfdbfe', display: 'flex', alignItems: 'center', gap: 12 }}>
              <Box style={{ width: 38, height: 38, borderRadius: 10, background: 'linear-gradient(135deg, #3b82f6, #2563eb)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 8px rgba(59,130,246,0.3)' }}>
                <SendIcon style={{ fontSize: 18, color: '#fff' }} />
              </Box>
              <Box>
                <Typography style={{ fontSize: '0.95rem', fontWeight: 700, color: '#1e40af' }}>
                  {lang === 'pt' ? 'Confirmar Despacho' : 'Confirm Dispatch'}
                </Typography>
                <Typography style={{ fontSize: '0.62rem', color: '#64748b' }}>
                  {confirmDispatchData.orderNumber}
                </Typography>
              </Box>
            </Box>

            {/* Route info */}
            <Box style={{ padding: '16px 20px' }}>
              {/* Origin → Destination */}
              <Box style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 14 }}>
                <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, paddingTop: 4 }}>
                  <Box style={{ width: 10, height: 10, borderRadius: '50%', background: '#22c55e', border: '2px solid #fff', boxShadow: '0 0 0 1.5px #22c55e' }} />
                  <Box style={{ width: 1, height: 28, background: '#e2e8f0' }} />
                  <Box style={{ width: 10, height: 10, borderRadius: '50%', background: '#ef4444', border: '2px solid #fff', boxShadow: '0 0 0 1.5px #ef4444' }} />
                </Box>
                <Box style={{ flex: 1 }}>
                  <Box style={{ marginBottom: 12 }}>
                    <Typography style={{ fontSize: '0.58rem', fontWeight: 700, color: '#22c55e', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                      {confirmDispatchData.serviceType === 'assistance' ? (lang === 'pt' ? 'Saída' : 'Departure') : (lang === 'pt' ? 'Recolha' : 'Pickup')}
                    </Typography>
                    <Typography style={{ fontSize: '0.82rem', fontWeight: 600, color: '#0f172a' }}>
                      {confirmDispatchData.originName || confirmDispatchData.pickupName}
                    </Typography>
                    {confirmDispatchData.originAddress && (
                      <Typography style={{ fontSize: '0.62rem', color: '#475569', marginTop: 2 }}>
                        {confirmDispatchData.originAddress}
                      </Typography>
                    )}
                    <Typography style={{ fontSize: '0.6rem', color: '#64748b' }}>{confirmDispatchData.pickupWindow}</Typography>
                  </Box>
                  <Box>
                    <Typography style={{ fontSize: '0.58rem', fontWeight: 700, color: '#ef4444', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                      {confirmDispatchData.serviceType === 'assistance' ? (lang === 'pt' ? 'Local de serviço' : 'Service location') : (lang === 'pt' ? 'Entrega' : 'Delivery')}
                    </Typography>
                    <Typography style={{ fontSize: '0.82rem', fontWeight: 600, color: '#0f172a' }}>{confirmDispatchData.deliveryName}</Typography>
                    <Typography style={{ fontSize: '0.6rem', color: '#64748b' }}>{confirmDispatchData.deliveryWindow}</Typography>
                  </Box>
                </Box>
              </Box>

              {/* Details grid */}
              <Box style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <Box style={{ padding: '8px 12px', background: '#f0fdf4', borderRadius: 10, border: '1px solid #dcfce7' }}>
                  <Typography style={{ fontSize: '0.52rem', fontWeight: 700, color: '#22c55e', textTransform: 'uppercase' }}>Veículo</Typography>
                  <Typography style={{ fontSize: '0.82rem', fontWeight: 700, color: '#0f172a' }}>{confirmDispatchData.vehiclePlate}</Typography>
                </Box>
                <Box style={{ padding: '8px 12px', background: '#eff6ff', borderRadius: 10, border: '1px solid #dbeafe' }}>
                  <Typography style={{ fontSize: '0.52rem', fontWeight: 700, color: '#3b82f6', textTransform: 'uppercase' }}>Motorista</Typography>
                  <Typography style={{ fontSize: '0.82rem', fontWeight: 600, color: '#0f172a' }}>{confirmDispatchData.driverName}</Typography>
                  {confirmDispatchData.driverPhone && (
                    <Typography
                      component="a"
                      href={`tel:${confirmDispatchData.driverPhone}`}
                      style={{ fontSize: '0.7rem', fontWeight: 600, color: '#1d4ed8', textDecoration: 'none', display: 'inline-block', marginTop: 2 }}
                    >
                      📞 {confirmDispatchData.driverPhone}
                    </Typography>
                  )}
                </Box>
                <Box style={{ padding: '8px 12px', background: '#f8fafc', borderRadius: 10, border: '1px solid #e2e8f0' }}>
                  <Typography style={{ fontSize: '0.52rem', fontWeight: 700, color: '#64748b', textTransform: 'uppercase' }}>Carga</Typography>
                  <Typography style={{ fontSize: '0.72rem', color: '#0f172a' }}>{confirmDispatchData.cargo}</Typography>
                </Box>
                {confirmDispatchData.unloadingTime > 0 && (
                  <Box style={{ padding: '8px 12px', background: '#fffbeb', borderRadius: 10, border: '1px solid #fde68a' }}>
                    <Typography style={{ fontSize: '0.52rem', fontWeight: 700, color: '#f59e0b', textTransform: 'uppercase' }}>Tempo descarga</Typography>
                    <Typography style={{ fontSize: '0.72rem', fontWeight: 600, color: '#0f172a' }}>{confirmDispatchData.unloadingTime} min</Typography>
                  </Box>
                )}
              </Box>
            </Box>

            {/* Actions */}
            <Box style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, padding: '12px 20px', borderTop: '1px solid #e2e8f0', background: '#fafbfc' }}>
              <Button size="small" onClick={() => setConfirmDispatchData(null)}
                style={{ fontSize: '0.75rem', textTransform: 'none', color: '#64748b' }}>
                {lang === 'pt' ? 'Cancelar' : 'Cancel'}
              </Button>
              <Button size="small" variant="contained" disabled={vehicleAssigning}
                onClick={executeFullDispatch}
                style={{
                  fontSize: '0.75rem', fontWeight: 700, textTransform: 'none',
                  background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
                  color: '#fff', borderRadius: 10, padding: '6px 24px',
                }}>
                {vehicleAssigning ? '...' : (lang === 'pt' ? 'Confirmar e Despachar' : 'Confirm & Dispatch')}
              </Button>
            </Box>
          </Box>
        </>
      )}

      {/* Status change confirmation — reset to pending */}
      {statusChangeConfirm && (
        <>
          <Box style={{ position: 'fixed', inset: 0, zIndex: 1300, background: 'rgba(15,23,42,0.5)', backdropFilter: 'blur(2px)' }}
            onClick={() => setStatusChangeConfirm(null)} />
          <Box style={{
            position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
            zIndex: 1301, width: 400, background: '#fff', borderRadius: 16,
            boxShadow: '0 20px 60px rgba(0,0,0,0.2)', overflow: 'hidden',
          }}>
            <Box style={{ padding: '16px 20px', background: 'linear-gradient(180deg, #fff 0%, #fef3c7 100%)', borderBottom: '1px solid #fde68a', display: 'flex', alignItems: 'center', gap: 12 }}>
              <Box style={{ width: 36, height: 36, borderRadius: 10, background: '#f59e0b', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography style={{ fontSize: 18, color: '#fff' }}>⚠</Typography>
              </Box>
              <Box>
                <Typography style={{ fontSize: '0.9rem', fontWeight: 700, color: '#92400e' }}>
                  {lang === 'pt' ? 'Voltar a Por Atribuir' : 'Revert to Unassigned'}
                </Typography>
                <Typography style={{ fontSize: '0.62rem', color: '#a16207' }}>
                  {lang === 'pt' ? 'Dados de atribuição serão removidos' : 'Assignment data will be removed'}
                </Typography>
              </Box>
            </Box>
            <Box style={{ padding: '16px 20px' }}>
              <Typography style={{ fontSize: '0.78rem', color: '#475569', lineHeight: 1.5 }}>
                {lang === 'pt' ? 'Ao passar para Pendente, os seguintes dados serão limpos:' : 'Reverting to Pending will clear:'}
              </Typography>
              <Box style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 4 }}>
                {statusChangeConfirm.vehiclePlate && (
                  <Box style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: '0.72rem' }}>
                    <span style={{ color: '#ef4444' }}>✕</span> <b>Veículo:</b> {statusChangeConfirm.vehiclePlate}
                  </Box>
                )}
                {statusChangeConfirm.driverName && (
                  <Box style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: '0.72rem' }}>
                    <span style={{ color: '#ef4444' }}>✕</span> <b>Motorista:</b> {statusChangeConfirm.driverName}
                  </Box>
                )}
                {statusChangeConfirm.hasRoute && (
                  <Box style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: '0.72rem' }}>
                    <span style={{ color: '#ef4444' }}>✕</span> <b>Rota associada</b>
                  </Box>
                )}
              </Box>
            </Box>
            <Box style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, padding: '12px 20px', borderTop: '1px solid #f1f5f9', background: '#fafbfc' }}>
              <Button size="small" onClick={() => setStatusChangeConfirm(null)}
                style={{ fontSize: '0.75rem', textTransform: 'none', color: '#64748b' }}>
                {lang === 'pt' ? 'Cancelar' : 'Cancel'}
              </Button>
              <Button size="small" variant="contained"
                onClick={() => {
                  dispatch(updateOrder({
                    token, id: statusChangeConfirm.orderId,
                    data: { status: 'pending', vehicleId: null, driverId: null, assignedRouteId: null },
                  })).then(() => doFetch());
                  setStatusChangeConfirm(null);
                }}
                style={{
                  fontSize: '0.75rem', fontWeight: 700, textTransform: 'none',
                  background: '#f59e0b', color: '#fff', borderRadius: 10, padding: '6px 20px',
                }}>
                {lang === 'pt' ? 'Confirmar' : 'Confirm'}
              </Button>
            </Box>
          </Box>
        </>
      )}

      {/* Assign to Route Dialog */}
      {assignOrderId && (() => {
        const currentOT = list.find(o => (o._id || o.id) === assignOrderId);
        const statusColor = { draft: '#94a3b8', planned: '#3b82f6', in_progress: '#f59e0b', completed: '#22c55e', ready: '#8b5cf6' };
        const statusLabel = (s) => ({
          draft: lang === 'pt' ? 'Rascunho' : 'Draft',
          planned: lang === 'pt' ? 'Planeada' : 'Planned',
          in_progress: lang === 'pt' ? 'Em curso' : 'In progress',
          completed: lang === 'pt' ? 'Concluída' : 'Completed',
          ready: lang === 'pt' ? 'Pronta' : 'Ready',
        }[s] || s);

        // OT origin for proximity sorting
        const otLat = Number(currentOT?.pickupLat || 0);
        const otLng = Number(currentOT?.pickupLng || 0);
        const hasOTOrigin = otLat !== 0 && otLng !== 0;
        function routeDistFromOT(r) {
          if (!hasOTOrigin) return Infinity;
          const oCoords = typeof r.origin === 'object' ? r.origin?.coordinates : null;
          if (!oCoords || !Array.isArray(oCoords)) return Infinity;
          const dLat = (oCoords[1] - otLat) * 111;
          const dLng = (oCoords[0] - otLng) * 111 * Math.cos(otLat * Math.PI / 180);
          return Math.sqrt(dLat * dLat + dLng * dLng);
        }

        // Filter routes by search + status + freeOnly
        const q = assignSearch.trim().toLowerCase();
        const filteredRoutes = savedRoutes.filter(r => {
          const st = r.dbStatus || r.status || 'draft';
          if (assignStatusFilter !== 'all' && st !== assignStatusFilter) return false;
          if (assignFreeOnly && r.sentToVehicle) return false;
          if (q) {
            const originName = typeof r.origin === 'string' ? r.origin : r.origin?.name || '';
            const destName = typeof r.destination === 'string' ? r.destination : r.destination?.name || '';
            const hay = `${r.name || ''} ${originName} ${destName} ${(r.routeDrivers || []).map(rd => rd.driver?.name || '').join(' ')}`.toLowerCase();
            if (!hay.includes(q)) return false;
          }
          return true;
        }).sort((a, b) => routeDistFromOT(a) - routeDistFromOT(b));

        // Counts for quick filter chips
        const counts = {
          all: savedRoutes.length,
          draft: savedRoutes.filter(r => (r.dbStatus || r.status) === 'draft').length,
          planned: savedRoutes.filter(r => (r.dbStatus || r.status) === 'planned').length,
          in_progress: savedRoutes.filter(r => (r.dbStatus || r.status) === 'in_progress').length,
          completed: savedRoutes.filter(r => (r.dbStatus || r.status) === 'completed').length,
          free: savedRoutes.filter(r => !r.sentToVehicle).length,
        };

        const selectedRoute = savedRoutes.find(r => String(r.id) === String(assignRouteId));
        const selectedIsDispatched = selectedRoute?.sentToVehicle;

        return (
          <Box style={{
            position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', backdropFilter: 'blur(4px)',
            zIndex: 9999,
          }} onClick={() => setAssignOrderId(null)}>
            <Box style={{
              position: 'absolute',
              top: assignDialogPos ? assignDialogPos.y : 88,
              left: assignDialogPos ? assignDialogPos.x : 'calc(50% - 480px)',
              background: '#fff', borderRadius: 16, padding: 0,
              width: 960, maxWidth: '96vw', height: 640, maxHeight: 'calc(100vh - 108px)',
              boxShadow: '0 24px 80px rgba(15,23,42,0.35)', overflow: 'hidden',
              display: 'flex', flexDirection: 'column',
            }} onClick={e => e.stopPropagation()}>

              {/* ═══════ Header — OT context (drag handle) ═══════ */}
              <Box
                onMouseDown={onAssignDialogDragStart}
                style={{
                  padding: '14px 20px', borderBottom: '1px solid #e2e8f0',
                  background: 'linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%)',
                  display: 'flex', alignItems: 'center', gap: 14, flexShrink: 0,
                  cursor: 'move', userSelect: 'none',
                }}
              >
                <Box style={{
                  width: 40, height: 40, borderRadius: 10,
                  background: 'linear-gradient(135deg, #3b82f6, #6366f1)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  boxShadow: '0 4px 12px rgba(59,130,246,0.3)',
                  flexShrink: 0,
                }}>
                  <LinkIcon style={{ fontSize: 20, color: '#fff' }} />
                </Box>
                <Box style={{ flex: 1, minWidth: 0 }}>
                  <Typography style={{ fontSize: '0.98rem', fontWeight: 800, color: '#0f172a', lineHeight: 1.2 }}>
                    {lang === 'pt' ? 'Atribuir Ordem a Rota' : 'Assign Order to Route'}
                  </Typography>
                  {currentOT && (
                    <Typography component="div" style={{ fontSize: '0.68rem', color: '#64748b', marginTop: 2, display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                      <span style={{ fontWeight: 700, color: '#1e40af' }} title={otTooltip(currentOT)}>{otLabel(currentOT)}</span>
                      <span style={{ color: '#cbd5e1' }}>•</span>
                      <span>{currentOT.pickupName || currentOT.pickupAddress?.split(',')[0] || '?'} → {currentOT.deliveryName || currentOT.deliveryAddress?.split(',')[0] || '?'}</span>
                      {currentOT.cargoType && (
                        <>
                          <span style={{ color: '#cbd5e1' }}>•</span>
                          <span>{currentOT.cargoType}{currentOT.cargoWeight ? ` · ${currentOT.cargoWeight}kg` : ''}</span>
                        </>
                      )}
                    </Typography>
                  )}
                </Box>
                {/* 6-dot drag handle */}
                <Box
                  title={lang === 'pt' ? 'Arrastar' : 'Drag'}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 4px)',
                    gridTemplateRows: 'repeat(3, 4px)',
                    gap: 3,
                    padding: 6,
                    borderRadius: 6,
                    cursor: 'grab',
                    opacity: 0.45,
                    transition: 'opacity 0.15s, background 0.15s',
                    flexShrink: 0,
                  }}
                  onMouseEnter={e => { e.currentTarget.style.opacity = 1; e.currentTarget.style.background = 'rgba(15,23,42,0.05)'; }}
                  onMouseLeave={e => { e.currentTarget.style.opacity = 0.45; e.currentTarget.style.background = 'transparent'; }}
                >
                  {[0, 1, 2, 3, 4, 5].map(i => (
                    <Box key={i} style={{ width: 4, height: 4, borderRadius: '50%', background: '#64748b' }} />
                  ))}
                </Box>
                <IconButton
                  size="small"
                  onClick={() => setAssignOrderId(null)}
                  onMouseDown={e => e.stopPropagation()}
                  style={{ color: '#64748b', flexShrink: 0 }}
                >
                  <CloseIcon style={{ fontSize: 18 }} />
                </IconButton>
              </Box>

              {/* ═══════ Toolbar — search + filter chips ═══════ */}
              <Box style={{ padding: '12px 20px 10px', borderBottom: '1px solid #f1f5f9', flexShrink: 0 }}>
                <Box style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                  <Box style={{
                    flex: 1, display: 'flex', alignItems: 'center', gap: 6,
                    background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10,
                    padding: '6px 12px',
                  }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
                    </svg>
                    <input
                      type="text"
                      value={assignSearch}
                      onChange={e => setAssignSearch(e.target.value)}
                      placeholder={lang === 'pt' ? 'Pesquisar por nome, origem, destino ou motorista…' : 'Search by name, origin, destination or driver…'}
                      style={{
                        flex: 1, border: 'none', outline: 'none', background: 'transparent',
                        fontSize: '0.78rem', color: '#0f172a',
                      }}
                    />
                    {assignSearch && (
                      <IconButton size="small" onClick={() => setAssignSearch('')} style={{ padding: 2 }}>
                        <CloseIcon style={{ fontSize: 12, color: '#94a3b8' }} />
                      </IconButton>
                    )}
                  </Box>
                  <Box
                    onClick={() => setAssignFreeOnly(v => !v)}
                    style={{
                      display: 'flex', alignItems: 'center', gap: 5, padding: '6px 12px',
                      borderRadius: 10, cursor: 'pointer', userSelect: 'none',
                      background: assignFreeOnly ? 'rgba(34,197,94,0.1)' : '#f8fafc',
                      border: `1px solid ${assignFreeOnly ? 'rgba(34,197,94,0.4)' : '#e2e8f0'}`,
                      color: assignFreeOnly ? '#15803d' : '#64748b',
                      fontSize: '0.72rem', fontWeight: 600, transition: 'all 0.15s',
                    }}
                  >
                    <Box style={{
                      width: 12, height: 12, borderRadius: 3,
                      border: `2px solid ${assignFreeOnly ? '#22c55e' : '#cbd5e1'}`,
                      background: assignFreeOnly ? '#22c55e' : 'transparent',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                      {assignFreeOnly && <svg width="8" height="8" viewBox="0 0 24 24" fill="#fff"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>}
                    </Box>
                    {lang === 'pt' ? 'Apenas livres' : 'Free only'} ({counts.free})
                  </Box>
                </Box>

                {/* Status filter chips */}
                <Box style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                  {['all', 'draft', 'planned', 'in_progress', 'completed'].map(st => {
                    const active = assignStatusFilter === st;
                    const label = st === 'all' ? (lang === 'pt' ? 'Todas' : 'All') : statusLabel(st);
                    const count = counts[st] || 0;
                    const color = st === 'all' ? '#3b82f6' : (statusColor[st] || '#94a3b8');
                    return (
                      <Box key={st}
                        onClick={() => setAssignStatusFilter(st)}
                        style={{
                          display: 'flex', alignItems: 'center', gap: 5, padding: '4px 10px',
                          borderRadius: 16, cursor: 'pointer', userSelect: 'none',
                          background: active ? `${color}18` : '#f8fafc',
                          border: `1px solid ${active ? color : '#e2e8f0'}`,
                          color: active ? color : '#64748b',
                          fontSize: '0.68rem', fontWeight: 700, transition: 'all 0.15s',
                        }}
                      >
                        {st !== 'all' && <Box style={{ width: 6, height: 6, borderRadius: '50%', background: color }} />}
                        {label}
                        <span style={{ opacity: 0.7, fontWeight: 600 }}>({count})</span>
                      </Box>
                    );
                  })}
                </Box>
              </Box>

              {/* ═══════ Table ═══════ */}
              <Box style={{ flex: 1, overflowY: 'auto', background: '#fff' }}>
                {assignLoading ? (
                  <Box style={{ padding: 40, textAlign: 'center', color: '#94a3b8', fontSize: '0.78rem' }}>
                    {lang === 'pt' ? 'A carregar rotas…' : 'Loading routes…'}
                  </Box>
                ) : filteredRoutes.length === 0 ? (
                  <Box style={{ padding: '60px 20px', textAlign: 'center' }}>
                    <Typography style={{ fontSize: '0.9rem', fontWeight: 600, color: '#475569', marginBottom: 4 }}>
                      {savedRoutes.length === 0
                        ? (lang === 'pt' ? 'Nenhuma rota gravada' : 'No saved routes')
                        : (lang === 'pt' ? 'Nenhuma rota corresponde aos filtros' : 'No routes match the filters')}
                    </Typography>
                    <Typography style={{ fontSize: '0.72rem', color: '#94a3b8' }}>
                      {savedRoutes.length === 0
                        ? (lang === 'pt' ? 'Crie uma rota no planeador para começar' : 'Create a route in the planner to get started')
                        : (lang === 'pt' ? 'Ajuste a pesquisa ou limpe os filtros' : 'Adjust the search or clear the filters')}
                    </Typography>
                  </Box>
                ) : (
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.72rem' }}>
                    <thead>
                      <tr style={{ background: '#f8fafc', position: 'sticky', top: 0, zIndex: 1 }}>
                        <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '0.58rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #e2e8f0', width: 28 }}></th>
                        <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '0.58rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #e2e8f0' }}>{lang === 'pt' ? 'Nome' : 'Name'}</th>
                        <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '0.58rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #e2e8f0' }}>{lang === 'pt' ? 'Trajeto' : 'Route'}</th>
                        <th style={{ padding: '8px 12px', textAlign: 'right', fontSize: '0.58rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #e2e8f0', width: 70 }}>{lang === 'pt' ? 'Distância' : 'Distance'}</th>
                        <th style={{ padding: '8px 12px', textAlign: 'right', fontSize: '0.58rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #e2e8f0', width: 70 }}>{lang === 'pt' ? 'Duração' : 'Duration'}</th>
                        <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '0.58rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #e2e8f0', width: 110 }}>{lang === 'pt' ? 'Partida' : 'Departure'}</th>
                        <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '0.58rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #e2e8f0', width: 120 }}>{lang === 'pt' ? 'Motorista' : 'Driver'}</th>
                        <th style={{ padding: '8px 12px', textAlign: 'center', fontSize: '0.58rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #e2e8f0', width: 90 }}>{lang === 'pt' ? 'Estado' : 'Status'}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredRoutes.map(r => {
                        const isSelected = String(assignRouteId) === String(r.id);
                        const originName = typeof r.origin === 'string' ? r.origin : r.origin?.name?.split(',')[0] || '?';
                        const destName = typeof r.destination === 'string' ? r.destination : r.destination?.name?.split(',')[0] || '?';
                        const distKm = r.distance ? Math.round(r.distance / 1000) : (r.computedRoute?.distance ? Math.round(r.computedRoute.distance / 1000) : null);
                        const durSec = r.duration || r.computedRoute?.duration || 0;
                        const durH = Math.floor(durSec / 3600);
                        const durM = Math.floor((durSec % 3600) / 60);
                        const drivers = r.routeDrivers || [];
                        const driverName = drivers[0]?.driver?.name || null;
                        const extraDrivers = drivers.length > 1 ? drivers.length - 1 : 0;
                        const st = r.dbStatus || r.status || 'draft';
                        const sc = statusColor[st] || '#94a3b8';
                        const dep = r.departureTime ? new Date(r.departureTime) : null;
                        const depLabel = dep ? dep.toLocaleString(lang === 'pt' ? 'pt-PT' : 'en-GB', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—';
                        return (
                          <tr key={r.id}
                            onClick={() => setAssignRouteId(r.id)}
                            style={{
                              background: isSelected ? '#eff6ff' : 'transparent',
                              cursor: 'pointer',
                              transition: 'background 0.12s',
                              borderLeft: isSelected ? '3px solid #3b82f6' : '3px solid transparent',
                            }}
                            onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = '#f8fafc'; }}
                            onMouseLeave={e => { if (!isSelected) e.currentTarget.style.background = 'transparent'; }}
                          >
                            <td style={{ padding: '10px 12px', borderBottom: '1px solid #f1f5f9' }}>
                              <Box style={{
                                width: 16, height: 16, borderRadius: '50%',
                                border: `2px solid ${isSelected ? '#3b82f6' : '#cbd5e1'}`,
                                background: isSelected ? '#3b82f6' : 'transparent',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                transition: 'all 0.12s',
                              }}>
                                {isSelected && <svg width="10" height="10" viewBox="0 0 24 24" fill="#fff"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>}
                              </Box>
                            </td>
                            <td style={{ padding: '10px 12px', borderBottom: '1px solid #f1f5f9' }}>
                              <Typography style={{ fontSize: '0.76rem', fontWeight: 700, color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 180 }}>
                                {r.name || `Rota #${r.id}`}
                              </Typography>
                              <Typography style={{ fontSize: '0.58rem', color: '#94a3b8', fontWeight: 500 }}>
                                #{r.id}
                              </Typography>
                            </td>
                            <td style={{ padding: '10px 12px', borderBottom: '1px solid #f1f5f9' }}>
                              <Box style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: '0.7rem', color: '#475569' }}>
                                <span style={{ maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{originName}</span>
                                <svg width="10" height="10" viewBox="0 0 24 24" fill="#94a3b8"><path d="M4 11v2h12l-5.5 5.5L12 20l8-8-8-8-1.5 1.5L16 11H4z"/></svg>
                                <span style={{ maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{destName}</span>
                              </Box>
                            </td>
                            <td style={{ padding: '10px 12px', borderBottom: '1px solid #f1f5f9', textAlign: 'right' }}>
                              <Typography style={{ fontSize: '0.74rem', fontWeight: 700, color: '#0f172a' }}>
                                {distKm != null ? `${distKm} km` : '—'}
                              </Typography>
                            </td>
                            <td style={{ padding: '10px 12px', borderBottom: '1px solid #f1f5f9', textAlign: 'right' }}>
                              <Typography style={{ fontSize: '0.74rem', fontWeight: 600, color: '#475569' }}>
                                {durSec > 0 ? `${durH}h${String(durM).padStart(2, '0')}` : '—'}
                              </Typography>
                            </td>
                            <td style={{ padding: '10px 12px', borderBottom: '1px solid #f1f5f9' }}>
                              <Typography style={{ fontSize: '0.68rem', color: '#475569', whiteSpace: 'nowrap' }}>
                                {depLabel}
                              </Typography>
                            </td>
                            <td style={{ padding: '10px 12px', borderBottom: '1px solid #f1f5f9' }}>
                              {driverName ? (
                                <Box style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                  <Typography style={{ fontSize: '0.68rem', fontWeight: 600, color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 90 }}>
                                    {driverName}
                                  </Typography>
                                  {extraDrivers > 0 && (
                                    <span style={{ fontSize: '0.56rem', fontWeight: 700, background: '#eff6ff', color: '#1d4ed8', borderRadius: 4, padding: '1px 4px' }}>
                                      +{extraDrivers}
                                    </span>
                                  )}
                                </Box>
                              ) : (
                                <Typography style={{ fontSize: '0.64rem', color: '#cbd5e1', fontStyle: 'italic' }}>—</Typography>
                              )}
                            </td>
                            <td style={{ padding: '10px 12px', borderBottom: '1px solid #f1f5f9', textAlign: 'center' }}>
                              <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
                                <span style={{
                                  display: 'inline-flex', alignItems: 'center', gap: 4,
                                  fontSize: '0.56rem', fontWeight: 800, color: sc,
                                  background: `${sc}15`, borderRadius: 10,
                                  padding: '2px 8px', textTransform: 'uppercase', letterSpacing: '0.03em',
                                }}>
                                  <Box style={{ width: 5, height: 5, borderRadius: '50%', background: sc }} />
                                  {statusLabel(st)}
                                </span>
                                {r.sentToVehicle && (
                                  <span style={{ fontSize: '0.52rem', fontWeight: 700, background: '#dcfce7', color: '#16a34a', borderRadius: 4, padding: '1px 5px' }}>
                                    {lang === 'pt' ? 'Despachada' : 'Dispatched'}
                                  </span>
                                )}
                              </Box>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </Box>

              {/* ═══════ Warnings ═══════ */}
              {(assignWarning || selectedIsDispatched) && (
                <Box style={{ padding: '10px 20px', flexShrink: 0, background: '#fffbeb', borderTop: '1px solid #fde68a' }}>
                  <Typography style={{ fontSize: '0.7rem', color: '#92400e', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}>
                    <WarningIcon style={{ fontSize: 14 }} />
                    {assignWarning || (lang === 'pt'
                      ? 'Esta rota já foi despachada para o motorista. A atribuição irá re-enviar.'
                      : 'This route has already been dispatched to the driver. Assigning will re-send it.')}
                  </Typography>
                </Box>
              )}

              {/* ═══════ Footer ═══════ */}
              <Box style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '12px 20px', borderTop: '1px solid #e2e8f0', background: '#fafbfc', flexShrink: 0,
              }}>
                <Typography style={{ fontSize: '0.7rem', color: '#64748b', fontWeight: 600 }}>
                  {filteredRoutes.length} {lang === 'pt' ? 'rotas' : 'routes'}
                  {filteredRoutes.length !== savedRoutes.length && (
                    <span style={{ color: '#94a3b8' }}> {lang === 'pt' ? `de ${savedRoutes.length}` : `of ${savedRoutes.length}`}</span>
                  )}
                </Typography>
                <Box style={{ display: 'flex', gap: 8 }}>
                  <Button size="small" onClick={() => setAssignOrderId(null)}
                    style={{ fontSize: '0.74rem', textTransform: 'none', borderRadius: 10, color: '#64748b', fontWeight: 700, padding: '6px 16px' }}>
                    {lang === 'pt' ? 'Cancelar' : 'Cancel'}
                  </Button>
                  <Button size="small" variant="contained" onClick={confirmAssign} disabled={!assignRouteId}
                    style={{
                      fontSize: '0.74rem', textTransform: 'none', borderRadius: 10,
                      background: assignRouteId ? 'linear-gradient(135deg, #3b82f6, #6366f1)' : '#e2e8f0',
                      color: '#fff', fontWeight: 700, boxShadow: assignRouteId ? '0 2px 8px rgba(59,130,246,0.3)' : 'none',
                      padding: '6px 20px',
                    }}>
                    {lang === 'pt' ? 'Atribuir Rota' : 'Assign Route'}
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        );
      })()}

      {/* Fuel start dialog — "Saí da base". Mostra a ROTA PLANEADA correcta
          (partida=base, recolha=terminal, entrega=cliente) e arranca a rota. */}
      {fuelStartDialog && (
        <Box style={{
          position: 'fixed', inset: 0, zIndex: 12000,
          background: 'rgba(15,23,42,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <Box style={{
            width: 'min(540px, calc(100% - 32px))',
            background: '#fff', borderRadius: 14,
            boxShadow: '0 20px 60px rgba(15,23,42,0.25)', overflow: 'hidden',
          }}>
            {/* Header */}
            <Box style={{
              padding: '14px 20px', borderBottom: '1px solid #fed7aa',
              display: 'flex', alignItems: 'center', gap: 10,
              background: 'linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)',
            }}>
              <span style={{ fontSize: 22 }}>🏁</span>
              <Typography style={{ fontSize: '1rem', fontWeight: 800, color: '#9a3412', flex: 1 }}>
                {(() => {
                  const dk = fuelStartDialog.departureKind || 'base';
                  if (dk === 'terminal') return lang === 'pt' ? 'Iniciar rota — saída do terminal' : 'Start route — leaving terminal';
                  if (dk === 'vehicle') return lang === 'pt' ? 'Iniciar rota — saída da posição actual' : 'Start route — leaving current position';
                  return lang === 'pt' ? 'Iniciar rota — saída da base' : 'Start route — leaving base';
                })()}
              </Typography>
            </Box>

            {/* Content */}
            <Box style={{ padding: '18px 20px' }}>
              <Typography style={{ fontSize: '0.82rem', color: '#0f172a', marginBottom: 14 }}>
                {lang === 'pt'
                  ? 'Vais registar a saída da base e iniciar a rota desta OT de combustível. Confirma o trajeto planeado:'
                  : 'You are about to record leaving base and start this fuel order route. Confirm the planned trip:'}
              </Typography>

              {fuelStartDialog.loading ? (
                <Typography style={{ fontSize: '0.78rem', color: '#94a3b8', fontStyle: 'italic', padding: '10px 0' }}>
                  {lang === 'pt' ? 'A carregar rota…' : 'Loading route…'}
                </Typography>
              ) : (
                <Box style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {/* Partida (base / terminal / posição do veículo) */}
                  {(() => {
                    const dk = fuelStartDialog.departureKind || 'base';
                    const icon = dk === 'terminal' ? '⛽' : dk === 'vehicle' ? '🚗' : '🏠';
                    const label = dk === 'terminal' ? (lang === 'pt' ? 'Partida · Terminal' : 'Departure · Terminal')
                      : dk === 'vehicle' ? (lang === 'pt' ? 'Partida · Local do veículo' : 'Departure · Vehicle location')
                      : (lang === 'pt' ? 'Partida · Base' : 'Departure · Base');
                    return (
                      <Box style={{ display: 'flex', gap: 10, alignItems: 'flex-start', padding: '8px 10px', borderRadius: 8, background: '#f0fdf4', border: '1px solid #bbf7d0' }}>
                        <span style={{ fontSize: 16 }}>{icon}</span>
                        <Box style={{ flex: 1 }}>
                          <Typography style={{ fontSize: '0.58rem', fontWeight: 800, color: '#15803d', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                            {label}
                          </Typography>
                          <Typography style={{ fontSize: '0.78rem', color: '#14532d', marginTop: 1 }}>
                            {fuelStartDialog.originName}
                          </Typography>
                          {/* Local aproximado da posição do veículo — morada
                              (Google) ou, na falta, coordenadas. */}
                          {dk === 'vehicle' && (fuelStartDialog.originAddress || fuelStartDialog.originCoords) && (
                            <Typography style={{ fontSize: '0.7rem', color: '#166534', marginTop: 3, display: 'flex', alignItems: 'flex-start', gap: 4 }}>
                              <span>📌</span>
                              <span>{lang === 'pt' ? 'Local aproximado: ' : 'Approx. location: '}
                                {fuelStartDialog.originAddress
                                  ? fuelStartDialog.originAddress
                                  : `${fuelStartDialog.originCoords.lat.toFixed(5)}, ${fuelStartDialog.originCoords.lng.toFixed(5)}`}
                              </span>
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    );
                  })()}
                  {/* Recolha (terminal) */}
                  <Box style={{ display: 'flex', gap: 10, alignItems: 'flex-start', padding: '8px 10px', borderRadius: 8, background: '#eff6ff', border: '1px solid #bfdbfe' }}>
                    <span style={{ fontSize: 16 }}>⛽</span>
                    <Box style={{ flex: 1 }}>
                      <Typography style={{ fontSize: '0.58rem', fontWeight: 800, color: '#1d4ed8', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                        {lang === 'pt' ? 'Recolha · Terminal' : 'Pickup · Terminal'}
                      </Typography>
                      <Typography style={{ fontSize: '0.78rem', color: '#1e3a8a', marginTop: 1 }}>
                        {fuelStartDialog.pickupName}
                      </Typography>
                    </Box>
                  </Box>
                  {/* Entrega (cliente) */}
                  <Box style={{ display: 'flex', gap: 10, alignItems: 'flex-start', padding: '8px 10px', borderRadius: 8, background: '#fef2f2', border: '1px solid #fecaca' }}>
                    <span style={{ fontSize: 16 }}>📍</span>
                    <Box style={{ flex: 1 }}>
                      <Typography style={{ fontSize: '0.58rem', fontWeight: 800, color: '#b91c1c', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                        {lang === 'pt' ? 'Entrega · Cliente' : 'Delivery · Customer'}
                      </Typography>
                      <Typography style={{ fontSize: '0.78rem', color: '#7f1d1d', marginTop: 1 }}>
                        {fuelStartDialog.deliveryName || (lang === 'pt' ? 'Revelado no carregamento (Ordem do cliente)' : 'Revealed at loading (customer Order)')}
                      </Typography>
                    </Box>
                  </Box>
                  {/* Rota planeada km · tempo */}
                  {fuelStartDialog.distanceKm != null && (
                    <Typography style={{ fontSize: '0.72rem', color: '#64748b', marginTop: 2 }}>
                      {lang === 'pt' ? 'Rota planeada: ' : 'Planned route: '}
                      <b style={{ color: '#0f172a' }}>{fuelStartDialog.distanceKm.toFixed(1)} km</b>
                      {fuelStartDialog.durationS != null && (() => {
                        const h = Math.floor(fuelStartDialog.durationS / 3600);
                        const m = Math.round((fuelStartDialog.durationS % 3600) / 60);
                        return <> · <b style={{ color: '#0f172a' }}>{h > 0 ? `${h}h${String(m).padStart(2, '0')}` : `${m} min`}</b></>;
                      })()}
                    </Typography>
                  )}
                  {/* Aviso: o veículo está longe da partida FIXA escolhida.
                      Só informativo — o arranque continua igual. */}
                  {fuelStartDialog.vehicleDistanceKm != null && fuelStartDialog.vehicleDistanceKm > FUEL_START_FAR_THRESHOLD_KM && (() => {
                    const d = fuelStartDialog.vehicleDistanceKm;
                    const dLabel = d < 1 ? `${Math.round(d * 1000)} m` : `${d.toFixed(1)} km`;
                    return (
                      <Box style={{ display: 'flex', gap: 8, alignItems: 'flex-start', padding: '8px 10px', borderRadius: 8, background: '#fffbeb', border: '1px solid #fde68a', marginTop: 2 }}>
                        <span style={{ fontSize: 15 }}>⚠️</span>
                        <Typography style={{ fontSize: '0.72rem', color: '#92400e', lineHeight: 1.4 }}>
                          {lang === 'pt'
                            ? <>O veículo está a <b>{dLabel}</b> do local de partida escolhido. A estimativa acima assume a partida escolhida; os tempos e distâncias reais serão medidos por GPS.</>
                            : <>The vehicle is <b>{dLabel}</b> from the chosen departure point. The estimate above assumes the chosen departure; real times and distances are measured by GPS.</>}
                        </Typography>
                      </Box>
                    );
                  })()}
                </Box>
              )}
            </Box>

            {/* Buttons */}
            <Box style={{
              padding: '10px 16px', borderTop: '1px solid #e2e8f0',
              display: 'flex', justifyContent: 'flex-end', gap: 8, background: '#f8fafc',
            }}>
              <Button onClick={() => setFuelStartDialog(null)} disabled={fuelStartDialog.busy} style={{ textTransform: 'none' }}>
                {lang === 'pt' ? 'Cancelar' : 'Cancel'}
              </Button>
              <Button onClick={confirmFuelStart} disabled={fuelStartDialog.busy || fuelStartDialog.loading}
                variant="contained" style={{
                  textTransform: 'none', fontWeight: 700, color: '#fff',
                  background: (fuelStartDialog.busy || fuelStartDialog.loading) ? '#cbd5e1' : 'linear-gradient(135deg, #22c55e, #16a34a)',
                }}>
                {fuelStartDialog.busy
                  ? (lang === 'pt' ? 'A iniciar…' : 'Starting…')
                  : (lang === 'pt' ? 'Iniciar rota' : 'Start route')}
              </Button>
            </Box>
          </Box>
        </Box>
      )}

      {/* Delete Confirmation Dialog */}
      {/* Start-route GPS check dialog — vehicle not at planned pickup */}
      {startRouteDialog && (
        <Box style={{
          position: 'fixed', inset: 0, zIndex: 12000,
          background: 'rgba(15,23,42,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <Box style={{
            width: 'min(520px, calc(100% - 32px))',
            background: '#fff', borderRadius: 14,
            boxShadow: '0 20px 60px rgba(15,23,42,0.25)',
            overflow: 'hidden',
          }}>
            <Box style={{
              padding: '14px 20px', borderBottom: '1px solid #e2e8f0',
              display: 'flex', alignItems: 'center', gap: 10,
              background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
            }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="#2563eb">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"/>
              </svg>
              <Typography style={{ fontSize: '1rem', fontWeight: 700, color: '#1e40af', flex: 1 }}>
                {lang === 'pt' ? 'Veículo fora do local de recolha' : 'Vehicle not at pickup'}
              </Typography>
            </Box>
            <Box style={{ padding: '18px 20px' }}>
              <Typography style={{ fontSize: '0.82rem', color: '#0f172a', marginBottom: 14 }}>
                {lang === 'pt'
                  ? `A viatura ${startRouteDialog.vehicle?.plate || ''} está a `
                  : `Vehicle ${startRouteDialog.vehicle?.plate || ''} is `}
                <b style={{ color: '#2563eb' }}>{startRouteDialog.distanceKm.toFixed(1)} km</b>
                {lang === 'pt' ? ' do ponto de recolha planeado.' : ' from the planned pickup.'}
              </Typography>
              <Box style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
                <Box style={{ padding: '8px 10px', borderRadius: 8, background: '#f0f9ff', border: '1px solid #bae6fd' }}>
                  <Typography style={{ fontSize: '0.58rem', fontWeight: 800, color: '#0369a1', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    {lang === 'pt' ? 'Posição actual' : 'Current position'}
                  </Typography>
                  <Typography style={{ fontSize: '0.72rem', color: '#0c4a6e', marginTop: 2 }}>
                    {startRouteDialog.vehicle?.position?.address?.split(',').slice(0, 2).join(', ') || '—'}
                  </Typography>
                </Box>
                <Box style={{ padding: '8px 10px', borderRadius: 8, background: '#fef2f2', border: '1px solid #fecaca' }}>
                  <Typography style={{ fontSize: '0.58rem', fontWeight: 800, color: '#b91c1c', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    {lang === 'pt' ? 'Recolha planeada' : 'Planned pickup'}
                  </Typography>
                  <Typography style={{ fontSize: '0.72rem', color: '#7f1d1d', marginTop: 2 }}>
                    {startRouteDialog.pickupName?.split(',').slice(0, 2).join(', ') || '—'}
                  </Typography>
                </Box>
              </Box>
              <Typography style={{ fontSize: '0.72rem', color: '#64748b', lineHeight: 1.5 }}>
                {lang === 'pt'
                  ? 'Podes recalcular a rota usando a posição actual do veículo como partida (a recolha passa a ponto intermédio), ou iniciar assim mesmo.'
                  : 'You can recalculate from the current position (pickup becomes an intermediate stop) or start as-is.'}
              </Typography>
            </Box>
            <Box style={{
              padding: '10px 16px', borderTop: '1px solid #e2e8f0',
              display: 'flex', justifyContent: 'flex-end', gap: 8, background: '#f8fafc',
            }}>
              <Button
                onClick={() => setStartRouteDialog(null)}
                disabled={startRouteDialog.busy}
                style={{ textTransform: 'none' }}
              >
                {lang === 'pt' ? 'Cancelar' : 'Cancel'}
              </Button>
              <Button
                onClick={() => {
                  const { order, routeId } = startRouteDialog;
                  setStartRouteDialog(null);
                  doRouteStatusChange(order, routeId, 'in_progress');
                }}
                disabled={startRouteDialog.busy}
                variant="outlined"
                style={{ textTransform: 'none', fontWeight: 600 }}
              >
                {lang === 'pt' ? 'Iniciar na mesma' : 'Start anyway'}
              </Button>
              <Button
                onClick={startRouteWithRecalc}
                disabled={startRouteDialog.busy}
                variant="contained"
                color="primary"
                style={{ textTransform: 'none', fontWeight: 700 }}
              >
                {startRouteDialog.busy
                  ? (lang === 'pt' ? 'A recalcular…' : 'Recalculating…')
                  : (lang === 'pt' ? 'Recalcular e iniciar' : 'Recalculate & start')}
              </Button>
            </Box>
          </Box>
        </Box>
      )}

      {/* Consolidation conflicts dialog — opened when handleConsolidateRoutes detects window issues */}
      {consolidationPreview && (
        <ConsolidationConflictsDialog
          open
          timeline={consolidationPreview.timeline}
          conflicts={consolidationPreview.conflicts}
          orderedOrders={consolidationPreview.orders}
          travelProvider={consolidationPreview.travelProvider}
          matrixSource={consolidationPreview.matrixSource}
          lang={lang}
          onCancel={() => setConsolidationPreview(null)}
          onProceed={() => {
            const { orders, driverHome, customDepartureId, customArrivalId, firstStopOTId, parqueForFuel } = consolidationPreview;
            setConsolidationPreview(null);
            // Respeita o Local de Partida / Local de Chegada escolhidos pelo operador.
            doConsolidateRoutes(orders, driverHome, { customDepartureId, customArrivalId, firstStopOTId, parqueForFuel });
          }}
          onReorganize={(reordered) => {
            const { driverHome, customDepartureId, customArrivalId, parqueForFuel } = consolidationPreview;
            setConsolidationPreview(null);
            // Ao reorganizar, a nova ordem manda na sequência — não re-fixamos
            // o firstStopOTId, mas mantemos partida/chegada do operador.
            doConsolidateRoutes(reordered, driverHome, { customDepartureId, customArrivalId, parqueForFuel });
          }}
        />
      )}

      {/* OT History Dialog */}
      {historyDialog && (() => {
        const { order: hOrder, events, loading } = historyDialog;
        const eventCfg = {
          created:           { label: lang === 'pt' ? 'Criada' : 'Created',           color: '#64748b', icon: '✎' },
          vehicle_assigned:  { label: lang === 'pt' ? 'Veículo atribuído' : 'Vehicle assigned', color: '#3b82f6', icon: '🚛' },
          route_linked:      { label: lang === 'pt' ? 'Rota associada' : 'Route linked', color: '#6366f1', icon: '🔗' },
          started:           { label: lang === 'pt' ? 'Iniciada' : 'Started',         color: '#22c55e', icon: '▶' },
          arrived:           { label: lang === 'pt' ? 'Chegou ao local' : 'On site',  color: '#0ea5e9', icon: '📍' },
          delivered:         { label: lang === 'pt' ? 'Entregue' : 'Delivered',       color: '#16a34a', icon: '✔' },
          cancelled:         { label: lang === 'pt' ? 'Cancelada' : 'Cancelled',      color: '#ef4444', icon: '✕' },
          status_change:     { label: lang === 'pt' ? 'Estado alterado' : 'Status changed', color: '#f59e0b', icon: '↻' },
          note:              { label: lang === 'pt' ? 'Nota' : 'Note',                color: '#94a3b8', icon: '📝' },
        };
        return (
          <Box style={{
            position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', backdropFilter: 'blur(4px)',
            zIndex: 9999, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '60px 20px',
          }} onClick={() => setHistoryDialog(null)}>
            <Box style={{
              background: '#fff', borderRadius: 16, width: 720, maxWidth: '96vw',
              maxHeight: 'calc(100vh - 120px)', display: 'flex', flexDirection: 'column',
              boxShadow: '0 24px 80px rgba(15,23,42,0.35)', overflow: 'hidden',
            }} onClick={(e) => e.stopPropagation()}>
              {/* Header */}
              <Box style={{
                padding: '14px 20px', borderBottom: '1px solid #e2e8f0',
                background: 'linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%)',
                display: 'flex', alignItems: 'center', gap: 12,
              }}>
                <Box style={{
                  width: 38, height: 38, borderRadius: 10,
                  background: 'linear-gradient(135deg, #6366f1, #4f46e5)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  boxShadow: '0 4px 12px rgba(99,102,241,0.3)', flexShrink: 0,
                }}>
                  <HistoryIcon style={{ fontSize: 18, color: '#fff' }} />
                </Box>
                <Box style={{ flex: 1 }}>
                  <Typography style={{ fontSize: '0.95rem', fontWeight: 800, color: '#0f172a' }}>
                    {lang === 'pt' ? 'Histórico da OT' : 'Order History'}
                  </Typography>
                  <Typography style={{ fontSize: '0.68rem', color: '#64748b' }}>
                    <span style={{ fontWeight: 700, color: '#1e40af' }} title={otTooltip(hOrder)}>{otLabel(hOrder)}</span>
                    {' · '}{hOrder.pickupName?.split(',')[0] || '?'} → {hOrder.deliveryName?.split(',')[0] || '?'}
                  </Typography>
                </Box>
                <IconButton size="small" onClick={() => setHistoryDialog(null)}>
                  <CloseIcon style={{ fontSize: 18, color: '#64748b' }} />
                </IconButton>
              </Box>
              {/* Body */}
              <Box style={{ flex: 1, overflowY: 'auto', padding: '16px 20px' }}>
                {loading ? (
                  <Box style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>
                    <CircularProgress size={24} />
                    <Typography style={{ fontSize: '0.74rem', marginTop: 8 }}>
                      {lang === 'pt' ? 'A carregar histórico…' : 'Loading history…'}
                    </Typography>
                  </Box>
                ) : events.length === 0 ? (
                  <Box style={{ textAlign: 'center', padding: 40 }}>
                    <Typography style={{ fontSize: '0.85rem', color: '#475569', fontWeight: 600 }}>
                      {lang === 'pt' ? 'Sem eventos registados' : 'No events recorded'}
                    </Typography>
                    <Typography style={{ fontSize: '0.7rem', color: '#94a3b8', marginTop: 4 }}>
                      {lang === 'pt' ? 'O histórico será criado conforme a OT avança no fluxo.' : 'History is created as the order progresses.'}
                    </Typography>
                  </Box>
                ) : (
                  <Box style={{ position: 'relative', paddingLeft: 22 }}>
                    {/* Vertical line */}
                    <Box style={{ position: 'absolute', top: 6, bottom: 6, left: 9, width: 2, background: '#e2e8f0' }} />
                    {/* Mais recente no topo (ordem descendente por data). */}
                    {[...events].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()).map((ev, idx) => {
                      const cfg = eventCfg[ev.eventType] || eventCfg.note;
                      const date = new Date(ev.createdAt);
                      return (
                        <Box key={ev.id || idx} style={{
                          position: 'relative', marginBottom: 14,
                        }}>
                          {/* Dot */}
                          <Box style={{
                            position: 'absolute', left: -22, top: 4,
                            width: 16, height: 16, borderRadius: '50%',
                            background: cfg.color, border: '3px solid #fff',
                            boxShadow: `0 0 0 2px ${cfg.color}40`,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            color: '#fff', fontSize: 8, fontWeight: 800,
                          }}>{cfg.icon}</Box>
                          {/* Card */}
                          <Box style={{
                            background: '#fff', border: '1px solid #e2e8f0',
                            borderRadius: 10, padding: '10px 14px',
                          }}>
                            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
                              <Box style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                <span style={{
                                  fontSize: '0.58rem', fontWeight: 800, color: cfg.color,
                                  background: `${cfg.color}18`, borderRadius: 12,
                                  padding: '2px 10px', textTransform: 'uppercase', letterSpacing: '0.04em',
                                }}>{cfg.label}</span>
                                {ev.fromStatus && ev.toStatus && ev.fromStatus !== ev.toStatus && (
                                  <Typography style={{ fontSize: '0.6rem', color: '#94a3b8', fontWeight: 600 }}>
                                    {ev.fromStatus} → {ev.toStatus}
                                  </Typography>
                                )}
                              </Box>
                              <Typography style={{ fontSize: '0.66rem', color: '#64748b', fontWeight: 600 }}>
                                {date.toLocaleString(lang === 'pt' ? 'pt-PT' : 'en-GB', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' })}
                              </Typography>
                            </Box>
                            {ev.notes && (
                              <Typography style={{ fontSize: '0.7rem', color: '#475569', marginBottom: 4 }}>
                                {ev.notes}
                              </Typography>
                            )}
                            <Box style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 4 }}>
                              {ev.routeName && (
                                <span style={{ fontSize: '0.6rem', color: '#475569', background: '#f1f5f9', borderRadius: 6, padding: '2px 8px' }}>
                                  🗺 {ev.routeName}
                                </span>
                              )}
                              {ev.vehiclePlate && (
                                <span style={{ fontSize: '0.6rem', color: '#16a34a', background: '#dcfce7', borderRadius: 6, padding: '2px 8px', fontWeight: 600 }}>
                                  🚛 {ev.vehiclePlate}
                                </span>
                              )}
                              {ev.driverName && (
                                <span style={{ fontSize: '0.6rem', color: '#1d4ed8', background: '#dbeafe', borderRadius: 6, padding: '2px 8px', fontWeight: 600 }}>
                                  👤 {ev.driverName}
                                </span>
                              )}
                              {ev.estimatedArrival && (
                                <span style={{ fontSize: '0.6rem', color: '#475569', background: '#fef3c7', borderRadius: 6, padding: '2px 8px' }}>
                                  ⏱ ETA: {new Date(ev.estimatedArrival).toLocaleString(lang === 'pt' ? 'pt-PT' : 'en-GB', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                                </span>
                              )}
                              {ev.estimatedCost != null && (
                                <span style={{ fontSize: '0.6rem', color: '#15803d', background: '#dcfce7', borderRadius: 6, padding: '2px 8px', fontWeight: 600 }}>
                                  💶 €{Number(ev.estimatedCost).toFixed(2)}
                                </span>
                              )}
                              {ev.distanceKm != null && (
                                <span style={{ fontSize: '0.6rem', color: '#64748b', background: '#f1f5f9', borderRadius: 6, padding: '2px 8px' }}>
                                  📏 {Number(ev.distanceKm).toFixed(1)} km
                                </span>
                              )}
                              {ev.userName && (
                                <span style={{ fontSize: '0.6rem', color: '#94a3b8', marginLeft: 'auto' }}>
                                  por {ev.userName}
                                </span>
                              )}
                            </Box>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                )}
              </Box>
              {/* Footer */}
              <Box style={{
                padding: '10px 20px', borderTop: '1px solid #e2e8f0',
                background: '#fafbfc', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              }}>
                <Typography style={{ fontSize: '0.7rem', color: '#64748b', fontWeight: 600 }}>
                  {events.length} {lang === 'pt' ? 'eventos' : 'events'}
                </Typography>
                <Button size="small" onClick={() => setHistoryDialog(null)}
                  style={{ fontSize: '0.74rem', textTransform: 'none', borderRadius: 8, color: '#475569', fontWeight: 700 }}>
                  {lang === 'pt' ? 'Fechar' : 'Close'}
                </Button>
              </Box>
            </Box>
          </Box>
        );
      })()}

      {/* Row actions menu — shared instance, positioned on the clicked row's "..." button */}
      <Menu
        anchorEl={rowMenuAnchor?.el}
        open={Boolean(rowMenuAnchor)}
        onClose={() => setRowMenuAnchor(null)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ style: { marginTop: 4, borderRadius: 12, minWidth: 240, boxShadow: '0 12px 32px rgba(15,23,42,0.14)', padding: 4 } }}
      >
        {rowMenuAnchor && (() => {
          const { order: ro, oid: rOid, status: rSt, hasRoute: rHasRoute, hasVehicle: rHasVehicle } = rowMenuAnchor;
          const close = () => setRowMenuAnchor(null);
          const items = [];
          // Edit (for any status except delivered/cancelled) or View (for delivered)
          if (rSt !== 'cancelled') {
            const isView = rSt === 'delivered';
            items.push(
              <MenuItem key="edit" onClick={() => { close(); handleEdit(ro, isView); }} style={{ borderRadius: 8, gap: 10, padding: '8px 10px' }}>
                {isView
                  ? <svg width="14" height="14" viewBox="0 0 24 24" fill="#4338ca"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/></svg>
                  : <EditIcon style={{ fontSize: 14, color: '#475569' }} />}
                <Typography style={{ fontSize: '0.76rem', fontWeight: 600 }}>
                  {isView
                    ? (lang === 'pt' ? 'Consultar ordem' : 'View order')
                    : (lang === 'pt' ? 'Editar ordem' : 'Edit order')}
                </Typography>
              </MenuItem>
            );
            // Delivered OT: offer a direct "history" shortcut
            if (isView) {
              items.push(
                <MenuItem key="history" onClick={() => { close(); openOTHistory(ro); }} style={{ borderRadius: 8, gap: 10, padding: '8px 10px' }}>
                  <HistoryIcon style={{ fontSize: 14, color: '#475569' }} />
                  <Typography style={{ fontSize: '0.76rem', fontWeight: 600 }}>
                    {lang === 'pt' ? 'Consultar histórico' : 'View history'}
                  </Typography>
                </MenuItem>
              );
            }
          }
          // Assign/change vehicle — promoted to direct icon, kept here for track-position states
          // (not shown here since it's always accessible via the direct icon)
          // Acção "Criar rota" removida — o fluxo único é via selecção
          // de OT(s) + "Alterar veículo e Planear rota" no rodapé (que
          // abre o dialog completo com origem/destino/VRP). Manter aqui
          // gerava 2 entradas para a mesma operação e o atalho saltava
          // a UI de escolha do operador.
          // "Atribuir a rota existente" removido — o fluxo único é via
          // selecção de OT(s) + "Alterar veículo e Planear rota" no rodapé,
          // que abre o dialog completo com origem/destino/VRP. A entrada
          // aqui criava 2 caminhos para a mesma operação e baralhava o
          // operador (o atalho saltava a UI de escolha).
          // Retirar OT da rota mantendo veículo/motorista. Disponível
          // quando a OT está atribuída a uma rota mas ainda não está
          // in_transit (rota em draft/planned). Para in_transit/delivered
          // este botão fica escondido — Fase 2 trata do caso em trânsito.
          if (rSt === 'assigned' && rHasRoute) items.push(
            <MenuItem key="remove-from-route" onClick={() => { close(); handleRemoveOTFromRoute(ro); }} style={{ borderRadius: 8, gap: 10, padding: '8px 10px' }}>
              <CloseIcon style={{ fontSize: 14, color: '#dc2626' }} />
              <Typography style={{ fontSize: '0.76rem', fontWeight: 600 }}>
                {lang === 'pt' ? 'Retirar da rota (manter veículo)' : 'Remove from route (keep vehicle)'}
              </Typography>
            </MenuItem>
          );
          // Despacho rápido (Casais): movido para um selo clicável "📱➤ DESPACHAR"
          // na coluna ESTADO (mesmo sítio do "ENVIADO"), a pedido do operador.
          // "Editar rota e reenviar" / "Contactar motorista" / "Enviar PDF
          // ao motorista" foram movidas para Operações > Rotas, onde o
          // LiveRouteMonitor já as expõe na sua barra de acções. Manter
          // as duplicadas aqui confundia o operador (não percebia onde
          // o re-dispatch ficava registado).
          // Live monitor — replaces the legacy "Consultar posição" entry.
          // Opens the route-level view in Operações → Rotas (the new home
          // for live monitoring) instead of the OT-centric LiveRoutePanel.
          if (rSt === 'in_transit' && ro.assignedRouteId) items.push(
            <MenuItem key="route-live" onClick={() => { close(); goToLiveRouteMonitor(ro); }} style={{ borderRadius: 8, gap: 10, padding: '8px 10px' }}>
              <GpsFixedIcon style={{ fontSize: 14, color: '#ef4444' }} />
              <Typography style={{ fontSize: '0.76rem', fontWeight: 600 }}>
                {lang === 'pt' ? 'Ver rota em tempo real' : 'View route live'}
              </Typography>
            </MenuItem>
          );
          // Go to Operations
          if (rHasRoute && (rSt === 'assigned' || rSt === 'in_transit')) items.push(
            <MenuItem key="operations" onClick={() => { close(); dispatch(navigateTo('manage')); setTimeout(() => window.dispatchEvent(new CustomEvent('manageOpenSection', { detail: { section: 'status', statusFilter: 'kanban' } })), 200); }} style={{ borderRadius: 8, gap: 10, padding: '8px 10px' }}>
              <SendIcon style={{ fontSize: 14, color: '#8b5cf6' }} /> <Typography style={{ fontSize: '0.76rem', fontWeight: 600 }}>{lang === 'pt' ? 'Ir para Operação' : 'Go to Operations'}</Typography>
            </MenuItem>
          );
          // "Abrir app motorista" removed from this menu — não fazia
          // sentido para o operador, era um atalho de teste.

          // Petrotec — gestão de mão-de-obra do BM (só assistência E só
          // quando a OT tem cliente final). Para OTs PT genéricas (sem
          // finalCustomer) o fluxo é o antigo — sem BM, sem H.N./H.E.
          // discriminados por código contabilístico.
          if (isPetrotecTenant(clientExternalId, clientSettings) && ro.serviceType === 'assistance' && !!ro.finalCustomerId) {
            items.push(
              <MenuItem key="labor" onClick={() => { close(); setLaborDialog({ orderId: rOid, orderRef: ro.orderNumber || ro.externalRef || `#${rOid}` }); }} style={{ borderRadius: 8, gap: 10, padding: '8px 10px' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="#0891b2"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/></svg>
                <Typography style={{ fontSize: '0.76rem', fontWeight: 600 }}>{lang === 'pt' ? 'Mão-de-obra (BM)' : 'Labor (BM)'}</Typography>
              </MenuItem>
            );
          }
          // Petrotec AO — enviar para Primavera ERP (placeholder, Fase D).
          // Aparece para todas as OTs de assistência Petrotec AO; ao clicar
          // mostra popup informando que a integração ainda não está
          // implementada (sync directa Planner → Primavera está planeada).
          if (isPetrotecTenant(clientExternalId, clientSettings) && ro.serviceType === 'assistance' && !!ro.finalCustomerId) {
            // ERP por tenant: Petrotec PT usa SAAP, Petrotec AO usa Primavera.
            const erpName = clientExternalId === '20' ? 'SAAP' : 'Primavera';
            items.push(
              <MenuItem key="erp-sync" onClick={() => { close(); setPrimaveraInfoOTId(rOid); }} style={{ borderRadius: 8, gap: 10, padding: '8px 10px' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="#f97316"><path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11 8 15.01z"/></svg>
                <Typography style={{ fontSize: '0.76rem', fontWeight: 600 }}>{lang === 'pt' ? `Enviar para ${erpName}` : `Send to ${erpName}`}</Typography>
              </MenuItem>
            );
          }
          // Duplicate
          items.push(
            <MenuItem key="duplicate" onClick={() => { close(); handleDuplicate(ro); }} style={{ borderRadius: 8, gap: 10, padding: '8px 10px' }}>
              <FileCopyIcon style={{ fontSize: 14, color: '#94a3b8' }} /> <Typography style={{ fontSize: '0.76rem', fontWeight: 600 }}>{lang === 'pt' ? 'Duplicar' : 'Duplicate'}</Typography>
            </MenuItem>
          );
          // Simulator entries removed — tests are real (Traccar GPS +
          // driver app). The /simulate endpoints stay on the backend
          // for emergency / demo use but no UI surfaces them anymore.

          // Eliminar — abre o diálogo individual. Para OTs com histórico
          // operacional o diálogo oferece Cancelar (soft); só purga total
          // com confirmação de admin. Separador antes para destacar.
          // Eliminar só para GESTOR (transversal a todos os clientes).
          if (canDeleteOrders) {
            items.push(<Box key="del-sep" style={{ height: 1, background: '#f1f5f9', margin: '4px 0' }} />);
            items.push(
              <MenuItem key="delete" onClick={() => { close(); handleDelete(rOid); }} style={{ borderRadius: 8, gap: 10, padding: '8px 10px' }}>
                <DeleteIcon style={{ fontSize: 14, color: '#dc2626' }} />
                <Typography style={{ fontSize: '0.76rem', fontWeight: 600, color: '#dc2626' }}>
                  {lang === 'pt' ? 'Eliminar ordem' : 'Delete order'}
                </Typography>
              </MenuItem>
            );
          }
          return items;
        })()}
      </Menu>

      {/* Bulk delete confirmation dialog */}
      {bulkDeleteConfirm && (
        <Box style={{
          position: 'fixed', inset: 0,
          background: 'rgba(15,23,42,0.55)', backdropFilter: 'blur(4px)',
          zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center',
        }} onClick={() => setBulkDeleteConfirm(false)}>
          <Box style={{
            background: '#fff', borderRadius: 16, padding: 0,
            width: 420, maxWidth: '92vw',
            boxShadow: '0 20px 60px rgba(0,0,0,0.25)', overflow: 'hidden',
          }} onClick={(e) => e.stopPropagation()}>
            {/* Header */}
            <Box style={{
              padding: '16px 20px',
              background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
              borderBottom: '1px solid #fecaca',
              display: 'flex', alignItems: 'center', gap: 12,
            }}>
              <Box style={{
                width: 40, height: 40, borderRadius: 10,
                background: 'linear-gradient(135deg, #ef4444, #dc2626)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(239,68,68,0.3)',
              }}>
                <WarningIcon style={{ fontSize: 20, color: '#fff' }} />
              </Box>
              <Box>
                <Typography style={{ fontSize: '0.98rem', fontWeight: 800, color: '#991b1b' }}>
                  {lang === 'pt' ? 'Eliminar Ordens de Transporte' : 'Delete Transport Orders'}
                </Typography>
                <Typography style={{ fontSize: '0.72rem', color: '#b91c1c', marginTop: 1 }}>
                  {lang === 'pt' ? 'Esta acção é irreversível' : 'This action cannot be undone'}
                </Typography>
              </Box>
            </Box>
            {/* Body */}
            <Box style={{ padding: '18px 20px' }}>
              <Typography style={{ fontSize: '0.82rem', color: '#334155', lineHeight: 1.5, marginBottom: 12 }}>
                {lang === 'pt'
                  ? `Tem a certeza que deseja eliminar ${selected.length} ordem(ns) de transporte seleccionada(s)?`
                  : `Are you sure you want to delete ${selected.length} selected transport order(s)?`}
              </Typography>
              <Box style={{
                padding: '10px 14px', background: '#fef2f2', border: '1px solid #fecaca',
                borderRadius: 8, fontSize: '0.72rem', color: '#991b1b',
              }}>
                {selected.slice(0, 5).map(oid => {
                  const o = list.find(x => (x._id || x.id) === oid);
                  return (
                    <Box key={oid} style={{ display: 'flex', gap: 6, marginBottom: 2 }}>
                      <Typography style={{ fontSize: '0.72rem', fontWeight: 700, color: '#dc2626' }} title={otTooltip(o)}>
                        {otLabel(o) || `OT-${oid}`}
                      </Typography>
                      <Typography style={{ fontSize: '0.68rem', color: '#b91c1c' }}>
                        {o?.pickupName?.split(',')[0] || '?'} → {o?.deliveryName?.split(',')[0] || '?'}
                      </Typography>
                    </Box>
                  );
                })}
                {selected.length > 5 && (
                  <Typography style={{ fontSize: '0.68rem', color: '#94a3b8', fontStyle: 'italic', marginTop: 4 }}>
                    +{selected.length - 5} {lang === 'pt' ? 'mais…' : 'more…'}
                  </Typography>
                )}
              </Box>
            </Box>
            {/* Footer */}
            <Box style={{
              display: 'flex', gap: 8, justifyContent: 'flex-end',
              padding: '12px 20px', borderTop: '1px solid #f1f5f9', background: '#fafbfc',
            }}>
              <Button size="small" onClick={() => setBulkDeleteConfirm(false)}
                style={{ fontSize: '0.74rem', textTransform: 'none', borderRadius: 10, color: '#64748b', fontWeight: 700, padding: '6px 18px' }}>
                {lang === 'pt' ? 'Cancelar' : 'Cancel'}
              </Button>
              <Button size="small" variant="contained"
                onClick={async () => {
                  setBulkDeleteConfirm(false);
                  const results = await Promise.all(selected.map(oid =>
                    dispatch(deleteOrder({ token, id: oid })).unwrap()
                      .then(() => ({ ok: true }))
                      .catch(err => ({ ok: false, code: err?.code }))
                  ));
                  doFetch(); setSelected([]);
                  const deleted = results.filter(r => r.ok).length;
                  const kept = results.filter(r => !r.ok && r.code === 'OT_HAS_FOOTPRINT').length;
                  const failed = results.length - deleted - kept;
                  if (deleted) dispatch(addToast({ severity: 'success', message: lang === 'pt' ? `${deleted} OT(s) eliminada(s)` : `${deleted} order(s) deleted` }));
                  if (kept) dispatch(addToast({ severity: 'info', message: lang === 'pt' ? `${kept} com histórico — não eliminada(s). Cancela/arquiva individualmente.` : `${kept} with history — not deleted. Cancel/archive individually.` }));
                  if (failed) dispatch(addToast({ severity: 'error', message: lang === 'pt' ? `${failed} OT(s) com erro` : `${failed} order(s) failed` }));
                }}
                style={{
                  fontSize: '0.74rem', textTransform: 'none', borderRadius: 10,
                  background: 'linear-gradient(135deg, #ef4444, #dc2626)',
                  color: '#fff', fontWeight: 700, padding: '6px 20px',
                  boxShadow: '0 2px 8px rgba(239,68,68,0.3)',
                }}>
                {lang === 'pt' ? `Eliminar ${selected.length} OT(s)` : `Delete ${selected.length} OT(s)`}
              </Button>
            </Box>
          </Box>
        </Box>
      )}

      {deleteConfirmId && (() => {
        // A eliminação é sempre em cascata completa no backend (OT + rota órfã
        // + histórico + stock reposto + referências). Aqui só calculamos se a
        // rota é partilhada, para o diálogo avisar que nesse caso a rota fica.
        const ot = list.find(o => (o._id || o.id) === deleteConfirmId);
        const routeId = ot?.assignedRouteId;
        const siblingsOnRoute = routeId
          ? list.filter(o => o.assignedRouteId === routeId && (o._id || o.id) !== deleteConfirmId).length
          : 0;
        const isTerminalOT = ['delivered', 'cancelled'].includes(ot?.status);
        const otLabel = ot?.orderNumber || `#${deleteConfirmId}`;
        // Tom: rascunho sem rasto → vermelho (eliminação direta); OT com rasto
        // operacional → âmbar (requer confirmação forte). Cabeçalho partilhado.
        const isDanger = !deleteFootprintMode;
        const accent = isDanger ? '#dc2626' : '#d97706';
        const accentSoft = isDanger ? '#fef2f2' : '#fffbeb';
        const accentBorder = isDanger ? '#fecaca' : '#fde68a';
        const HeaderIcon = isDanger ? DeleteIcon : WarningIcon;
        const headerTitle = !deleteFootprintMode
          ? (lang === 'pt' ? 'Eliminar Ordem de Transporte' : 'Delete Transport Order')
          : isTerminalOT
            ? (lang === 'pt' ? 'Esta OT está concluída' : 'This order is finalised')
            : (lang === 'pt' ? 'Esta OT tem histórico operacional' : 'This order has operational history');
        return (
        <Box style={{
          position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', backdropFilter: 'blur(5px)',
          zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center',
        }} onClick={closeDeleteDialog}>
          <Box style={{
            background: '#fff', borderRadius: 18, width: 470, maxWidth: '92vw', overflow: 'hidden',
            boxShadow: '0 28px 70px rgba(15,23,42,0.30)', border: '1px solid #eef2f7',
          }} onClick={e => e.stopPropagation()}>

            {/* Cabeçalho — ícone de tom + título + nº da OT */}
            <Box style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '18px 22px 16px' }}>
              <Box style={{
                width: 44, height: 44, borderRadius: 13, flexShrink: 0,
                background: accentSoft, border: `1px solid ${accentBorder}`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <HeaderIcon style={{ fontSize: 23, color: accent }} />
              </Box>
              <Box style={{ minWidth: 0 }}>
                <Typography style={{ fontSize: '1.02rem', fontWeight: 800, color: '#0f172a', letterSpacing: '-0.01em', lineHeight: 1.2 }}>
                  {headerTitle}
                </Typography>
                <Typography style={{ fontSize: '0.72rem', color: '#94a3b8', fontWeight: 600, marginTop: 1 }}>
                  {otLabel}
                </Typography>
              </Box>
            </Box>

            {/* Corpo */}
            <Box style={{ padding: '0 22px 18px' }}>
              {deleteFootprintMode ? (<>
                <Typography style={{ fontSize: '0.8rem', color: '#475569', lineHeight: 1.6, marginBottom: 14 }}>
                  {isTerminalOT
                    ? (lang === 'pt'
                        ? 'Esta OT já está entregue/cancelada e faz parte do histórico. Deve ser mantida para auditoria — só a deves eliminar se for lixo de teste.'
                        : 'This order is delivered/cancelled and part of the history. It should be kept for audit — only delete it if it is test junk.')
                    : (lang === 'pt'
                        ? 'Esta OT já foi despachada/executada ou consumiu stock. O recomendado é Cancelar — liberta o veículo, o motorista e a rota, mas preserva todo o histórico e a auditoria.'
                        : 'This order was dispatched/executed or consumed stock. The recommended action is to Cancel — it frees the vehicle, driver and route, but preserves all history and audit trail.')}
                </Typography>
                <Box style={{ padding: '11px 13px', borderRadius: 10, background: '#fffbeb', border: '1px solid #fde68a' }}>
                  <Typography style={{ fontSize: '0.72rem', color: '#92400e', lineHeight: 1.55 }}>
                    {lang === 'pt'
                      ? <><strong>Eliminação definitiva (irreversível):</strong> apaga a OT, a rota, todo o histórico/eventos e repõe o stock consumido. Perdes a auditoria para sempre.</>
                      : <><strong>Permanent deletion (irreversible):</strong> deletes the order, route, all history/events and restores consumed stock. The audit trail is lost forever.</>}
                  </Typography>
                </Box>
              </>) : (<>
                <Typography style={{ fontSize: '0.8rem', color: '#475569', lineHeight: 1.6, marginBottom: 14 }}>
                  {lang === 'pt' ? 'Esta acção é permanente e não pode ser revertida.' : 'This action is permanent and cannot be undone.'}
                </Typography>
                <Box style={{ padding: '11px 13px', borderRadius: 10, background: '#fef2f2', border: '1px solid #fecaca' }}>
                  <Typography style={{ fontSize: '0.72rem', fontWeight: 700, color: '#991b1b', marginBottom: 6 }}>
                    {lang === 'pt' ? 'Vai ser eliminado, sem deixar rasto:' : 'Will be permanently removed, leaving no trace:'}
                  </Typography>
                  <ul style={{ margin: 0, paddingLeft: 18 }}>
                    <li style={{ fontSize: '0.72rem', color: '#7f1d1d', marginBottom: 2, lineHeight: 1.5 }}>
                      {lang === 'pt' ? 'A Ordem de Transporte e o seu relatório' : 'The transport order and its report'}
                    </li>
                    <li style={{ fontSize: '0.72rem', color: '#7f1d1d', marginBottom: 2, lineHeight: 1.5 }}>
                      {routeId
                        ? (siblingsOnRoute > 0
                            ? (lang === 'pt' ? `A rota mantém-se (tem mais ${siblingsOnRoute} OT ligada${siblingsOnRoute > 1 ? 's' : ''})` : `The route stays (${siblingsOnRoute} other OT${siblingsOnRoute > 1 ? 's' : ''} linked)`)
                            : (lang === 'pt' ? 'A rota associada (ainda não despachada)' : 'The associated route (not yet dispatched)'))
                        : (lang === 'pt' ? 'Sem rota associada' : 'No associated route')}
                    </li>
                    <li style={{ fontSize: '0.72rem', color: '#7f1d1d', lineHeight: 1.5 }}>
                      {lang === 'pt' ? 'Referências desta OT na app' : 'References to this order in the app'}
                    </li>
                  </ul>
                </Box>
              </>)}
            </Box>

            {/* Rodapé */}
            <Box style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8,
              padding: '13px 22px', borderTop: '1px solid #eef2f7', background: '#fafbfc',
            }}>
              {deleteFootprintMode ? (<>
                <Button size="small" onClick={() => confirmDelete(true)} disabled={deleteBusy}
                  startIcon={<DeleteIcon style={{ fontSize: 15 }} />}
                  style={{ fontSize: '0.72rem', fontWeight: 700, textTransform: 'none', borderRadius: 8, color: '#b91c1c', border: '1px solid #fecaca', padding: '5px 12px' }}>
                  {lang === 'pt' ? 'Eliminação definitiva' : 'Permanent deletion'}
                </Button>
                <Box style={{ display: 'flex', gap: 8 }}>
                  <Button size="small" onClick={closeDeleteDialog} disabled={deleteBusy}
                    style={{ fontSize: '0.74rem', fontWeight: 600, textTransform: 'none', borderRadius: 8, color: '#64748b' }}>
                    {lang === 'pt' ? (isTerminalOT ? 'Manter' : 'Fechar') : (isTerminalOT ? 'Keep' : 'Close')}
                  </Button>
                  {!isTerminalOT && (
                    <Button size="small" variant="contained" disableElevation onClick={cancelOrderFromDelete} disabled={deleteBusy}
                      style={{ fontSize: '0.74rem', fontWeight: 700, textTransform: 'none', borderRadius: 8, background: '#2563eb', color: '#fff', padding: '5px 14px' }}>
                      {lang === 'pt' ? 'Cancelar OT' : 'Cancel order'}
                    </Button>
                  )}
                </Box>
              </>) : (<>
                <span />
                <Box style={{ display: 'flex', gap: 8 }}>
                  <Button size="small" onClick={closeDeleteDialog} disabled={deleteBusy}
                    style={{ fontSize: '0.74rem', fontWeight: 600, textTransform: 'none', borderRadius: 8, color: '#64748b' }}>
                    {lang === 'pt' ? 'Cancelar' : 'Cancel'}
                  </Button>
                  <Button size="small" variant="contained" disableElevation onClick={() => confirmDelete(false)} disabled={deleteBusy}
                    startIcon={<DeleteIcon style={{ fontSize: 15 }} />}
                    style={{ fontSize: '0.74rem', fontWeight: 700, textTransform: 'none', borderRadius: 8, background: '#ef4444', color: '#fff', padding: '5px 14px' }}>
                    {lang === 'pt' ? 'Eliminação definitiva' : 'Delete permanently'}
                  </Button>
                </Box>
              </>)}
            </Box>
          </Box>
        </Box>
        );
      })()}
      {/* Phone preview overlay — opened from the OT row's 3-dots menu. Shows
          the driver's view of the selected OT's route without touching the
          global currentRoute (so we don't leave the planner's state dirty). */}
      {phonePreviewRoute && (
        <PhonePreview
          routeOverride={phonePreviewRoute}
          onClose={() => setPhonePreviewRoute(null)}
        />
      )}

      {/* Confirmação "Retirar OT da rota" — dialog estilizado em vez de
          window.confirm. Mostra o detalhe completo: OT, rota, veículo e
          motorista que ficam mantidos. */}
      {/* Lightbox simples — overlay full-screen para ampliar assinaturas e
          fotos. Click no overlay (ou ESC, ou no botão ✕) fecha. Suporta
          imagens base64 (assinaturas) e URLs externos (fotos). */}
      {lightboxSrc && ReactDOM.createPortal(
        <Box
          onClick={() => setLightboxSrc(null)}
          style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            background: 'rgba(15,23,42,0.92)', backdropFilter: 'blur(6px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: 24, cursor: 'zoom-out',
          }}
        >
          <IconButton
            onClick={(e) => { e.stopPropagation(); setLightboxSrc(null); }}
            style={{ position: 'absolute', top: 16, right: 16, background: 'rgba(255,255,255,0.15)', color: '#fff' }}
            size="medium"
          >
            <CloseIcon style={{ fontSize: 22 }} />
          </IconButton>
          <img
            src={lightboxSrc}
            alt="ampliação"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: '92vw', maxHeight: '92vh', objectFit: 'contain', background: '#fff', borderRadius: 8, boxShadow: '0 20px 60px rgba(0,0,0,0.5)', cursor: 'default' }}
          />
        </Box>,
        document.body
      )}

      {/* Petrotec — popup informativo "Enviar para ERP" (Fase D pendente).
          Nome do ERP varia por tenant: Petrotec PT → SAAP, Petrotec AO →
          Primavera. */}
      {(() => {
        const erpName = clientExternalId === '20' ? 'SAAP' : 'Primavera';
        return (
          <ConfirmDialog
            open={!!primaveraInfoOTId}
            onClose={() => setPrimaveraInfoOTId(null)}
            onConfirm={() => setPrimaveraInfoOTId(null)}
            severity="info"
            title={lang === 'pt' ? `Envio para ${erpName}` : `Send to ${erpName}`}
            confirmLabel={lang === 'pt' ? 'Entendido' : 'Got it'}
            cancelLabel={null}
            message={lang === 'pt'
              ? `Esta funcionalidade ainda não está implementada.\n\nA integração directa Planner → ${erpName} ERP está prevista para a próxima fase.`
              : `This feature is not yet implemented.\n\nDirect Planner → ${erpName} ERP integration is planned for the next phase.`}
          />
        );
      })()}

      {/* Petrotec AO — aviso antes de planificar rota com veículo sem stock */}
      <ConfirmDialog
        open={!!noStockConfirm}
        onClose={() => setNoStockConfirm(null)}
        onConfirm={() => { const fn = noStockConfirm; setNoStockConfirm(null); if (typeof fn === 'function') fn(); }}
        severity="warning"
        title={lang === 'pt' ? 'Veículo sem stock' : 'Vehicle has no stock'}
        confirmLabel={lang === 'pt' ? 'Continuar mesmo assim' : 'Continue anyway'}
        cancelLabel={lang === 'pt' ? 'Cancelar' : 'Cancel'}
        message={lang === 'pt'
          ? 'O veículo escolhido não tem stock atribuído. O técnico pode chegar ao posto e não ter peças para a intervenção. Queres continuar a planificar mesmo assim?'
          : 'The selected vehicle has no stock assigned. The technician may arrive on site without parts. Continue planning anyway?'}
      />
      <ConfirmDialog
        open={!!removeFromRouteOT}
        onClose={() => setRemoveFromRouteOT(null)}
        onConfirm={performRemoveOTFromRoute}
        severity="warning"
        title={lang === 'pt' ? 'Retirar ordem da rota' : 'Remove order from route'}
        confirmLabel={lang === 'pt' ? 'Retirar da rota' : 'Remove from route'}
        cancelLabel={lang === 'pt' ? 'Manter' : 'Keep'}
        message={(() => {
          if (!removeFromRouteOT) return '';
          const otRef = removeFromRouteOT.customRef || removeFromRouteOT.orderNumber || `OT-${removeFromRouteOT.id || removeFromRouteOT._id}`;
          const routeRef = removeFromRouteOT.routeName || removeFromRouteOT.assignedRoute?.name || `Rota #${removeFromRouteOT.assignedRouteId}`;
          const plate = removeFromRouteOT.vehiclePlate || '—';
          const driver = removeFromRouteOT.driverName || '—';
          return lang === 'pt'
            ? `${otRef} será retirada de "${routeRef}".\n\nO veículo ${plate} e o motorista ${driver} mantêm-se atribuídos à ordem — a OT volta para a lista "sem rota".\n\nA geometria da rota NÃO é recalculada automaticamente.`
            : `${otRef} will be removed from "${routeRef}".\n\nVehicle ${plate} and driver ${driver} stay assigned to the order — it goes back to the "no route" list.\n\nRoute geometry will NOT auto-recalculate.`;
        })()}
      />

      {/* Driver PDF preview/send — same dialog as the planner's Acções > PDF
          Motorista, available per-OT from the row 3-dots menu. */}
      <DriverPdfPreviewDialog
        open={!!pdfPreviewRoute}
        route={pdfPreviewRoute || {}}
        vehiclePlate={pdfPreviewMeta.vehiclePlate}
        driverName={pdfPreviewMeta.driverName}
        lang={lang}
        otNotesById={otNotesById}
        onClose={() => setPdfPreviewRoute(null)}
      />

      {/* Manage drivers dialog — opened from the toolbar button. */}
      <ManageDriversDialog
        open={showManageDrivers}
        onClose={() => setShowManageDrivers(false)}
      />

      {/* LIVE route panel — full-screen overlay with the route map, driver
          contact, sibling OTs and quick actions. Co-exists with the inline
          "manage" panel; opened by the red live-dot icon on each row. */}
      <LiveRoutePanel
        open={!!livePanelState}
        onClose={() => setLivePanelState(null)}
        // Always resolve `order` from the live list so status flips (assigned →
        // in_transit when the operator clicks Iniciar) and any other server-
        // side updates propagate into the panel without having to reopen it.
        // Falls back to the snapshot taken at open time if the list hasn't
        // refreshed yet (mid-flight between save and doFetch).
        order={livePanelState ? (
          list.find(o => {
            const a = Number(o.id || o._id);
            const b = Number(livePanelState.order.id || livePanelState.order._id);
            return a === b;
          }) || livePanelState.order
        ) : null}
        routeGeometry={livePanelState?.geometry}
        routeMeta={livePanelState?.routeMeta}
        clientSettings={clientSettings}
        allOrders={list}
        drivers={allDrivers}
        lang={lang}
        onOpenOT={(ot) => openLivePanel(ot)}
        onContactDriver={(ot) => setContactOrder(ot)}
        onOpenHistory={(ot) => { setLivePanelState(null); openOTHistory(ot); }}
        onEditRoute={(ot) => {
          setLivePanelState(null);
          // Re-use the existing re-plan flow already wired in OrdersView.
          if (ot.assignedRouteId) {
            // Set BEFORE fetch — fetchRouteDetail.fulfilled inspects
            // replanningRouteId to decide if the loaded route should be
            // editable; setting it after would leave the route view-only.
            dispatch(setReplanningRouteId(ot.assignedRouteId));
            dispatch(setReplanReturnLiveOTId(ot.id || ot._id));
            dispatch(fetchRouteDetail({ token, routeId: ot.assignedRouteId }))
              .unwrap()
              .then(() => {
                dispatch(setSidebarVisible(true));
                dispatch(setSidebarTab(0));
                dispatch(navigateTo('planner'));
              })
              .catch(() => {});
          }
        }}
        onStatusChange={(ot, newStatus) => {
          // Delegate to the existing inline status handler so we get the same
          // 500m vehicle-vs-pickup check, toast, doFetch refresh, etc.
          handleInlineRouteAction(ot, newStatus);
          // Keep the panel open when STARTING — the route status flips to
          // 'in_progress' on the server, the simulator auto-starts, and the
          // operator wants to *see* the truck moving inside the same screen.
          // For Concluir/Cancelar the panel state will close naturally (the
          // OT row's live action drops out and the next selectFromList gets
          // a final status). Cancel uses its own confirm dialog already.
          if (newStatus !== 'in_progress') {
            setLivePanelState(null);
          }
        }}
        onStartSimulation={undefined /* Simulation removed — real GPS tests only */}
        onAddOrderToRoute={async (currentOT, newOT) => {
          // 1. Assign the new OT to the same vehicle/driver as the current
          //    route — re-uses the assign-vehicle endpoint so all the
          //    lazy-driver-persist + audit log machinery runs identically.
          // 2. Re-fetch all sibling OTs (now N+1) and run the same VRP that
          //    the orders-screen "Otimizar Rota" uses — same origin / return
          //    home rules apply.
          // 3. Land in the planner with `replanningRouteId` set so the
          //    operator sees the saliente Save / Save&Resend / Cancel bar.
          if (!currentOT?.assignedRouteId || !newOT) return;
          try {
            // Resolve the existing vehicle/driver for the route from the
            // current OT (whose data is the freshest).
            const refVehicleId = currentOT.vehicleId;
            const refVehiclePlate = currentOT.vehiclePlate;
            const refDriverId = currentOT.driverId;
            const refDriverName = currentOT.driverName;
            const drv = allDrivers.find(d => Number(d.id) === Number(refDriverId));
            const newOTId = newOT.id || newOT._id;
            const assignRes = await fetch(`/planner-api/transport-orders/${newOTId}/assign-vehicle`, {
              method: 'POST',
              headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
              body: JSON.stringify({
                vehicleId: refVehicleId,
                vehiclePlate: refVehiclePlate,
                driverName: refDriverName,
                driverExternalId: drv?.externalId || null,
                driverTachoCard: drv?.tachoCard || null,
                driverPhone: drv?.phone || null,
                driverEmail: drv?.email || null,
              }),
            });
            if (!assignRes.ok) throw new Error('Falha a atribuir o veículo à nova ordem');

            // Collect OTs to optimise. Phase 3 rule: when the route is
            // already in progress, we DO NOT re-optimise OTs that have been
            // delivered — they're history. Only the in_transit/assigned OTs
            // plus the new one are sent to the consolidator. The vehicle's
            // current GPS becomes the origin so the new geometry starts
            // exactly where the truck is now.
            const sourceOTs = list
              .filter(o => o.assignedRouteId === currentOT.assignedRouteId);
            const isRouteInProgress = sourceOTs.some(o => o.status === 'in_transit');
            const liveOTs = isRouteInProgress
              ? sourceOTs.filter(o => o.status !== 'delivered')
              : sourceOTs;
            const sourceIds = liveOTs.map(o => o.id || o._id);
            const allIds = Array.from(new Set([...sourceIds, newOTId])).map(Number);
            const fresh = await Promise.all(allIds.map(id =>
              fetch(`/planner-api/transport-orders/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
              }).then(r => r.ok ? r.json() : null).catch(() => null)
            ));
            const validOrders = fresh.filter(o => o && (o.id || o._id));
            if (validOrders.length < 2) {
              throw new Error('Não foi possível recolher as ordens da rota');
            }
            // Mark the route as the one being replanned so the planner shows
            // the saliente action bar and the live panel reopens after Save.
            dispatch(setReplanningRouteId(currentOT.assignedRouteId));
            dispatch(setReplanReturnLiveOTId(currentOT.id || currentOT._id));
            setLivePanelState(null);

            // For an in-progress route we override the origin with the
            // vehicle's current GPS BEFORE the consolidator runs. The
            // existing replan flow already supports a custom origin via
            // `setOrigin`; we just resolve the GPS and pass it along.
            if (isRouteInProgress) {
              const liveVehicle = vehicles.find(v =>
                Number(v.id) === Number(currentOT.vehicleId) ||
                (v.plate || '').toUpperCase() === String(currentOT.vehiclePlate || '').toUpperCase()
              );
              const pos = liveVehicle?.position;
              if (pos?.latitude != null && pos?.longitude != null) {
                dispatch(setOrigin({
                  name: 'Posição actual do veículo',
                  coordinates: [Number(pos.longitude), Number(pos.latitude)],
                }));
                dispatch(setNeedsRecalculation(true));
              }
              const deliveredCount = sourceOTs.length - liveOTs.length;
              if (deliveredCount > 0) {
                dispatch(addToast({
                  type: 'info',
                  message: lang === 'pt'
                    ? `✚ Optimização vai considerar ${liveOTs.length} OT(s) restantes + ${newOT.orderNumber} (${deliveredCount} já entregues mantêm-se).`
                    : `✚ Optimising ${liveOTs.length} remaining OT(s) + ${newOT.orderNumber} (${deliveredCount} already delivered are kept).`,
                  duration: 6000,
                }));
              }
            }
            // Run the same VRP-driven consolidation that the bulk planner uses.
            // It rebuilds origin/waypoints/destination including driverHome
            // and return-home semantics.
            await handleConsolidateRoutes(allIds, validOrders);
            dispatch(addToast({
              type: 'success',
              message: lang === 'pt'
                ? `✚ ${otLabel(newOT) || `OT-${newOTId}`} adicionada à rota — confirma e reenvia.`
                : `✚ ${otLabel(newOT) || `OT-${newOTId}`} added to route — confirm and resend.`,
            }));
          } catch (e) {
            console.error('AddOrderToRoute error:', e);
            dispatch(addToast({ type: 'error', message: (lang === 'pt' ? 'Erro: ' : 'Error: ') + (e?.message || e) }));
          }
        }}
      />

      {/* ─── Popup "Confirmar morada do motorista" ─────────────────
          Aparece quando um motorista escolhido no diálogo de atribuir
          veículo não tem homeLat/homeLng. Pré-preenche com o address
          do EcooGPS (se houver) ou homeAddress local; o operador refina
          numa caixa Google Places que devolve lat/lng exactos; gravamos
          no registo local via /drivers/upsert. Não bloqueia o diálogo
          principal — é um overlay com z-index acima. */}
      <Dialog
        open={!!addressPromptDriver}
        onClose={() => { if (!addressPromptSaving) closeAddressPrompt(); }}
        PaperProps={{ style: { borderRadius: 12, padding: 0, maxWidth: 480, width: '92vw' } }}
      >
        {addressPromptDriver && (
          <Box style={{ padding: 0 }}>
            <Box style={{
              padding: '14px 18px',
              background: 'linear-gradient(135deg, #eff6ff, #dbeafe)',
              borderBottom: '1px solid #bfdbfe',
              display: 'flex', alignItems: 'center', gap: 10,
            }}>
              <Box style={{ fontSize: 18 }}>📍</Box>
              <Box style={{ flex: 1, minWidth: 0 }}>
                <Typography style={{ fontSize: '0.92rem', fontWeight: 800, color: '#1e3a8a' }}>
                  {lang === 'pt' ? `Confirma a morada de ${addressPromptDriver.name}` : `Confirm address of ${addressPromptDriver.name}`}
                </Typography>
                <Typography style={{ fontSize: '0.7rem', color: '#475569', marginTop: 2 }}>
                  {lang === 'pt'
                    ? 'Necessário para usar a casa do motorista como partida nas OTs de assistência.'
                    : 'Needed to use the driver\'s home as the starting point for assistance OTs.'}
                </Typography>
              </Box>
            </Box>

            <Box style={{ padding: '16px 18px' }}>
              <Typography style={{ fontSize: '0.7rem', color: '#64748b', marginBottom: 6 }}>
                {lang === 'pt' ? 'Morada (escreve e escolhe da lista para fixar as coordenadas)' : 'Address (type and pick from list to lock the coordinates)'}
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                value={addressPromptInput}
                onChange={(e) => handleAddressPromptInput(e.target.value)}
                placeholder={lang === 'pt' ? 'Ex.: Passeio dos Cruzados, 18, Lisboa' : 'e.g.: Passeio dos Cruzados, 18, Lisbon'}
                autoFocus
                disabled={addressPromptSaving}
                InputProps={{
                  endAdornment: addressPromptSelected
                    ? <span style={{ color: '#16a34a', fontWeight: 800, fontSize: '0.78rem' }}>✓</span>
                    : null,
                }}
              />

              {/* Lista de sugestões — só visível enquanto não há selecção firme */}
              {!addressPromptSelected && addressPromptSuggestions.length > 0 && (
                <Box style={{
                  marginTop: 4, border: '1px solid #e2e8f0', borderRadius: 8,
                  maxHeight: 220, overflowY: 'auto', background: '#fff',
                }}>
                  {addressPromptSuggestions.map((s, i) => {
                    // Cor do badge por origem do provider — útil para o operador
                    // perceber porque uma morada apareceu (Google vs HERE vs OSM).
                    const srcLabel = s.source === 'google' ? 'Google'
                      : s.source === 'here' ? 'HERE'
                      : s.source === 'mapbox' ? 'Mapbox'
                      : s.source === 'osm' ? 'OSM' : '';
                    return (
                      <Box key={s.placeId || `${s.source}-${i}`}
                        onClick={() => handleAddressPromptPick(s)}
                        style={{
                          padding: '8px 12px', cursor: 'pointer',
                          borderBottom: i < addressPromptSuggestions.length - 1 ? '1px solid #f1f5f9' : 'none',
                          display: 'flex', alignItems: 'center', gap: 8,
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.background = '#f8fafc'}
                        onMouseLeave={(e) => e.currentTarget.style.background = '#fff'}
                      >
                        <Box style={{ flex: 1, minWidth: 0 }}>
                          <Typography style={{ fontSize: '0.78rem', fontWeight: 600, color: '#0f172a' }}>
                            {s.label}
                          </Typography>
                          {s.sub && (
                            <Typography style={{ fontSize: '0.66rem', color: '#64748b' }}>
                              {s.sub}
                            </Typography>
                          )}
                        </Box>
                        {srcLabel && (
                          <Typography style={{
                            fontSize: '0.56rem', fontWeight: 700,
                            background: '#f1f5f9', color: '#64748b',
                            padding: '1px 5px', borderRadius: 3,
                            letterSpacing: '0.04em', textTransform: 'uppercase',
                          }}>{srcLabel}</Typography>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              )}

              {/* Selecção firme — mostra coordenadas como confirmação */}
              {addressPromptSelected && (
                <Box style={{
                  marginTop: 8, padding: '8px 10px', borderRadius: 6,
                  background: '#f0fdf4', border: '1px solid #bbf7d0',
                  display: 'flex', alignItems: 'center', gap: 8,
                }}>
                  <Typography style={{ fontSize: '0.66rem', color: '#15803d', fontFamily: 'monospace' }}>
                    {addressPromptSelected.lat.toFixed(6)}, {addressPromptSelected.lng.toFixed(6)}
                  </Typography>
                </Box>
              )}
            </Box>

            <Box style={{
              display: 'flex', justifyContent: 'flex-end', gap: 8,
              padding: '12px 18px', borderTop: '1px solid #f1f5f9',
              background: '#fafafa',
            }}>
              <Button
                onClick={closeAddressPrompt}
                disabled={addressPromptSaving}
                style={{ fontSize: '0.74rem', textTransform: 'none', color: '#64748b' }}
              >
                {lang === 'pt' ? 'Cancelar' : 'Cancel'}
              </Button>
              <Button
                onClick={confirmAddressPrompt}
                disabled={!addressPromptSelected || addressPromptSaving}
                variant="contained"
                style={{
                  fontSize: '0.74rem', textTransform: 'none', fontWeight: 700,
                  background: (!addressPromptSelected || addressPromptSaving) ? '#cbd5e1' : '#2563eb',
                  color: '#fff', boxShadow: 'none',
                }}
              >
                {addressPromptSaving
                  ? (lang === 'pt' ? 'A gravar…' : 'Saving…')
                  : (lang === 'pt' ? 'Confirmar e gravar' : 'Confirm & save')}
              </Button>
            </Box>
          </Box>
        )}
      </Dialog>
    </Box>
    </ThemeProvider>
  );
}

export default OrdersView;
